window.theme = window.theme || {}, window.themeInfo = {name: "Icon"}, function () {
    (function (e, t) {
        typeof exports == "object" && typeof module < "u" ? module.exports = t() : typeof define == "function" && define.amd ? define(t) : e.AOS = t()
    })(this, function () {
        "use strict";
        var e = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {},
            t = "Expected a function", n = NaN, o = "[object Symbol]", i = /^\s+|\s+$/g, a = /^[-+]0x[0-9a-f]+$/i,
            r = /^0b[01]+$/i, c = /^0o[0-7]+$/i, s = parseInt,
            u = typeof e == "object" && e && e.Object === Object && e,
            d = typeof self == "object" && self && self.Object === Object && self,
            l = u || d || Function("return this")(), f = Object.prototype.toString, m = Math.max, p = Math.min,
            b = function () {
                return l.Date.now()
            };

        function v(e2, n2, o2) {
            var i2, a2, r2, c2, s2, u2, d2 = 0, l2 = !1, f2 = !1, v2 = !0;
            if (typeof e2 != "function") throw new TypeError(t);

            function y2(t2) {
                var n3 = i2, o3 = a2;
                return i2 = a2 = void 0, d2 = t2, c2 = e2.apply(o3, n3)
            }

            function h2(e3) {
                var t2 = e3 - u2;
                return u2 === void 0 || t2 >= n2 || t2 < 0 || f2 && e3 - d2 >= r2
            }

            function k2() {
                var e3 = b();
                if (h2(e3)) return x2(e3);
                s2 = setTimeout(k2, function (e4) {
                    var t2 = n2 - (e4 - u2);
                    return f2 ? p(t2, r2 - (e4 - d2)) : t2
                }(e3))
            }

            function x2(e3) {
                return s2 = void 0, v2 && i2 ? y2(e3) : (i2 = a2 = void 0, c2)
            }

            function O2() {
                var e3 = b(), t2 = h2(e3);
                if (i2 = arguments, a2 = this, u2 = e3, t2) {
                    if (s2 === void 0) return function (e4) {
                        return d2 = e4, s2 = setTimeout(k2, n2), l2 ? y2(e4) : c2
                    }(u2);
                    if (f2) return s2 = setTimeout(k2, n2), y2(u2)
                }
                return s2 === void 0 && (s2 = setTimeout(k2, n2)), c2
            }

            return n2 = w(n2) || 0, g(o2) && (l2 = !!o2.leading, r2 = (f2 = "maxWait" in o2) ? m(w(o2.maxWait) || 0, n2) : r2, v2 = "trailing" in o2 ? !!o2.trailing : v2), O2.cancel = function () {
                s2 !== void 0 && clearTimeout(s2), d2 = 0, i2 = u2 = a2 = s2 = void 0
            }, O2.flush = function () {
                return s2 === void 0 ? c2 : x2(b())
            }, O2
        }

        function g(e2) {
            var t2 = typeof e2;
            return !!e2 && (t2 == "object" || t2 == "function")
        }

        function w(e2) {
            if (typeof e2 == "number") return e2;
            if (function (e3) {
                return typeof e3 == "symbol" || function (e4) {
                    return !!e4 && typeof e4 == "object"
                }(e3) && f.call(e3) == o
            }(e2)) return n;
            if (g(e2)) {
                var t2 = typeof e2.valueOf == "function" ? e2.valueOf() : e2;
                e2 = g(t2) ? t2 + "" : t2
            }
            if (typeof e2 != "string") return e2 === 0 ? e2 : +e2;
            e2 = e2.replace(i, "");
            var u2 = r.test(e2);
            return u2 || c.test(e2) ? s(e2.slice(2), u2 ? 2 : 8) : a.test(e2) ? n : +e2
        }

        var y = function (e2, n2, o2) {
                var i2 = !0, a2 = !0;
                if (typeof e2 != "function") throw new TypeError(t);
                return g(o2) && (i2 = "leading" in o2 ? !!o2.leading : i2, a2 = "trailing" in o2 ? !!o2.trailing : a2), v(e2, n2, {
                    leading: i2,
                    maxWait: n2,
                    trailing: a2
                })
            }, h = "Expected a function", k = NaN, x = "[object Symbol]", O = /^\s+|\s+$/g, j = /^[-+]0x[0-9a-f]+$/i,
            E = /^0b[01]+$/i, N = /^0o[0-7]+$/i, z = parseInt,
            C = typeof e == "object" && e && e.Object === Object && e,
            A = typeof self == "object" && self && self.Object === Object && self,
            q = C || A || Function("return this")(), L = Object.prototype.toString, T = Math.max, M = Math.min,
            S = function () {
                return q.Date.now()
            };

        function D(e2) {
            var t2 = typeof e2;
            return !!e2 && (t2 == "object" || t2 == "function")
        }

        function H(e2) {
            if (typeof e2 == "number") return e2;
            if (function (e3) {
                return typeof e3 == "symbol" || function (e4) {
                    return !!e4 && typeof e4 == "object"
                }(e3) && L.call(e3) == x
            }(e2)) return k;
            if (D(e2)) {
                var t2 = typeof e2.valueOf == "function" ? e2.valueOf() : e2;
                e2 = D(t2) ? t2 + "" : t2
            }
            if (typeof e2 != "string") return e2 === 0 ? e2 : +e2;
            e2 = e2.replace(O, "");
            var n2 = E.test(e2);
            return n2 || N.test(e2) ? z(e2.slice(2), n2 ? 2 : 8) : j.test(e2) ? k : +e2
        }

        var $ = function (e2, t2, n2) {
            var o2, i2, a2, r2, c2, s2, u2 = 0, d2 = !1, l2 = !1, f2 = !0;
            if (typeof e2 != "function") throw new TypeError(h);

            function m2(t3) {
                var n3 = o2, a3 = i2;
                return o2 = i2 = void 0, u2 = t3, r2 = e2.apply(a3, n3)
            }

            function p2(e3) {
                var n3 = e3 - s2;
                return s2 === void 0 || n3 >= t2 || n3 < 0 || l2 && e3 - u2 >= a2
            }

            function b2() {
                var e3 = S();
                if (p2(e3)) return v2(e3);
                c2 = setTimeout(b2, function (e4) {
                    var n3 = t2 - (e4 - s2);
                    return l2 ? M(n3, a2 - (e4 - u2)) : n3
                }(e3))
            }

            function v2(e3) {
                return c2 = void 0, f2 && o2 ? m2(e3) : (o2 = i2 = void 0, r2)
            }

            function g2() {
                var e3 = S(), n3 = p2(e3);
                if (o2 = arguments, i2 = this, s2 = e3, n3) {
                    if (c2 === void 0) return function (e4) {
                        return u2 = e4, c2 = setTimeout(b2, t2), d2 ? m2(e4) : r2
                    }(s2);
                    if (l2) return c2 = setTimeout(b2, t2), m2(s2)
                }
                return c2 === void 0 && (c2 = setTimeout(b2, t2)), r2
            }

            return t2 = H(t2) || 0, D(n2) && (d2 = !!n2.leading, a2 = (l2 = "maxWait" in n2) ? T(H(n2.maxWait) || 0, t2) : a2, f2 = "trailing" in n2 ? !!n2.trailing : f2), g2.cancel = function () {
                c2 !== void 0 && clearTimeout(c2), u2 = 0, o2 = s2 = i2 = c2 = void 0
            }, g2.flush = function () {
                return c2 === void 0 ? r2 : v2(S())
            }, g2
        }, W = function () {
        };

        function P(e2) {
            e2 && e2.forEach(function (e3) {
                var t2 = Array.prototype.slice.call(e3.addedNodes), n2 = Array.prototype.slice.call(e3.removedNodes);
                if (function e4(t3) {
                    var n3 = void 0, o2 = void 0;
                    for (n3 = 0; n3 < t3.length; n3 += 1) if ((o2 = t3[n3]).dataset && o2.dataset.aos || o2.children && e4(o2.children)) return !0;
                    return !1
                }(t2.concat(n2))) return W()
            })
        }

        function Y() {
            return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
        }

        var _2 = {
                isSupported: function () {
                    return !!Y()
                }, ready: function (e2, t2) {
                    var n2 = window.document, o2 = new (Y())(P);
                    W = t2, o2.observe(n2.documentElement, {childList: !0, subtree: !0, removedNodes: !0})
                }
            }, B = function (e2, t2) {
                if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function")
            }, F = function () {
                function e2(e3, t2) {
                    for (var n2 = 0; n2 < t2.length; n2++) {
                        var o2 = t2[n2];
                        o2.enumerable = o2.enumerable || !1, o2.configurable = !0, "value" in o2 && (o2.writable = !0), Object.defineProperty(e3, o2.key, o2)
                    }
                }

                return function (t2, n2, o2) {
                    return n2 && e2(t2.prototype, n2), o2 && e2(t2, o2), t2
                }
            }(), I = Object.assign || function (e2) {
                for (var t2 = 1; t2 < arguments.length; t2++) {
                    var n2 = arguments[t2];
                    for (var o2 in n2) Object.prototype.hasOwnProperty.call(n2, o2) && (e2[o2] = n2[o2])
                }
                return e2
            },
            K = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
            G = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            J = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
            Q = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;

        function R() {
            return navigator.userAgent || navigator.vendor || window.opera || ""
        }

        var U = new (function () {
            function e2() {
                B(this, e2)
            }

            return F(e2, [{
                key: "phone", value: function () {
                    var e3 = R();
                    return !(!K.test(e3) && !G.test(e3.substr(0, 4)))
                }
            }, {
                key: "mobile", value: function () {
                    var e3 = R();
                    return !(!J.test(e3) && !Q.test(e3.substr(0, 4)))
                }
            }, {
                key: "tablet", value: function () {
                    return this.mobile() && !this.phone()
                }
            }, {
                key: "ie11", value: function () {
                    return "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style
                }
            }]), e2
        }()), V = function (e2, t2) {
            var n2 = void 0;
            return U.ie11() ? (n2 = document.createEvent("CustomEvent")).initCustomEvent(e2, !0, !0, {detail: t2}) : n2 = new CustomEvent(e2, {detail: t2}), document.dispatchEvent(n2)
        }, X = function (e2) {
            return e2.forEach(function (e3, t2) {
                return function (e4, t3) {
                    var n2 = e4.options, o2 = e4.position, i2 = e4.node, a2 = (e4.data, function () {
                        e4.animated && (function (e5, t4) {
                            t4 && t4.forEach(function (t5) {
                                return e5.classList.remove(t5)
                            })
                        }(i2, n2.animatedClassNames), V("aos:out", i2), e4.options.id && V("aos:in:" + e4.options.id, i2), e4.animated = !1)
                    });
                    n2.mirror && t3 >= o2.out && !n2.once ? a2() : t3 >= o2.in ? e4.animated || (function (e5, t4) {
                        t4 && t4.forEach(function (t5) {
                            return e5.classList.add(t5)
                        })
                    }(i2, n2.animatedClassNames), V("aos:in", i2), e4.options.id && V("aos:in:" + e4.options.id, i2), e4.animated = !0) : e4.animated && !n2.once && a2()
                }(e3, window.pageYOffset)
            })
        }, Z = function (e2) {
            for (var t2 = 0, n2 = 0; e2 && !isNaN(e2.offsetLeft) && !isNaN(e2.offsetTop);) t2 += e2.offsetLeft - (e2.tagName != "BODY" ? e2.scrollLeft : 0), n2 += e2.offsetTop - (e2.tagName != "BODY" ? e2.scrollTop : 0), e2 = e2.offsetParent;
            return {top: n2, left: t2}
        }, ee = function (e2, t2, n2) {
            var o2 = e2.getAttribute("data-aos-" + t2);
            if (o2 !== void 0) {
                if (o2 === "true") return !0;
                if (o2 === "false") return !1
            }
            return o2 || n2
        }, te = function (e2, t2) {
            return e2.forEach(function (e3, n2) {
                var o2 = ee(e3.node, "mirror", t2.mirror), i2 = ee(e3.node, "once", t2.once), a2 = ee(e3.node, "id"),
                    r2 = t2.useClassNames && e3.node.getAttribute("data-aos"),
                    c2 = [t2.animatedClassName].concat(r2 ? r2.split(" ") : []).filter(function (e4) {
                        return typeof e4 == "string"
                    });
                t2.initClassName && e3.node.classList.add(t2.initClassName), e3.position = {
                    in: function (e4, t3, n3) {
                        var o3 = window.innerHeight, i3 = ee(e4, "anchor"), a3 = ee(e4, "anchor-placement"),
                            r3 = Number(ee(e4, "offset", a3 ? 0 : t3)), c3 = a3 || n3, s2 = e4;
                        i3 && document.querySelectorAll(i3) && (s2 = document.querySelectorAll(i3)[0]);
                        var u2 = Z(s2).top - o3;
                        switch (c3) {
                            case"top-bottom":
                                break;
                            case"center-bottom":
                                u2 += s2.offsetHeight / 2;
                                break;
                            case"bottom-bottom":
                                u2 += s2.offsetHeight;
                                break;
                            case"top-center":
                                u2 += o3 / 2;
                                break;
                            case"center-center":
                                u2 += o3 / 2 + s2.offsetHeight / 2;
                                break;
                            case"bottom-center":
                                u2 += o3 / 2 + s2.offsetHeight;
                                break;
                            case"top-top":
                                u2 += o3;
                                break;
                            case"bottom-top":
                                u2 += o3 + s2.offsetHeight;
                                break;
                            case"center-top":
                                u2 += o3 + s2.offsetHeight / 2
                        }
                        return u2 + r3
                    }(e3.node, t2.offset, t2.anchorPlacement), out: o2 && function (e4, t3) {
                        window.innerHeight;
                        var n3 = ee(e4, "anchor"), o3 = ee(e4, "offset", t3), i3 = e4;
                        return n3 && document.querySelectorAll(n3) && (i3 = document.querySelectorAll(n3)[0]), Z(i3).top + i3.offsetHeight - o3
                    }(e3.node, t2.offset)
                }, e3.options = {once: i2, mirror: o2, animatedClassNames: c2, id: a2}
            }), e2
        }, ne = function () {
            var e2 = document.querySelectorAll("[data-aos]");
            return Array.prototype.map.call(e2, function (e3) {
                return {node: e3}
            })
        }, oe = [], ie = !1, ae = {
            offset: 120,
            delay: 0,
            easing: "ease",
            duration: 400,
            disable: !1,
            once: !1,
            mirror: !1,
            anchorPlacement: "top-bottom",
            startEvent: "DOMContentLoaded",
            animatedClassName: "aos-animate",
            initClassName: "aos-init",
            useClassNames: !1,
            disableMutationObserver: !1,
            throttleDelay: 99,
            debounceDelay: 50
        }, re = function () {
            return document.all && !window.atob
        }, ce = function () {
            arguments.length > 0 && arguments[0] !== void 0 && arguments[0] && (ie = !0), ie && (oe = te(oe, ae), X(oe), window.addEventListener("scroll", y(function () {
                X(oe, ae.once)
            }, ae.throttleDelay)))
        }, se = function () {
            if (oe = ne(), de(ae.disable) || re()) return ue();
            ce()
        }, ue = function () {
            oe.forEach(function (e2, t2) {
                e2.node.removeAttribute("data-aos"), e2.node.removeAttribute("data-aos-easing"), e2.node.removeAttribute("data-aos-duration"), e2.node.removeAttribute("data-aos-delay"), ae.initClassName && e2.node.classList.remove(ae.initClassName), ae.animatedClassName && e2.node.classList.remove(ae.animatedClassName)
            })
        }, de = function (e2) {
            return e2 === !0 || e2 === "mobile" && U.mobile() || e2 === "phone" && U.phone() || e2 === "tablet" && U.tablet() || typeof e2 == "function" && e2() === !0
        };
        return {
            init: function (e2) {
                return ae = I(ae, e2), oe = ne(), ae.disableMutationObserver || _2.isSupported() || (console.info(`
      aos: MutationObserver is not supported on this browser,
      code mutations observing has been disabled.
      You may have to call "refreshHard()" by yourself.
    `), ae.disableMutationObserver = !0), ae.disableMutationObserver || _2.ready("[data-aos]", se), de(ae.disable) || re() ? ue() : (document.querySelector("body").setAttribute("data-aos-easing", ae.easing), document.querySelector("body").setAttribute("data-aos-duration", ae.duration), document.querySelector("body").setAttribute("data-aos-delay", ae.delay), ["DOMContentLoaded", "load"].indexOf(ae.startEvent) === -1 ? document.addEventListener(ae.startEvent, function () {
                    ce(!0)
                }) : window.addEventListener("load", function () {
                    ce(!0)
                }), ae.startEvent === "DOMContentLoaded" && ["complete", "interactive"].indexOf(document.readyState) > -1 && ce(!0), window.addEventListener("resize", $(ce, ae.debounceDelay, !0)), window.addEventListener("orientationchange", $(ce, ae.debounceDelay, !0)), oe)
            }, refresh: ce, refreshHard: se
        }
    })
}(), function () {/*!
 * simpleParallax.min - simpleParallax is a simple JavaScript library that gives your website parallax animations on any images or videos,
 * @date: 20-08-2020 14:0:14,
 * @version: 5.6.2,
 * @link: https://simpleparallax.com/
 */
    (function (t, e) {
        typeof exports == "object" && typeof module == "object" ? module.exports = e() : typeof define == "function" && define.amd ? define("simpleParallax", [], e) : typeof exports == "object" ? exports.simpleParallax = e() : t.simpleParallax = e()
    })(window, function () {
        return function (t) {
            var e = {};

            function n(i) {
                if (e[i]) return e[i].exports;
                var r = e[i] = {i, l: !1, exports: {}};
                return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports
            }

            return n.m = t, n.c = e, n.d = function (t2, e2, i) {
                n.o(t2, e2) || Object.defineProperty(t2, e2, {enumerable: !0, get: i})
            }, n.r = function (t2) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(t2, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(t2, "__esModule", {value: !0})
            }, n.t = function (t2, e2) {
                if (1 & e2 && (t2 = n(t2)), 8 & e2 || 4 & e2 && typeof t2 == "object" && t2 && t2.__esModule) return t2;
                var i = Object.create(null);
                if (n.r(i), Object.defineProperty(i, "default", {
                    enumerable: !0,
                    value: t2
                }), 2 & e2 && typeof t2 != "string") for (var r in t2) n.d(i, r, function (e3) {
                    return t2[e3]
                }.bind(null, r));
                return i
            }, n.n = function (t2) {
                var e2 = t2 && t2.__esModule ? function () {
                    return t2.default
                } : function () {
                    return t2
                };
                return n.d(e2, "a", e2), e2
            }, n.o = function (t2, e2) {
                return Object.prototype.hasOwnProperty.call(t2, e2)
            }, n.p = "", n(n.s = 0)
        }([function (t, e, n) {
            "use strict";
            n.r(e), n.d(e, "default", function () {
                return x
            });
            var i = function () {
                return Element.prototype.closest && "IntersectionObserver" in window
            };

            function r(t2, e2) {
                for (var n2 = 0; n2 < e2.length; n2++) {
                    var i2 = e2[n2];
                    i2.enumerable = i2.enumerable || !1, i2.configurable = !0, "value" in i2 && (i2.writable = !0), Object.defineProperty(t2, i2.key, i2)
                }
            }

            var s = new (function () {
                function t2() {
                    (function (t3, e3) {
                        if (!(t3 instanceof e3)) throw new TypeError("Cannot call a class as a function")
                    })(this, t2), this.positions = {top: 0, bottom: 0, height: 0}
                }

                var e2, n2, i2;
                return e2 = t2, (n2 = [{
                    key: "setViewportTop", value: function (t3) {
                        return this.positions.top = t3 ? t3.scrollTop : window.pageYOffset, this.positions
                    }
                }, {
                    key: "setViewportBottom", value: function () {
                        return this.positions.bottom = this.positions.top + this.positions.height, this.positions
                    }
                }, {
                    key: "setViewportAll", value: function (t3) {
                        return this.positions.top = t3 ? t3.scrollTop : window.pageYOffset, this.positions.height = t3 ? t3.clientHeight : document.documentElement.clientHeight, this.positions.bottom = this.positions.top + this.positions.height, this.positions
                    }
                }]) && r(e2.prototype, n2), i2 && r(e2, i2), t2
            }()), o = function (t2) {
                return NodeList.prototype.isPrototypeOf(t2) || HTMLCollection.prototype.isPrototypeOf(t2) ? Array.from(t2) : typeof t2 == "string" || t2 instanceof String ? document.querySelectorAll(t2) : [t2]
            }, a = function () {
                for (var t2, e2 = "transform webkitTransform mozTransform oTransform msTransform".split(" "), n2 = 0; t2 === void 0;) t2 = document.createElement("div").style[e2[n2]] !== void 0 ? e2[n2] : void 0, n2 += 1;
                return t2
            }(), l = function (t2) {
                return t2.tagName.toLowerCase() !== "img" && t2.tagName.toLowerCase() !== "picture" || !!t2 && !!t2.complete && (t2.naturalWidth === void 0 || t2.naturalWidth !== 0)
            };

            function u(t2) {
                return function (t3) {
                    if (Array.isArray(t3)) return c(t3)
                }(t2) || function (t3) {
                    if (typeof Symbol < "u" && Symbol.iterator in Object(t3)) return Array.from(t3)
                }(t2) || function (t3, e2) {
                    if (t3) {
                        if (typeof t3 == "string") return c(t3, e2);
                        var n2 = Object.prototype.toString.call(t3).slice(8, -1);
                        if (n2 === "Object" && t3.constructor && (n2 = t3.constructor.name), n2 === "Map" || n2 === "Set") return Array.from(t3);
                        if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return c(t3, e2)
                    }
                }(t2) || function () {
                    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)
                }()
            }

            function c(t2, e2) {
                (e2 == null || e2 > t2.length) && (e2 = t2.length);
                for (var n2 = 0, i2 = new Array(e2); n2 < e2; n2++) i2[n2] = t2[n2];
                return i2
            }

            function h(t2, e2) {
                for (var n2 = 0; n2 < e2.length; n2++) {
                    var i2 = e2[n2];
                    i2.enumerable = i2.enumerable || !1, i2.configurable = !0, "value" in i2 && (i2.writable = !0), Object.defineProperty(t2, i2.key, i2)
                }
            }

            var f = function () {
                function t2(e3, n3) {
                    var i3 = this;
                    (function (t3, e4) {
                        if (!(t3 instanceof e4)) throw new TypeError("Cannot call a class as a function")
                    })(this, t2), this.element = e3, this.elementContainer = e3, this.settings = n3, this.isVisible = !0, this.isInit = !1, this.oldTranslateValue = -1, this.init = this.init.bind(this), this.customWrapper = this.settings.customWrapper && this.element.closest(this.settings.customWrapper) ? this.element.closest(this.settings.customWrapper) : null, l(e3) ? this.init() : this.element.addEventListener("load", function () {
                        setTimeout(function () {
                            i3.init(!0)
                        }, 50)
                    })
                }

                var e2, n2, i2;
                return e2 = t2, (n2 = [{
                    key: "init", value: function (t3) {
                        var e3 = this;
                        this.isInit || (t3 && (this.rangeMax = null), this.element.closest(".simpleParallax") || (this.settings.overflow === !1 && this.wrapElement(this.element), this.setTransformCSS(), this.getElementOffset(), this.intersectionObserver(), this.getTranslateValue(), this.animate(), this.settings.delay > 0 ? setTimeout(function () {
                            e3.setTransitionCSS(), e3.elementContainer.classList.add("simple-parallax-initialized")
                        }, 10) : this.elementContainer.classList.add("simple-parallax-initialized"), this.isInit = !0))
                    }
                }, {
                    key: "wrapElement", value: function () {
                        var t3 = this.element.closest("picture") || this.element,
                            e3 = this.customWrapper || document.createElement("div");
                        e3.classList.add("simpleParallax"), e3.style.overflow = "hidden", this.customWrapper || (t3.parentNode.insertBefore(e3, t3), e3.appendChild(t3)), this.elementContainer = e3
                    }
                }, {
                    key: "unWrapElement", value: function () {
                        var t3 = this.elementContainer;
                        this.customWrapper ? (t3.classList.remove("simpleParallax"), t3.style.overflow = "") : t3.replaceWith.apply(t3, u(t3.childNodes))
                    }
                }, {
                    key: "setTransformCSS", value: function () {
                        this.settings.overflow === !1 && (this.element.style[a] = "scale(".concat(this.settings.scale, ")")), this.element.style.willChange = "transform"
                    }
                }, {
                    key: "setTransitionCSS", value: function () {
                        this.element.style.transition = "transform ".concat(this.settings.delay, "s ").concat(this.settings.transition)
                    }
                }, {
                    key: "unSetStyle", value: function () {
                        this.element.style.willChange = "", this.element.style[a] = "", this.element.style.transition = ""
                    }
                }, {
                    key: "getElementOffset", value: function () {
                        var t3 = this.elementContainer.getBoundingClientRect();
                        if (this.elementHeight = t3.height, this.elementTop = t3.top + s.positions.top, this.settings.customContainer) {
                            var e3 = this.settings.customContainer.getBoundingClientRect();
                            this.elementTop = t3.top - e3.top + s.positions.top
                        }
                        this.elementBottom = this.elementHeight + this.elementTop
                    }
                }, {
                    key: "buildThresholdList", value: function () {
                        for (var t3 = [], e3 = 1; e3 <= this.elementHeight; e3++) {
                            var n3 = e3 / this.elementHeight;
                            t3.push(n3)
                        }
                        return t3
                    }
                }, {
                    key: "intersectionObserver", value: function () {
                        var t3 = {root: null, threshold: this.buildThresholdList()};
                        this.observer = new IntersectionObserver(this.intersectionObserverCallback.bind(this), t3), this.observer.observe(this.element)
                    }
                }, {
                    key: "intersectionObserverCallback", value: function (t3) {
                        var e3 = this;
                        t3.forEach(function (t4) {
                            t4.isIntersecting ? e3.isVisible = !0 : e3.isVisible = !1
                        })
                    }
                }, {
                    key: "checkIfVisible", value: function () {
                        return this.elementBottom > s.positions.top && this.elementTop < s.positions.bottom
                    }
                }, {
                    key: "getRangeMax", value: function () {
                        var t3 = this.element.clientHeight;
                        this.rangeMax = t3 * this.settings.scale - t3
                    }
                }, {
                    key: "getTranslateValue", value: function () {
                        var t3 = ((s.positions.bottom - this.elementTop) / ((s.positions.height + this.elementHeight) / 100)).toFixed(1);
                        return t3 = Math.min(100, Math.max(0, t3)), this.settings.maxTransition !== 0 && t3 > this.settings.maxTransition && (t3 = this.settings.maxTransition), this.oldPercentage !== t3 && (this.rangeMax || this.getRangeMax(), this.translateValue = (t3 / 100 * this.rangeMax - this.rangeMax / 2).toFixed(0), this.oldTranslateValue !== this.translateValue && (this.oldPercentage = t3, this.oldTranslateValue = this.translateValue, !0))
                    }
                }, {
                    key: "animate", value: function () {
                        var t3, e3 = 0, n3 = 0;
                        (this.settings.orientation.includes("left") || this.settings.orientation.includes("right")) && (n3 = "".concat(this.settings.orientation.includes("left") ? -1 * this.translateValue : this.translateValue, "px")), (this.settings.orientation.includes("up") || this.settings.orientation.includes("down")) && (e3 = "".concat(this.settings.orientation.includes("up") ? -1 * this.translateValue : this.translateValue, "px")), t3 = this.settings.overflow === !1 ? "translate3d(".concat(n3, ", ").concat(e3, ", 0) scale(").concat(this.settings.scale, ")") : "translate3d(".concat(n3, ", ").concat(e3, ", 0)"), this.element.style[a] = t3
                    }
                }]) && h(e2.prototype, n2), i2 && h(e2, i2), t2
            }();

            function m(t2) {
                return function (t3) {
                    if (Array.isArray(t3)) return y(t3)
                }(t2) || function (t3) {
                    if (typeof Symbol < "u" && Symbol.iterator in Object(t3)) return Array.from(t3)
                }(t2) || d(t2) || function () {
                    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)
                }()
            }

            function p(t2, e2) {
                return function (t3) {
                    if (Array.isArray(t3)) return t3
                }(t2) || function (t3, e3) {
                    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t3)))) {
                        var n2 = [], i2 = !0, r2 = !1, s2 = void 0;
                        try {
                            for (var o2, a2 = t3[Symbol.iterator](); !(i2 = (o2 = a2.next()).done) && (n2.push(o2.value), !e3 || n2.length !== e3); i2 = !0) ;
                        } catch (t4) {
                            r2 = !0, s2 = t4
                        } finally {
                            try {
                                i2 || a2.return == null || a2.return()
                            } finally {
                                if (r2) throw s2
                            }
                        }
                        return n2
                    }
                }(t2, e2) || d(t2, e2) || function () {
                    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)
                }()
            }

            function d(t2, e2) {
                if (t2) {
                    if (typeof t2 == "string") return y(t2, e2);
                    var n2 = Object.prototype.toString.call(t2).slice(8, -1);
                    return n2 === "Object" && t2.constructor && (n2 = t2.constructor.name), n2 === "Map" || n2 === "Set" ? Array.from(t2) : n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2) ? y(t2, e2) : void 0
                }
            }

            function y(t2, e2) {
                (e2 == null || e2 > t2.length) && (e2 = t2.length);
                for (var n2 = 0, i2 = new Array(e2); n2 < e2; n2++) i2[n2] = t2[n2];
                return i2
            }

            function v(t2, e2) {
                for (var n2 = 0; n2 < e2.length; n2++) {
                    var i2 = e2[n2];
                    i2.enumerable = i2.enumerable || !1, i2.configurable = !0, "value" in i2 && (i2.writable = !0), Object.defineProperty(t2, i2.key, i2)
                }
            }

            var g, b, w = !1, T = [], x = function () {
                function t2(e3, n3) {
                    if (function (t3, e4) {
                        if (!(t3 instanceof e4)) throw new TypeError("Cannot call a class as a function")
                    }(this, t2), e3 && i()) {
                        if (this.elements = o(e3), this.defaults = {
                            delay: 0,
                            orientation: "up",
                            scale: 1.3,
                            overflow: !1,
                            transition: "cubic-bezier(0,0,0,1)",
                            customContainer: "",
                            customWrapper: "",
                            maxTransition: 0
                        }, this.settings = Object.assign(this.defaults, n3), this.settings.customContainer) {
                            var r3 = p(o(this.settings.customContainer), 1);
                            this.customContainer = r3[0]
                        }
                        this.lastPosition = -1, this.resizeIsDone = this.resizeIsDone.bind(this), this.refresh = this.refresh.bind(this), this.proceedRequestAnimationFrame = this.proceedRequestAnimationFrame.bind(this), this.init()
                    }
                }

                var e2, n2, r2;
                return e2 = t2, (n2 = [{
                    key: "init", value: function () {
                        var t3 = this;
                        s.setViewportAll(this.customContainer), T = [].concat(m(this.elements.map(function (e3) {
                            return new f(e3, t3.settings)
                        })), m(T)), w || (this.proceedRequestAnimationFrame(), window.addEventListener("resize", this.resizeIsDone), w = !0)
                    }
                }, {
                    key: "resizeIsDone", value: function () {
                        clearTimeout(b), b = setTimeout(this.refresh, 200)
                    }
                }, {
                    key: "proceedRequestAnimationFrame", value: function () {
                        var t3 = this;
                        s.setViewportTop(this.customContainer), this.lastPosition !== s.positions.top ? (s.setViewportBottom(), T.forEach(function (e3) {
                            t3.proceedElement(e3)
                        }), g = window.requestAnimationFrame(this.proceedRequestAnimationFrame), this.lastPosition = s.positions.top) : g = window.requestAnimationFrame(this.proceedRequestAnimationFrame)
                    }
                }, {
                    key: "proceedElement", value: function (t3) {
                        (this.customContainer ? t3.checkIfVisible() : t3.isVisible) && t3.getTranslateValue() && t3.animate()
                    }
                }, {
                    key: "refresh", value: function () {
                        s.setViewportAll(this.customContainer), T.forEach(function (t3) {
                            t3.getElementOffset(), t3.getRangeMax()
                        }), this.lastPosition = -1
                    }
                }, {
                    key: "destroy", value: function () {
                        var t3 = this, e3 = [];
                        T = T.filter(function (n3) {
                            return t3.elements.includes(n3.element) ? (e3.push(n3), !1) : n3
                        }), e3.forEach(function (e4) {
                            e4.unSetStyle(), t3.settings.overflow === !1 && e4.unWrapElement()
                        }), T.length || (window.cancelAnimationFrame(g), window.removeEventListener("resize", this.refresh), w = !1)
                    }
                }]) && v(e2.prototype, n2), r2 && v(e2, r2), t2
            }()
        }]).default
    })
}(), function () {/*!
 * Infinite Scroll PACKAGED v4.0.1
 * Automatically add next page
 *
 * Licensed GPLv3 for open source use
 * or Infinite Scroll Commercial License for commercial use
 *
 * https://infinite-scroll.com
 * Copyright 2018-2020 Metafizzy
 */
    (function (t, e) {
        typeof module == "object" && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery)
    })(window, function (t, e) {
        let i = t.console, n = i === void 0 ? function () {
        } : function (t2) {
            i.error(t2)
        };
        return function (i2, o, s) {
            (s = s || e || t.jQuery) && (o.prototype.option || (o.prototype.option = function (t2) {
                t2 && (this.options = Object.assign(this.options || {}, t2))
            }), s.fn[i2] = function (t2, ...e2) {
                return typeof t2 == "string" ? function (t3, e3, o2) {
                    let r2, l = `$().${i2}("${e3}")`;
                    return t3.each(function (t4, h) {
                        let a = s.data(h, i2);
                        if (!a) return void n(`${i2} not initialized. Cannot call method ${l}`);
                        let c = a[e3];
                        if (!c || e3.charAt(0) == "_") return void n(`${l} is not a valid method`);
                        let u = c.apply(a, o2);
                        r2 = r2 === void 0 ? u : r2
                    }), r2 !== void 0 ? r2 : t3
                }(this, t2, e2) : (r = t2, this.each(function (t3, e3) {
                    let n2 = s.data(e3, i2);
                    n2 ? (n2.option(r), n2._init()) : (n2 = new o(e3, r), s.data(e3, i2, n2))
                }), this);
                var r
            })
        }
    }), function (t, e) {
        typeof module == "object" && module.exports ? module.exports = e() : t.EvEmitter = e()
    }(typeof window < "u" ? window : this, function () {
        function t() {
        }

        let e = t.prototype;
        return e.on = function (t2, e2) {
            if (!t2 || !e2) return this;
            let i = this._events = this._events || {}, n = i[t2] = i[t2] || [];
            return n.includes(e2) || n.push(e2), this
        }, e.once = function (t2, e2) {
            if (!t2 || !e2) return this;
            this.on(t2, e2);
            let i = this._onceEvents = this._onceEvents || {};
            return (i[t2] = i[t2] || {})[e2] = !0, this
        }, e.off = function (t2, e2) {
            let i = this._events && this._events[t2];
            if (!i || !i.length) return this;
            let n = i.indexOf(e2);
            return n != -1 && i.splice(n, 1), this
        }, e.emitEvent = function (t2, e2) {
            let i = this._events && this._events[t2];
            if (!i || !i.length) return this;
            i = i.slice(0), e2 = e2 || [];
            let n = this._onceEvents && this._onceEvents[t2];
            for (let o of i) n && n[o] && (this.off(t2, o), delete n[o]), o.apply(this, e2);
            return this
        }, e.allOff = function () {
            return delete this._events, delete this._onceEvents, this
        }, t
    }), function (t, e) {
        typeof module == "object" && module.exports ? module.exports = e(t) : t.fizzyUIUtils = e(t)
    }(this, function (t) {
        let e = {
            extend: function (t2, e2) {
                return Object.assign(t2, e2)
            }, modulo: function (t2, e2) {
                return (t2 % e2 + e2) % e2
            }, makeArray: function (t2) {
                return Array.isArray(t2) ? t2 : t2 == null ? [] : typeof t2 == "object" && typeof t2.length == "number" ? [...t2] : [t2]
            }, removeFrom: function (t2, e2) {
                let i2 = t2.indexOf(e2);
                i2 != -1 && t2.splice(i2, 1)
            }, getParent: function (t2, e2) {
                for (; t2.parentNode && t2 != document.body;) if ((t2 = t2.parentNode).matches(e2)) return t2
            }, getQueryElement: function (t2) {
                return typeof t2 == "string" ? document.querySelector(t2) : t2
            }, handleEvent: function (t2) {
                let e2 = "on" + t2.type;
                this[e2] && this[e2](t2)
            }, filterFindElements: function (t2, i2) {
                return (t2 = e.makeArray(t2)).filter(t3 => t3 instanceof HTMLElement).reduce((t3, e2) => {
                    if (!i2) return t3.push(e2), t3;
                    e2.matches(i2) && t3.push(e2);
                    let n = e2.querySelectorAll(i2);
                    return t3 = t3.concat(...n)
                }, [])
            }, debounceMethod: function (t2, e2, i2) {
                i2 = i2 || 100;
                let n = t2.prototype[e2], o = e2 + "Timeout";
                t2.prototype[e2] = function () {
                    clearTimeout(this[o]);
                    let t3 = arguments;
                    this[o] = setTimeout(() => {
                        n.apply(this, t3), delete this[o]
                    }, i2)
                }
            }, docReady: function (t2) {
                let e2 = document.readyState;
                e2 == "complete" || e2 == "interactive" ? setTimeout(t2) : document.addEventListener("DOMContentLoaded", t2)
            }, toDashed: function (t2) {
                return t2.replace(/(.)([A-Z])/g, function (t3, e2, i2) {
                    return e2 + "-" + i2
                }).toLowerCase()
            }
        }, i = t.console;
        return e.htmlInit = function (n, o) {
            e.docReady(function () {
                let s = "data-" + e.toDashed(o), r = document.querySelectorAll(`[${s}]`), l = t.jQuery;
                [...r].forEach(t2 => {
                    let e2, r2 = t2.getAttribute(s);
                    try {
                        e2 = r2 && JSON.parse(r2)
                    } catch (e3) {
                        return void (i && i.error(`Error parsing ${s} on ${t2.className}: ${e3}`))
                    }
                    let h = new n(t2, e2);
                    l && l.data(t2, o, h)
                })
            })
        }, e
    }), function (t, e) {
        typeof module == "object" && module.exports ? module.exports = e(t, require("ev-emitter"), require("fizzy-ui-utils")) : t.InfiniteScroll = e(t, t.EvEmitter, t.fizzyUIUtils)
    }(window, function (t, e, i) {
        let n = t.jQuery, o = {};

        function s(t2, e2) {
            let r2 = i.getQueryElement(t2);
            if (r2) {
                if ((t2 = r2).infiniteScrollGUID) {
                    let i2 = o[t2.infiniteScrollGUID];
                    return i2.option(e2), i2
                }
                this.element = t2, this.options = {...s.defaults}, this.option(e2), n && (this.$element = n(this.element)), this.create()
            } else console.error("Bad element for InfiniteScroll: " + (r2 || t2))
        }

        s.defaults = {}, s.create = {}, s.destroy = {};
        let r = s.prototype;
        Object.assign(r, e.prototype);
        let l = 0;
        r.create = function () {
            let t2 = this.guid = ++l;
            if (this.element.infiniteScrollGUID = t2, o[t2] = this, this.pageIndex = 1, this.loadCount = 0, this.updateGetPath(), this.getPath && this.getPath()) {
                this.updateGetAbsolutePath(), this.log("initialized", [this.element.className]), this.callOnInit();
                for (let t3 in s.create) s.create[t3].call(this)
            } else console.error("Disabling InfiniteScroll")
        }, r.option = function (t2) {
            Object.assign(this.options, t2)
        }, r.callOnInit = function () {
            let t2 = this.options.onInit;
            t2 && t2.call(this, this)
        }, r.dispatchEvent = function (t2, e2, i2) {
            this.log(t2, i2);
            let o2 = e2 ? [e2].concat(i2) : i2;
            if (this.emitEvent(t2, o2), !n || !this.$element) return;
            let s2 = t2 += ".infiniteScroll";
            if (e2) {
                let i3 = n.Event(e2);
                i3.type = t2, s2 = i3
            }
            this.$element.trigger(s2, i2)
        };
        let h = {
            initialized: t2 => `on ${t2}`,
            request: t2 => `URL: ${t2}`,
            load: (t2, e2) => `${t2.title || ""}. URL: ${e2}`,
            error: (t2, e2) => `${t2}. URL: ${e2}`,
            append: (t2, e2, i2) => `${i2.length} items. URL: ${e2}`,
            last: (t2, e2) => `URL: ${e2}`,
            history: (t2, e2) => `URL: ${e2}`,
            pageIndex: function (t2, e2) {
                return `current page determined to be: ${t2} from ${e2}`
            }
        };
        r.log = function (t2, e2) {
            if (!this.options.debug) return;
            let i2 = `[InfiniteScroll] ${t2}`, n2 = h[t2];
            n2 && (i2 += ". " + n2.apply(this, e2)), console.log(i2)
        }, r.updateMeasurements = function () {
            this.windowHeight = t.innerHeight;
            let e2 = this.element.getBoundingClientRect();
            this.top = e2.top + t.scrollY
        }, r.updateScroller = function () {
            let e2 = this.options.elementScroll;
            if (e2) {
                if (this.scroller = e2 === !0 ? this.element : i.getQueryElement(e2), !this.scroller) throw new Error(`Unable to find elementScroll: ${e2}`)
            } else this.scroller = t
        }, r.updateGetPath = function () {
            let t2 = this.options.path;
            if (!t2) return void console.error(`InfiniteScroll path option required. Set as: ${t2}`);
            let e2 = typeof t2;
            e2 != "function" ? e2 == "string" && t2.match("{{#}}") ? this.updateGetPathTemplate(t2) : this.updateGetPathSelector(t2) : this.getPath = t2
        }, r.updateGetPathTemplate = function (t2) {
            this.getPath = () => {
                let e3 = this.pageIndex + 1;
                return t2.replace("{{#}}", e3)
            };
            let e2 = t2.replace(/(\\\?|\?)/, "\\?").replace("{{#}}", "(\\d\\d?\\d?)"), i2 = new RegExp(e2),
                n2 = location.href.match(i2);
            n2 && (this.pageIndex = parseInt(n2[1], 10), this.log("pageIndex", [this.pageIndex, "template string"]))
        };
        let a = [/^(.*?\/?page\/?)(\d\d?\d?)(.*?$)/, /^(.*?\/?\?page=)(\d\d?\d?)(.*?$)/, /(.*?)(\d\d?\d?)(?!.*\d)(.*?$)/],
            c = s.getPathParts = function (t2) {
                if (t2) for (let e2 of a) {
                    let i2 = t2.match(e2);
                    if (i2) {
                        let [, t3, e3, n2] = i2;
                        return {begin: t3, index: e3, end: n2}
                    }
                }
            };
        r.updateGetPathSelector = function (t2) {
            let e2 = document.querySelector(t2);
            if (!e2) return void console.error(`Bad InfiniteScroll path option. Next link not found: ${t2}`);
            let i2 = e2.getAttribute("href"), n2 = c(i2);
            if (!n2) return void console.error(`InfiniteScroll unable to parse next link href: ${i2}`);
            let {begin: o2, index: s2, end: r2} = n2;
            this.isPathSelector = !0, this.getPath = () => o2 + (this.pageIndex + 1) + r2, this.pageIndex = parseInt(s2, 10) - 1, this.log("pageIndex", [this.pageIndex, "next link"])
        }, r.updateGetAbsolutePath = function () {
            let t2 = this.getPath();
            if (t2.match(/^http/) || t2.match(/^\//)) return void (this.getAbsolutePath = this.getPath);
            let {pathname: e2} = location, i2 = t2.match(/^\?/), n2 = e2.substring(0, e2.lastIndexOf("/")),
                o2 = i2 ? e2 : n2 + "/";
            this.getAbsolutePath = () => o2 + this.getPath()
        }, s.create.hideNav = function () {
            let t2 = i.getQueryElement(this.options.hideNav);
            t2 && (t2.style.display = "none", this.nav = t2)
        }, s.destroy.hideNav = function () {
            this.nav && (this.nav.style.display = "")
        }, r.destroy = function () {
            this.allOff();
            for (let t2 in s.destroy) s.destroy[t2].call(this);
            delete this.element.infiniteScrollGUID, delete o[this.guid], n && this.$element && n.removeData(this.element, "infiniteScroll")
        }, s.throttle = function (t2, e2) {
            let i2, n2;
            return e2 = e2 || 200, function () {
                let o2 = +new Date, s2 = arguments, r2 = () => {
                    i2 = o2, t2.apply(this, s2)
                };
                i2 && o2 < i2 + e2 ? (clearTimeout(n2), n2 = setTimeout(r2, e2)) : r2()
            }
        }, s.data = function (t2) {
            let e2 = (t2 = i.getQueryElement(t2)) && t2.infiniteScrollGUID;
            return e2 && o[e2]
        }, s.setJQuery = function (t2) {
            n = t2
        }, i.htmlInit(s, "infinite-scroll"), r._init = function () {
        };
        let {jQueryBridget: u} = t;
        return n && u && u("infiniteScroll", s, n), s
    }), function (t, e) {
        typeof module == "object" && module.exports ? module.exports = e(t, require("./core")) : e(t, t.InfiniteScroll)
    }(window, function (t, e) {
        let i = e.prototype;
        Object.assign(e.defaults, {
            loadOnScroll: !0,
            checkLastPage: !0,
            responseBody: "text",
            domParseResponse: !0
        }), e.create.pageLoad = function () {
            this.canLoad = !0, this.on("scrollThreshold", this.onScrollThresholdLoad), this.on("load", this.checkLastPage), this.options.outlayer && this.on("append", this.onAppendOutlayer)
        }, i.onScrollThresholdLoad = function () {
            this.options.loadOnScroll && this.loadNextPage()
        };
        let n = new DOMParser;

        function o(t2) {
            let e2 = document.createDocumentFragment();
            return t2 && e2.append(...t2), e2
        }

        return i.loadNextPage = function () {
            if (this.isLoading || !this.canLoad) return;
            let {responseBody: t2, domParseResponse: e2, fetchOptions: i2} = this.options, o2 = this.getAbsolutePath();
            this.isLoading = !0, typeof i2 == "function" && (i2 = i2());
            let s = fetch(o2, i2).then(i3 => {
                if (!i3.ok) {
                    let t3 = new Error(i3.statusText);
                    return this.onPageError(t3, o2, i3), {response: i3}
                }
                return i3[t2]().then(s2 => (t2 == "text" && e2 && (s2 = n.parseFromString(s2, "text/html")), i3.status == 204 ? (this.lastPageReached(s2, o2), {
                    body: s2,
                    response: i3
                }) : this.onPageLoad(s2, o2, i3)))
            }).catch(t3 => {
                this.onPageError(t3, o2)
            });
            return this.dispatchEvent("request", null, [o2, s]), s
        }, i.onPageLoad = function (t2, e2, i2) {
            return this.options.append || (this.isLoading = !1), this.pageIndex++, this.loadCount++, this.dispatchEvent("load", null, [t2, e2, i2]), this.appendNextPage(t2, e2, i2)
        }, i.appendNextPage = function (t2, e2, i2) {
            let {append: n2, responseBody: s, domParseResponse: r} = this.options;
            if (!(s == "text" && r) || !n2) return {body: t2, response: i2};
            let l = t2.querySelectorAll(n2), h = {body: t2, response: i2, items: l};
            if (!l || !l.length) return this.lastPageReached(t2, e2), h;
            let a = o(l),
                c = () => (this.appendItems(l, a), this.isLoading = !1, this.dispatchEvent("append", null, [t2, e2, l, i2]), h);
            return this.options.outlayer ? this.appendOutlayerItems(a, c) : c()
        }, i.appendItems = function (t2, e2) {
            t2 && t2.length && (function (t3) {
                let e3 = t3.querySelectorAll("script");
                for (let t4 of e3) {
                    let e4 = document.createElement("script"), i2 = t4.attributes;
                    for (let t5 of i2) e4.setAttribute(t5.name, t5.value);
                    e4.innerHTML = t4.innerHTML, t4.parentNode.replaceChild(e4, t4)
                }
            }(e2 = e2 || o(t2)), this.element.appendChild(e2))
        }, i.appendOutlayerItems = function (i2, n2) {
            let o2 = e.imagesLoaded || t.imagesLoaded;
            return o2 ? new Promise(function (t2) {
                o2(i2, function () {
                    let e2 = n2();
                    t2(e2)
                })
            }) : (console.error("[InfiniteScroll] imagesLoaded required for outlayer option"), void (this.isLoading = !1))
        }, i.onAppendOutlayer = function (t2, e2, i2) {
            this.options.outlayer.appended(i2)
        }, i.checkLastPage = function (t2, e2) {
            let i2, {checkLastPage: n2, path: o2} = this.options;
            if (n2) {
                if (typeof o2 == "function" && !this.getPath()) return void this.lastPageReached(t2, e2);
                typeof n2 == "string" ? i2 = n2 : this.isPathSelector && (i2 = o2), i2 && t2.querySelector && (t2.querySelector(i2) || this.lastPageReached(t2, e2))
            }
        }, i.lastPageReached = function (t2, e2) {
            this.canLoad = !1, this.dispatchEvent("last", null, [t2, e2])
        }, i.onPageError = function (t2, e2, i2) {
            return this.isLoading = !1, this.canLoad = !1, this.dispatchEvent("error", null, [t2, e2, i2]), t2
        }, e.create.prefill = function () {
            if (!this.options.prefill) return;
            let t2 = this.options.append;
            t2 ? (this.updateMeasurements(), this.updateScroller(), this.isPrefilling = !0, this.on("append", this.prefill), this.once("error", this.stopPrefill), this.once("last", this.stopPrefill), this.prefill()) : console.error(`append option required for prefill. Set as :${t2}`)
        }, i.prefill = function () {
            let t2 = this.getPrefillDistance();
            this.isPrefilling = t2 >= 0, this.isPrefilling ? (this.log("prefill"), this.loadNextPage()) : this.stopPrefill()
        }, i.getPrefillDistance = function () {
            return this.options.elementScroll ? this.scroller.clientHeight - this.scroller.scrollHeight : this.windowHeight - this.element.clientHeight
        }, i.stopPrefill = function () {
            this.log("stopPrefill"), this.off("append", this.prefill)
        }, e
    }), function (t, e) {
        typeof module == "object" && module.exports ? module.exports = e(t, require("./core"), require("fizzy-ui-utils")) : e(t, t.InfiniteScroll, t.fizzyUIUtils)
    }(window, function (t, e, i) {
        let n = e.prototype;
        return Object.assign(e.defaults, {scrollThreshold: 400}), e.create.scrollWatch = function () {
            this.pageScrollHandler = this.onPageScroll.bind(this), this.resizeHandler = this.onResize.bind(this);
            let t2 = this.options.scrollThreshold;
            (t2 || t2 === 0) && this.enableScrollWatch()
        }, e.destroy.scrollWatch = function () {
            this.disableScrollWatch()
        }, n.enableScrollWatch = function () {
            this.isScrollWatching || (this.isScrollWatching = !0, this.updateMeasurements(), this.updateScroller(), this.on("last", this.disableScrollWatch), this.bindScrollWatchEvents(!0))
        }, n.disableScrollWatch = function () {
            this.isScrollWatching && (this.bindScrollWatchEvents(!1), delete this.isScrollWatching)
        }, n.bindScrollWatchEvents = function (e2) {
            let i2 = e2 ? "addEventListener" : "removeEventListener";
            this.scroller[i2]("scroll", this.pageScrollHandler), t[i2]("resize", this.resizeHandler)
        }, n.onPageScroll = e.throttle(function () {
            this.getBottomDistance() <= this.options.scrollThreshold && this.dispatchEvent("scrollThreshold")
        }), n.getBottomDistance = function () {
            let e2, i2;
            return this.options.elementScroll ? (e2 = this.scroller.scrollHeight, i2 = this.scroller.scrollTop + this.scroller.clientHeight) : (e2 = this.top + this.element.clientHeight, i2 = t.scrollY + this.windowHeight), e2 - i2
        }, n.onResize = function () {
            this.updateMeasurements()
        }, i.debounceMethod(e, "onResize", 150), e
    }), function (t, e) {
        typeof module == "object" && module.exports ? module.exports = e(t, require("./core"), require("fizzy-ui-utils")) : e(t, t.InfiniteScroll, t.fizzyUIUtils)
    }(window, function (t, e, i) {
        let n = e.prototype;
        Object.assign(e.defaults, {history: "replace"});
        let o = document.createElement("a");
        return e.create.history = function () {
            this.options.history && (o.href = this.getAbsolutePath(), (o.origin || o.protocol + "//" + o.host) == location.origin ? this.options.append ? this.createHistoryAppend() : this.createHistoryPageLoad() : console.error(`[InfiniteScroll] cannot set history with different origin: ${o.origin} on ${location.origin} . History behavior disabled.`))
        }, n.createHistoryAppend = function () {
            this.updateMeasurements(), this.updateScroller(), this.scrollPages = [{
                top: 0,
                path: location.href,
                title: document.title
            }], this.scrollPage = this.scrollPages[0], this.scrollHistoryHandler = this.onScrollHistory.bind(this), this.unloadHandler = this.onUnload.bind(this), this.scroller.addEventListener("scroll", this.scrollHistoryHandler), this.on("append", this.onAppendHistory), this.bindHistoryAppendEvents(!0)
        }, n.bindHistoryAppendEvents = function (e2) {
            let i2 = e2 ? "addEventListener" : "removeEventListener";
            this.scroller[i2]("scroll", this.scrollHistoryHandler), t[i2]("unload", this.unloadHandler)
        }, n.createHistoryPageLoad = function () {
            this.on("load", this.onPageLoadHistory)
        }, e.destroy.history = n.destroyHistory = function () {
            this.options.history && this.options.append && this.bindHistoryAppendEvents(!1)
        }, n.onAppendHistory = function (t2, e2, i2) {
            if (!i2 || !i2.length) return;
            let n2 = i2[0], s = this.getElementScrollY(n2);
            o.href = e2, this.scrollPages.push({top: s, path: o.href, title: t2.title})
        }, n.getElementScrollY = function (e2) {
            return this.options.elementScroll ? e2.offsetTop - this.top : e2.getBoundingClientRect().top + t.scrollY
        }, n.onScrollHistory = function () {
            let t2 = this.getClosestScrollPage();
            t2 != this.scrollPage && (this.scrollPage = t2, this.setHistory(t2.title, t2.path))
        }, i.debounceMethod(e, "onScrollHistory", 150), n.getClosestScrollPage = function () {
            let e2, i2;
            e2 = this.options.elementScroll ? this.scroller.scrollTop + this.scroller.clientHeight / 2 : t.scrollY + this.windowHeight / 2;
            for (let t2 of this.scrollPages) {
                if (t2.top >= e2) break;
                i2 = t2
            }
            return i2
        }, n.setHistory = function (t2, e2) {
            let i2 = this.options.history;
            i2 && history[i2 + "State"] && (history[i2 + "State"](null, t2, e2), this.options.historyTitle && (document.title = t2), this.dispatchEvent("history", null, [t2, e2]))
        }, n.onUnload = function () {
            if (this.scrollPage.top === 0) return;
            let e2 = t.scrollY - this.scrollPage.top + this.top;
            this.destroyHistory(), scrollTo(0, e2)
        }, n.onPageLoadHistory = function (t2, e2) {
            this.setHistory(t2.title, e2)
        }, e
    }), function (t, e) {
        typeof module == "object" && module.exports ? module.exports = e(t, require("./core"), require("fizzy-ui-utils")) : e(t, t.InfiniteScroll, t.fizzyUIUtils)
    }(window, function (t, e, i) {
        class n {
            constructor(t2, e2) {
                this.element = t2, this.infScroll = e2, this.clickHandler = this.onClick.bind(this), this.element.addEventListener("click", this.clickHandler), e2.on("request", this.disable.bind(this)), e2.on("load", this.enable.bind(this)), e2.on("error", this.hide.bind(this)), e2.on("last", this.hide.bind(this))
            }

            onClick(t2) {
                t2.preventDefault(), this.infScroll.loadNextPage()
            }

            enable() {
                this.element.removeAttribute("disabled")
            }

            disable() {
                this.element.disabled = "disabled"
            }

            hide() {
                this.element.style.display = "none"
            }

            destroy() {
                this.element.removeEventListener("click", this.clickHandler)
            }
        }

        return e.create.button = function () {
            let t2 = i.getQueryElement(this.options.button);
            t2 && (this.button = new n(t2, this))
        }, e.destroy.button = function () {
            this.button && this.button.destroy()
        }, e.Button = n, e
    }), function (t, e) {
        typeof module == "object" && module.exports ? module.exports = e(t, require("./core"), require("fizzy-ui-utils")) : e(t, t.InfiniteScroll, t.fizzyUIUtils)
    }(window, function (t, e, i) {
        let n = e.prototype;

        function o(t2) {
            r(t2, "none")
        }

        function s(t2) {
            r(t2, "block")
        }

        function r(t2, e2) {
            t2 && (t2.style.display = e2)
        }

        return e.create.status = function () {
            let t2 = i.getQueryElement(this.options.status);
            t2 && (this.statusElement = t2, this.statusEventElements = {
                request: t2.querySelector(".infinite-scroll-request"),
                error: t2.querySelector(".infinite-scroll-error"),
                last: t2.querySelector(".infinite-scroll-last")
            }, this.on("request", this.showRequestStatus), this.on("error", this.showErrorStatus), this.on("last", this.showLastStatus), this.bindHideStatus("on"))
        }, n.bindHideStatus = function (t2) {
            let e2 = this.options.append ? "append" : "load";
            this[t2](e2, this.hideAllStatus)
        }, n.showRequestStatus = function () {
            this.showStatus("request")
        }, n.showErrorStatus = function () {
            this.showStatus("error")
        }, n.showLastStatus = function () {
            this.showStatus("last"), this.bindHideStatus("off")
        }, n.showStatus = function (t2) {
            s(this.statusElement), this.hideStatusEventElements(), s(this.statusEventElements[t2])
        }, n.hideAllStatus = function () {
            o(this.statusElement), this.hideStatusEventElements()
        }, n.hideStatusEventElements = function () {
            for (let t2 in this.statusEventElements) o(this.statusEventElements[t2])
        }, e
    }), function (t, e) {
        "use strict";
        typeof define == "function" && define.amd ? define(["ev-emitter/ev-emitter"], function (i) {
            return e(t, i)
        }) : typeof module == "object" && module.exports ? module.exports = e(t, require("ev-emitter")) : t.imagesLoaded = e(t, t.EvEmitter)
    }(typeof window < "u" ? window : this, function (t, e) {
        "use strict";
        var i = t.jQuery, n = t.console;

        function o(t2, e2) {
            for (var i2 in e2) t2[i2] = e2[i2];
            return t2
        }

        var s = Array.prototype.slice;

        function r(t2, e2, l2) {
            if (!(this instanceof r)) return new r(t2, e2, l2);
            var h2, a2 = t2;
            typeof t2 == "string" && (a2 = document.querySelectorAll(t2)), a2 ? (this.elements = (h2 = a2, Array.isArray(h2) ? h2 : typeof h2 == "object" && typeof h2.length == "number" ? s.call(h2) : [h2]), this.options = o({}, this.options), typeof e2 == "function" ? l2 = e2 : o(this.options, e2), l2 && this.on("always", l2), this.getImages(), i && (this.jqDeferred = new i.Deferred), setTimeout(this.check.bind(this))) : n.error("Bad element for imagesLoaded " + (a2 || t2))
        }

        r.prototype = Object.create(e.prototype), r.prototype.options = {}, r.prototype.getImages = function () {
            this.images = [], this.elements.forEach(this.addElementImages, this)
        }, r.prototype.addElementImages = function (t2) {
            t2.nodeName == "IMG" && this.addImage(t2), this.options.background === !0 && this.addElementBackgroundImages(t2);
            var e2 = t2.nodeType;
            if (e2 && l[e2]) {
                for (var i2 = t2.querySelectorAll("img"), n2 = 0; n2 < i2.length; n2++) {
                    var o2 = i2[n2];
                    this.addImage(o2)
                }
                if (typeof this.options.background == "string") {
                    var s2 = t2.querySelectorAll(this.options.background);
                    for (n2 = 0; n2 < s2.length; n2++) {
                        var r2 = s2[n2];
                        this.addElementBackgroundImages(r2)
                    }
                }
            }
        };
        var l = {1: !0, 9: !0, 11: !0};

        function h(t2) {
            this.img = t2
        }

        function a(t2, e2) {
            this.url = t2, this.element = e2, this.img = new Image
        }

        return r.prototype.addElementBackgroundImages = function (t2) {
            var e2 = getComputedStyle(t2);
            if (e2) for (var i2 = /url\((['"])?(.*?)\1\)/gi, n2 = i2.exec(e2.backgroundImage); n2 !== null;) {
                var o2 = n2 && n2[2];
                o2 && this.addBackground(o2, t2), n2 = i2.exec(e2.backgroundImage)
            }
        }, r.prototype.addImage = function (t2) {
            var e2 = new h(t2);
            this.images.push(e2)
        }, r.prototype.addBackground = function (t2, e2) {
            var i2 = new a(t2, e2);
            this.images.push(i2)
        }, r.prototype.check = function () {
            var t2 = this;

            function e2(e3, i2, n2) {
                setTimeout(function () {
                    t2.progress(e3, i2, n2)
                })
            }

            this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? this.images.forEach(function (t3) {
                t3.once("progress", e2), t3.check()
            }) : this.complete()
        }, r.prototype.progress = function (t2, e2, i2) {
            this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t2.isLoaded, this.emitEvent("progress", [this, t2, e2]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t2), this.progressedCount == this.images.length && this.complete(), this.options.debug && n && n.log("progress: " + i2, t2, e2)
        }, r.prototype.complete = function () {
            var t2 = this.hasAnyBroken ? "fail" : "done";
            if (this.isComplete = !0, this.emitEvent(t2, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
                var e2 = this.hasAnyBroken ? "reject" : "resolve";
                this.jqDeferred[e2](this)
            }
        }, h.prototype = Object.create(e.prototype), h.prototype.check = function () {
            this.getIsImageComplete() ? this.confirm(this.img.naturalWidth !== 0, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.proxyImage.src = this.img.src)
        }, h.prototype.getIsImageComplete = function () {
            return this.img.complete && this.img.naturalWidth
        }, h.prototype.confirm = function (t2, e2) {
            this.isLoaded = t2, this.emitEvent("progress", [this, this.img, e2])
        }, h.prototype.handleEvent = function (t2) {
            var e2 = "on" + t2.type;
            this[e2] && this[e2](t2)
        }, h.prototype.onload = function () {
            this.confirm(!0, "onload"), this.unbindEvents()
        }, h.prototype.onerror = function () {
            this.confirm(!1, "onerror"), this.unbindEvents()
        }, h.prototype.unbindEvents = function () {
            this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
        }, a.prototype = Object.create(h.prototype), a.prototype.check = function () {
            this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(this.img.naturalWidth !== 0, "naturalWidth"), this.unbindEvents())
        }, a.prototype.unbindEvents = function () {
            this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
        }, a.prototype.confirm = function (t2, e2) {
            this.isLoaded = t2, this.emitEvent("progress", [this, this.element, e2])
        }, r.makeJQueryPlugin = function (e2) {
            (e2 = e2 || t.jQuery) && ((i = e2).fn.imagesLoaded = function (t2, e3) {
                return new r(this, t2, e3).jqDeferred.promise(i(this))
            })
        }, r.makeJQueryPlugin(), r
    })
}(), function () {/*!
* Flickity PACKAGED v2.2.1
* Touch, responsive, flickable carousels
*
* Licensed GPLv3 for open source use
* or Flickity Commercial License for commercial use
*
* https://flickity.metafizzy.co
* Copyright 2015-2019 Metafizzy
*/
    (function (e, i) {
        typeof define == "function" && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function (t) {
            return i(e, t)
        }) : typeof module == "object" && module.exports ? module.exports = i(e, require("jquery")) : e.jQueryBridget = i(e, e.jQuery)
    })(window, function (t, e) {
        "use strict";
        var i = Array.prototype.slice, n = t.console, d = n === void 0 ? function () {
        } : function (t2) {
            n.error(t2)
        };

        function s(h, s2, c) {
            (c = c || e || t.jQuery) && (s2.prototype.option || (s2.prototype.option = function (t2) {
                c.isPlainObject(t2) && (this.options = c.extend(!0, this.options, t2))
            }), c.fn[h] = function (t2) {
                return typeof t2 == "string" ? function (t3, o2, r) {
                    var a, l = "$()." + h + '("' + o2 + '")';
                    return t3.each(function (t4, e2) {
                        var i2 = c.data(e2, h);
                        if (i2) {
                            var n2 = i2[o2];
                            if (n2 && o2.charAt(0) != "_") {
                                var s3 = n2.apply(i2, r);
                                a = a === void 0 ? s3 : a
                            } else d(l + " is not a valid method")
                        } else d(h + " not initialized. Cannot call methods, i.e. " + l)
                    }), a !== void 0 ? a : t3
                }(this, t2, i.call(arguments, 1)) : (function (t3, n2) {
                    t3.each(function (t4, e2) {
                        var i2 = c.data(e2, h);
                        i2 ? (i2.option(n2), i2._init()) : (i2 = new s2(e2, n2), c.data(e2, h, i2))
                    })
                }(this, t2), this)
            }, o(c))
        }

        function o(t2) {
            !t2 || t2 && t2.bridget || (t2.bridget = s)
        }

        return o(e || t.jQuery), s
    }), function (t, e) {
        typeof define == "function" && define.amd ? define("ev-emitter/ev-emitter", e) : typeof module == "object" && module.exports ? module.exports = e() : t.EvEmitter = e()
    }(typeof window < "u" ? window : this, function () {
        function t() {
        }

        var e = t.prototype;
        return e.on = function (t2, e2) {
            if (t2 && e2) {
                var i = this._events = this._events || {}, n = i[t2] = i[t2] || [];
                return n.indexOf(e2) == -1 && n.push(e2), this
            }
        }, e.once = function (t2, e2) {
            if (t2 && e2) {
                this.on(t2, e2);
                var i = this._onceEvents = this._onceEvents || {};
                return (i[t2] = i[t2] || {})[e2] = !0, this
            }
        }, e.off = function (t2, e2) {
            var i = this._events && this._events[t2];
            if (i && i.length) {
                var n = i.indexOf(e2);
                return n != -1 && i.splice(n, 1), this
            }
        }, e.emitEvent = function (t2, e2) {
            var i = this._events && this._events[t2];
            if (i && i.length) {
                i = i.slice(0), e2 = e2 || [];
                for (var n = this._onceEvents && this._onceEvents[t2], s = 0; s < i.length; s++) {
                    var o = i[s];
                    n && n[o] && (this.off(t2, o), delete n[o]), o.apply(this, e2)
                }
                return this
            }
        }, e.allOff = function () {
            delete this._events, delete this._onceEvents
        }, t
    }), function (t, e) {
        typeof define == "function" && define.amd ? define("get-size/get-size", e) : typeof module == "object" && module.exports ? module.exports = e() : t.getSize = e()
    }(window, function () {
        "use strict";

        function m(t) {
            var e = parseFloat(t);
            return t.indexOf("%") == -1 && !isNaN(e) && e
        }

        var i = typeof console > "u" ? function () {
            } : function (t) {
                console.error(t)
            },
            y = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            b = y.length;

        function E(t) {
            var e = getComputedStyle(t);
            return e || i("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e
        }

        var S, C = !1;

        function x(t) {
            if (function () {
                if (!C) {
                    C = !0;
                    var t2 = document.createElement("div");
                    t2.style.width = "200px", t2.style.padding = "1px 2px 3px 4px", t2.style.borderStyle = "solid", t2.style.borderWidth = "1px 2px 3px 4px", t2.style.boxSizing = "border-box";
                    var e2 = document.body || document.documentElement;
                    e2.appendChild(t2);
                    var i3 = E(t2);
                    S = Math.round(m(i3.width)) == 200, x.isBoxSizeOuter = S, e2.removeChild(t2)
                }
            }(), typeof t == "string" && (t = document.querySelector(t)), t && typeof t == "object" && t.nodeType) {
                var e = E(t);
                if (e.display == "none") return function () {
                    for (var t2 = {
                        width: 0,
                        height: 0,
                        innerWidth: 0,
                        innerHeight: 0,
                        outerWidth: 0,
                        outerHeight: 0
                    }, e2 = 0; e2 < b; e2++) t2[y[e2]] = 0;
                    return t2
                }();
                var i2 = {};
                i2.width = t.offsetWidth, i2.height = t.offsetHeight;
                for (var n = i2.isBorderBox = e.boxSizing == "border-box", s = 0; s < b; s++) {
                    var o = y[s], r = e[o], a = parseFloat(r);
                    i2[o] = isNaN(a) ? 0 : a
                }
                var l = i2.paddingLeft + i2.paddingRight, h = i2.paddingTop + i2.paddingBottom,
                    c = i2.marginLeft + i2.marginRight, d = i2.marginTop + i2.marginBottom,
                    u = i2.borderLeftWidth + i2.borderRightWidth, f = i2.borderTopWidth + i2.borderBottomWidth,
                    p = n && S, g = m(e.width);
                g !== !1 && (i2.width = g + (p ? 0 : l + u));
                var v = m(e.height);
                return v !== !1 && (i2.height = v + (p ? 0 : h + f)), i2.innerWidth = i2.width - (l + u), i2.innerHeight = i2.height - (h + f), i2.outerWidth = i2.width + c, i2.outerHeight = i2.height + d, i2
            }
        }

        return x
    }), function (t, e) {
        "use strict";
        typeof define == "function" && define.amd ? define("desandro-matches-selector/matches-selector", e) : typeof module == "object" && module.exports ? module.exports = e() : t.matchesSelector = e()
    }(window, function () {
        "use strict";
        var i = function () {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (var e = ["webkit", "moz", "ms", "o"], i2 = 0; i2 < e.length; i2++) {
                var n = e[i2] + "MatchesSelector";
                if (t[n]) return n
            }
        }();
        return function (t, e) {
            return t[i](e)
        }
    }), function (e, i) {
        typeof define == "function" && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (t) {
            return i(e, t)
        }) : typeof module == "object" && module.exports ? module.exports = i(e, require("desandro-matches-selector")) : e.fizzyUIUtils = i(e, e.matchesSelector)
    }(window, function (h, o) {
        var c = {
            extend: function (t, e2) {
                for (var i in e2) t[i] = e2[i];
                return t
            }, modulo: function (t, e2) {
                return (t % e2 + e2) % e2
            }
        }, e = Array.prototype.slice;
        c.makeArray = function (t) {
            return Array.isArray(t) ? t : t == null ? [] : typeof t == "object" && typeof t.length == "number" ? e.call(t) : [t]
        }, c.removeFrom = function (t, e2) {
            var i = t.indexOf(e2);
            i != -1 && t.splice(i, 1)
        }, c.getParent = function (t, e2) {
            for (; t.parentNode && t != document.body;) if (t = t.parentNode, o(t, e2)) return t
        }, c.getQueryElement = function (t) {
            return typeof t == "string" ? document.querySelector(t) : t
        }, c.handleEvent = function (t) {
            var e2 = "on" + t.type;
            this[e2] && this[e2](t)
        }, c.filterFindElements = function (t, n) {
            t = c.makeArray(t);
            var s = [];
            return t.forEach(function (t2) {
                if (t2 instanceof HTMLElement) if (n) {
                    o(t2, n) && s.push(t2);
                    for (var e2 = t2.querySelectorAll(n), i = 0; i < e2.length; i++) s.push(e2[i])
                } else s.push(t2)
            }), s
        }, c.debounceMethod = function (t, e2, n) {
            n = n || 100;
            var s = t.prototype[e2], o2 = e2 + "Timeout";
            t.prototype[e2] = function () {
                var t2 = this[o2];
                clearTimeout(t2);
                var e3 = arguments, i = this;
                this[o2] = setTimeout(function () {
                    s.apply(i, e3), delete i[o2]
                }, n)
            }
        }, c.docReady = function (t) {
            var e2 = document.readyState;
            e2 == "complete" || e2 == "interactive" ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
        }, c.toDashed = function (t) {
            return t.replace(/(.)([A-Z])/g, function (t2, e2, i) {
                return e2 + "-" + i
            }).toLowerCase()
        };
        var d = h.console;
        return c.htmlInit = function (a, l) {
            c.docReady(function () {
                var t = c.toDashed(l), s = "data-" + t, e2 = document.querySelectorAll("[" + s + "]"),
                    i = document.querySelectorAll(".js-" + t), n = c.makeArray(e2).concat(c.makeArray(i)),
                    o2 = s + "-options", r = h.jQuery;
                n.forEach(function (e3) {
                    var t2, i2 = e3.getAttribute(s) || e3.getAttribute(o2);
                    try {
                        t2 = i2 && JSON.parse(i2)
                    } catch (t3) {
                        return void (d && d.error("Error parsing " + s + " on " + e3.className + ": " + t3))
                    }
                    var n2 = new a(e3, t2);
                    r && r.data(e3, l, n2)
                })
            })
        }, c
    }), function (e, i) {
        typeof define == "function" && define.amd ? define("flickity/js/cell", ["get-size/get-size"], function (t) {
            return i(e, t)
        }) : typeof module == "object" && module.exports ? module.exports = i(e, require("get-size")) : (e.Flickity = e.Flickity || {}, e.Flickity.Cell = i(e, e.getSize))
    }(window, function (t, e) {
        function i(t2, e2) {
            this.element = t2, this.parent = e2, this.create()
        }

        var n = i.prototype;
        return n.create = function () {
            this.element.style.position = "absolute", this.element.setAttribute("aria-hidden", "true"), this.x = 0, this.shift = 0
        }, n.destroy = function () {
            this.unselect(), this.element.style.position = "";
            var t2 = this.parent.originSide;
            this.element.style[t2] = ""
        }, n.getSize = function () {
            this.size = e(this.element)
        }, n.setPosition = function (t2) {
            this.x = t2, this.updateTarget(), this.renderPosition(t2)
        }, n.updateTarget = n.setDefaultTarget = function () {
            var t2 = this.parent.originSide == "left" ? "marginLeft" : "marginRight";
            this.target = this.x + this.size[t2] + this.size.width * this.parent.cellAlign
        }, n.renderPosition = function (t2) {
            var e2 = this.parent.originSide;
            this.element.style[e2] = this.parent.getPositionValue(t2)
        }, n.select = function () {
            this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden")
        }, n.unselect = function () {
            this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true")
        }, n.wrapShift = function (t2) {
            this.shift = t2, this.renderPosition(this.x + this.parent.slideableWidth * t2)
        }, n.remove = function () {
            this.element.parentNode.removeChild(this.element)
        }, i
    }), function (t, e) {
        typeof define == "function" && define.amd ? define("flickity/js/slide", e) : typeof module == "object" && module.exports ? module.exports = e() : (t.Flickity = t.Flickity || {}, t.Flickity.Slide = e())
    }(window, function () {
        "use strict";

        function t(t2) {
            this.parent = t2, this.isOriginLeft = t2.originSide == "left", this.cells = [], this.outerWidth = 0, this.height = 0
        }

        var e = t.prototype;
        return e.addCell = function (t2) {
            if (this.cells.push(t2), this.outerWidth += t2.size.outerWidth, this.height = Math.max(t2.size.outerHeight, this.height), this.cells.length == 1) {
                this.x = t2.x;
                var e2 = this.isOriginLeft ? "marginLeft" : "marginRight";
                this.firstMargin = t2.size[e2]
            }
        }, e.updateTarget = function () {
            var t2 = this.isOriginLeft ? "marginRight" : "marginLeft", e2 = this.getLastCell(),
                i = e2 ? e2.size[t2] : 0, n = this.outerWidth - (this.firstMargin + i);
            this.target = this.x + this.firstMargin + n * this.parent.cellAlign
        }, e.getLastCell = function () {
            return this.cells[this.cells.length - 1]
        }, e.select = function () {
            this.cells.forEach(function (t2) {
                t2.select()
            })
        }, e.unselect = function () {
            this.cells.forEach(function (t2) {
                t2.unselect()
            })
        }, e.getCellElements = function () {
            return this.cells.map(function (t2) {
                return t2.element
            })
        }, t
    }), function (e, i) {
        typeof define == "function" && define.amd ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function (t) {
            return i(e, t)
        }) : typeof module == "object" && module.exports ? module.exports = i(e, require("fizzy-ui-utils")) : (e.Flickity = e.Flickity || {}, e.Flickity.animatePrototype = i(e, e.fizzyUIUtils))
    }(window, function (t, e) {
        var i = {
            startAnimation: function () {
                this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate())
            }, animate: function () {
                this.applyDragForce(), this.applySelectedAttraction();
                var t2 = this.x;
                if (this.integratePhysics(), this.positionSlider(), this.settle(t2), this.isAnimating) {
                    var e2 = this;
                    requestAnimationFrame(function () {
                        e2.animate()
                    })
                }
            }, positionSlider: function () {
                var t2 = this.x;
                this.options.wrapAround && 1 < this.cells.length && (t2 = e.modulo(t2, this.slideableWidth), t2 -= this.slideableWidth, this.shiftWrapCells(t2)), this.setTranslateX(t2, this.isAnimating), this.dispatchScrollEvent()
            }, setTranslateX: function (t2, e2) {
                t2 += this.cursorPosition, t2 = this.options.rightToLeft ? -t2 : t2;
                var i2 = this.getPositionValue(t2);
                this.slider.style.transform = e2 ? "translate3d(" + i2 + ",0,0)" : "translateX(" + i2 + ")"
            }, dispatchScrollEvent: function () {
                var t2 = this.slides[0];
                if (t2) {
                    var e2 = -this.x - t2.target, i2 = e2 / this.slidesWidth;
                    this.dispatchEvent("scroll", null, [i2, e2])
                }
            }, positionSliderAtSelected: function () {
                this.cells.length && (this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider())
            }, getPositionValue: function (t2) {
                return this.options.percentPosition ? .01 * Math.round(t2 / this.size.innerWidth * 1e4) + "%" : Math.round(t2) + "px"
            }, settle: function (t2) {
                this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * t2) || this.restingFrames++, 2 < this.restingFrames && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]))
            }, shiftWrapCells: function (t2) {
                var e2 = this.cursorPosition + t2;
                this._shiftCells(this.beforeShiftCells, e2, -1);
                var i2 = this.size.innerWidth - (t2 + this.slideableWidth + this.cursorPosition);
                this._shiftCells(this.afterShiftCells, i2, 1)
            }, _shiftCells: function (t2, e2, i2) {
                for (var n = 0; n < t2.length; n++) {
                    var s = t2[n], o = 0 < e2 ? i2 : 0;
                    s.wrapShift(o), e2 -= s.size.outerWidth
                }
            }, _unshiftCells: function (t2) {
                if (t2 && t2.length) for (var e2 = 0; e2 < t2.length; e2++) t2[e2].wrapShift(0)
            }, integratePhysics: function () {
                this.x += this.velocity, this.velocity *= this.getFrictionFactor()
            }, applyForce: function (t2) {
                this.velocity += t2
            }, getFrictionFactor: function () {
                return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
            }, getRestingPosition: function () {
                return this.x + this.velocity / (1 - this.getFrictionFactor())
            }, applyDragForce: function () {
                if (this.isDraggable && this.isPointerDown) {
                    var t2 = this.dragX - this.x - this.velocity;
                    this.applyForce(t2)
                }
            }, applySelectedAttraction: function () {
                if (!(this.isDraggable && this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                    var t2 = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                    this.applyForce(t2)
                }
            }
        };
        return i
    }), function (r, a) {
        if (typeof define == "function" && define.amd) define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function (t2, e, i, n, s, o) {
            return a(r, t2, e, i, n, s, o)
        }); else if (typeof module == "object" && module.exports) module.exports = a(r, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate")); else {
            var t = r.Flickity;
            r.Flickity = a(r, r.EvEmitter, r.getSize, r.fizzyUIUtils, t.Cell, t.Slide, t.animatePrototype)
        }
    }(window, function (n, t, e, a, i, r, s) {
        var l = n.jQuery, o = n.getComputedStyle, h = n.console;

        function c(t2, e2) {
            for (t2 = a.makeArray(t2); t2.length;) e2.appendChild(t2.shift())
        }

        var d = 0, u = {};

        function f(t2, e2) {
            var i2 = a.getQueryElement(t2);
            if (i2) {
                if (this.element = i2, this.element.flickityGUID) {
                    var n2 = u[this.element.flickityGUID];
                    return n2.option(e2), n2
                }
                l && (this.$element = l(this.element)), this.options = a.extend({}, this.constructor.defaults), this.option(e2), this._create()
            } else h && h.error("Bad element for Flickity: " + (i2 || t2))
        }

        f.defaults = {
            accessibility: !0,
            cellAlign: "center",
            freeScrollFriction: .075,
            friction: .28,
            namespaceJQueryEvents: !0,
            percentPosition: !0,
            resize: !0,
            selectedAttraction: .025,
            setGallerySize: !0
        }, f.createMethods = [];
        var p = f.prototype;
        a.extend(p, t.prototype), p._create = function () {
            var t2 = this.guid = ++d;
            for (var e2 in this.element.flickityGUID = t2, (u[t2] = this).selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.originSide = this.options.rightToLeft ? "right" : "left", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", this._createSlider(), (this.options.resize || this.options.watchCSS) && n.addEventListener("resize", this), this.options.on) {
                var i2 = this.options.on[e2];
                this.on(e2, i2)
            }
            f.createMethods.forEach(function (t3) {
                this[t3]()
            }, this), this.options.watchCSS ? this.watchCSS() : this.activate()
        }, p.option = function (t2) {
            a.extend(this.options, t2)
        }, p.activate = function () {
            this.isActive || (this.isActive = !0, this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize(), c(this._filterFindCellElements(this.element.children), this.slider), this.viewport.appendChild(this.slider), this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, this.element.addEventListener("keydown", this)), this.emitEvent("activate"), this.selectInitialIndex(), this.isInitActivated = !0, this.dispatchEvent("ready"))
        }, p._createSlider = function () {
            var t2 = document.createElement("div");
            t2.className = "flickity-slider", t2.style[this.originSide] = 0, this.slider = t2
        }, p._filterFindCellElements = function (t2) {
            return a.filterFindElements(t2, this.options.cellSelector)
        }, p.reloadCells = function () {
            this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
        }, p._makeCells = function (t2) {
            return this._filterFindCellElements(t2).map(function (t3) {
                return new i(t3, this)
            }, this)
        }, p.getLastCell = function () {
            return this.cells[this.cells.length - 1]
        }, p.getLastSlide = function () {
            return this.slides[this.slides.length - 1]
        }, p.positionCells = function () {
            this._sizeCells(this.cells), this._positionCells(0)
        }, p._positionCells = function (t2) {
            t2 = t2 || 0, this.maxCellHeight = t2 && this.maxCellHeight || 0;
            var e2 = 0;
            if (0 < t2) {
                var i2 = this.cells[t2 - 1];
                e2 = i2.x + i2.size.outerWidth
            }
            for (var n2 = this.cells.length, s2 = t2; s2 < n2; s2++) {
                var o2 = this.cells[s2];
                o2.setPosition(e2), e2 += o2.size.outerWidth, this.maxCellHeight = Math.max(o2.size.outerHeight, this.maxCellHeight)
            }
            this.slideableWidth = e2, this.updateSlides(), this._containSlides(), this.slidesWidth = n2 ? this.getLastSlide().target - this.slides[0].target : 0
        }, p._sizeCells = function (t2) {
            t2.forEach(function (t3) {
                t3.getSize()
            })
        }, p.updateSlides = function () {
            if (this.slides = [], this.cells.length) {
                var n2 = new r(this);
                this.slides.push(n2);
                var s2 = this.originSide == "left" ? "marginRight" : "marginLeft", o2 = this._getCanCellFit();
                this.cells.forEach(function (t2, e2) {
                    if (n2.cells.length) {
                        var i2 = n2.outerWidth - n2.firstMargin + (t2.size.outerWidth - t2.size[s2]);
                        o2.call(this, e2, i2) || (n2.updateTarget(), n2 = new r(this), this.slides.push(n2)), n2.addCell(t2)
                    } else n2.addCell(t2)
                }, this), n2.updateTarget(), this.updateSelectedSlide()
            }
        }, p._getCanCellFit = function () {
            var t2 = this.options.groupCells;
            if (!t2) return function () {
                return !1
            };
            if (typeof t2 == "number") {
                var e2 = parseInt(t2, 10);
                return function (t3) {
                    return t3 % e2 != 0
                }
            }
            var i2 = typeof t2 == "string" && t2.match(/^(\d+)%$/), n2 = i2 ? parseInt(i2[1], 10) / 100 : 1;
            return function (t3, e3) {
                return e3 <= (this.size.innerWidth + 1) * n2
            }
        }, p._init = p.reposition = function () {
            this.positionCells(), this.positionSliderAtSelected()
        }, p.getSize = function () {
            this.size = e(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
        };
        var g = {center: {left: .5, right: .5}, left: {left: 0, right: 1}, right: {right: 0, left: 1}};
        return p.setCellAlign = function () {
            var t2 = g[this.options.cellAlign];
            this.cellAlign = t2 ? t2[this.originSide] : this.options.cellAlign
        }, p.setGallerySize = function () {
            if (this.options.setGallerySize) {
                var t2 = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                this.viewport.style.height = t2 + "px"
            }
        }, p._getWrapShiftCells = function () {
            if (this.options.wrapAround) {
                this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                var t2 = this.cursorPosition, e2 = this.cells.length - 1;
                this.beforeShiftCells = this._getGapCells(t2, e2, -1), t2 = this.size.innerWidth - this.cursorPosition, this.afterShiftCells = this._getGapCells(t2, 0, 1)
            }
        }, p._getGapCells = function (t2, e2, i2) {
            for (var n2 = []; 0 < t2;) {
                var s2 = this.cells[e2];
                if (!s2) break;
                n2.push(s2), e2 += i2, t2 -= s2.size.outerWidth
            }
            return n2
        }, p._containSlides = function () {
            if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                var t2 = this.options.rightToLeft, e2 = t2 ? "marginRight" : "marginLeft",
                    i2 = t2 ? "marginLeft" : "marginRight", n2 = this.slideableWidth - this.getLastCell().size[i2],
                    s2 = n2 < this.size.innerWidth, o2 = this.cursorPosition + this.cells[0].size[e2],
                    r2 = n2 - this.size.innerWidth * (1 - this.cellAlign);
                this.slides.forEach(function (t3) {
                    s2 ? t3.target = n2 * this.cellAlign : (t3.target = Math.max(t3.target, o2), t3.target = Math.min(t3.target, r2))
                }, this)
            }
        }, p.dispatchEvent = function (t2, e2, i2) {
            var n2 = e2 ? [e2].concat(i2) : i2;
            if (this.emitEvent(t2, n2), l && this.$element) {
                var s2 = t2 += this.options.namespaceJQueryEvents ? ".flickity" : "";
                if (e2) {
                    var o2 = l.Event(e2);
                    o2.type = t2, s2 = o2
                }
                this.$element.trigger(s2, i2)
            }
        }, p.select = function (t2, e2, i2) {
            if (this.isActive && (t2 = parseInt(t2, 10), this._wrapSelect(t2), (this.options.wrapAround || e2) && (t2 = a.modulo(t2, this.slides.length)), this.slides[t2])) {
                var n2 = this.selectedIndex;
                this.selectedIndex = t2, this.updateSelectedSlide(), i2 ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select", null, [t2]), t2 != n2 && this.dispatchEvent("change", null, [t2]), this.dispatchEvent("cellSelect")
            }
        }, p._wrapSelect = function (t2) {
            var e2 = this.slides.length;
            if (!(this.options.wrapAround && 1 < e2)) return t2;
            var i2 = a.modulo(t2, e2), n2 = Math.abs(i2 - this.selectedIndex),
                s2 = Math.abs(i2 + e2 - this.selectedIndex), o2 = Math.abs(i2 - e2 - this.selectedIndex);
            !this.isDragSelect && s2 < n2 ? t2 += e2 : !this.isDragSelect && o2 < n2 && (t2 -= e2), t2 < 0 ? this.x -= this.slideableWidth : e2 <= t2 && (this.x += this.slideableWidth)
        }, p.previous = function (t2, e2) {
            this.select(this.selectedIndex - 1, t2, e2)
        }, p.next = function (t2, e2) {
            this.select(this.selectedIndex + 1, t2, e2)
        }, p.updateSelectedSlide = function () {
            var t2 = this.slides[this.selectedIndex];
            t2 && (this.unselectSelectedSlide(), (this.selectedSlide = t2).select(), this.selectedCells = t2.cells, this.selectedElements = t2.getCellElements(), this.selectedCell = t2.cells[0], this.selectedElement = this.selectedElements[0])
        }, p.unselectSelectedSlide = function () {
            this.selectedSlide && this.selectedSlide.unselect()
        }, p.selectInitialIndex = function () {
            var t2 = this.options.initialIndex;
            if (this.isInitActivated) this.select(this.selectedIndex, !1, !0); else {
                if (t2 && typeof t2 == "string" && this.queryCell(t2)) return void this.selectCell(t2, !1, !0);
                var e2 = 0;
                t2 && this.slides[t2] && (e2 = t2), this.select(e2, !1, !0)
            }
        }, p.selectCell = function (t2, e2, i2) {
            var n2 = this.queryCell(t2);
            if (n2) {
                var s2 = this.getCellSlideIndex(n2);
                this.select(s2, e2, i2)
            }
        }, p.getCellSlideIndex = function (t2) {
            for (var e2 = 0; e2 < this.slides.length; e2++) if (this.slides[e2].cells.indexOf(t2) != -1) return e2
        }, p.getCell = function (t2) {
            for (var e2 = 0; e2 < this.cells.length; e2++) {
                var i2 = this.cells[e2];
                if (i2.element == t2) return i2
            }
        }, p.getCells = function (t2) {
            t2 = a.makeArray(t2);
            var i2 = [];
            return t2.forEach(function (t3) {
                var e2 = this.getCell(t3);
                e2 && i2.push(e2)
            }, this), i2
        }, p.getCellElements = function () {
            return this.cells.map(function (t2) {
                return t2.element
            })
        }, p.getParentCell = function (t2) {
            var e2 = this.getCell(t2);
            return e2 || (t2 = a.getParent(t2, ".flickity-slider > *"), this.getCell(t2))
        }, p.getAdjacentCellElements = function (t2, e2) {
            if (!t2) return this.selectedSlide.getCellElements();
            e2 = e2 === void 0 ? this.selectedIndex : e2;
            var i2 = this.slides.length;
            if (i2 <= 1 + 2 * t2) return this.getCellElements();
            for (var n2 = [], s2 = e2 - t2; s2 <= e2 + t2; s2++) {
                var o2 = this.options.wrapAround ? a.modulo(s2, i2) : s2, r2 = this.slides[o2];
                r2 && (n2 = n2.concat(r2.getCellElements()))
            }
            return n2
        }, p.queryCell = function (t2) {
            if (typeof t2 == "number") return this.cells[t2];
            if (typeof t2 == "string") {
                if (t2.match(/^[#\.]?[\d\/]/)) return;
                t2 = this.element.querySelector(t2)
            }
            return this.getCell(t2)
        }, p.uiChange = function () {
            this.emitEvent("uiChange")
        }, p.childUIPointerDown = function (t2) {
            t2.type != "touchstart" && t2.preventDefault(), this.focus()
        }, p.onresize = function () {
            this.watchCSS(), this.resize()
        }, a.debounceMethod(f, "onresize", 150), p.resize = function () {
            if (this.isActive) {
                this.getSize(), this.options.wrapAround && (this.x = a.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
                var t2 = this.selectedElements && this.selectedElements[0];
                this.selectCell(t2, !1, !0)
            }
        }, p.watchCSS = function () {
            this.options.watchCSS && (o(this.element, ":after").content.indexOf("flickity") != -1 ? this.activate() : this.deactivate())
        }, p.onkeydown = function (t2) {
            var e2 = document.activeElement && document.activeElement != this.element;
            if (this.options.accessibility && !e2) {
                var i2 = f.keyboardHandlers[t2.keyCode];
                i2 && i2.call(this)
            }
        }, f.keyboardHandlers = {
            37: function () {
                var t2 = this.options.rightToLeft ? "next" : "previous";
                this.uiChange(), this[t2]()
            }, 39: function () {
                var t2 = this.options.rightToLeft ? "previous" : "next";
                this.uiChange(), this[t2]()
            }
        }, p.focus = function () {
            var t2 = n.pageYOffset;
            this.element.focus({preventScroll: !0}), n.pageYOffset != t2 && n.scrollTo(n.pageXOffset, t2)
        }, p.deactivate = function () {
            this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), this.unselectSelectedSlide(), this.cells.forEach(function (t2) {
                t2.destroy()
            }), this.element.removeChild(this.viewport), c(this.slider.children, this.element), this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), this.isActive = !1, this.emitEvent("deactivate"))
        }, p.destroy = function () {
            this.deactivate(), n.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), l && this.$element && l.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete u[this.guid]
        }, a.extend(p, s), f.data = function (t2) {
            var e2 = (t2 = a.getQueryElement(t2)) && t2.flickityGUID;
            return e2 && u[e2]
        }, a.htmlInit(f, "flickity"), l && l.bridget && l.bridget("flickity", f), f.setJQuery = function (t2) {
            l = t2
        }, f.Cell = i, f.Slide = r, f
    }), function (e, i) {
        typeof define == "function" && define.amd ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function (t) {
            return i(e, t)
        }) : typeof module == "object" && module.exports ? module.exports = i(e, require("ev-emitter")) : e.Unipointer = i(e, e.EvEmitter)
    }(window, function (s, t) {
        function e() {
        }

        var i = e.prototype = Object.create(t.prototype);
        i.bindStartEvent = function (t2) {
            this._bindStartEvent(t2, !0)
        }, i.unbindStartEvent = function (t2) {
            this._bindStartEvent(t2, !1)
        }, i._bindStartEvent = function (t2, e2) {
            var i2 = (e2 = e2 === void 0 || e2) ? "addEventListener" : "removeEventListener", n2 = "mousedown";
            s.PointerEvent ? n2 = "pointerdown" : "ontouchstart" in s && (n2 = "touchstart"), t2[i2](n2, this)
        }, i.handleEvent = function (t2) {
            var e2 = "on" + t2.type;
            this[e2] && this[e2](t2)
        }, i.getTouch = function (t2) {
            for (var e2 = 0; e2 < t2.length; e2++) {
                var i2 = t2[e2];
                if (i2.identifier == this.pointerIdentifier) return i2
            }
        }, i.onmousedown = function (t2) {
            var e2 = t2.button;
            e2 && e2 !== 0 && e2 !== 1 || this._pointerDown(t2, t2)
        }, i.ontouchstart = function (t2) {
            this._pointerDown(t2, t2.changedTouches[0])
        }, i.onpointerdown = function (t2) {
            this._pointerDown(t2, t2)
        }, i._pointerDown = function (t2, e2) {
            t2.button || this.isPointerDown || (this.isPointerDown = !0, this.pointerIdentifier = e2.pointerId !== void 0 ? e2.pointerId : e2.identifier, this.pointerDown(t2, e2))
        }, i.pointerDown = function (t2, e2) {
            this._bindPostStartEvents(t2), this.emitEvent("pointerDown", [t2, e2])
        };
        var n = {
            mousedown: ["mousemove", "mouseup"],
            touchstart: ["touchmove", "touchend", "touchcancel"],
            pointerdown: ["pointermove", "pointerup", "pointercancel"]
        };
        return i._bindPostStartEvents = function (t2) {
            if (t2) {
                var e2 = n[t2.type];
                e2.forEach(function (t3) {
                    s.addEventListener(t3, this)
                }, this), this._boundPointerEvents = e2
            }
        }, i._unbindPostStartEvents = function () {
            this._boundPointerEvents && (this._boundPointerEvents.forEach(function (t2) {
                s.removeEventListener(t2, this)
            }, this), delete this._boundPointerEvents)
        }, i.onmousemove = function (t2) {
            this._pointerMove(t2, t2)
        }, i.onpointermove = function (t2) {
            t2.pointerId == this.pointerIdentifier && this._pointerMove(t2, t2)
        }, i.ontouchmove = function (t2) {
            var e2 = this.getTouch(t2.changedTouches);
            e2 && this._pointerMove(t2, e2)
        }, i._pointerMove = function (t2, e2) {
            this.pointerMove(t2, e2)
        }, i.pointerMove = function (t2, e2) {
            this.emitEvent("pointerMove", [t2, e2])
        }, i.onmouseup = function (t2) {
            this._pointerUp(t2, t2)
        }, i.onpointerup = function (t2) {
            t2.pointerId == this.pointerIdentifier && this._pointerUp(t2, t2)
        }, i.ontouchend = function (t2) {
            var e2 = this.getTouch(t2.changedTouches);
            e2 && this._pointerUp(t2, e2)
        }, i._pointerUp = function (t2, e2) {
            this._pointerDone(), this.pointerUp(t2, e2)
        }, i.pointerUp = function (t2, e2) {
            this.emitEvent("pointerUp", [t2, e2])
        }, i._pointerDone = function () {
            this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone()
        }, i._pointerReset = function () {
            this.isPointerDown = !1, delete this.pointerIdentifier
        }, i.pointerDone = function () {
        }, i.onpointercancel = function (t2) {
            t2.pointerId == this.pointerIdentifier && this._pointerCancel(t2, t2)
        }, i.ontouchcancel = function (t2) {
            var e2 = this.getTouch(t2.changedTouches);
            e2 && this._pointerCancel(t2, e2)
        }, i._pointerCancel = function (t2, e2) {
            this._pointerDone(), this.pointerCancel(t2, e2)
        }, i.pointerCancel = function (t2, e2) {
            this.emitEvent("pointerCancel", [t2, e2])
        }, e.getPointerPoint = function (t2) {
            return {x: t2.pageX, y: t2.pageY}
        }, e
    }), function (e, i) {
        typeof define == "function" && define.amd ? define("unidragger/unidragger", ["unipointer/unipointer"], function (t) {
            return i(e, t)
        }) : typeof module == "object" && module.exports ? module.exports = i(e, require("unipointer")) : e.Unidragger = i(e, e.Unipointer)
    }(window, function (o, t) {
        function e() {
        }

        var i = e.prototype = Object.create(t.prototype);
        i.bindHandles = function () {
            this._bindHandles(!0)
        }, i.unbindHandles = function () {
            this._bindHandles(!1)
        }, i._bindHandles = function (t2) {
            for (var e2 = (t2 = t2 === void 0 || t2) ? "addEventListener" : "removeEventListener", i2 = t2 ? this._touchActionValue : "", n = 0; n < this.handles.length; n++) {
                var s2 = this.handles[n];
                this._bindStartEvent(s2, t2), s2[e2]("click", this), o.PointerEvent && (s2.style.touchAction = i2)
            }
        }, i._touchActionValue = "none", i.pointerDown = function (t2, e2) {
            this.okayPointerDown(t2) && (this.pointerDownPointer = e2, t2.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(t2), this.emitEvent("pointerDown", [t2, e2]))
        };
        var s = {TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0},
            r = {radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0};
        return i.okayPointerDown = function (t2) {
            var e2 = s[t2.target.nodeName], i2 = r[t2.target.type], n = !e2 || i2;
            return n || this._pointerReset(), n
        }, i.pointerDownBlur = function () {
            var t2 = document.activeElement;
            t2 && t2.blur && t2 != document.body && t2.blur()
        }, i.pointerMove = function (t2, e2) {
            var i2 = this._dragPointerMove(t2, e2);
            this.emitEvent("pointerMove", [t2, e2, i2]), this._dragMove(t2, e2, i2)
        }, i._dragPointerMove = function (t2, e2) {
            var i2 = {x: e2.pageX - this.pointerDownPointer.pageX, y: e2.pageY - this.pointerDownPointer.pageY};
            return !this.isDragging && this.hasDragStarted(i2) && this._dragStart(t2, e2), i2
        }, i.hasDragStarted = function (t2) {
            return 3 < Math.abs(t2.x) || 3 < Math.abs(t2.y)
        }, i.pointerUp = function (t2, e2) {
            this.emitEvent("pointerUp", [t2, e2]), this._dragPointerUp(t2, e2)
        }, i._dragPointerUp = function (t2, e2) {
            this.isDragging ? this._dragEnd(t2, e2) : this._staticClick(t2, e2)
        }, i._dragStart = function (t2, e2) {
            this.isDragging = !0, this.isPreventingClicks = !0, this.dragStart(t2, e2)
        }, i.dragStart = function (t2, e2) {
            this.emitEvent("dragStart", [t2, e2])
        }, i._dragMove = function (t2, e2, i2) {
            this.isDragging && this.dragMove(t2, e2, i2)
        }, i.dragMove = function (t2, e2, i2) {
            t2.preventDefault(), this.emitEvent("dragMove", [t2, e2, i2])
        }, i._dragEnd = function (t2, e2) {
            this.isDragging = !1, setTimeout(function () {
                delete this.isPreventingClicks
            }.bind(this)), this.dragEnd(t2, e2)
        }, i.dragEnd = function (t2, e2) {
            this.emitEvent("dragEnd", [t2, e2])
        }, i.onclick = function (t2) {
            this.isPreventingClicks && t2.preventDefault()
        }, i._staticClick = function (t2, e2) {
            this.isIgnoringMouseUp && t2.type == "mouseup" || (this.staticClick(t2, e2), t2.type != "mouseup" && (this.isIgnoringMouseUp = !0, setTimeout(function () {
                delete this.isIgnoringMouseUp
            }.bind(this), 400)))
        }, i.staticClick = function (t2, e2) {
            this.emitEvent("staticClick", [t2, e2])
        }, e.getPointerPoint = t.getPointerPoint, e
    }), function (n, s) {
        typeof define == "function" && define.amd ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function (t, e, i) {
            return s(n, t, e, i)
        }) : typeof module == "object" && module.exports ? module.exports = s(n, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : n.Flickity = s(n, n.Flickity, n.Unidragger, n.fizzyUIUtils)
    }(window, function (i, t, e, a) {
        a.extend(t.defaults, {draggable: ">1", dragThreshold: 3}), t.createMethods.push("_createDrag");
        var n = t.prototype;
        a.extend(n, e.prototype), n._touchActionValue = "pan-y";
        var s = "createTouch" in document, o = !1;
        n._createDrag = function () {
            this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable), s && !o && (i.addEventListener("touchmove", function () {
            }), o = !0)
        }, n.onActivateDrag = function () {
            this.handles = [this.viewport], this.bindHandles(), this.updateDraggable()
        }, n.onDeactivateDrag = function () {
            this.unbindHandles(), this.element.classList.remove("is-draggable")
        }, n.updateDraggable = function () {
            this.options.draggable == ">1" ? this.isDraggable = 1 < this.slides.length : this.isDraggable = this.options.draggable, this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
        }, n.bindDrag = function () {
            this.options.draggable = !0, this.updateDraggable()
        }, n.unbindDrag = function () {
            this.options.draggable = !1, this.updateDraggable()
        }, n._uiChangeDrag = function () {
            delete this.isFreeScrolling
        }, n.pointerDown = function (t2, e2) {
            this.isDraggable ? this.okayPointerDown(t2) && (this._pointerDownPreventDefault(t2), this.pointerDownFocus(t2), document.activeElement != this.element && this.pointerDownBlur(), this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this.pointerDownScroll = l(), i.addEventListener("scroll", this), this._pointerDownDefault(t2, e2)) : this._pointerDownDefault(t2, e2)
        }, n._pointerDownDefault = function (t2, e2) {
            this.pointerDownPointer = {
                pageX: e2.pageX,
                pageY: e2.pageY
            }, this._bindPostStartEvents(t2), this.dispatchEvent("pointerDown", t2, [e2])
        };
        var r = {INPUT: !0, TEXTAREA: !0, SELECT: !0};

        function l() {
            return {x: i.pageXOffset, y: i.pageYOffset}
        }

        return n.pointerDownFocus = function (t2) {
            r[t2.target.nodeName] || this.focus()
        }, n._pointerDownPreventDefault = function (t2) {
            var e2 = t2.type == "touchstart", i2 = t2.pointerType == "touch", n2 = r[t2.target.nodeName];
            e2 || i2 || n2 || t2.preventDefault()
        }, n.hasDragStarted = function (t2) {
            return Math.abs(t2.x) > this.options.dragThreshold
        }, n.pointerUp = function (t2, e2) {
            delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", t2, [e2]), this._dragPointerUp(t2, e2)
        }, n.pointerDone = function () {
            i.removeEventListener("scroll", this), delete this.pointerDownScroll
        }, n.dragStart = function (t2, e2) {
            this.isDraggable && (this.dragStartPosition = this.x, this.startAnimation(), i.removeEventListener("scroll", this), this.dispatchEvent("dragStart", t2, [e2]))
        }, n.pointerMove = function (t2, e2) {
            var i2 = this._dragPointerMove(t2, e2);
            this.dispatchEvent("pointerMove", t2, [e2, i2]), this._dragMove(t2, e2, i2)
        }, n.dragMove = function (t2, e2, i2) {
            if (this.isDraggable) {
                t2.preventDefault(), this.previousDragX = this.dragX;
                var n2 = this.options.rightToLeft ? -1 : 1;
                this.options.wrapAround && (i2.x = i2.x % this.slideableWidth);
                var s2 = this.dragStartPosition + i2.x * n2;
                if (!this.options.wrapAround && this.slides.length) {
                    var o2 = Math.max(-this.slides[0].target, this.dragStartPosition);
                    s2 = o2 < s2 ? .5 * (s2 + o2) : s2;
                    var r2 = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                    s2 = s2 < r2 ? .5 * (s2 + r2) : s2
                }
                this.dragX = s2, this.dragMoveTime = new Date, this.dispatchEvent("dragMove", t2, [e2, i2])
            }
        }, n.dragEnd = function (t2, e2) {
            if (this.isDraggable) {
                this.options.freeScroll && (this.isFreeScrolling = !0);
                var i2 = this.dragEndRestingSelect();
                if (this.options.freeScroll && !this.options.wrapAround) {
                    var n2 = this.getRestingPosition();
                    this.isFreeScrolling = -n2 > this.slides[0].target && -n2 < this.getLastSlide().target
                } else this.options.freeScroll || i2 != this.selectedIndex || (i2 += this.dragEndBoostSelect());
                delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select(i2), delete this.isDragSelect, this.dispatchEvent("dragEnd", t2, [e2])
            }
        }, n.dragEndRestingSelect = function () {
            var t2 = this.getRestingPosition(), e2 = Math.abs(this.getSlideDistance(-t2, this.selectedIndex)),
                i2 = this._getClosestResting(t2, e2, 1), n2 = this._getClosestResting(t2, e2, -1);
            return i2.distance < n2.distance ? i2.index : n2.index
        }, n._getClosestResting = function (t2, e2, i2) {
            for (var n2 = this.selectedIndex, s2 = 1 / 0, o2 = this.options.contain && !this.options.wrapAround ? function (t3, e3) {
                return t3 <= e3
            } : function (t3, e3) {
                return t3 < e3
            }; o2(e2, s2) && (n2 += i2, s2 = e2, (e2 = this.getSlideDistance(-t2, n2)) !== null);) e2 = Math.abs(e2);
            return {distance: s2, index: n2 - i2}
        }, n.getSlideDistance = function (t2, e2) {
            var i2 = this.slides.length, n2 = this.options.wrapAround && 1 < i2, s2 = n2 ? a.modulo(e2, i2) : e2,
                o2 = this.slides[s2];
            if (!o2) return null;
            var r2 = n2 ? this.slideableWidth * Math.floor(e2 / i2) : 0;
            return t2 - (o2.target + r2)
        }, n.dragEndBoostSelect = function () {
            if (this.previousDragX === void 0 || !this.dragMoveTime || 100 < new Date - this.dragMoveTime) return 0;
            var t2 = this.getSlideDistance(-this.dragX, this.selectedIndex), e2 = this.previousDragX - this.dragX;
            return 0 < t2 && 0 < e2 ? 1 : t2 < 0 && e2 < 0 ? -1 : 0
        }, n.staticClick = function (t2, e2) {
            var i2 = this.getParentCell(t2.target), n2 = i2 && i2.element, s2 = i2 && this.cells.indexOf(i2);
            this.dispatchEvent("staticClick", t2, [e2, n2, s2])
        }, n.onscroll = function () {
            var t2 = l(), e2 = this.pointerDownScroll.x - t2.x, i2 = this.pointerDownScroll.y - t2.y;
            (3 < Math.abs(e2) || 3 < Math.abs(i2)) && this._pointerDone()
        }, t
    }), function (n, s) {
        typeof define == "function" && define.amd ? define("flickity/js/prev-next-button", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function (t, e, i) {
            return s(n, t, e, i)
        }) : typeof module == "object" && module.exports ? module.exports = s(n, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils)
    }(window, function (t, e, i, n) {
        "use strict";
        var s = "http://www.w3.org/2000/svg";

        function o(t2, e2) {
            this.direction = t2, this.parent = e2, this._create()
        }

        (o.prototype = Object.create(i.prototype))._create = function () {
            this.isEnabled = !0, this.isPrevious = this.direction == -1;
            var t2 = this.parent.options.rightToLeft ? 1 : -1;
            this.isLeft = this.direction == t2;
            var e2 = this.element = document.createElement("button");
            e2.className = "flickity-button flickity-prev-next-button", e2.className += this.isPrevious ? " previous" : " next", e2.setAttribute("type", "button"), this.disable(), e2.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
            var i2 = this.createSVG();
            e2.appendChild(i2), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
        }, o.prototype.activate = function () {
            this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element)
        }, o.prototype.deactivate = function () {
            this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this)
        }, o.prototype.createSVG = function () {
            var t2 = document.createElementNS(s, "svg");
            t2.setAttribute("class", "flickity-button-icon"), t2.setAttribute("viewBox", "0 0 100 100");
            var e2 = document.createElementNS(s, "path"), i2 = function (t3) {
                return typeof t3 != "string" ? "M " + t3.x0 + ",50 L " + t3.x1 + "," + (t3.y1 + 50) + " L " + t3.x2 + "," + (t3.y2 + 50) + " L " + t3.x3 + ",50  L " + t3.x2 + "," + (50 - t3.y2) + " L " + t3.x1 + "," + (50 - t3.y1) + " Z" : t3
            }(this.parent.options.arrowShape);
            return e2.setAttribute("d", i2), e2.setAttribute("class", "arrow"), this.isLeft || e2.setAttribute("transform", "translate(100, 100) rotate(180) "), t2.appendChild(e2), t2
        }, o.prototype.handleEvent = n.handleEvent, o.prototype.onclick = function () {
            if (this.isEnabled) {
                this.parent.uiChange();
                var t2 = this.isPrevious ? "previous" : "next";
                this.parent[t2]()
            }
        }, o.prototype.enable = function () {
            this.isEnabled || (this.element.disabled = !1, this.isEnabled = !0)
        }, o.prototype.disable = function () {
            this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1)
        }, o.prototype.update = function () {
            var t2 = this.parent.slides;
            if (this.parent.options.wrapAround && 1 < t2.length) this.enable(); else {
                var e2 = t2.length ? t2.length - 1 : 0, i2 = this.isPrevious ? 0 : e2;
                this[this.parent.selectedIndex == i2 ? "disable" : "enable"]()
            }
        }, o.prototype.destroy = function () {
            this.deactivate(), this.allOff()
        }, n.extend(e.defaults, {
            prevNextButtons: !0,
            arrowShape: {x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30}
        }), e.createMethods.push("_createPrevNextButtons");
        var r = e.prototype;
        return r._createPrevNextButtons = function () {
            this.options.prevNextButtons && (this.prevButton = new o(-1, this), this.nextButton = new o(1, this), this.on("activate", this.activatePrevNextButtons))
        }, r.activatePrevNextButtons = function () {
            this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons)
        }, r.deactivatePrevNextButtons = function () {
            this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons)
        }, e.PrevNextButton = o, e
    }), function (n, s) {
        typeof define == "function" && define.amd ? define("flickity/js/page-dots", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function (t, e, i) {
            return s(n, t, e, i)
        }) : typeof module == "object" && module.exports ? module.exports = s(n, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils)
    }(window, function (t, e, i, n) {
        function s(t2) {
            this.parent = t2, this._create()
        }

        (s.prototype = Object.create(i.prototype))._create = function () {
            this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", this.dots = [], this.handleClick = this.onClick.bind(this), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
        }, s.prototype.activate = function () {
            this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder)
        }, s.prototype.deactivate = function () {
            this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder)
        }, s.prototype.setDots = function () {
            var t2 = this.parent.slides.length - this.dots.length;
            0 < t2 ? this.addDots(t2) : t2 < 0 && this.removeDots(-t2)
        }, s.prototype.addDots = function (t2) {
            for (var e2 = document.createDocumentFragment(), i2 = [], n2 = this.dots.length, s2 = n2 + t2, o2 = n2; o2 < s2; o2++) {
                var r = document.createElement("li");
                r.className = "dot", r.setAttribute("aria-label", "Page dot " + (o2 + 1)), e2.appendChild(r), i2.push(r)
            }
            this.holder.appendChild(e2), this.dots = this.dots.concat(i2)
        }, s.prototype.removeDots = function (t2) {
            this.dots.splice(this.dots.length - t2, t2).forEach(function (t3) {
                this.holder.removeChild(t3)
            }, this)
        }, s.prototype.updateSelected = function () {
            this.selectedDot && (this.selectedDot.className = "dot", this.selectedDot.removeAttribute("aria-current")), this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], this.selectedDot.className = "dot is-selected", this.selectedDot.setAttribute("aria-current", "step"))
        }, s.prototype.onTap = s.prototype.onClick = function (t2) {
            var e2 = t2.target;
            if (e2.nodeName == "LI") {
                this.parent.uiChange();
                var i2 = this.dots.indexOf(e2);
                this.parent.select(i2)
            }
        }, s.prototype.destroy = function () {
            this.deactivate(), this.allOff()
        }, e.PageDots = s, n.extend(e.defaults, {pageDots: !0}), e.createMethods.push("_createPageDots");
        var o = e.prototype;
        return o._createPageDots = function () {
            this.options.pageDots && (this.pageDots = new s(this), this.on("activate", this.activatePageDots), this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots))
        }, o.activatePageDots = function () {
            this.pageDots.activate()
        }, o.updateSelectedPageDots = function () {
            this.pageDots.updateSelected()
        }, o.updatePageDots = function () {
            this.pageDots.setDots()
        }, o.deactivatePageDots = function () {
            this.pageDots.deactivate()
        }, e.PageDots = s, e
    }), function (t, n) {
        typeof define == "function" && define.amd ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function (t2, e, i) {
            return n(t2, e, i)
        }) : typeof module == "object" && module.exports ? module.exports = n(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : n(t.EvEmitter, t.fizzyUIUtils, t.Flickity)
    }(window, function (t, e, i) {
        function n(t2) {
            this.parent = t2, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind(this), this.onVisibilityPlay = this.visibilityPlay.bind(this)
        }

        (n.prototype = Object.create(t.prototype)).play = function () {
            this.state != "playing" && (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : (this.state = "playing", document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()))
        }, n.prototype.tick = function () {
            if (this.state == "playing") {
                var t2 = this.parent.options.autoPlay;
                t2 = typeof t2 == "number" ? t2 : 3e3;
                var e2 = this;
                this.clear(), this.timeout = setTimeout(function () {
                    e2.parent.next(!0), e2.tick()
                }, t2)
            }
        }, n.prototype.stop = function () {
            this.state = "stopped", this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange)
        }, n.prototype.clear = function () {
            clearTimeout(this.timeout)
        }, n.prototype.pause = function () {
            this.state == "playing" && (this.state = "paused", this.clear())
        }, n.prototype.unpause = function () {
            this.state == "paused" && this.play()
        }, n.prototype.visibilityChange = function () {
            this[document.hidden ? "pause" : "unpause"]()
        }, n.prototype.visibilityPlay = function () {
            this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay)
        }, e.extend(i.defaults, {pauseAutoPlayOnHover: !0}), i.createMethods.push("_createPlayer");
        var s = i.prototype;
        return s._createPlayer = function () {
            this.player = new n(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer)
        }, s.activatePlayer = function () {
            this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this))
        }, s.playPlayer = function () {
            this.player.play()
        }, s.stopPlayer = function () {
            this.player.stop()
        }, s.pausePlayer = function () {
            this.player.pause()
        }, s.unpausePlayer = function () {
            this.player.unpause()
        }, s.deactivatePlayer = function () {
            this.player.stop(), this.element.removeEventListener("mouseenter", this)
        }, s.onmouseenter = function () {
            this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this))
        }, s.onmouseleave = function () {
            this.player.unpause(), this.element.removeEventListener("mouseleave", this)
        }, i.Player = n, i
    }), function (i, n) {
        typeof define == "function" && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function (t, e) {
            return n(i, t, e)
        }) : typeof module == "object" && module.exports ? module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")) : n(i, i.Flickity, i.fizzyUIUtils)
    }(window, function (t, e, n) {
        var i = e.prototype;
        return i.insert = function (t2, e2) {
            var i2 = this._makeCells(t2);
            if (i2 && i2.length) {
                var n2 = this.cells.length;
                e2 = e2 === void 0 ? n2 : e2;
                var s = function (t3) {
                    var e3 = document.createDocumentFragment();
                    return t3.forEach(function (t4) {
                        e3.appendChild(t4.element)
                    }), e3
                }(i2), o = e2 == n2;
                if (o) this.slider.appendChild(s); else {
                    var r = this.cells[e2].element;
                    this.slider.insertBefore(s, r)
                }
                if (e2 === 0) this.cells = i2.concat(this.cells); else if (o) this.cells = this.cells.concat(i2); else {
                    var a = this.cells.splice(e2, n2 - e2);
                    this.cells = this.cells.concat(i2).concat(a)
                }
                this._sizeCells(i2), this.cellChange(e2, !0)
            }
        }, i.append = function (t2) {
            this.insert(t2, this.cells.length)
        }, i.prepend = function (t2) {
            this.insert(t2, 0)
        }, i.remove = function (t2) {
            var e2 = this.getCells(t2);
            if (e2 && e2.length) {
                var i2 = this.cells.length - 1;
                e2.forEach(function (t3) {
                    t3.remove();
                    var e3 = this.cells.indexOf(t3);
                    i2 = Math.min(e3, i2), n.removeFrom(this.cells, t3)
                }, this), this.cellChange(i2, !0)
            }
        }, i.cellSizeChange = function (t2) {
            var e2 = this.getCell(t2);
            if (e2) {
                e2.getSize();
                var i2 = this.cells.indexOf(e2);
                this.cellChange(i2)
            }
        }, i.cellChange = function (t2, e2) {
            var i2 = this.selectedElement;
            this._positionCells(t2), this._getWrapShiftCells(), this.setGallerySize();
            var n2 = this.getCell(i2);
            n2 && (this.selectedIndex = this.getCellSlideIndex(n2)), this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex), this.emitEvent("cellChange", [t2]), this.select(this.selectedIndex), e2 && this.positionSliderAtSelected()
        }, e
    }), function (i, n) {
        typeof define == "function" && define.amd ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function (t, e) {
            return n(i, t, e)
        }) : typeof module == "object" && module.exports ? module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")) : n(i, i.Flickity, i.fizzyUIUtils)
    }(window, function (t, e, o) {
        "use strict";
        e.createMethods.push("_createLazyload");
        var i = e.prototype;

        function s(t2, e2) {
            this.img = t2, this.flickity = e2, this.load()
        }

        return i._createLazyload = function () {
            this.on("select", this.lazyLoad)
        }, i.lazyLoad = function () {
            var t2 = this.options.lazyLoad;
            if (t2) {
                var e2 = typeof t2 == "number" ? t2 : 0, i2 = this.getAdjacentCellElements(e2), n = [];
                i2.forEach(function (t3) {
                    var e3 = function (t4) {
                        if (t4.nodeName == "IMG") {
                            var e4 = t4.getAttribute("data-flickity-lazyload"),
                                i3 = t4.getAttribute("data-flickity-lazyload-src"),
                                n2 = t4.getAttribute("data-flickity-lazyload-srcset");
                            if (e4 || i3 || n2) return [t4]
                        }
                        var s2 = t4.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");
                        return o.makeArray(s2)
                    }(t3);
                    n = n.concat(e3)
                }), n.forEach(function (t3) {
                    new s(t3, this)
                }, this)
            }
        }, s.prototype.handleEvent = o.handleEvent, s.prototype.load = function () {
            this.img.addEventListener("load", this), this.img.addEventListener("error", this);
            var t2 = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
                e2 = this.img.getAttribute("data-flickity-lazyload-srcset");
            this.img.src = t2, e2 && this.img.setAttribute("srcset", e2), this.img.removeAttribute("data-flickity-lazyload"), this.img.removeAttribute("data-flickity-lazyload-src"), this.img.removeAttribute("data-flickity-lazyload-srcset")
        }, s.prototype.onload = function (t2) {
            this.complete(t2, "flickity-lazyloaded")
        }, s.prototype.onerror = function (t2) {
            this.complete(t2, "flickity-lazyerror")
        }, s.prototype.complete = function (t2, e2) {
            this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            var i2 = this.flickity.getParentCell(this.img), n = i2 && i2.element;
            this.flickity.cellSizeChange(n), this.img.classList.add(e2), this.flickity.dispatchEvent("lazyLoad", t2, n)
        }, e.LazyLoader = s, e
    }), function (t, e) {
        typeof define == "function" && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], e) : typeof module == "object" && module.exports && (module.exports = e(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")))
    }(window, function (t) {
        return t
    }), function (t, e) {
        typeof define == "function" && define.amd ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], e) : typeof module == "object" && module.exports ? module.exports = e(require("flickity"), require("fizzy-ui-utils")) : t.Flickity = e(t.Flickity, t.fizzyUIUtils)
    }(window, function (n, s) {
        n.createMethods.push("_createAsNavFor");
        var t = n.prototype;
        return t._createAsNavFor = function () {
            this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
            var t2 = this.options.asNavFor;
            if (t2) {
                var e = this;
                setTimeout(function () {
                    e.setNavCompanion(t2)
                })
            }
        }, t.setNavCompanion = function (t2) {
            t2 = s.getQueryElement(t2);
            var e = n.data(t2);
            if (e && e != this) {
                this.navCompanion = e;
                var i = this;
                this.onNavCompanionSelect = function () {
                    i.navCompanionSelect()
                }, e.on("select", this.onNavCompanionSelect), this.on("staticClick", this.onNavStaticClick), this.navCompanionSelect(!0)
            }
        }, t.navCompanionSelect = function (t2) {
            var e = this.navCompanion && this.navCompanion.selectedCells;
            if (e) {
                var i = e[0], n2 = this.navCompanion.cells.indexOf(i), s2 = n2 + e.length - 1,
                    o = Math.floor(function (t3, e2, i2) {
                        return (e2 - t3) * i2 + t3
                    }(n2, s2, this.navCompanion.cellAlign));
                if (this.selectCell(o, !1, t2), this.removeNavSelectedElements(), !(o >= this.cells.length)) {
                    var r = this.cells.slice(n2, 1 + s2);
                    this.navSelectedElements = r.map(function (t3) {
                        return t3.element
                    }), this.changeNavSelectedClass("add")
                }
            }
        }, t.changeNavSelectedClass = function (e) {
            this.navSelectedElements.forEach(function (t2) {
                t2.classList[e]("is-nav-selected")
            })
        }, t.activateAsNavFor = function () {
            this.navCompanionSelect(!0)
        }, t.removeNavSelectedElements = function () {
            this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements)
        }, t.onNavStaticClick = function (t2, e, i, n2) {
            typeof n2 == "number" && this.navCompanion.selectCell(n2)
        }, t.deactivateAsNavFor = function () {
            this.removeNavSelectedElements()
        }, t.destroyAsNavFor = function () {
            this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion)
        }, n
    }), function (e, i) {
        "use strict";
        typeof define == "function" && define.amd ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function (t) {
            return i(e, t)
        }) : typeof module == "object" && module.exports ? module.exports = i(e, require("ev-emitter")) : e.imagesLoaded = i(e, e.EvEmitter)
    }(typeof window < "u" ? window : this, function (e, t) {
        var s = e.jQuery, o = e.console;

        function r(t2, e2) {
            for (var i2 in e2) t2[i2] = e2[i2];
            return t2
        }

        var a = Array.prototype.slice;

        function l(t2, e2, i2) {
            if (!(this instanceof l)) return new l(t2, e2, i2);
            var n2 = t2;
            typeof t2 == "string" && (n2 = document.querySelectorAll(t2)), n2 ? (this.elements = function (t3) {
                return Array.isArray(t3) ? t3 : typeof t3 == "object" && typeof t3.length == "number" ? a.call(t3) : [t3]
            }(n2), this.options = r({}, this.options), typeof e2 == "function" ? i2 = e2 : r(this.options, e2), i2 && this.on("always", i2), this.getImages(), s && (this.jqDeferred = new s.Deferred), setTimeout(this.check.bind(this))) : o.error("Bad element for imagesLoaded " + (n2 || t2))
        }

        (l.prototype = Object.create(t.prototype)).options = {}, l.prototype.getImages = function () {
            this.images = [], this.elements.forEach(this.addElementImages, this)
        }, l.prototype.addElementImages = function (t2) {
            t2.nodeName == "IMG" && this.addImage(t2), this.options.background === !0 && this.addElementBackgroundImages(t2);
            var e2 = t2.nodeType;
            if (e2 && h[e2]) {
                for (var i2 = t2.querySelectorAll("img"), n2 = 0; n2 < i2.length; n2++) {
                    var s2 = i2[n2];
                    this.addImage(s2)
                }
                if (typeof this.options.background == "string") {
                    var o2 = t2.querySelectorAll(this.options.background);
                    for (n2 = 0; n2 < o2.length; n2++) {
                        var r2 = o2[n2];
                        this.addElementBackgroundImages(r2)
                    }
                }
            }
        };
        var h = {1: !0, 9: !0, 11: !0};

        function i(t2) {
            this.img = t2
        }

        function n(t2, e2) {
            this.url = t2, this.element = e2, this.img = new Image
        }

        return l.prototype.addElementBackgroundImages = function (t2) {
            var e2 = getComputedStyle(t2);
            if (e2) for (var i2 = /url\((['"])?(.*?)\1\)/gi, n2 = i2.exec(e2.backgroundImage); n2 !== null;) {
                var s2 = n2 && n2[2];
                s2 && this.addBackground(s2, t2), n2 = i2.exec(e2.backgroundImage)
            }
        }, l.prototype.addImage = function (t2) {
            var e2 = new i(t2);
            this.images.push(e2)
        }, l.prototype.addBackground = function (t2, e2) {
            var i2 = new n(t2, e2);
            this.images.push(i2)
        }, l.prototype.check = function () {
            var n2 = this;

            function e2(t2, e3, i2) {
                setTimeout(function () {
                    n2.progress(t2, e3, i2)
                })
            }

            this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? this.images.forEach(function (t2) {
                t2.once("progress", e2), t2.check()
            }) : this.complete()
        }, l.prototype.progress = function (t2, e2, i2) {
            this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t2.isLoaded, this.emitEvent("progress", [this, t2, e2]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t2), this.progressedCount == this.images.length && this.complete(), this.options.debug && o && o.log("progress: " + i2, t2, e2)
        }, l.prototype.complete = function () {
            var t2 = this.hasAnyBroken ? "fail" : "done";
            if (this.isComplete = !0, this.emitEvent(t2, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
                var e2 = this.hasAnyBroken ? "reject" : "resolve";
                this.jqDeferred[e2](this)
            }
        }, (i.prototype = Object.create(t.prototype)).check = function () {
            this.getIsImageComplete() ? this.confirm(this.img.naturalWidth !== 0, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.proxyImage.src = this.img.src)
        }, i.prototype.getIsImageComplete = function () {
            return this.img.complete && this.img.naturalWidth
        }, i.prototype.confirm = function (t2, e2) {
            this.isLoaded = t2, this.emitEvent("progress", [this, this.img, e2])
        }, i.prototype.handleEvent = function (t2) {
            var e2 = "on" + t2.type;
            this[e2] && this[e2](t2)
        }, i.prototype.onload = function () {
            this.confirm(!0, "onload"), this.unbindEvents()
        }, i.prototype.onerror = function () {
            this.confirm(!1, "onerror"), this.unbindEvents()
        }, i.prototype.unbindEvents = function () {
            this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
        }, (n.prototype = Object.create(i.prototype)).check = function () {
            this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(this.img.naturalWidth !== 0, "naturalWidth"), this.unbindEvents())
        }, n.prototype.unbindEvents = function () {
            this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
        }, n.prototype.confirm = function (t2, e2) {
            this.isLoaded = t2, this.emitEvent("progress", [this, this.element, e2])
        }, l.makeJQueryPlugin = function (t2) {
            (t2 = t2 || e.jQuery) && ((s = t2).fn.imagesLoaded = function (t3, e2) {
                return new l(this, t3, e2).jqDeferred.promise(s(this))
            })
        }, l.makeJQueryPlugin(), l
    }), function (i, n) {
        typeof define == "function" && define.amd ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function (t, e) {
            return n(i, t, e)
        }) : typeof module == "object" && module.exports ? module.exports = n(i, require("flickity"), require("imagesloaded")) : i.Flickity = n(i, i.Flickity, i.imagesLoaded)
    }(window, function (t, e, i) {
        "use strict";
        e.createMethods.push("_createImagesLoaded");
        var n = e.prototype;
        return n._createImagesLoaded = function () {
            this.on("activate", this.imagesLoaded)
        }, n.imagesLoaded = function () {
            if (this.options.imagesLoaded) {
                var n2 = this;
                i(this.slider).on("progress", function (t2, e2) {
                    var i2 = n2.getParentCell(e2.img);
                    n2.cellSizeChange(i2 && i2.element), n2.options.freeScroll || n2.positionSliderAtSelected()
                })
            }
        }, e
    }), function (e, t) {
        typeof define == "function" && define.amd ? define(["flickity/js/index", "fizzy-ui-utils/utils"], t) : typeof module == "object" && module.exports ? module.exports = t(require("flickity"), require("fizzy-ui-utils")) : t(e.Flickity, e.fizzyUIUtils)
    }(this, function (e, t) {
        var i = e.Slide, s = i.prototype.updateTarget;
        i.prototype.updateTarget = function () {
            if (s.apply(this, arguments), this.parent.options.fade) {
                var e2 = this.target - this.x, t2 = this.cells[0].x;
                this.cells.forEach(function (i2) {
                    var s2 = i2.x - t2 - e2;
                    i2.renderPosition(s2)
                })
            }
        }, i.prototype.setOpacity = function (e2) {
            this.cells.forEach(function (t2) {
                t2.element.style.opacity = e2
            })
        };
        var a = e.prototype;
        e.createMethods.push("_createFade"), a._createFade = function () {
            this.fadeIndex = this.selectedIndex, this.prevSelectedIndex = this.selectedIndex, this.on("select", this.onSelectFade), this.on("dragEnd", this.onDragEndFade), this.on("settle", this.onSettleFade), this.on("activate", this.onActivateFade), this.on("deactivate", this.onDeactivateFade)
        };
        var n = a.updateSlides;
        a.updateSlides = function () {
            n.apply(this, arguments), this.options.fade && this.slides.forEach(function (e2, t2) {
                var i2 = t2 == this.selectedIndex ? 1 : 0;
                e2.setOpacity(i2)
            }, this)
        }, a.onSelectFade = function () {
            this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1), this.prevSelectedIndex = this.selectedIndex
        }, a.onSettleFade = function () {
            delete this.didDragEnd, this.options.fade && (this.selectedSlide.setOpacity(1), this.slides[this.fadeIndex] && this.fadeIndex != this.selectedIndex && this.slides[this.fadeIndex].setOpacity(0))
        }, a.onDragEndFade = function () {
            this.didDragEnd = !0
        }, a.onActivateFade = function () {
            this.options.fade && this.element.classList.add("is-fade")
        }, a.onDeactivateFade = function () {
            this.options.fade && (this.element.classList.remove("is-fade"), this.slides.forEach(function (e2) {
                e2.setOpacity("")
            }))
        };
        var d = a.positionSlider;
        a.positionSlider = function () {
            this.options.fade ? (this.fadeSlides(), this.dispatchScrollEvent()) : d.apply(this, arguments)
        };
        var h = a.positionSliderAtSelected;
        a.positionSliderAtSelected = function () {
            this.options.fade && this.setTranslateX(0), h.apply(this, arguments)
        }, a.fadeSlides = function () {
            if (!(this.slides.length < 2)) {
                var e2 = this.getFadeIndexes(), t2 = this.slides[e2.a], i2 = this.slides[e2.b],
                    s2 = this.wrapDifference(t2.target, i2.target), a2 = this.wrapDifference(t2.target, -this.x);
                a2 /= s2, t2.setOpacity(1 - a2), i2.setOpacity(a2);
                var n2 = e2.a;
                this.isDragging && (n2 = a2 > .5 ? e2.a : e2.b), this.fadeHideIndex != null && this.fadeHideIndex != n2 && this.fadeHideIndex != e2.a && this.fadeHideIndex != e2.b && this.slides[this.fadeHideIndex].setOpacity(0), this.fadeHideIndex = n2
            }
        }, a.getFadeIndexes = function () {
            return this.isDragging || this.didDragEnd ? this.options.wrapAround ? this.getFadeDragWrapIndexes() : this.getFadeDragLimitIndexes() : {
                a: this.fadeIndex,
                b: this.selectedIndex
            }
        }, a.getFadeDragWrapIndexes = function () {
            var e2 = this.slides.map(function (e3, t2) {
                    return this.getSlideDistance(-this.x, t2)
                }, this), i2 = e2.map(function (e3) {
                    return Math.abs(e3)
                }), s2 = Math.min.apply(Math, i2), a2 = i2.indexOf(s2), n2 = e2[a2], d2 = this.slides.length,
                h2 = n2 >= 0 ? 1 : -1;
            return {a: a2, b: t.modulo(a2 + h2, d2)}
        }, a.getFadeDragLimitIndexes = function () {
            for (var e2 = 0, t2 = 0; t2 < this.slides.length - 1; t2++) {
                var i2 = this.slides[t2];
                if (-this.x < i2.target) break;
                e2 = t2
            }
            return {a: e2, b: e2 + 1}
        }, a.wrapDifference = function (e2, t2) {
            var i2 = t2 - e2;
            if (!this.options.wrapAround) return i2;
            var s2 = i2 + this.slideableWidth, a2 = i2 - this.slideableWidth;
            return Math.abs(s2) < Math.abs(i2) && (i2 = s2), Math.abs(a2) < Math.abs(i2) && (i2 = a2), i2
        };
        var o = a._getWrapShiftCells;
        a._getWrapShiftCells = function () {
            this.options.fade || o.apply(this, arguments)
        };
        var r = a.shiftWrapCells;
        return a.shiftWrapCells = function () {
            this.options.fade || r.apply(this, arguments)
        }, e
    });/*!
* Flickity sync v2.0.0
* enable sync for Flickity
*/
    (function (t, n) {
        typeof define == "function" && define.amd ? define(["flickity/js/index", "fizzy-ui-utils/utils"], n) : typeof module == "object" && module.exports ? module.exports = n(require("flickity"), require("fizzy-ui-utils")) : t.Flickity = n(t.Flickity, t.fizzyUIUtils)
    })(window, function (t, n) {
        "use strict";
        return t.createMethods.push("_createSync"), t.prototype._createSync = function () {
            this.syncers = {};
            var t2 = this.options.sync;
            if (this.on("destroy", this.unsyncAll), t2) {
                var n2 = this;
                setTimeout(function () {
                    n2.sync(t2)
                })
            }
        }, t.prototype.sync = function (i) {
            i = n.getQueryElement(i);
            var e = t.data(i);
            e && (this._syncCompanion(e), e._syncCompanion(this))
        }, t.prototype._syncCompanion = function (t2) {
            var n2 = this;

            function i() {
                var i2 = n2.selectedIndex;
                t2.selectedIndex != i2 && t2.select(i2)
            }

            this.on("select", i), this.syncers[t2.guid] = {flickity: t2, listener: i}
        }, t.prototype.unsync = function (i) {
            i = n.getQueryElement(i);
            var e = t.data(i);
            this._unsync(e)
        }, t.prototype._unsync = function (t2) {
            t2 && (this._unsyncCompanion(t2), t2._unsyncCompanion(this))
        }, t.prototype._unsyncCompanion = function (t2) {
            var n2 = t2.guid, i = this.syncers[n2];
            this.off("select", i.listener), delete this.syncers[n2]
        }, t.prototype.unsyncAll = function () {
            for (var t2 in this.syncers) {
                var n2 = this.syncers[t2];
                this._unsync(n2.flickity)
            }
        }, t
    })
}(), function () {
    /**
     stickybits - Stickybits is a lightweight alternative to `position: sticky` polyfills
     @version v3.7.8
     @link https://github.com/yowainwright/stickybits#readme
     @author Jeff Wainwright <yowainwright@gmail.com> (https://jeffry.in)
     @license MIT
     **/(function (t, s) {
        typeof exports == "object" && typeof module < "u" ? module.exports = s() : typeof define == "function" && define.amd ? define(s) : (t = t || self).stickybits = s()
    })(this, function () {
        "use strict";

        function b() {
            return (b = Object.assign || function (t) {
                for (var s = 1; s < arguments.length; s++) {
                    var e2 = arguments[s];
                    for (var i in e2) Object.prototype.hasOwnProperty.call(e2, i) && (t[i] = e2[i])
                }
                return t
            }).apply(this, arguments)
        }

        var e = function () {
            function t(t2, s2) {
                var e2 = this, i = s2 !== void 0 ? s2 : {};
                this.version = "3.7.8", this.userAgent = window.navigator.userAgent || "no `userAgent` provided by the browser", this.props = {
                    customStickyChangeNumber: i.customStickyChangeNumber || null,
                    noStyles: i.noStyles || !1,
                    stickyBitStickyOffset: i.stickyBitStickyOffset || 0,
                    parentClass: i.parentClass || "js-stickybit-parent",
                    scrollEl: typeof i.scrollEl == "string" ? document.querySelector(i.scrollEl) : i.scrollEl || window,
                    stickyClass: i.stickyClass || "js-is-sticky",
                    stuckClass: i.stuckClass || "js-is-stuck",
                    stickyChangeClass: i.stickyChangeClass || "js-is-sticky--change",
                    useStickyClasses: i.useStickyClasses || !1,
                    useFixed: i.useFixed || !1,
                    useGetBoundingClientRect: i.useGetBoundingClientRect || !1,
                    verticalPosition: i.verticalPosition || "top",
                    applyStyle: i.applyStyle || function (t3, s3) {
                        return e2.applyStyle(t3, s3)
                    }
                }, this.props.positionVal = this.definePosition() || "fixed", this.instances = [];
                var n = this.props, o = n.positionVal, a = n.verticalPosition, l = n.noStyles,
                    r = n.stickyBitStickyOffset, c = a !== "top" || l ? "" : r + "px", p = o !== "fixed" ? o : "";
                this.els = typeof t2 == "string" ? document.querySelectorAll(t2) : t2, "length" in this.els || (this.els = [this.els]);
                for (var f = 0; f < this.els.length; f++) {
                    var u, y = this.els[f], h = this.addInstance(y, this.props);
                    this.props.applyStyle({
                        styles: ((u = {})[a] = c, u.position = p, u),
                        classes: {}
                    }, h), this.manageState(h), this.instances.push(h)
                }
            }

            var s = t.prototype;
            return s.definePosition = function () {
                var t2;
                if (this.props.useFixed) t2 = "fixed"; else {
                    for (var s2 = ["", "-o-", "-webkit-", "-moz-", "-ms-"], e2 = document.head.style, i = 0; i < s2.length; i += 1) e2.position = s2[i] + "sticky";
                    t2 = e2.position ? e2.position : "fixed", e2.position = ""
                }
                return t2
            }, s.addInstance = function (t2, s2) {
                var e2 = this, i = {el: t2, parent: t2.parentNode, props: s2};
                if (s2.positionVal === "fixed" || s2.useStickyClasses) {
                    this.isWin = this.props.scrollEl === window;
                    var n = this.isWin ? window : this.getClosestParent(i.el, i.props.scrollEl);
                    this.computeScrollOffsets(i), this.toggleClasses(i.parent, "", s2.parentClass), i.state = "default", i.stateChange = "default", i.stateContainer = function () {
                        return e2.manageState(i)
                    }, n.addEventListener("scroll", i.stateContainer)
                }
                return i
            }, s.getClosestParent = function (t2, s2) {
                var e2 = s2, i = t2;
                if (i.parentElement === e2) return e2;
                for (; i.parentElement !== e2;) i = i.parentElement;
                return e2
            }, s.getTopPosition = function (t2) {
                if (this.props.useGetBoundingClientRect) return t2.getBoundingClientRect().top + (this.props.scrollEl.pageYOffset || document.documentElement.scrollTop);
                for (var s2 = 0; s2 = t2.offsetTop + s2, t2 = t2.offsetParent;) ;
                return s2
            }, s.computeScrollOffsets = function (t2) {
                var s2 = t2, e2 = s2.props, i = s2.el, n = s2.parent, o = !this.isWin && e2.positionVal === "fixed",
                    a = e2.verticalPosition !== "bottom", l = o ? this.getTopPosition(e2.scrollEl) : 0,
                    r = o ? this.getTopPosition(n) - l : this.getTopPosition(n),
                    c = e2.customStickyChangeNumber !== null ? e2.customStickyChangeNumber : i.offsetHeight,
                    p = r + n.offsetHeight;
                s2.offset = o ? 0 : l + e2.stickyBitStickyOffset, s2.stickyStart = a ? r - s2.offset : 0, s2.stickyChange = s2.stickyStart + c, s2.stickyStop = a ? p - (i.offsetHeight + s2.offset) : p - window.innerHeight
            }, s.toggleClasses = function (t2, s2, e2) {
                var i = t2, n = i.className.split(" ");
                e2 && n.indexOf(e2) === -1 && n.push(e2);
                var o = n.indexOf(s2);
                o !== -1 && n.splice(o, 1), i.className = n.join(" ")
            }, s.manageState = function (r) {
                function t2(t3) {
                    t3()
                }

                var c = this, p = r, f = p.props, s2 = p.state, e2 = p.stateChange, i = p.stickyStart,
                    n = p.stickyChange, o = p.stickyStop, u = f.positionVal, a = f.scrollEl, y = f.stickyClass,
                    h = f.stickyChangeClass, d = f.stuckClass, g = f.verticalPosition, l = g !== "bottom",
                    k = f.applyStyle, m = f.noStyles,
                    v = this.isWin && (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame) || t2,
                    C = this.isWin ? window.scrollY || window.pageYOffset : a.scrollTop,
                    S = l && C <= i && (s2 === "sticky" || s2 === "stuck"), w = o <= C && s2 === "sticky";
                i < C && C < o && (s2 === "default" || s2 === "stuck") ? p.state = "sticky" : S ? p.state = "default" : w && (p.state = "stuck");
                var x = n <= C && C <= o;
                C < n / 2 || o < C ? p.stateChange = "default" : x && (p.stateChange = "sticky"), s2 === p.state && e2 === p.stateChange || v(function () {
                    var t3, s3, e3, i2, n2, o2, a2 = {
                        sticky: {
                            styles: ((t3 = {
                                position: u,
                                top: "",
                                bottom: ""
                            })[g] = f.stickyBitStickyOffset + "px", t3), classes: ((s3 = {})[y] = !0, s3)
                        },
                        default: {styles: ((e3 = {})[g] = "", e3), classes: {}},
                        stuck: {
                            styles: b(((i2 = {})[g] = "", i2), u === "fixed" && !m || !c.isWin ? {
                                position: "absolute",
                                top: "",
                                bottom: "0"
                            } : {}), classes: ((n2 = {})[d] = !0, n2)
                        }
                    };
                    u === "fixed" && (a2.default.styles.position = "");
                    var l2 = a2[p.state];
                    l2.classes = ((o2 = {})[d] = !!l2.classes[d], o2[y] = !!l2.classes[y], o2[h] = x, o2), k(l2, r)
                })
            }, s.applyStyle = function (t2, s2) {
                var e2 = t2.styles, i = t2.classes, n = s2.el, o = s2.props, a = n.style, l = o.noStyles,
                    r = n.className.split(" ");
                for (var c in i) if (i[c]) r.indexOf(c) === -1 && r.push(c); else {
                    var p = r.indexOf(c);
                    p !== -1 && r.splice(p, 1)
                }
                if (n.className = r.join(" "), e2.position && (a.position = e2.position), !l) for (var f in e2) a[f] = e2[f]
            }, s.update = function (e2) {
                var i = this;
                return e2 === void 0 && (e2 = null), this.instances.forEach(function (t2) {
                    if (i.computeScrollOffsets(t2), e2) for (var s2 in e2) t2.props[s2] = e2[s2]
                }), this
            }, s.removeInstance = function (t2) {
                var s2, e2, i = t2.el, n = t2.props;
                this.applyStyle({
                    styles: ((s2 = {position: ""})[n.verticalPosition] = "", s2),
                    classes: ((e2 = {})[n.stickyClass] = "", e2[n.stuckClass] = "", e2)
                }, t2), this.toggleClasses(i.parentNode, n.parentClass)
            }, s.cleanup = function () {
                for (var t2 = 0; t2 < this.instances.length; t2 += 1) {
                    var s2 = this.instances[t2];
                    s2.stateContainer && s2.props.scrollEl.removeEventListener("scroll", s2.stateContainer), this.removeInstance(s2)
                }
                this.manageState = !1, this.instances = []
            }, t
        }();
        return function (t, s) {
            return new e(t, s)
        }
    })
}(), function () {/*! PhotoSwipe - v4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */
    (function (a, b) {
        typeof define == "function" && define.amd ? define(b) : typeof exports == "object" ? module.exports = b() : a.PhotoSwipe = b()
    })(this, function () {
        "use strict";
        var a = function (a2, b, c, d) {
            var e = {
                features: null, bind: function (a3, b2, c2, d2) {
                    var e2 = (d2 ? "remove" : "add") + "EventListener";
                    b2 = b2.split(" ");
                    for (var f2 = 0; f2 < b2.length; f2++) b2[f2] && a3[e2](b2[f2], c2, !1)
                }, isArray: function (a3) {
                    return a3 instanceof Array
                }, createEl: function (a3, b2) {
                    var c2 = document.createElement(b2 || "div");
                    return a3 && (c2.className = a3), c2
                }, getScrollY: function () {
                    var a3 = window.pageYOffset;
                    return a3 !== void 0 ? a3 : document.documentElement.scrollTop
                }, unbind: function (a3, b2, c2) {
                    e.bind(a3, b2, c2, !0)
                }, removeClass: function (a3, b2) {
                    var c2 = new RegExp("(\\s|^)" + b2 + "(\\s|$)");
                    a3.className = a3.className.replace(c2, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
                }, addClass: function (a3, b2) {
                    e.hasClass(a3, b2) || (a3.className += (a3.className ? " " : "") + b2)
                }, hasClass: function (a3, b2) {
                    return a3.className && new RegExp("(^|\\s)" + b2 + "(\\s|$)").test(a3.className)
                }, getChildByClass: function (a3, b2) {
                    for (var c2 = a3.firstChild; c2;) {
                        if (e.hasClass(c2, b2)) return c2;
                        c2 = c2.nextSibling
                    }
                }, arraySearch: function (a3, b2, c2) {
                    for (var d2 = a3.length; d2--;) if (a3[d2][c2] === b2) return d2;
                    return -1
                }, extend: function (a3, b2, c2) {
                    for (var d2 in b2) if (b2.hasOwnProperty(d2)) {
                        if (c2 && a3.hasOwnProperty(d2)) continue;
                        a3[d2] = b2[d2]
                    }
                }, easing: {
                    sine: {
                        out: function (a3) {
                            return Math.sin(a3 * (Math.PI / 2))
                        }, inOut: function (a3) {
                            return -(Math.cos(Math.PI * a3) - 1) / 2
                        }
                    }, cubic: {
                        out: function (a3) {
                            return --a3 * a3 * a3 + 1
                        }
                    }
                }, detectFeatures: function () {
                    if (e.features) return e.features;
                    var a3 = e.createEl(), b2 = a3.style, c2 = "", d2 = {};
                    if (d2.oldIE = document.all && !document.addEventListener, d2.touch = "ontouchstart" in window, window.requestAnimationFrame && (d2.raf = window.requestAnimationFrame, d2.caf = window.cancelAnimationFrame), d2.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled, !d2.pointerEvent) {
                        var f2 = navigator.userAgent;
                        if (/iP(hone|od)/.test(navigator.platform)) {
                            var g2 = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                            g2 && g2.length > 0 && (g2 = parseInt(g2[1], 10), g2 >= 1 && g2 < 8 && (d2.isOldIOSPhone = !0))
                        }
                        var h2 = f2.match(/Android\s([0-9\.]*)/), i2 = h2 ? h2[1] : 0;
                        i2 = parseFloat(i2), i2 >= 1 && (i2 < 4.4 && (d2.isOldAndroid = !0), d2.androidVersion = i2), d2.isMobileOpera = /opera mini|opera mobi/i.test(f2)
                    }
                    for (var j2, k2, l2 = ["transform", "perspective", "animationName"], m2 = ["", "webkit", "Moz", "ms", "O"], n2 = 0; n2 < 4; n2++) {
                        c2 = m2[n2];
                        for (var o2 = 0; o2 < 3; o2++) j2 = l2[o2], k2 = c2 + (c2 ? j2.charAt(0).toUpperCase() + j2.slice(1) : j2), !d2[j2] && k2 in b2 && (d2[j2] = k2);
                        c2 && !d2.raf && (c2 = c2.toLowerCase(), d2.raf = window[c2 + "RequestAnimationFrame"], d2.raf && (d2.caf = window[c2 + "CancelAnimationFrame"] || window[c2 + "CancelRequestAnimationFrame"]))
                    }
                    if (!d2.raf) {
                        var p2 = 0;
                        d2.raf = function (a4) {
                            var b3 = new Date().getTime(), c3 = Math.max(0, 16 - (b3 - p2)),
                                d3 = window.setTimeout(function () {
                                    a4(b3 + c3)
                                }, c3);
                            return p2 = b3 + c3, d3
                        }, d2.caf = function (a4) {
                            clearTimeout(a4)
                        }
                    }
                    return d2.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect, e.features = d2, d2
                }
            };
            e.detectFeatures(), e.features.oldIE && (e.bind = function (a3, b2, c2, d2) {
                b2 = b2.split(" ");
                for (var e2, f2 = (d2 ? "detach" : "attach") + "Event", g2 = function () {
                    c2.handleEvent.call(c2)
                }, h2 = 0; h2 < b2.length; h2++) if (e2 = b2[h2]) if (typeof c2 == "object" && c2.handleEvent) {
                    if (d2) {
                        if (!c2["oldIE" + e2]) return !1
                    } else c2["oldIE" + e2] = g2;
                    a3[f2]("on" + e2, c2["oldIE" + e2])
                } else a3[f2]("on" + e2, c2)
            });
            var f = this, g = 25, h = 3, i = {
                allowPanToNext: !0,
                spacing: .12,
                bgOpacity: 1,
                mouseUsed: !1,
                loop: !0,
                pinchToClose: !0,
                closeOnScroll: !0,
                closeOnVerticalDrag: !0,
                verticalDragRange: .75,
                hideAnimationDuration: 333,
                showAnimationDuration: 333,
                showHideOpacity: !1,
                focus: !0,
                escKey: !0,
                arrowKeys: !0,
                mainScrollEndFriction: .35,
                panEndFriction: .35,
                isClickableElement: function (a3) {
                    return a3.tagName === "A"
                },
                getDoubleTapZoom: function (a3, b2) {
                    return a3 || b2.initialZoomLevel < .7 ? 1 : 1.33
                },
                maxSpreadZoom: 1.33,
                modal: !0,
                scaleMode: "fit"
            };
            e.extend(i, d);
            var j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z, A, B, C, D, E, F, G, H, I, J, K, L, M, N, O, P, Q, R,
                S, T, U, V, W, X, Y, Z, $, _2, aa, ba, ca, da, ea, fa, ga, ha, ia, ja, ka, la, ma = function () {
                    return {x: 0, y: 0}
                }, na = ma(), oa = ma(), pa = ma(), qa = {}, ra = 0, sa = {}, ta = ma(), ua = 0, va = !0, wa = [], xa = {},
                ya = !1, za = function (a3, b2) {
                    e.extend(f, b2.publicMethods), wa.push(a3)
                }, Aa = function (a3) {
                    var b2 = ac();
                    return a3 > b2 - 1 ? a3 - b2 : a3 < 0 ? b2 + a3 : a3
                }, Ba = {}, Ca = function (a3, b2) {
                    return Ba[a3] || (Ba[a3] = []), Ba[a3].push(b2)
                }, Da = function (a3) {
                    var b2 = Ba[a3];
                    if (b2) {
                        var c2 = Array.prototype.slice.call(arguments);
                        c2.shift();
                        for (var d2 = 0; d2 < b2.length; d2++) b2[d2].apply(f, c2)
                    }
                }, Ea = function () {
                    return new Date().getTime()
                }, Fa = function (a3) {
                    ja = a3, f.bg.style.opacity = a3 * i.bgOpacity
                }, Ga = function (a3, b2, c2, d2, e2) {
                    (!ya || e2 && e2 !== f.currItem) && (d2 /= e2 ? e2.fitRatio : f.currItem.fitRatio), a3[E] = u + b2 + "px, " + c2 + "px" + v + " scale(" + d2 + ")"
                }, Ha = function (a3) {
                    ea && (a3 && (s > f.currItem.fitRatio ? ya || (mc(f.currItem, !1, !0), ya = !0) : ya && (mc(f.currItem), ya = !1)), Ga(ea, pa.x, pa.y, s))
                }, Ia = function (a3) {
                    a3.container && Ga(a3.container.style, a3.initialPosition.x, a3.initialPosition.y, a3.initialZoomLevel, a3)
                }, Ja = function (a3, b2) {
                    b2[E] = u + a3 + "px, 0px" + v
                }, Ka = function (a3, b2) {
                    if (!i.loop && b2) {
                        var c2 = m + (ta.x * ra - a3) / ta.x, d2 = Math.round(a3 - tb.x);
                        (c2 < 0 && d2 > 0 || c2 >= ac() - 1 && d2 < 0) && (a3 = tb.x + d2 * i.mainScrollEndFriction)
                    }
                    tb.x = a3, Ja(a3, n)
                }, La = function (a3, b2) {
                    var c2 = ub[a3] - sa[a3];
                    return oa[a3] + na[a3] + c2 - c2 * (b2 / t)
                }, Ma = function (a3, b2) {
                    a3.x = b2.x, a3.y = b2.y, b2.id && (a3.id = b2.id)
                }, Na = function (a3) {
                    a3.x = Math.round(a3.x), a3.y = Math.round(a3.y)
                }, Oa = null, Pa = function () {
                    Oa && (e.unbind(document, "mousemove", Pa), e.addClass(a2, "pswp--has_mouse"), i.mouseUsed = !0, Da("mouseUsed")), Oa = setTimeout(function () {
                        Oa = null
                    }, 100)
                }, Qa = function () {
                    e.bind(document, "keydown", f), N.transform && e.bind(f.scrollWrap, "click", f), i.mouseUsed || e.bind(document, "mousemove", Pa), e.bind(window, "resize scroll orientationchange", f), Da("bindEvents")
                }, Ra = function () {
                    e.unbind(window, "resize scroll orientationchange", f), e.unbind(window, "scroll", r.scroll), e.unbind(document, "keydown", f), e.unbind(document, "mousemove", Pa), N.transform && e.unbind(f.scrollWrap, "click", f), V && e.unbind(window, p, f), clearTimeout(O), Da("unbindEvents")
                }, Sa = function (a3, b2) {
                    var c2 = ic(f.currItem, qa, a3);
                    return b2 && (da = c2), c2
                }, Ta = function (a3) {
                    return a3 || (a3 = f.currItem), a3.initialZoomLevel
                }, Ua = function (a3) {
                    return a3 || (a3 = f.currItem), a3.w > 0 ? i.maxSpreadZoom : 1
                }, Va = function (a3, b2, c2, d2) {
                    return d2 === f.currItem.initialZoomLevel ? (c2[a3] = f.currItem.initialPosition[a3], !0) : (c2[a3] = La(a3, d2), c2[a3] > b2.min[a3] ? (c2[a3] = b2.min[a3], !0) : c2[a3] < b2.max[a3] && (c2[a3] = b2.max[a3], !0))
                }, Wa = function () {
                    if (E) {
                        var b2 = N.perspective && !G;
                        return u = "translate" + (b2 ? "3d(" : "("), void (v = N.perspective ? ", 0px)" : ")")
                    }
                    E = "left", e.addClass(a2, "pswp--ie"), Ja = function (a3, b3) {
                        b3.left = a3 + "px"
                    }, Ia = function (a3) {
                        var b3 = a3.fitRatio > 1 ? 1 : a3.fitRatio, c2 = a3.container.style, d2 = b3 * a3.w, e2 = b3 * a3.h;
                        c2.width = d2 + "px", c2.height = e2 + "px", c2.left = a3.initialPosition.x + "px", c2.top = a3.initialPosition.y + "px"
                    }, Ha = function () {
                        if (ea) {
                            var a3 = ea, b3 = f.currItem, c2 = b3.fitRatio > 1 ? 1 : b3.fitRatio, d2 = c2 * b3.w,
                                e2 = c2 * b3.h;
                            a3.width = d2 + "px", a3.height = e2 + "px", a3.left = pa.x + "px", a3.top = pa.y + "px"
                        }
                    }
                }, Xa = function (a3) {
                    var b2 = "";
                    i.escKey && a3.keyCode === 27 ? b2 = "close" : i.arrowKeys && (a3.keyCode === 37 ? b2 = "prev" : a3.keyCode === 39 && (b2 = "next")), b2 && (a3.ctrlKey || a3.altKey || a3.shiftKey || a3.metaKey || (a3.preventDefault ? a3.preventDefault() : a3.returnValue = !1, f[b2]()))
                }, Ya = function (a3) {
                    a3 && (Y || X || fa || T) && (a3.preventDefault(), a3.stopPropagation())
                }, Za = function () {
                    f.setScrollOffset(0, e.getScrollY())
                }, $a = {}, _a = 0, ab = function (a3) {
                    $a[a3] && ($a[a3].raf && I($a[a3].raf), _a--, delete $a[a3])
                }, bb = function (a3) {
                    $a[a3] && ab(a3), $a[a3] || (_a++, $a[a3] = {})
                }, cb = function () {
                    for (var a3 in $a) $a.hasOwnProperty(a3) && ab(a3)
                }, db = function (a3, b2, c2, d2, e2, f2, g2) {
                    var h2, i2 = Ea();
                    bb(a3);
                    var j2 = function () {
                        if ($a[a3]) {
                            if (h2 = Ea() - i2, h2 >= d2) return ab(a3), f2(c2), void (g2 && g2());
                            f2((c2 - b2) * e2(h2 / d2) + b2), $a[a3].raf = H(j2)
                        }
                    };
                    j2()
                }, eb = {
                    shout: Da, listen: Ca, viewportSize: qa, options: i, isMainScrollAnimating: function () {
                        return fa
                    }, getZoomLevel: function () {
                        return s
                    }, getCurrentIndex: function () {
                        return m
                    }, isDragging: function () {
                        return V
                    }, isZooming: function () {
                        return aa
                    }, setScrollOffset: function (a3, b2) {
                        sa.x = a3, M = sa.y = b2, Da("updateScrollOffset", sa)
                    }, applyZoomPan: function (a3, b2, c2, d2) {
                        pa.x = b2, pa.y = c2, s = a3, Ha(d2)
                    }, init: function () {
                        if (!j && !k) {
                            var c2;
                            f.framework = e, f.template = a2, f.bg = e.getChildByClass(a2, "pswp__bg"), J = a2.className, j = !0, N = e.detectFeatures(), H = N.raf, I = N.caf, E = N.transform, L = N.oldIE, f.scrollWrap = e.getChildByClass(a2, "pswp__scroll-wrap"), f.container = e.getChildByClass(f.scrollWrap, "pswp__container"), n = f.container.style, f.itemHolders = y = [{
                                el: f.container.children[0],
                                wrap: 0,
                                index: -1
                            }, {el: f.container.children[1], wrap: 0, index: -1}, {
                                el: f.container.children[2],
                                wrap: 0,
                                index: -1
                            }], y[0].el.style.display = y[2].el.style.display = "none", Wa(), r = {
                                resize: f.updateSize,
                                orientationchange: function () {
                                    clearTimeout(O), O = setTimeout(function () {
                                        qa.x !== f.scrollWrap.clientWidth && f.updateSize()
                                    }, 500)
                                },
                                scroll: Za,
                                keydown: Xa,
                                click: Ya
                            };
                            var d2 = N.isOldIOSPhone || N.isOldAndroid || N.isMobileOpera;
                            for (N.animationName && N.transform && !d2 || (i.showAnimationDuration = i.hideAnimationDuration = 0), c2 = 0; c2 < wa.length; c2++) f["init" + wa[c2]]();
                            if (b) {
                                var g2 = f.ui = new b(f, e);
                                g2.init()
                            }
                            Da("firstUpdate"), m = m || i.index || 0, (isNaN(m) || m < 0 || m >= ac()) && (m = 0), f.currItem = _b(m), (N.isOldIOSPhone || N.isOldAndroid) && (va = !1), a2.setAttribute("aria-hidden", "false"), i.modal && (va ? a2.style.position = "fixed" : (a2.style.position = "absolute", a2.style.top = e.getScrollY() + "px")), M === void 0 && (Da("initialLayout"), M = K = e.getScrollY());
                            var l2 = "pswp--open ";
                            for (i.mainClass && (l2 += i.mainClass + " "), i.showHideOpacity && (l2 += "pswp--animate_opacity "), l2 += G ? "pswp--touch" : "pswp--notouch", l2 += N.animationName ? " pswp--css_animation" : "", l2 += N.svg ? " pswp--svg" : "", e.addClass(a2, l2), f.updateSize(), o = -1, ua = null, c2 = 0; c2 < h; c2++) Ja((c2 + o) * ta.x, y[c2].el.style);
                            L || e.bind(f.scrollWrap, q, f), Ca("initialZoomInEnd", function () {
                                f.setContent(y[0], m - 1), f.setContent(y[2], m + 1), y[0].el.style.display = y[2].el.style.display = "block", i.focus && a2.focus(), Qa()
                            }), f.setContent(y[1], m), f.updateCurrItem(), Da("afterInit"), va || (w = setInterval(function () {
                                _a || V || aa || s !== f.currItem.initialZoomLevel || f.updateSize()
                            }, 1e3)), e.addClass(a2, "pswp--visible")
                        }
                    }, close: function () {
                        j && (j = !1, k = !0, Da("close"), Ra(), cc(f.currItem, null, !0, f.destroy))
                    }, destroy: function () {
                        Da("destroy"), Xb && clearTimeout(Xb), a2.setAttribute("aria-hidden", "true"), a2.className = J, w && clearInterval(w), e.unbind(f.scrollWrap, q, f), e.unbind(window, "scroll", f), zb(), cb(), Ba = null
                    }, panTo: function (a3, b2, c2) {
                        c2 || (a3 > da.min.x ? a3 = da.min.x : a3 < da.max.x && (a3 = da.max.x), b2 > da.min.y ? b2 = da.min.y : b2 < da.max.y && (b2 = da.max.y)), pa.x = a3, pa.y = b2, Ha()
                    }, handleEvent: function (a3) {
                        a3 = a3 || window.event, r[a3.type] && r[a3.type](a3)
                    }, goTo: function (a3) {
                        a3 = Aa(a3);
                        var b2 = a3 - m;
                        ua = b2, m = a3, f.currItem = _b(m), ra -= b2, Ka(ta.x * ra), cb(), fa = !1, f.updateCurrItem()
                    }, next: function () {
                        f.goTo(m + 1)
                    }, prev: function () {
                        f.goTo(m - 1)
                    }, updateCurrZoomItem: function (a3) {
                        if (a3 && Da("beforeChange", 0), y[1].el.children.length) {
                            var b2 = y[1].el.children[0];
                            ea = e.hasClass(b2, "pswp__zoom-wrap") ? b2.style : null
                        } else ea = null;
                        da = f.currItem.bounds, t = s = f.currItem.initialZoomLevel, pa.x = da.center.x, pa.y = da.center.y, a3 && Da("afterChange")
                    }, invalidateCurrItems: function () {
                        x = !0;
                        for (var a3 = 0; a3 < h; a3++) y[a3].item && (y[a3].item.needsUpdate = !0)
                    }, updateCurrItem: function (a3) {
                        if (ua !== 0) {
                            var b2, c2 = Math.abs(ua);
                            if (!(a3 && c2 < 2)) {
                                f.currItem = _b(m), ya = !1, Da("beforeChange", ua), c2 >= h && (o += ua + (ua > 0 ? -h : h), c2 = h);
                                for (var d2 = 0; d2 < c2; d2++) ua > 0 ? (b2 = y.shift(), y[h - 1] = b2, o++, Ja((o + 2) * ta.x, b2.el.style), f.setContent(b2, m - c2 + d2 + 1 + 1)) : (b2 = y.pop(), y.unshift(b2), o--, Ja(o * ta.x, b2.el.style), f.setContent(b2, m + c2 - d2 - 1 - 1));
                                if (ea && Math.abs(ua) === 1) {
                                    var e2 = _b(z);
                                    e2.initialZoomLevel !== s && (ic(e2, qa), mc(e2), Ia(e2))
                                }
                                ua = 0, f.updateCurrZoomItem(), z = m, Da("afterChange")
                            }
                        }
                    }, updateSize: function (b2) {
                        if (!va && i.modal) {
                            var c2 = e.getScrollY();
                            if (M !== c2 && (a2.style.top = c2 + "px", M = c2), !b2 && xa.x === window.innerWidth && xa.y === window.innerHeight) return;
                            xa.x = window.innerWidth, xa.y = window.innerHeight, a2.style.height = xa.y + "px"
                        }
                        if (qa.x = f.scrollWrap.clientWidth, qa.y = f.scrollWrap.clientHeight, Za(), ta.x = qa.x + Math.round(qa.x * i.spacing), ta.y = qa.y, Ka(ta.x * ra), Da("beforeResize"), o !== void 0) {
                            for (var d2, g2, j2, k2 = 0; k2 < h; k2++) d2 = y[k2], Ja((k2 + o) * ta.x, d2.el.style), j2 = m + k2 - 1, i.loop && ac() > 2 && (j2 = Aa(j2)), g2 = _b(j2), g2 && (x || g2.needsUpdate || !g2.bounds) ? (f.cleanSlide(g2), f.setContent(d2, j2), k2 === 1 && (f.currItem = g2, f.updateCurrZoomItem(!0)), g2.needsUpdate = !1) : d2.index === -1 && j2 >= 0 && f.setContent(d2, j2), g2 && g2.container && (ic(g2, qa), mc(g2), Ia(g2));
                            x = !1
                        }
                        t = s = f.currItem.initialZoomLevel, da = f.currItem.bounds, da && (pa.x = da.center.x, pa.y = da.center.y, Ha(!0)), Da("resize")
                    }, zoomTo: function (a3, b2, c2, d2, f2) {
                        b2 && (t = s, ub.x = Math.abs(b2.x) - pa.x, ub.y = Math.abs(b2.y) - pa.y, Ma(oa, pa));
                        var g2 = Sa(a3, !1), h2 = {};
                        Va("x", g2, h2, a3), Va("y", g2, h2, a3);
                        var i2 = s, j2 = {x: pa.x, y: pa.y};
                        Na(h2);
                        var k2 = function (b3) {
                            b3 === 1 ? (s = a3, pa.x = h2.x, pa.y = h2.y) : (s = (a3 - i2) * b3 + i2, pa.x = (h2.x - j2.x) * b3 + j2.x, pa.y = (h2.y - j2.y) * b3 + j2.y), f2 && f2(b3), Ha(b3 === 1)
                        };
                        c2 ? db("customZoomTo", 0, 1, c2, d2 || e.easing.sine.inOut, k2) : k2(1)
                    }
                }, fb = 30, gb = 10, hb = {}, ib = {}, jb = {}, kb = {}, lb = {}, mb = [], nb = {}, ob = [], pb = {},
                qb = 0, rb = ma(), sb = 0, tb = ma(), ub = ma(), vb = ma(), wb = function (a3, b2) {
                    return a3.x === b2.x && a3.y === b2.y
                }, xb = function (a3, b2) {
                    return Math.abs(a3.x - b2.x) < g && Math.abs(a3.y - b2.y) < g
                }, yb = function (a3, b2) {
                    return pb.x = Math.abs(a3.x - b2.x), pb.y = Math.abs(a3.y - b2.y), Math.sqrt(pb.x * pb.x + pb.y * pb.y)
                }, zb = function () {
                    Z && (I(Z), Z = null)
                }, Ab = function () {
                    V && (Z = H(Ab), Qb())
                }, Bb = function () {
                    return !(i.scaleMode === "fit" && s === f.currItem.initialZoomLevel)
                }, Cb = function (a3, b2) {
                    return !(!a3 || a3 === document) && !(a3.getAttribute("class") && a3.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (b2(a3) ? a3 : Cb(a3.parentNode, b2))
                }, Db = {}, Eb = function (a3, b2) {
                    return Db.prevent = !Cb(a3.target, i.isClickableElement), Da("preventDragEvent", a3, b2, Db), Db.prevent
                }, Fb = function (a3, b2) {
                    return b2.x = a3.pageX, b2.y = a3.pageY, b2.id = a3.identifier, b2
                }, Gb = function (a3, b2, c2) {
                    c2.x = .5 * (a3.x + b2.x), c2.y = .5 * (a3.y + b2.y)
                }, Hb = function (a3, b2, c2) {
                    if (a3 - Q > 50) {
                        var d2 = ob.length > 2 ? ob.shift() : {};
                        d2.x = b2, d2.y = c2, ob.push(d2), Q = a3
                    }
                }, Ib = function () {
                    var a3 = pa.y - f.currItem.initialPosition.y;
                    return 1 - Math.abs(a3 / (qa.y / 2))
                }, Jb = {}, Kb = {}, Lb = [], Mb = function (a3) {
                    for (; Lb.length > 0;) Lb.pop();
                    return F ? (la = 0, mb.forEach(function (a4) {
                        la === 0 ? Lb[0] = a4 : la === 1 && (Lb[1] = a4), la++
                    })) : a3.type.indexOf("touch") > -1 ? a3.touches && a3.touches.length > 0 && (Lb[0] = Fb(a3.touches[0], Jb), a3.touches.length > 1 && (Lb[1] = Fb(a3.touches[1], Kb))) : (Jb.x = a3.pageX, Jb.y = a3.pageY, Jb.id = "", Lb[0] = Jb), Lb
                }, Nb = function (a3, b2) {
                    var c2, d2, e2, g2, h2 = 0, j2 = pa[a3] + b2[a3], k2 = b2[a3] > 0, l2 = tb.x + b2.x, m2 = tb.x - nb.x;
                    return c2 = j2 > da.min[a3] || j2 < da.max[a3] ? i.panEndFriction : 1, j2 = pa[a3] + b2[a3] * c2, !i.allowPanToNext && s !== f.currItem.initialZoomLevel || (ea ? ga !== "h" || a3 !== "x" || X || (k2 ? (j2 > da.min[a3] && (c2 = i.panEndFriction, h2 = da.min[a3] - j2, d2 = da.min[a3] - oa[a3]), (d2 <= 0 || m2 < 0) && ac() > 1 ? (g2 = l2, m2 < 0 && l2 > nb.x && (g2 = nb.x)) : da.min.x !== da.max.x && (e2 = j2)) : (j2 < da.max[a3] && (c2 = i.panEndFriction, h2 = j2 - da.max[a3], d2 = oa[a3] - da.max[a3]), (d2 <= 0 || m2 > 0) && ac() > 1 ? (g2 = l2, m2 > 0 && l2 < nb.x && (g2 = nb.x)) : da.min.x !== da.max.x && (e2 = j2))) : g2 = l2, a3 !== "x") ? void (fa || $ || s > f.currItem.fitRatio && (pa[a3] += b2[a3] * c2)) : (g2 !== void 0 && (Ka(g2, !0), $ = g2 !== nb.x), da.min.x !== da.max.x && (e2 !== void 0 ? pa.x = e2 : $ || (pa.x += b2.x * c2)), g2 !== void 0)
                }, Ob = function (a3) {
                    if (!(a3.type === "mousedown" && a3.button > 0)) {
                        if ($b) return void a3.preventDefault();
                        if (!U || a3.type !== "mousedown") {
                            if (Eb(a3, !0) && a3.preventDefault(), Da("pointerDown"), F) {
                                var b2 = e.arraySearch(mb, a3.pointerId, "id");
                                b2 < 0 && (b2 = mb.length), mb[b2] = {x: a3.pageX, y: a3.pageY, id: a3.pointerId}
                            }
                            var c2 = Mb(a3), d2 = c2.length;
                            _2 = null, cb(), V && d2 !== 1 || (V = ha = !0, e.bind(window, p, f), S = ka = ia = T = $ = Y = W = X = !1, ga = null, Da("firstTouchStart", c2), Ma(oa, pa), na.x = na.y = 0, Ma(kb, c2[0]), Ma(lb, kb), nb.x = ta.x * ra, ob = [{
                                x: kb.x,
                                y: kb.y
                            }], Q = P = Ea(), Sa(s, !0), zb(), Ab()), !aa && d2 > 1 && !fa && !$ && (t = s, X = !1, aa = W = !0, na.y = na.x = 0, Ma(oa, pa), Ma(hb, c2[0]), Ma(ib, c2[1]), Gb(hb, ib, vb), ub.x = Math.abs(vb.x) - pa.x, ub.y = Math.abs(vb.y) - pa.y, ba = ca = yb(hb, ib))
                        }
                    }
                }, Pb = function (a3) {
                    if (a3.preventDefault(), F) {
                        var b2 = e.arraySearch(mb, a3.pointerId, "id");
                        if (b2 > -1) {
                            var c2 = mb[b2];
                            c2.x = a3.pageX, c2.y = a3.pageY
                        }
                    }
                    if (V) {
                        var d2 = Mb(a3);
                        if (ga || Y || aa) _2 = d2; else if (tb.x !== ta.x * ra) ga = "h"; else {
                            var f2 = Math.abs(d2[0].x - kb.x) - Math.abs(d2[0].y - kb.y);
                            Math.abs(f2) >= gb && (ga = f2 > 0 ? "h" : "v", _2 = d2)
                        }
                    }
                }, Qb = function () {
                    if (_2) {
                        var a3 = _2.length;
                        if (a3 !== 0) if (Ma(hb, _2[0]), jb.x = hb.x - kb.x, jb.y = hb.y - kb.y, aa && a3 > 1) {
                            if (kb.x = hb.x, kb.y = hb.y, !jb.x && !jb.y && wb(_2[1], ib)) return;
                            Ma(ib, _2[1]), X || (X = !0, Da("zoomGestureStarted"));
                            var b2 = yb(hb, ib), c2 = Vb(b2);
                            c2 > f.currItem.initialZoomLevel + f.currItem.initialZoomLevel / 15 && (ka = !0);
                            var d2 = 1, e2 = Ta(), g2 = Ua();
                            if (c2 < e2) if (i.pinchToClose && !ka && t <= f.currItem.initialZoomLevel) {
                                var h2 = e2 - c2, j2 = 1 - h2 / (e2 / 1.2);
                                Fa(j2), Da("onPinchClose", j2), ia = !0
                            } else d2 = (e2 - c2) / e2, d2 > 1 && (d2 = 1), c2 = e2 - d2 * (e2 / 3); else c2 > g2 && (d2 = (c2 - g2) / (6 * e2), d2 > 1 && (d2 = 1), c2 = g2 + d2 * e2);
                            d2 < 0 && (d2 = 0), ba = b2, Gb(hb, ib, rb), na.x += rb.x - vb.x, na.y += rb.y - vb.y, Ma(vb, rb), pa.x = La("x", c2), pa.y = La("y", c2), S = c2 > s, s = c2, Ha()
                        } else {
                            if (!ga || (ha && (ha = !1, Math.abs(jb.x) >= gb && (jb.x -= _2[0].x - lb.x), Math.abs(jb.y) >= gb && (jb.y -= _2[0].y - lb.y)), kb.x = hb.x, kb.y = hb.y, jb.x === 0 && jb.y === 0)) return;
                            if (ga === "v" && i.closeOnVerticalDrag && !Bb()) {
                                na.y += jb.y, pa.y += jb.y;
                                var k2 = Ib();
                                return T = !0, Da("onVerticalDrag", k2), Fa(k2), void Ha()
                            }
                            Hb(Ea(), hb.x, hb.y), Y = !0, da = f.currItem.bounds;
                            var l2 = Nb("x", jb);
                            l2 || (Nb("y", jb), Na(pa), Ha())
                        }
                    }
                }, Rb = function (a3) {
                    if (N.isOldAndroid) {
                        if (U && a3.type === "mouseup") return;
                        a3.type.indexOf("touch") > -1 && (clearTimeout(U), U = setTimeout(function () {
                            U = 0
                        }, 600))
                    }
                    Da("pointerUp"), Eb(a3, !1) && a3.preventDefault();
                    var b2;
                    if (F) {
                        var c2 = e.arraySearch(mb, a3.pointerId, "id");
                        if (c2 > -1) if (b2 = mb.splice(c2, 1)[0], navigator.msPointerEnabled) {
                            var d2 = {4: "mouse", 2: "touch", 3: "pen"};
                            b2.type = d2[a3.pointerType], b2.type || (b2.type = a3.pointerType || "mouse")
                        } else b2.type = a3.pointerType || "mouse"
                    }
                    var g2, h2 = Mb(a3), j2 = h2.length;
                    if (a3.type === "mouseup" && (j2 = 0), j2 === 2) return _2 = null, !0;
                    j2 === 1 && Ma(lb, h2[0]), j2 !== 0 || ga || fa || (b2 || (a3.type === "mouseup" ? b2 = {
                        x: a3.pageX,
                        y: a3.pageY,
                        type: "mouse"
                    } : a3.changedTouches && a3.changedTouches[0] && (b2 = {
                        x: a3.changedTouches[0].pageX,
                        y: a3.changedTouches[0].pageY,
                        type: "touch"
                    })), Da("touchRelease", a3, b2));
                    var k2 = -1;
                    if (j2 === 0 && (V = !1, e.unbind(window, p, f), zb(), aa ? k2 = 0 : sb !== -1 && (k2 = Ea() - sb)), sb = j2 === 1 ? Ea() : -1, g2 = k2 !== -1 && k2 < 150 ? "zoom" : "swipe", aa && j2 < 2 && (aa = !1, j2 === 1 && (g2 = "zoomPointerUp"), Da("zoomGestureEnded")), _2 = null, Y || X || fa || T) if (cb(), R || (R = Sb()), R.calculateSwipeSpeed("x"), T) {
                        var l2 = Ib();
                        if (l2 < i.verticalDragRange) f.close(); else {
                            var m2 = pa.y, n2 = ja;
                            db("verticalDrag", 0, 1, 300, e.easing.cubic.out, function (a4) {
                                pa.y = (f.currItem.initialPosition.y - m2) * a4 + m2, Fa((1 - n2) * a4 + n2), Ha()
                            }), Da("onVerticalDrag", 1)
                        }
                    } else {
                        if (($ || fa) && j2 === 0) {
                            var o2 = Ub(g2, R);
                            if (o2) return;
                            g2 = "zoomPointerUp"
                        }
                        if (!fa) return g2 !== "swipe" ? void Wb() : void (!$ && s > f.currItem.fitRatio && Tb(R))
                    }
                }, Sb = function () {
                    var a3, b2, c2 = {
                        lastFlickOffset: {},
                        lastFlickDist: {},
                        lastFlickSpeed: {},
                        slowDownRatio: {},
                        slowDownRatioReverse: {},
                        speedDecelerationRatio: {},
                        speedDecelerationRatioAbs: {},
                        distanceOffset: {},
                        backAnimDestination: {},
                        backAnimStarted: {},
                        calculateSwipeSpeed: function (d2) {
                            ob.length > 1 ? (a3 = Ea() - Q + 50, b2 = ob[ob.length - 2][d2]) : (a3 = Ea() - P, b2 = lb[d2]), c2.lastFlickOffset[d2] = kb[d2] - b2, c2.lastFlickDist[d2] = Math.abs(c2.lastFlickOffset[d2]), c2.lastFlickDist[d2] > 20 ? c2.lastFlickSpeed[d2] = c2.lastFlickOffset[d2] / a3 : c2.lastFlickSpeed[d2] = 0, Math.abs(c2.lastFlickSpeed[d2]) < .1 && (c2.lastFlickSpeed[d2] = 0), c2.slowDownRatio[d2] = .95, c2.slowDownRatioReverse[d2] = 1 - c2.slowDownRatio[d2], c2.speedDecelerationRatio[d2] = 1
                        },
                        calculateOverBoundsAnimOffset: function (a4, b3) {
                            c2.backAnimStarted[a4] || (pa[a4] > da.min[a4] ? c2.backAnimDestination[a4] = da.min[a4] : pa[a4] < da.max[a4] && (c2.backAnimDestination[a4] = da.max[a4]), c2.backAnimDestination[a4] !== void 0 && (c2.slowDownRatio[a4] = .7, c2.slowDownRatioReverse[a4] = 1 - c2.slowDownRatio[a4], c2.speedDecelerationRatioAbs[a4] < .05 && (c2.lastFlickSpeed[a4] = 0, c2.backAnimStarted[a4] = !0, db("bounceZoomPan" + a4, pa[a4], c2.backAnimDestination[a4], b3 || 300, e.easing.sine.out, function (b4) {
                                pa[a4] = b4, Ha()
                            }))))
                        },
                        calculateAnimOffset: function (a4) {
                            c2.backAnimStarted[a4] || (c2.speedDecelerationRatio[a4] = c2.speedDecelerationRatio[a4] * (c2.slowDownRatio[a4] + c2.slowDownRatioReverse[a4] - c2.slowDownRatioReverse[a4] * c2.timeDiff / 10), c2.speedDecelerationRatioAbs[a4] = Math.abs(c2.lastFlickSpeed[a4] * c2.speedDecelerationRatio[a4]), c2.distanceOffset[a4] = c2.lastFlickSpeed[a4] * c2.speedDecelerationRatio[a4] * c2.timeDiff, pa[a4] += c2.distanceOffset[a4])
                        },
                        panAnimLoop: function () {
                            if ($a.zoomPan && ($a.zoomPan.raf = H(c2.panAnimLoop), c2.now = Ea(), c2.timeDiff = c2.now - c2.lastNow, c2.lastNow = c2.now, c2.calculateAnimOffset("x"), c2.calculateAnimOffset("y"), Ha(), c2.calculateOverBoundsAnimOffset("x"), c2.calculateOverBoundsAnimOffset("y"), c2.speedDecelerationRatioAbs.x < .05 && c2.speedDecelerationRatioAbs.y < .05)) return pa.x = Math.round(pa.x), pa.y = Math.round(pa.y), Ha(), void ab("zoomPan")
                        }
                    };
                    return c2
                }, Tb = function (a3) {
                    return a3.calculateSwipeSpeed("y"), da = f.currItem.bounds, a3.backAnimDestination = {}, a3.backAnimStarted = {}, Math.abs(a3.lastFlickSpeed.x) <= .05 && Math.abs(a3.lastFlickSpeed.y) <= .05 ? (a3.speedDecelerationRatioAbs.x = a3.speedDecelerationRatioAbs.y = 0, a3.calculateOverBoundsAnimOffset("x"), a3.calculateOverBoundsAnimOffset("y"), !0) : (bb("zoomPan"), a3.lastNow = Ea(), void a3.panAnimLoop())
                }, Ub = function (a3, b2) {
                    var c2;
                    fa || (qb = m);
                    var d2;
                    if (a3 === "swipe") {
                        var g2 = kb.x - lb.x, h2 = b2.lastFlickDist.x < 10;
                        g2 > fb && (h2 || b2.lastFlickOffset.x > 20) ? d2 = -1 : g2 < -fb && (h2 || b2.lastFlickOffset.x < -20) && (d2 = 1)
                    }
                    var j2;
                    d2 && (m += d2, m < 0 ? (m = i.loop ? ac() - 1 : 0, j2 = !0) : m >= ac() && (m = i.loop ? 0 : ac() - 1, j2 = !0), j2 && !i.loop || (ua += d2, ra -= d2, c2 = !0));
                    var k2, l2 = ta.x * ra, n2 = Math.abs(l2 - tb.x);
                    return c2 || l2 > tb.x == b2.lastFlickSpeed.x > 0 ? (k2 = Math.abs(b2.lastFlickSpeed.x) > 0 ? n2 / Math.abs(b2.lastFlickSpeed.x) : 333, k2 = Math.min(k2, 400), k2 = Math.max(k2, 250)) : k2 = 333, qb === m && (c2 = !1), fa = !0, Da("mainScrollAnimStart"), db("mainScroll", tb.x, l2, k2, e.easing.cubic.out, Ka, function () {
                        cb(), fa = !1, qb = -1, (c2 || qb !== m) && f.updateCurrItem(), Da("mainScrollAnimComplete")
                    }), c2 && f.updateCurrItem(!0), c2
                }, Vb = function (a3) {
                    return 1 / ca * a3 * t
                }, Wb = function () {
                    var a3 = s, b2 = Ta(), c2 = Ua();
                    s < b2 ? a3 = b2 : s > c2 && (a3 = c2);
                    var d2, g2 = 1, h2 = ja;
                    return ia && !S && !ka && s < b2 ? (f.close(), !0) : (ia && (d2 = function (a4) {
                        Fa((g2 - h2) * a4 + h2)
                    }), f.zoomTo(a3, 0, 200, e.easing.cubic.out, d2), !0)
                };
            za("Gestures", {
                publicMethods: {
                    initGestures: function () {
                        var a3 = function (a4, b2, c2, d2, e2) {
                            A = a4 + b2, B = a4 + c2, C = a4 + d2, D = e2 ? a4 + e2 : ""
                        };
                        F = N.pointerEvent, F && N.touch && (N.touch = !1), F ? navigator.msPointerEnabled ? a3("MSPointer", "Down", "Move", "Up", "Cancel") : a3("pointer", "down", "move", "up", "cancel") : N.touch ? (a3("touch", "start", "move", "end", "cancel"), G = !0) : a3("mouse", "down", "move", "up"), p = B + " " + C + " " + D, q = A, F && !G && (G = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1), f.likelyTouchDevice = G, r[A] = Ob, r[B] = Pb, r[C] = Rb, D && (r[D] = r[C]), N.touch && (q += " mousedown", p += " mousemove mouseup", r.mousedown = r[A], r.mousemove = r[B], r.mouseup = r[C]), G || (i.allowPanToNext = !1)
                    }
                }
            });
            var Xb, Yb, Zb, $b, _b, ac, bc, cc = function (b2, c2, d2, g2) {
                Xb && clearTimeout(Xb), $b = !0, Zb = !0;
                var h2;
                b2.initialLayout ? (h2 = b2.initialLayout, b2.initialLayout = null) : h2 = i.getThumbBoundsFn && i.getThumbBoundsFn(m);
                var j2 = d2 ? i.hideAnimationDuration : i.showAnimationDuration, k2 = function () {
                    ab("initialZoom"), d2 ? (f.template.removeAttribute("style"), f.bg.removeAttribute("style")) : (Fa(1), c2 && (c2.style.display = "block"), e.addClass(a2, "pswp--animated-in"), Da("initialZoom" + (d2 ? "OutEnd" : "InEnd"))), g2 && g2(), $b = !1
                };
                if (!j2 || !h2 || h2.x === void 0) return Da("initialZoom" + (d2 ? "Out" : "In")), s = b2.initialZoomLevel, Ma(pa, b2.initialPosition), Ha(), a2.style.opacity = d2 ? 0 : 1, Fa(1), void (j2 ? setTimeout(function () {
                    k2()
                }, j2) : k2());
                var n2 = function () {
                    var c3 = l, g3 = !f.currItem.src || f.currItem.loadError || i.showHideOpacity;
                    b2.miniImg && (b2.miniImg.style.webkitBackfaceVisibility = "hidden"), d2 || (s = h2.w / b2.w, pa.x = h2.x, pa.y = h2.y - K, f[g3 ? "template" : "bg"].style.opacity = .001, Ha()), bb("initialZoom"), d2 && !c3 && e.removeClass(a2, "pswp--animated-in"), g3 && (d2 ? e[(c3 ? "remove" : "add") + "Class"](a2, "pswp--animate_opacity") : setTimeout(function () {
                        e.addClass(a2, "pswp--animate_opacity")
                    }, 30)), Xb = setTimeout(function () {
                        if (Da("initialZoom" + (d2 ? "Out" : "In")), d2) {
                            var f2 = h2.w / b2.w, i2 = {x: pa.x, y: pa.y}, l2 = s, m2 = ja, n3 = function (b3) {
                                b3 === 1 ? (s = f2, pa.x = h2.x, pa.y = h2.y - M) : (s = (f2 - l2) * b3 + l2, pa.x = (h2.x - i2.x) * b3 + i2.x, pa.y = (h2.y - M - i2.y) * b3 + i2.y), Ha(), g3 ? a2.style.opacity = 1 - b3 : Fa(m2 - b3 * m2)
                            };
                            c3 ? db("initialZoom", 0, 1, j2, e.easing.cubic.out, n3, k2) : (n3(1), Xb = setTimeout(k2, j2 + 20))
                        } else s = b2.initialZoomLevel, Ma(pa, b2.initialPosition), Ha(), Fa(1), g3 ? a2.style.opacity = 1 : Fa(1), Xb = setTimeout(k2, j2 + 20)
                    }, d2 ? 25 : 90)
                };
                n2()
            }, dc = {}, ec = [], fc = {
                index: 0,
                errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                forceProgressiveLoading: !1,
                preload: [1, 1],
                getNumItemsFn: function () {
                    return Yb.length
                }
            }, gc = function () {
                return {center: {x: 0, y: 0}, max: {x: 0, y: 0}, min: {x: 0, y: 0}}
            }, hc = function (a3, b2, c2) {
                var d2 = a3.bounds;
                d2.center.x = Math.round((dc.x - b2) / 2), d2.center.y = Math.round((dc.y - c2) / 2) + a3.vGap.top, d2.max.x = b2 > dc.x ? Math.round(dc.x - b2) : d2.center.x, d2.max.y = c2 > dc.y ? Math.round(dc.y - c2) + a3.vGap.top : d2.center.y, d2.min.x = b2 > dc.x ? 0 : d2.center.x, d2.min.y = c2 > dc.y ? a3.vGap.top : d2.center.y
            }, ic = function (a3, b2, c2) {
                if (a3.src && !a3.loadError) {
                    var d2 = !c2;
                    if (d2 && (a3.vGap || (a3.vGap = {
                        top: 0,
                        bottom: 0
                    }), Da("parseVerticalMargin", a3)), dc.x = b2.x, dc.y = b2.y - a3.vGap.top - a3.vGap.bottom, d2) {
                        var e2 = dc.x / a3.w, f2 = dc.y / a3.h;
                        a3.fitRatio = e2 < f2 ? e2 : f2;
                        var g2 = i.scaleMode;
                        g2 === "orig" ? c2 = 1 : g2 === "fit" && (c2 = a3.fitRatio), c2 > 1 && (c2 = 1), a3.initialZoomLevel = c2, a3.bounds || (a3.bounds = gc())
                    }
                    return c2 ? (hc(a3, a3.w * c2, a3.h * c2), d2 && c2 === a3.initialZoomLevel && (a3.initialPosition = a3.bounds.center), a3.bounds) : void 0
                }
                return a3.w = a3.h = 0, a3.initialZoomLevel = a3.fitRatio = 1, a3.bounds = gc(), a3.initialPosition = a3.bounds.center, a3.bounds
            }, jc = function (a3, b2, c2, d2, e2, g2) {
                b2.loadError || d2 && (b2.imageAppended = !0, mc(b2, d2, b2 === f.currItem && ya), c2.appendChild(d2), g2 && setTimeout(function () {
                    b2 && b2.loaded && b2.placeholder && (b2.placeholder.style.display = "none", b2.placeholder = null)
                }, 500))
            }, kc = function (a3) {
                a3.loading = !0, a3.loaded = !1;
                var b2 = a3.img = e.createEl("pswp__img", "img"), c2 = function () {
                    a3.loading = !1, a3.loaded = !0, a3.loadComplete ? a3.loadComplete(a3) : a3.img = null, b2.onload = b2.onerror = null, b2 = null
                };
                return b2.onload = c2, b2.onerror = function () {
                    a3.loadError = !0, c2()
                }, b2.src = a3.src, b2
            }, lc = function (a3, b2) {
                if (a3.src && a3.loadError && a3.container) return b2 && (a3.container.innerHTML = ""), a3.container.innerHTML = i.errorMsg.replace("%url%", a3.src), !0
            }, mc = function (a3, b2, c2) {
                if (a3.src) {
                    b2 || (b2 = a3.container.lastChild);
                    var d2 = c2 ? a3.w : Math.round(a3.w * a3.fitRatio),
                        e2 = c2 ? a3.h : Math.round(a3.h * a3.fitRatio);
                    a3.placeholder && !a3.loaded && (a3.placeholder.style.width = d2 + "px", a3.placeholder.style.height = e2 + "px"), b2.style.width = d2 + "px", b2.style.height = e2 + "px"
                }
            }, nc = function () {
                if (ec.length) {
                    for (var a3, b2 = 0; b2 < ec.length; b2++) a3 = ec[b2], a3.holder.index === a3.index && jc(a3.index, a3.item, a3.baseDiv, a3.img, !1, a3.clearPlaceholder);
                    ec = []
                }
            };
            za("Controller", {
                publicMethods: {
                    lazyLoadItem: function (a3) {
                        a3 = Aa(a3);
                        var b2 = _b(a3);
                        b2 && (!b2.loaded && !b2.loading || x) && (Da("gettingData", a3, b2), b2.src && kc(b2))
                    }, initController: function () {
                        e.extend(i, fc, !0), f.items = Yb = c, _b = f.getItemAt, ac = i.getNumItemsFn, bc = i.loop, ac() < 3 && (i.loop = !1), Ca("beforeChange", function (a3) {
                            var b2, c2 = i.preload, d2 = a3 === null || a3 >= 0, e2 = Math.min(c2[0], ac()),
                                g2 = Math.min(c2[1], ac());
                            for (b2 = 1; b2 <= (d2 ? g2 : e2); b2++) f.lazyLoadItem(m + b2);
                            for (b2 = 1; b2 <= (d2 ? e2 : g2); b2++) f.lazyLoadItem(m - b2)
                        }), Ca("initialLayout", function () {
                            f.currItem.initialLayout = i.getThumbBoundsFn && i.getThumbBoundsFn(m)
                        }), Ca("mainScrollAnimComplete", nc), Ca("initialZoomInEnd", nc), Ca("destroy", function () {
                            for (var a3, b2 = 0; b2 < Yb.length; b2++) a3 = Yb[b2], a3.container && (a3.container = null), a3.placeholder && (a3.placeholder = null), a3.img && (a3.img = null), a3.preloader && (a3.preloader = null), a3.loadError && (a3.loaded = a3.loadError = !1);
                            ec = null
                        })
                    }, getItemAt: function (a3) {
                        return a3 >= 0 && Yb[a3] !== void 0 && Yb[a3]
                    }, allowProgressiveImg: function () {
                        return i.forceProgressiveLoading || !G || i.mouseUsed || screen.width > 1200
                    }, setContent: function (a3, b2) {
                        i.loop && (b2 = Aa(b2));
                        var c2 = f.getItemAt(a3.index);
                        c2 && (c2.container = null);
                        var d2, g2 = f.getItemAt(b2);
                        if (!g2) return void (a3.el.innerHTML = "");
                        Da("gettingData", b2, g2), a3.index = b2, a3.item = g2;
                        var h2 = g2.container = e.createEl("pswp__zoom-wrap");
                        if (!g2.src && g2.html && (g2.html.tagName ? h2.appendChild(g2.html) : h2.innerHTML = g2.html), lc(g2), ic(g2, qa), !g2.src || g2.loadError || g2.loaded) g2.src && !g2.loadError && (d2 = e.createEl("pswp__img", "img"), d2.style.opacity = 1, d2.src = g2.src, mc(g2, d2), jc(b2, g2, h2, d2, !0)); else {
                            if (g2.loadComplete = function (c3) {
                                if (j) {
                                    if (a3 && a3.index === b2) {
                                        if (lc(c3, !0)) return c3.loadComplete = c3.img = null, ic(c3, qa), Ia(c3), void (a3.index === m && f.updateCurrZoomItem());
                                        c3.imageAppended ? !$b && c3.placeholder && (c3.placeholder.style.display = "none", c3.placeholder = null) : N.transform && (fa || $b) ? ec.push({
                                            item: c3,
                                            baseDiv: h2,
                                            img: c3.img,
                                            index: b2,
                                            holder: a3,
                                            clearPlaceholder: !0
                                        }) : jc(b2, c3, h2, c3.img, fa || $b, !0)
                                    }
                                    c3.loadComplete = null, c3.img = null, Da("imageLoadComplete", b2, c3)
                                }
                            }, e.features.transform) {
                                var k2 = "pswp__img pswp__img--placeholder";
                                k2 += g2.msrc ? "" : " pswp__img--placeholder--blank";
                                var l2 = e.createEl(k2, g2.msrc ? "img" : "");
                                g2.msrc && (l2.src = g2.msrc), mc(g2, l2), h2.appendChild(l2), g2.placeholder = l2
                            }
                            g2.loading || kc(g2), f.allowProgressiveImg() && (!Zb && N.transform ? ec.push({
                                item: g2,
                                baseDiv: h2,
                                img: g2.img,
                                index: b2,
                                holder: a3
                            }) : jc(b2, g2, h2, g2.img, !0, !0))
                        }
                        Zb || b2 !== m ? Ia(g2) : (ea = h2.style, cc(g2, d2 || g2.img)), a3.el.innerHTML = "", a3.el.appendChild(h2)
                    }, cleanSlide: function (a3) {
                        a3.img && (a3.img.onload = a3.img.onerror = null), a3.loaded = a3.loading = a3.img = a3.imageAppended = !1
                    }
                }
            });
            var oc, pc = {}, qc = function (a3, b2, c2) {
                var d2 = document.createEvent("CustomEvent"),
                    e2 = {origEvent: a3, target: a3.target, releasePoint: b2, pointerType: c2 || "touch"};
                d2.initCustomEvent("pswpTap", !0, !0, e2), a3.target.dispatchEvent(d2)
            };
            za("Tap", {
                publicMethods: {
                    initTap: function () {
                        Ca("firstTouchStart", f.onTapStart), Ca("touchRelease", f.onTapRelease), Ca("destroy", function () {
                            pc = {}, oc = null
                        })
                    }, onTapStart: function (a3) {
                        a3.length > 1 && (clearTimeout(oc), oc = null)
                    }, onTapRelease: function (a3, b2) {
                        if (b2 && !Y && !W && !_a) {
                            var c2 = b2;
                            if (oc && (clearTimeout(oc), oc = null, xb(c2, pc))) return void Da("doubleTap", c2);
                            if (b2.type === "mouse") return void qc(a3, b2, "mouse");
                            var d2 = a3.target.tagName.toUpperCase();
                            if (d2 === "BUTTON" || e.hasClass(a3.target, "pswp__single-tap")) return void qc(a3, b2);
                            Ma(pc, c2), oc = setTimeout(function () {
                                qc(a3, b2), oc = null
                            }, 300)
                        }
                    }
                }
            });
            var rc;
            za("DesktopZoom", {
                publicMethods: {
                    initDesktopZoom: function () {
                        L || (G ? Ca("mouseUsed", function () {
                            f.setupDesktopZoom()
                        }) : f.setupDesktopZoom(!0))
                    }, setupDesktopZoom: function (b2) {
                        rc = {};
                        var c2 = "wheel mousewheel DOMMouseScroll";
                        Ca("bindEvents", function () {
                            e.bind(a2, c2, f.handleMouseWheel)
                        }), Ca("unbindEvents", function () {
                            rc && e.unbind(a2, c2, f.handleMouseWheel)
                        }), f.mouseZoomedIn = !1;
                        var d2, g2 = function () {
                            f.mouseZoomedIn && (e.removeClass(a2, "pswp--zoomed-in"), f.mouseZoomedIn = !1), s < 1 ? e.addClass(a2, "pswp--zoom-allowed") : e.removeClass(a2, "pswp--zoom-allowed"), h2()
                        }, h2 = function () {
                            d2 && (e.removeClass(a2, "pswp--dragging"), d2 = !1)
                        };
                        Ca("resize", g2), Ca("afterChange", g2), Ca("pointerDown", function () {
                            f.mouseZoomedIn && (d2 = !0, e.addClass(a2, "pswp--dragging"))
                        }), Ca("pointerUp", h2), b2 || g2()
                    }, handleMouseWheel: function (a3) {
                        if (s <= f.currItem.fitRatio) return i.modal && (!i.closeOnScroll || _a || V ? a3.preventDefault() : E && Math.abs(a3.deltaY) > 2 && (l = !0, f.close())), !0;
                        if (a3.stopPropagation(), rc.x = 0, "deltaX" in a3) a3.deltaMode === 1 ? (rc.x = 18 * a3.deltaX, rc.y = 18 * a3.deltaY) : (rc.x = a3.deltaX, rc.y = a3.deltaY); else if ("wheelDelta" in a3) a3.wheelDeltaX && (rc.x = -.16 * a3.wheelDeltaX), a3.wheelDeltaY ? rc.y = -.16 * a3.wheelDeltaY : rc.y = -.16 * a3.wheelDelta; else {
                            if (!("detail" in a3)) return;
                            rc.y = a3.detail
                        }
                        Sa(s, !0);
                        var b2 = pa.x - rc.x, c2 = pa.y - rc.y;
                        (i.modal || b2 <= da.min.x && b2 >= da.max.x && c2 <= da.min.y && c2 >= da.max.y) && a3.preventDefault(), f.panTo(b2, c2)
                    }, toggleDesktopZoom: function (b2) {
                        b2 = b2 || {x: qa.x / 2 + sa.x, y: qa.y / 2 + sa.y};
                        var c2 = i.getDoubleTapZoom(!0, f.currItem), d2 = s === c2;
                        f.mouseZoomedIn = !d2, f.zoomTo(d2 ? f.currItem.initialZoomLevel : c2, b2, 333), e[(d2 ? "remove" : "add") + "Class"](a2, "pswp--zoomed-in")
                    }
                }
            });
            var sc, tc, uc, vc, wc, xc, yc, zc, Ac, Bc, Cc, Dc, Ec = {history: !0, galleryUID: 1}, Fc = function () {
                return Cc.hash.substring(1)
            }, Gc = function () {
                sc && clearTimeout(sc), uc && clearTimeout(uc)
            }, Hc = function () {
                var a3 = Fc(), b2 = {};
                if (a3.length < 5) return b2;
                var c2, d2 = a3.split("&");
                for (c2 = 0; c2 < d2.length; c2++) if (d2[c2]) {
                    var e2 = d2[c2].split("=");
                    e2.length < 2 || (b2[e2[0]] = e2[1])
                }
                if (i.galleryPIDs) {
                    var f2 = b2.pid;
                    for (b2.pid = 0, c2 = 0; c2 < Yb.length; c2++) if (Yb[c2].pid === f2) {
                        b2.pid = c2;
                        break
                    }
                } else b2.pid = parseInt(b2.pid, 10) - 1;
                return b2.pid < 0 && (b2.pid = 0), b2
            }, Ic = function () {
                if (uc && clearTimeout(uc), _a || V) return void (uc = setTimeout(Ic, 500));
                vc ? clearTimeout(tc) : vc = !0;
                var a3 = m + 1, b2 = _b(m);
                b2.hasOwnProperty("pid") && (a3 = b2.pid);
                var c2 = yc + "&gid=" + i.galleryUID + "&pid=" + a3;
                zc || Cc.hash.indexOf(c2) === -1 && (Bc = !0);
                var d2 = Cc.href.split("#")[0] + "#" + c2;
                Dc ? "#" + c2 !== window.location.hash && history[zc ? "replaceState" : "pushState"]("", document.title, d2) : zc ? Cc.replace(d2) : Cc.hash = c2, zc = !0, tc = setTimeout(function () {
                    vc = !1
                }, 60)
            };
            za("History", {
                publicMethods: {
                    initHistory: function () {
                        if (e.extend(i, Ec, !0), i.history) {
                            Cc = window.location, Bc = !1, Ac = !1, zc = !1, yc = Fc(), Dc = "pushState" in history, yc.indexOf("gid=") > -1 && (yc = yc.split("&gid=")[0], yc = yc.split("?gid=")[0]), Ca("afterChange", f.updateURL), Ca("unbindEvents", function () {
                                e.unbind(window, "hashchange", f.onHashChange)
                            });
                            var a3 = function () {
                                xc = !0, Ac || (Bc ? history.back() : yc ? Cc.hash = yc : Dc ? history.pushState("", document.title, Cc.pathname + Cc.search) : Cc.hash = ""), Gc()
                            };
                            Ca("unbindEvents", function () {
                                l && a3()
                            }), Ca("destroy", function () {
                                xc || a3()
                            }), Ca("firstUpdate", function () {
                                m = Hc().pid
                            });
                            var b2 = yc.indexOf("pid=");
                            b2 > -1 && (yc = yc.substring(0, b2), yc.slice(-1) === "&" && (yc = yc.slice(0, -1))), setTimeout(function () {
                                j && e.bind(window, "hashchange", f.onHashChange)
                            }, 40)
                        }
                    }, onHashChange: function () {
                        return Fc() === yc ? (Ac = !0, void f.close()) : void (vc || (wc = !0, f.goTo(Hc().pid), wc = !1))
                    }, updateURL: function () {
                        Gc(), wc || (zc ? sc = setTimeout(Ic, 800) : Ic())
                    }
                }
            }), e.extend(f, eb)
        };
        return a
    });/*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */
    (function (a, b) {
        typeof define == "function" && define.amd ? define(b) : typeof exports == "object" ? module.exports = b() : a.PhotoSwipeUI_Default = b()
    })(this, function () {
        "use strict";
        var a = function (a2, b) {
            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v = this, w = !1, x = !0, y = !0, z = {
                barsSize: {top: 44, bottom: "auto"},
                closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
                timeToIdle: 4e3,
                timeToIdleOutside: 1e3,
                loadingIndicatorDelay: 1e3,
                addCaptionHTMLFn: function (a3, b2) {
                    return a3.title ? (b2.children[0].innerHTML = a3.title, !0) : (b2.children[0].innerHTML = "", !1)
                },
                closeEl: !0,
                captionEl: !0,
                fullscreenEl: !0,
                zoomEl: !0,
                shareEl: !0,
                counterEl: !0,
                arrowEl: !0,
                preloaderEl: !0,
                tapToClose: !1,
                tapToToggleControls: !0,
                clickToCloseNonZoomable: !0,
                shareButtons: [{
                    id: "facebook",
                    label: "Share on Facebook",
                    url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
                }, {
                    id: "twitter",
                    label: "Tweet",
                    url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
                }, {
                    id: "pinterest",
                    label: "Pin it",
                    url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
                }, {id: "download", label: "Download image", url: "{{raw_image_url}}", download: !0}],
                getImageURLForShare: function () {
                    return a2.currItem.src || ""
                },
                getPageURLForShare: function () {
                    return window.location.href
                },
                getTextForShare: function () {
                    return a2.currItem.title || ""
                },
                indexIndicatorSep: " / ",
                fitControlsWidth: 1200
            }, A = function (a3) {
                if (r) return !0;
                a3 = a3 || window.event, q.timeToIdle && q.mouseUsed && !k && K();
                for (var c2, d2, e2 = a3.target || a3.srcElement, f2 = e2.getAttribute("class") || "", g2 = 0; g2 < S.length; g2++) c2 = S[g2], c2.onTap && f2.indexOf("pswp__" + c2.name) > -1 && (c2.onTap(), d2 = !0);
                if (d2) {
                    a3.stopPropagation && a3.stopPropagation(), r = !0;
                    var h2 = b.features.isOldAndroid ? 600 : 30;
                    s = setTimeout(function () {
                        r = !1
                    }, h2)
                }
            }, B = function () {
                return !a2.likelyTouchDevice || q.mouseUsed || screen.width > q.fitControlsWidth
            }, C = function (a3, c2, d2) {
                b[(d2 ? "add" : "remove") + "Class"](a3, "pswp__" + c2)
            }, D = function () {
                var a3 = q.getNumItemsFn() === 1;
                a3 !== p && (C(d, "ui--one-slide", a3), p = a3)
            }, E = function () {
                C(i, "share-modal--hidden", y)
            }, F = function () {
                return y = !y, y ? (b.removeClass(i, "pswp__share-modal--fade-in"), setTimeout(function () {
                    y && E()
                }, 300)) : (E(), setTimeout(function () {
                    y || b.addClass(i, "pswp__share-modal--fade-in")
                }, 30)), y || H(), !1
            }, G = function (b2) {
                b2 = b2 || window.event;
                var c2 = b2.target || b2.srcElement;
                return a2.shout("shareLinkClick", b2, c2), !!c2.href && (!!c2.hasAttribute("download") || (window.open(c2.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), y || F(), !1))
            }, H = function () {
                for (var a3, b2, c2, d2, e2, f2 = "", g2 = 0; g2 < q.shareButtons.length; g2++) a3 = q.shareButtons[g2], c2 = q.getImageURLForShare(a3), d2 = q.getPageURLForShare(a3), e2 = q.getTextForShare(a3), b2 = a3.url.replace("{{url}}", encodeURIComponent(d2)).replace("{{image_url}}", encodeURIComponent(c2)).replace("{{raw_image_url}}", c2).replace("{{text}}", encodeURIComponent(e2)), f2 += '<a href="' + b2 + '" target="_blank" class="pswp__share--' + a3.id + '"' + (a3.download ? "download" : "") + ">" + a3.label + "</a>", q.parseShareButtonOut && (f2 = q.parseShareButtonOut(a3, f2));
                i.children[0].innerHTML = f2, i.children[0].onclick = G
            }, I = function (a3) {
                for (var c2 = 0; c2 < q.closeElClasses.length; c2++) if (b.hasClass(a3, "pswp__" + q.closeElClasses[c2])) return !0
            }, J = 0, K = function () {
                clearTimeout(u), J = 0, k && v.setIdle(!1)
            }, L = function (a3) {
                a3 = a3 || window.event;
                var b2 = a3.relatedTarget || a3.toElement;
                b2 && b2.nodeName !== "HTML" || (clearTimeout(u), u = setTimeout(function () {
                    v.setIdle(!0)
                }, q.timeToIdleOutside))
            }, M = function () {
                q.fullscreenEl && !b.features.isOldAndroid && (c || (c = v.getFullscreenAPI()), c ? (b.bind(document, c.eventK, v.updateFullscreen), v.updateFullscreen(), b.addClass(a2.template, "pswp--supports-fs")) : b.removeClass(a2.template, "pswp--supports-fs"))
            }, N = function () {
                q.preloaderEl && (O(!0), l("beforeChange", function () {
                    clearTimeout(o), o = setTimeout(function () {
                        a2.currItem && a2.currItem.loading ? (!a2.allowProgressiveImg() || a2.currItem.img && !a2.currItem.img.naturalWidth) && O(!1) : O(!0)
                    }, q.loadingIndicatorDelay)
                }), l("imageLoadComplete", function (b2, c2) {
                    a2.currItem === c2 && O(!0)
                }))
            }, O = function (a3) {
                n !== a3 && (C(m, "preloader--active", !a3), n = a3)
            }, P = function (a3) {
                var c2 = a3.vGap;
                if (B()) {
                    var g2 = q.barsSize;
                    if (q.captionEl && g2.bottom === "auto") if (f || (f = b.createEl("pswp__caption pswp__caption--fake"), f.appendChild(b.createEl("pswp__caption__center")), d.insertBefore(f, e), b.addClass(d, "pswp__ui--fit")), q.addCaptionHTMLFn(a3, f, !0)) {
                        var h2 = f.clientHeight;
                        c2.bottom = parseInt(h2, 10) || 44
                    } else c2.bottom = g2.top; else c2.bottom = g2.bottom === "auto" ? 0 : g2.bottom;
                    c2.top = g2.top
                } else c2.top = c2.bottom = 0
            }, Q = function () {
                q.timeToIdle && l("mouseUsed", function () {
                    b.bind(document, "mousemove", K), b.bind(document, "mouseout", L), t = setInterval(function () {
                        J++, J === 2 && v.setIdle(!0)
                    }, q.timeToIdle / 2)
                })
            }, R = function () {
                l("onVerticalDrag", function (a4) {
                    x && a4 < .95 ? v.hideControls() : !x && a4 >= .95 && v.showControls()
                });
                var a3;
                l("onPinchClose", function (b2) {
                    x && b2 < .9 ? (v.hideControls(), a3 = !0) : a3 && !x && b2 > .9 && v.showControls()
                }), l("zoomGestureEnded", function () {
                    a3 = !1, a3 && !x && v.showControls()
                })
            }, S = [{
                name: "caption", option: "captionEl", onInit: function (a3) {
                    e = a3
                }
            }, {
                name: "share-modal", option: "shareEl", onInit: function (a3) {
                    i = a3
                }, onTap: function () {
                    F()
                }
            }, {
                name: "button--share", option: "shareEl", onInit: function (a3) {
                    h = a3
                }, onTap: function () {
                    F()
                }
            }, {name: "button--zoom", option: "zoomEl", onTap: a2.toggleDesktopZoom}, {
                name: "counter",
                option: "counterEl",
                onInit: function (a3) {
                    g = a3
                }
            }, {name: "button--close", option: "closeEl", onTap: a2.close}, {
                name: "button--arrow--left",
                option: "arrowEl",
                onTap: a2.prev
            }, {name: "button--arrow--right", option: "arrowEl", onTap: a2.next}, {
                name: "button--fs",
                option: "fullscreenEl",
                onTap: function () {
                    c.isFullscreen() ? c.exit() : c.enter()
                }
            }, {
                name: "preloader", option: "preloaderEl", onInit: function (a3) {
                    m = a3
                }
            }], T = function () {
                var a3, c2, e2, f2 = function (d2) {
                    if (d2) for (var f3 = d2.length, g3 = 0; g3 < f3; g3++) {
                        a3 = d2[g3], c2 = a3.className;
                        for (var h2 = 0; h2 < S.length; h2++) e2 = S[h2], c2.indexOf("pswp__" + e2.name) > -1 && (q[e2.option] ? (b.removeClass(a3, "pswp__element--disabled"), e2.onInit && e2.onInit(a3)) : b.addClass(a3, "pswp__element--disabled"))
                    }
                };
                f2(d.children);
                var g2 = b.getChildByClass(d, "pswp__top-bar");
                g2 && f2(g2.children)
            };
            v.init = function () {
                b.extend(a2.options, z, !0), q = a2.options, d = b.getChildByClass(a2.scrollWrap, "pswp__ui"), l = a2.listen, R(), l("beforeChange", v.update), l("doubleTap", function (b2) {
                    var c2 = a2.currItem.initialZoomLevel;
                    a2.getZoomLevel() !== c2 ? a2.zoomTo(c2, b2, 333) : a2.zoomTo(q.getDoubleTapZoom(!1, a2.currItem), b2, 333)
                }), l("preventDragEvent", function (a3, b2, c2) {
                    var d2 = a3.target || a3.srcElement;
                    d2 && d2.getAttribute("class") && a3.type.indexOf("mouse") > -1 && (d2.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(d2.tagName)) && (c2.prevent = !1)
                }), l("bindEvents", function () {
                    b.bind(d, "pswpTap click", A), b.bind(a2.scrollWrap, "pswpTap", v.onGlobalTap), a2.likelyTouchDevice || b.bind(a2.scrollWrap, "mouseover", v.onMouseOver)
                }), l("unbindEvents", function () {
                    y || F(), t && clearInterval(t), b.unbind(document, "mouseout", L), b.unbind(document, "mousemove", K), b.unbind(d, "pswpTap click", A), b.unbind(a2.scrollWrap, "pswpTap", v.onGlobalTap), b.unbind(a2.scrollWrap, "mouseover", v.onMouseOver), c && (b.unbind(document, c.eventK, v.updateFullscreen), c.isFullscreen() && (q.hideAnimationDuration = 0, c.exit()), c = null)
                }), l("destroy", function () {
                    q.captionEl && (f && d.removeChild(f), b.removeClass(e, "pswp__caption--empty")), i && (i.children[0].onclick = null), b.removeClass(d, "pswp__ui--over-close"), b.addClass(d, "pswp__ui--hidden"), v.setIdle(!1)
                }), q.showAnimationDuration || b.removeClass(d, "pswp__ui--hidden"), l("initialZoomIn", function () {
                    q.showAnimationDuration && b.removeClass(d, "pswp__ui--hidden")
                }), l("initialZoomOut", function () {
                    b.addClass(d, "pswp__ui--hidden")
                }), l("parseVerticalMargin", P), T(), q.shareEl && h && i && (y = !0), D(), Q(), M(), N()
            }, v.setIdle = function (a3) {
                k = a3, C(d, "ui--idle", a3)
            }, v.update = function () {
                x && a2.currItem ? (v.updateIndexIndicator(), q.captionEl && (q.addCaptionHTMLFn(a2.currItem, e), C(e, "caption--empty", !a2.currItem.title)), w = !0) : w = !1, y || F(), D()
            }, v.updateFullscreen = function (d2) {
                d2 && setTimeout(function () {
                    a2.setScrollOffset(0, b.getScrollY())
                }, 50), b[(c.isFullscreen() ? "add" : "remove") + "Class"](a2.template, "pswp--fs")
            }, v.updateIndexIndicator = function () {
                q.counterEl && (g.innerHTML = a2.getCurrentIndex() + 1 + q.indexIndicatorSep + q.getNumItemsFn())
            }, v.onGlobalTap = function (c2) {
                c2 = c2 || window.event;
                var d2 = c2.target || c2.srcElement;
                if (!r) {
                    if (c2.detail && c2.detail.pointerType === "mouse") {
                        if (I(d2)) return void a2.close();
                        b.hasClass(d2, "pswp__img") && (a2.getZoomLevel() === 1 && a2.getZoomLevel() <= a2.currItem.fitRatio ? q.clickToCloseNonZoomable && a2.close() : a2.toggleDesktopZoom(c2.detail.releasePoint))
                    } else if (q.tapToToggleControls && (x ? v.hideControls() : v.showControls()), q.tapToClose && (b.hasClass(d2, "pswp__img") || I(d2))) return void a2.close()
                }
            }, v.onMouseOver = function (a3) {
                a3 = a3 || window.event;
                var b2 = a3.target || a3.srcElement;
                C(d, "ui--over-close", I(b2))
            }, v.hideControls = function () {
                b.addClass(d, "pswp__ui--hidden"), x = !1
            }, v.showControls = function () {
                x = !0, w || v.update(), b.removeClass(d, "pswp__ui--hidden")
            }, v.supportsFullscreen = function () {
                var a3 = document;
                return !!(a3.exitFullscreen || a3.mozCancelFullScreen || a3.webkitExitFullscreen || a3.msExitFullscreen)
            }, v.getFullscreenAPI = function () {
                var b2, c2 = document.documentElement, d2 = "fullscreenchange";
                return c2.requestFullscreen ? b2 = {
                    enterK: "requestFullscreen",
                    exitK: "exitFullscreen",
                    elementK: "fullscreenElement",
                    eventK: d2
                } : c2.mozRequestFullScreen ? b2 = {
                    enterK: "mozRequestFullScreen",
                    exitK: "mozCancelFullScreen",
                    elementK: "mozFullScreenElement",
                    eventK: "moz" + d2
                } : c2.webkitRequestFullscreen ? b2 = {
                    enterK: "webkitRequestFullscreen",
                    exitK: "webkitExitFullscreen",
                    elementK: "webkitFullscreenElement",
                    eventK: "webkit" + d2
                } : c2.msRequestFullscreen && (b2 = {
                    enterK: "msRequestFullscreen",
                    exitK: "msExitFullscreen",
                    elementK: "msFullscreenElement",
                    eventK: "MSFullscreenChange"
                }), b2 && (b2.enter = function () {
                    return j = q.closeOnScroll, q.closeOnScroll = !1, this.enterK !== "webkitRequestFullscreen" ? a2.template[this.enterK]() : void a2.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
                }, b2.exit = function () {
                    return q.closeOnScroll = j, document[this.exitK]()
                }, b2.isFullscreen = function () {
                    return document[this.elementK]
                }), b2
            }
        };
        return a
    })
}(), function () {
    /**
     * @license
     * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
     * Build: `lodash core -o ./dist/lodash.core.js`
     */(function () {
        function n(n2, t2) {
            for (var r2 = -1, e2 = t2.length, u2 = n2.length; ++r2 < e2;) n2[u2 + r2] = t2[r2];
            return n2
        }

        function t(n2, t2, r2) {
            for (var e2 = -1, u2 = n2.length; ++e2 < u2;) {
                var o2 = n2[e2], i2 = t2(o2);
                if (i2 != null && (c2 === an ? i2 === i2 : r2(i2, c2))) var c2 = i2, f2 = o2
            }
            return f2
        }

        function r(n2, t2, r2) {
            var e2;
            return r2(n2, function (n3, r3, u2) {
                return t2(n3, r3, u2) ? (e2 = n3, !1) : void 0
            }), e2
        }

        function e(n2, t2, r2, e2, u2) {
            return u2(n2, function (n3, u3, o2) {
                r2 = e2 ? (e2 = !1, n3) : t2(r2, n3, u3, o2)
            }), r2
        }

        function u(n2, t2) {
            return O(t2, function (t3) {
                return n2[t3]
            })
        }

        function o(n2) {
            return n2 && n2.Object === Object ? n2 : null
        }

        function i(n2) {
            return vn[n2]
        }

        function c(n2) {
            var t2 = !1;
            if (n2 != null && typeof n2.toString != "function") try {
                t2 = !!(n2 + "")
            } catch {
            }
            return t2
        }

        function f(n2, t2) {
            return n2 = typeof n2 == "number" || hn.test(n2) ? +n2 : -1, n2 > -1 && n2 % 1 == 0 && (t2 ?? 9007199254740991) > n2
        }

        function a(n2) {
            if (Y(n2) && !Pn(n2)) {
                if (n2 instanceof l) return n2;
                if (En.call(n2, "__wrapped__")) {
                    var t2 = new l(n2.__wrapped__, n2.__chain__);
                    return t2.__actions__ = N(n2.__actions__), t2
                }
            }
            return new l(n2)
        }

        function l(n2, t2) {
            this.__wrapped__ = n2, this.__actions__ = [], this.__chain__ = !!t2
        }

        function p(n2, t2, r2, e2) {
            var u2;
            return (u2 = n2 === an) || (u2 = xn[r2], u2 = (n2 === u2 || n2 !== n2 && u2 !== u2) && !En.call(e2, r2)), u2 ? t2 : n2
        }

        function s(n2) {
            return X(n2) ? Fn(n2) : {}
        }

        function h(n2, t2, r2) {
            if (typeof n2 != "function") throw new TypeError("Expected a function");
            return setTimeout(function () {
                n2.apply(an, r2)
            }, t2)
        }

        function v(n2, t2) {
            var r2 = !0;
            return $n(n2, function (n3, e2, u2) {
                return r2 = !!t2(n3, e2, u2)
            }), r2
        }

        function y(n2, t2) {
            var r2 = [];
            return $n(n2, function (n3, e2, u2) {
                t2(n3, e2, u2) && r2.push(n3)
            }), r2
        }

        function _2(t2, r2, e2, u2) {
            u2 || (u2 = []);
            for (var o2 = -1, i2 = t2.length; ++o2 < i2;) {
                var c2 = t2[o2];
                r2 > 0 && Y(c2) && L(c2) && (e2 || Pn(c2) || K(c2)) ? r2 > 1 ? _2(c2, r2 - 1, e2, u2) : n(u2, c2) : e2 || (u2[u2.length] = c2)
            }
            return u2
        }

        function g(n2, t2) {
            return n2 && qn(n2, t2, en)
        }

        function b(n2, t2) {
            return y(t2, function (t3) {
                return Q(n2[t3])
            })
        }

        function j(n2, t2, r2, e2, u2) {
            return n2 === t2 ? !0 : n2 == null || t2 == null || !X(n2) && !Y(t2) ? n2 !== n2 && t2 !== t2 : m(n2, t2, j, r2, e2, u2)
        }

        function m(n2, t2, r2, e2, u2, o2) {
            var i2 = Pn(n2), f2 = Pn(t2), a2 = "[object Array]", l2 = "[object Array]";
            i2 || (a2 = kn.call(n2), a2 == "[object Arguments]" && (a2 = "[object Object]")), f2 || (l2 = kn.call(t2), l2 == "[object Arguments]" && (l2 = "[object Object]"));
            var p2 = a2 == "[object Object]" && !c(n2), f2 = l2 == "[object Object]" && !c(t2);
            return !(l2 = a2 == l2) || i2 || p2 ? 2 & u2 || (a2 = p2 && En.call(n2, "__wrapped__"), f2 = f2 && En.call(t2, "__wrapped__"), !a2 && !f2) ? l2 ? (o2 || (o2 = []), (a2 = J(o2, function (t3) {
                return t3[0] === n2
            })) && a2[1] ? a2[1] == t2 : (o2.push([n2, t2]), t2 = (i2 ? I : q)(n2, t2, r2, e2, u2, o2), o2.pop(), t2)) : !1 : r2(a2 ? n2.value() : n2, f2 ? t2.value() : t2, e2, u2, o2) : $(n2, t2, a2)
        }

        function d(n2) {
            var t2 = typeof n2;
            return t2 == "function" ? n2 : n2 == null ? cn : (t2 == "object" ? x : A)(n2)
        }

        function w(n2) {
            n2 = n2 == null ? n2 : Object(n2);
            var t2, r2 = [];
            for (t2 in n2) r2.push(t2);
            return r2
        }

        function O(n2, t2) {
            var r2 = -1, e2 = L(n2) ? Array(n2.length) : [];
            return $n(n2, function (n3, u2, o2) {
                e2[++r2] = t2(n3, u2, o2)
            }), e2
        }

        function x(n2) {
            var t2 = en(n2);
            return function (r2) {
                var e2 = t2.length;
                if (r2 == null) return !e2;
                for (r2 = Object(r2); e2--;) {
                    var u2 = t2[e2];
                    if (!(u2 in r2 && j(n2[u2], r2[u2], an, 3))) return !1
                }
                return !0
            }
        }

        function E(n2, t2) {
            return n2 = Object(n2), P(t2, function (t3, r2) {
                return r2 in n2 && (t3[r2] = n2[r2]), t3
            }, {})
        }

        function A(n2) {
            return function (t2) {
                return t2 == null ? an : t2[n2]
            }
        }

        function k(n2, t2, r2) {
            var e2 = -1, u2 = n2.length;
            for (0 > t2 && (t2 = -t2 > u2 ? 0 : u2 + t2), r2 = r2 > u2 ? u2 : r2, 0 > r2 && (r2 += u2), u2 = t2 > r2 ? 0 : r2 - t2 >>> 0, t2 >>>= 0, r2 = Array(u2); ++e2 < u2;) r2[e2] = n2[e2 + t2];
            return r2
        }

        function N(n2) {
            return k(n2, 0, n2.length)
        }

        function S(n2, t2) {
            var r2;
            return $n(n2, function (n3, e2, u2) {
                return r2 = t2(n3, e2, u2), !r2
            }), !!r2
        }

        function T(t2, r2) {
            return P(r2, function (t3, r3) {
                return r3.func.apply(r3.thisArg, n([t3], r3.args))
            }, t2)
        }

        function F(n2, t2, r2, e2) {
            r2 || (r2 = {});
            for (var u2 = -1, o2 = t2.length; ++u2 < o2;) {
                var i2 = t2[u2], c2 = e2 ? e2(r2[i2], n2[i2], i2, r2, n2) : n2[i2], f2 = r2, a2 = f2[i2];
                En.call(f2, i2) && (a2 === c2 || a2 !== a2 && c2 !== c2) && (c2 !== an || i2 in f2) || (f2[i2] = c2)
            }
            return r2
        }

        function R(n2) {
            return V(function (t2, r2) {
                var e2 = -1, u2 = r2.length, o2 = u2 > 1 ? r2[u2 - 1] : an,
                    o2 = typeof o2 == "function" ? (u2--, o2) : an;
                for (t2 = Object(t2); ++e2 < u2;) {
                    var i2 = r2[e2];
                    i2 && n2(t2, i2, e2, o2)
                }
                return t2
            })
        }

        function B(n2) {
            return function () {
                var t2 = arguments, r2 = s(n2.prototype), t2 = n2.apply(r2, t2);
                return X(t2) ? t2 : r2
            }
        }

        function D(n2, t2, r2) {
            function e2() {
                for (var o2 = -1, i2 = arguments.length, c2 = -1, f2 = r2.length, a2 = Array(f2 + i2), l2 = this && this !== wn && this instanceof e2 ? u2 : n2; ++c2 < f2;) a2[c2] = r2[c2];
                for (; i2--;) a2[c2++] = arguments[++o2];
                return l2.apply(t2, a2)
            }

            if (typeof n2 != "function") throw new TypeError("Expected a function");
            var u2 = B(n2);
            return e2
        }

        function I(n2, t2, r2, e2, u2, o2) {
            var i2 = -1, c2 = 1 & u2, f2 = n2.length, a2 = t2.length;
            if (f2 != a2 && !(2 & u2 && a2 > f2)) return !1;
            for (a2 = !0; ++i2 < f2;) {
                var l2 = n2[i2], p2 = t2[i2];
                if (an !== void 0) {
                    a2 = !1;
                    break
                }
                if (c2) {
                    if (!S(t2, function (n3) {
                        return l2 === n3 || r2(l2, n3, e2, u2, o2)
                    })) {
                        a2 = !1;
                        break
                    }
                } else if (l2 !== p2 && !r2(l2, p2, e2, u2, o2)) {
                    a2 = !1;
                    break
                }
            }
            return a2
        }

        function $(n2, t2, r2) {
            switch (r2) {
                case"[object Boolean]":
                case"[object Date]":
                    return +n2 == +t2;
                case"[object Error]":
                    return n2.name == t2.name && n2.message == t2.message;
                case"[object Number]":
                    return n2 != +n2 ? t2 != +t2 : n2 == +t2;
                case"[object RegExp]":
                case"[object String]":
                    return n2 == t2 + ""
            }
            return !1
        }

        function q(n2, t2, r2, e2, u2, o2) {
            var i2 = 2 & u2, c2 = en(n2), f2 = c2.length, a2 = en(t2).length;
            if (f2 != a2 && !i2) return !1;
            for (var l2 = f2; l2--;) {
                var p2 = c2[l2];
                if (!(i2 ? p2 in t2 : En.call(t2, p2))) return !1
            }
            for (a2 = !0; ++l2 < f2;) {
                var p2 = c2[l2], s2 = n2[p2], h2 = t2[p2];
                if (an !== void 0 || s2 !== h2 && !r2(s2, h2, e2, u2, o2)) {
                    a2 = !1;
                    break
                }
                i2 || (i2 = p2 == "constructor")
            }
            return a2 && !i2 && (r2 = n2.constructor, e2 = t2.constructor, r2 != e2 && "constructor" in n2 && "constructor" in t2 && !(typeof r2 == "function" && r2 instanceof r2 && typeof e2 == "function" && e2 instanceof e2) && (a2 = !1)), a2
        }

        function z(n2) {
            var t2 = n2 ? n2.length : an;
            if (W(t2) && (Pn(n2) || nn(n2) || K(n2))) {
                n2 = String;
                for (var r2 = -1, e2 = Array(t2); ++r2 < t2;) e2[r2] = n2(r2);
                t2 = e2
            } else t2 = null;
            return t2
        }

        function C(n2) {
            var t2 = n2 && n2.constructor, t2 = Q(t2) && t2.prototype || xn;
            return n2 === t2
        }

        function G(n2) {
            return n2 ? n2[0] : an
        }

        function J(n2, t2) {
            return r(n2, d(t2), $n)
        }

        function M(n2, t2) {
            return $n(n2, typeof t2 == "function" ? t2 : cn)
        }

        function P(n2, t2, r2) {
            return e(n2, d(t2), r2, 3 > arguments.length, $n)
        }

        function U(n2, t2) {
            var r2;
            if (typeof t2 != "function") throw new TypeError("Expected a function");
            return n2 = Un(n2), function () {
                return 0 < --n2 && (r2 = t2.apply(this, arguments)), 1 >= n2 && (t2 = an), r2
            }
        }

        function V(n2) {
            var t2;
            if (typeof n2 != "function") throw new TypeError("Expected a function");
            return t2 = In(t2 === an ? n2.length - 1 : Un(t2), 0), function () {
                for (var r2 = arguments, e2 = -1, u2 = In(r2.length - t2, 0), o2 = Array(u2); ++e2 < u2;) o2[e2] = r2[t2 + e2];
                for (u2 = Array(t2 + 1), e2 = -1; ++e2 < t2;) u2[e2] = r2[e2];
                return u2[t2] = o2, n2.apply(this, u2)
            }
        }

        function H(n2, t2) {
            return n2 > t2
        }

        function K(n2) {
            return Y(n2) && L(n2) && En.call(n2, "callee") && (!Rn.call(n2, "callee") || kn.call(n2) == "[object Arguments]")
        }

        function L(n2) {
            return n2 != null && !(typeof n2 == "function" && Q(n2)) && W(zn(n2))
        }

        function Q(n2) {
            return n2 = X(n2) ? kn.call(n2) : "", n2 == "[object Function]" || n2 == "[object GeneratorFunction]"
        }

        function W(n2) {
            return typeof n2 == "number" && n2 > -1 && n2 % 1 == 0 && 9007199254740991 >= n2
        }

        function X(n2) {
            var t2 = typeof n2;
            return !!n2 && (t2 == "object" || t2 == "function")
        }

        function Y(n2) {
            return !!n2 && typeof n2 == "object"
        }

        function Z(n2) {
            return typeof n2 == "number" || Y(n2) && kn.call(n2) == "[object Number]"
        }

        function nn(n2) {
            return typeof n2 == "string" || !Pn(n2) && Y(n2) && kn.call(n2) == "[object String]"
        }

        function tn(n2, t2) {
            return t2 > n2
        }

        function rn(n2) {
            return typeof n2 == "string" ? n2 : n2 == null ? "" : n2 + ""
        }

        function en(n2) {
            var t2 = C(n2);
            if (!t2 && !L(n2)) return Dn(Object(n2));
            var r2, e2 = z(n2), u2 = !!e2, e2 = e2 || [], o2 = e2.length;
            for (r2 in n2) !En.call(n2, r2) || u2 && (r2 == "length" || f(r2, o2)) || t2 && r2 == "constructor" || e2.push(r2);
            return e2
        }

        function un(n2) {
            for (var t2 = -1, r2 = C(n2), e2 = w(n2), u2 = e2.length, o2 = z(n2), i2 = !!o2, o2 = o2 || [], c2 = o2.length; ++t2 < u2;) {
                var a2 = e2[t2];
                i2 && (a2 == "length" || f(a2, c2)) || a2 == "constructor" && (r2 || !En.call(n2, a2)) || o2.push(a2)
            }
            return o2
        }

        function on(n2) {
            return n2 ? u(n2, en(n2)) : []
        }

        function cn(n2) {
            return n2
        }

        function fn(t2, r2, e2) {
            var u2 = en(r2), o2 = b(r2, u2);
            e2 != null || X(r2) && (o2.length || !u2.length) || (e2 = r2, r2 = t2, t2 = this, o2 = b(r2, en(r2)));
            var i2 = X(e2) && "chain" in e2 ? e2.chain : !0, c2 = Q(t2);
            return $n(o2, function (e3) {
                var u3 = r2[e3];
                t2[e3] = u3, c2 && (t2.prototype[e3] = function () {
                    var r3 = this.__chain__;
                    if (i2 || r3) {
                        var e4 = t2(this.__wrapped__);
                        return (e4.__actions__ = N(this.__actions__)).push({
                            func: u3,
                            args: arguments,
                            thisArg: t2
                        }), e4.__chain__ = r3, e4
                    }
                    return u3.apply(t2, n([this.value()], arguments))
                })
            }), t2
        }

        var an, ln = 1 / 0, pn = /[&<>"'`]/g, sn = RegExp(pn.source), hn = /^(?:0|[1-9]\d*)$/,
            vn = {"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "`": "&#96;"},
            yn = {function: !0, object: !0}, _n = yn[typeof exports] && exports && !exports.nodeType ? exports : an,
            gn = yn[typeof module] && module && !module.nodeType ? module : an, bn = gn && gn.exports === _n ? _n : an,
            jn = o(yn[typeof self] && self), mn = o(yn[typeof window] && window), dn = o(yn[typeof this] && this),
            wn = o(_n && gn && typeof global == "object" && global) || mn !== (dn && dn.window) && mn || jn || dn || Function("return this")(),
            On = Array.prototype, xn = Object.prototype, En = xn.hasOwnProperty, An = 0, kn = xn.toString, Nn = wn._,
            Sn = wn.Reflect, Tn = Sn ? Sn.f : an, Fn = Object.create, Rn = xn.propertyIsEnumerable, Bn = wn.isFinite,
            Dn = Object.keys, In = Math.max, $n = function (n2, t2) {
                return function (r2, e2) {
                    if (r2 == null) return r2;
                    if (!L(r2)) return n2(r2, e2);
                    for (var u2 = r2.length, o2 = t2 ? u2 : -1, i2 = Object(r2); (t2 ? o2-- : ++o2 < u2) && e2(i2[o2], o2, i2) !== !1;) ;
                    return r2
                }
            }(g), qn = function (n2) {
                return function (t2, r2, e2) {
                    var u2 = -1, o2 = Object(t2);
                    e2 = e2(t2);
                    for (var i2 = e2.length; i2--;) {
                        var c2 = e2[n2 ? i2 : ++u2];
                        if (r2(o2[c2], c2, o2) === !1) break
                    }
                    return t2
                }
            }();
        Tn && !Rn.call({valueOf: 1}, "valueOf") && (w = function (n2) {
            n2 = Tn(n2);
            for (var t2, r2 = []; !(t2 = n2.next()).done;) r2.push(t2.value);
            return r2
        });
        var zn = A("length"), Cn = V(function (t2, r2) {
            return Pn(t2) || (t2 = t2 == null ? [] : [Object(t2)]), _2(r2, 1), n(N(t2), on)
        }), Gn = V(function (n2, t2, r2) {
            return D(n2, t2, r2)
        }), Jn = V(function (n2, t2) {
            return h(n2, 1, t2)
        }), Mn = V(function (n2, t2, r2) {
            return h(n2, Vn(t2) || 0, r2)
        }), Pn = Array.isArray, Un = Number, Vn = Number, Hn = R(function (n2, t2) {
            F(t2, en(t2), n2)
        }), Kn = R(function (n2, t2) {
            F(t2, un(t2), n2)
        }), Ln = R(function (n2, t2, r2, e2) {
            F(t2, un(t2), n2, e2)
        }), Qn = V(function (n2) {
            return n2.push(an, p), Ln.apply(an, n2)
        }), Wn = V(function (n2, t2) {
            return n2 == null ? {} : E(n2, _2(t2, 1))
        }), Xn = d;
        l.prototype = s(a.prototype), l.prototype.constructor = l, a.assignIn = Kn, a.before = U, a.bind = Gn, a.chain = function (n2) {
            return n2 = a(n2), n2.__chain__ = !0, n2
        }, a.compact = function (n2) {
            return y(n2, Boolean)
        }, a.concat = Cn, a.create = function (n2, t2) {
            var r2 = s(n2);
            return t2 ? Hn(r2, t2) : r2
        }, a.defaults = Qn, a.defer = Jn, a.delay = Mn, a.filter = function (n2, t2) {
            return y(n2, d(t2))
        }, a.flatten = function (n2) {
            return n2 && n2.length ? _2(n2, 1) : []
        }, a.flattenDeep = function (n2) {
            return n2 && n2.length ? _2(n2, ln) : []
        }, a.iteratee = Xn, a.keys = en, a.map = function (n2, t2) {
            return O(n2, d(t2))
        }, a.matches = function (n2) {
            return x(Hn({}, n2))
        }, a.mixin = fn, a.negate = function (n2) {
            if (typeof n2 != "function") throw new TypeError("Expected a function");
            return function () {
                return !n2.apply(this, arguments)
            }
        }, a.once = function (n2) {
            return U(2, n2)
        }, a.pick = Wn, a.slice = function (n2, t2, r2) {
            var e2 = n2 ? n2.length : 0;
            return r2 = r2 === an ? e2 : +r2, e2 ? k(n2, t2 == null ? 0 : +t2, r2) : []
        }, a.sortBy = function (n2, t2) {
            var r2 = 0;
            return t2 = d(t2), O(O(n2, function (n3, e2, u2) {
                return {c: n3, b: r2++, a: t2(n3, e2, u2)}
            }).sort(function (n3, t3) {
                var r3;
                n:{
                    r3 = n3.a;
                    var e2 = t3.a;
                    if (r3 !== e2) {
                        var u2 = r3 === null, o2 = r3 === an, i2 = r3 === r3, c2 = e2 === null, f2 = e2 === an,
                            a2 = e2 === e2;
                        if (r3 > e2 && !c2 || !i2 || u2 && !f2 && a2 || o2 && a2) {
                            r3 = 1;
                            break n
                        }
                        if (e2 > r3 && !u2 || !a2 || c2 && !o2 && i2 || f2 && i2) {
                            r3 = -1;
                            break n
                        }
                    }
                    r3 = 0
                }
                return r3 || n3.b - t3.b
            }), A("c"))
        }, a.tap = function (n2, t2) {
            return t2(n2), n2
        }, a.thru = function (n2, t2) {
            return t2(n2)
        }, a.toArray = function (n2) {
            return L(n2) ? n2.length ? N(n2) : [] : on(n2)
        }, a.values = on, a.extend = Kn, fn(a, a), a.clone = function (n2) {
            return X(n2) ? Pn(n2) ? N(n2) : F(n2, en(n2)) : n2
        }, a.escape = function (n2) {
            return (n2 = rn(n2)) && sn.test(n2) ? n2.replace(pn, i) : n2
        }, a.every = function (n2, t2, r2) {
            return t2 = r2 ? an : t2, v(n2, d(t2))
        }, a.find = J, a.forEach = M, a.has = function (n2, t2) {
            return n2 != null && En.call(n2, t2)
        }, a.head = G, a.identity = cn, a.indexOf = function (n2, t2, r2) {
            var e2 = n2 ? n2.length : 0;
            r2 = typeof r2 == "number" ? 0 > r2 ? In(e2 + r2, 0) : r2 : 0, r2 = (r2 || 0) - 1;
            for (var u2 = t2 === t2; ++r2 < e2;) {
                var o2 = n2[r2];
                if (u2 ? o2 === t2 : o2 !== o2) return r2
            }
            return -1
        }, a.isArguments = K, a.isArray = Pn, a.isBoolean = function (n2) {
            return n2 === !0 || n2 === !1 || Y(n2) && kn.call(n2) == "[object Boolean]"
        }, a.isDate = function (n2) {
            return Y(n2) && kn.call(n2) == "[object Date]"
        }, a.isEmpty = function (n2) {
            if (L(n2) && (Pn(n2) || nn(n2) || Q(n2.splice) || K(n2))) return !n2.length;
            for (var t2 in n2) if (En.call(n2, t2)) return !1;
            return !0
        }, a.isEqual = function (n2, t2) {
            return j(n2, t2)
        }, a.isFinite = function (n2) {
            return typeof n2 == "number" && Bn(n2)
        }, a.isFunction = Q, a.isNaN = function (n2) {
            return Z(n2) && n2 != +n2
        }, a.isNull = function (n2) {
            return n2 === null
        }, a.isNumber = Z, a.isObject = X, a.isRegExp = function (n2) {
            return X(n2) && kn.call(n2) == "[object RegExp]"
        }, a.isString = nn, a.isUndefined = function (n2) {
            return n2 === an
        }, a.last = function (n2) {
            var t2 = n2 ? n2.length : 0;
            return t2 ? n2[t2 - 1] : an
        }, a.max = function (n2) {
            return n2 && n2.length ? t(n2, cn, H) : an
        }, a.min = function (n2) {
            return n2 && n2.length ? t(n2, cn, tn) : an
        }, a.noConflict = function () {
            return wn._ === this && (wn._ = Nn), this
        }, a.noop = function () {
        }, a.reduce = P, a.result = function (n2, t2, r2) {
            return t2 = n2 == null ? an : n2[t2], t2 === an && (t2 = r2), Q(t2) ? t2.call(n2) : t2
        }, a.size = function (n2) {
            return n2 == null ? 0 : (n2 = L(n2) ? n2 : en(n2), n2.length)
        }, a.some = function (n2, t2, r2) {
            return t2 = r2 ? an : t2, S(n2, d(t2))
        }, a.uniqueId = function (n2) {
            var t2 = ++An;
            return rn(n2) + t2
        }, a.each = M, a.first = G, fn(a, function () {
            var n2 = {};
            return g(a, function (t2, r2) {
                En.call(a.prototype, r2) || (n2[r2] = t2)
            }), n2
        }(), {chain: !1}), a.VERSION = "4.5.1", $n("pop join replace reverse split push shift sort splice unshift".split(" "), function (n2) {
            var t2 = (/^(?:replace|split)$/.test(n2) ? String.prototype : On)[n2],
                r2 = /^(?:push|sort|unshift)$/.test(n2) ? "tap" : "thru", e2 = /^(?:pop|join|replace|shift)$/.test(n2);
            a.prototype[n2] = function () {
                var n3 = arguments;
                return e2 && !this.__chain__ ? t2.apply(this.value(), n3) : this[r2](function (r3) {
                    return t2.apply(r3, n3)
                })
            }
        }), a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = function () {
            return T(this.__wrapped__, this.__actions__)
        }, (mn || jn || {})._ = a, typeof define == "function" && typeof define.amd == "object" && define.amd ? define(function () {
            return a
        }) : _n && gn ? (bn && ((gn.exports = a)._ = a), _n._ = a) : wn._ = a
    }).call(this)
}(), function () {
    (function (e) {
        var n;
        if (typeof define == "function" && define.amd && (define(e), n = !0), typeof exports == "object" && (module.exports = e(), n = !0), !n) {
            var t = window.Cookies, o = window.Cookies = e();
            o.noConflict = function () {
                return window.Cookies = t, o
            }
        }
    })(function () {
        function e() {
            for (var e2 = 0, n2 = {}; e2 < arguments.length; e2++) {
                var t = arguments[e2];
                for (var o in t) n2[o] = t[o]
            }
            return n2
        }

        function n(e2) {
            return e2.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent)
        }

        return function t(o) {
            function r() {
            }

            function i(n2, t2, i2) {
                if (typeof document < "u") {
                    typeof (i2 = e({path: "/"}, r.defaults, i2)).expires == "number" && (i2.expires = new Date(1 * new Date + 864e5 * i2.expires)), i2.expires = i2.expires ? i2.expires.toUTCString() : "";
                    try {
                        var c2 = JSON.stringify(t2);
                        /^[\{\[]/.test(c2) && (t2 = c2)
                    } catch {
                    }
                    t2 = o.write ? o.write(t2, n2) : encodeURIComponent(String(t2)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), n2 = encodeURIComponent(String(n2)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                    var f = "";
                    for (var u in i2) i2[u] && (f += "; " + u, i2[u] !== !0 && (f += "=" + i2[u].split(";")[0]));
                    return document.cookie = n2 + "=" + t2 + f
                }
            }

            function c(e2, t2) {
                if (typeof document < "u") {
                    for (var r2 = {}, i2 = document.cookie ? document.cookie.split("; ") : [], c2 = 0; c2 < i2.length; c2++) {
                        var f = i2[c2].split("="), u = f.slice(1).join("=");
                        t2 || u.charAt(0) !== '"' || (u = u.slice(1, -1));
                        try {
                            var a = n(f[0]);
                            if (u = (o.read || o)(u, a) || n(u), t2) try {
                                u = JSON.parse(u)
                            } catch {
                            }
                            if (r2[a] = u, e2 === a) break
                        } catch {
                        }
                    }
                    return e2 ? r2[e2] : r2
                }
            }

            return r.set = i, r.get = function (e2) {
                return c(e2, !1)
            }, r.getJSON = function (e2) {
                return c(e2, !0)
            }, r.remove = function (n2, t2) {
                i(n2, "", e(t2, {expires: -1}))
            }, r.defaults = {}, r.withConverter = t, r
        }(function () {
        })
    })
}();
var Events = new EventEmitter3;
Events.trigger = Events.emit;

function onYouTubeIframeAPIReady() {
    VideoTT.playerBuild(), theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube), WAU.Video.loadVideos("youtube")
}

window.WAU = window.WAU || {}, WAU.Video = function () {
    var videos = {}, hosts = {html5: "html5", youtube: "youtube"};

    function init7(videoContainer, sectionId, flkty, videoAudio) {
        var videoElement = videoContainer.querySelector("iframe");
        if (!videoElement) var videoElement = videoContainer.querySelector("video");
        if (!videoElement) return;
        const mediaId = videoContainer.dataset.videoId;
        videos[mediaId] = {
            mediaId,
            sectionId,
            host: hostFromVideoElement(videoElement),
            container: videoContainer,
            element: videoElement,
            ready: function () {
                createPlayer(this, flkty, videoAudio)
            }
        };
        var video = videos[mediaId];
        switch (video.host) {
            case hosts.html5:
                window.Shopify.loadFeatures([{
                    name: "video-ui",
                    version: "1.0",
                    onLoad: setupPlyrVideos
                }]), theme.LibraryLoader.load("plyrShopifyStyles");
                break;
            case hosts.youtube:
                theme.LibraryLoader.load("youtubeSdk", setupYouTubeVideos);
                break
        }
    }

    function setupPlyrVideos(errors) {
        if (errors) {
            fallbackToNativeVideo();
            return
        }
        loadVideos(hosts.html5)
    }

    function setupYouTubeVideos() {
        window.YT.Player && loadVideos(hosts.youtube)
    }

    function createPlayer(video, flkty, videoAudio) {
        if (!video.player) switch (video.host) {
            case hosts.html5:
                if (videoAudio == "off") var muted = !0; else var muted = !1;
                video.player = new Shopify.Plyr(video.element, {
                    muted,
                    hideControlsOnPause: !1,
                    autoplay: !1,
                    settings: {loop: !1},
                    tooltips: {controls: !0, seek: !0}
                }), video.player.on("play", function () {
                    flkty.stopPlayer()
                }), video.player.on("ended", function () {
                    flkty.playPlayer()
                }), flkty.on("change", function (index) {
                    video.player.pause()
                });
                break;
            case hosts.youtube:
                let onPlayerReady2 = function (event2) {
                    videoAudio == "off" && event2.target.mute(), flkty.on("change", function (index) {
                        event2.target.stopVideo()
                    })
                }, onPlayerStateChange2 = function (event2) {
                    event2.data == 1 && flkty.stopPlayer(), event2.data == 0 && flkty.playPlayer()
                };
                var onPlayerReady = onPlayerReady2, onPlayerStateChange = onPlayerStateChange2,
                    videoId = video.container.dataset.videoId;
                video.player = new YT.Player(video.element, {
                    videoId,
                    events: {onStateChange: onPlayerStateChange2, onReady: onPlayerReady2}
                });
                break
        }
    }

    function hostFromVideoElement(video) {
        return video.tagName === "VIDEO" ? hosts.html5 : video.tagName === "IFRAME" && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(video.src) ? hosts.youtube : null
    }

    function loadVideos(host) {
        for (var key2 in videos) if (videos.hasOwnProperty(key2)) {
            var video = videos[key2];
            video.host === host && video.ready()
        }
    }

    function fallbackToNativeVideo() {
        for (var key2 in videos) if (videos.hasOwnProperty(key2)) {
            var video = videos[key2];
            if (video.nativeVideo) continue;
            video.host === hosts.html5 && (video.element.setAttribute("controls", "controls"), video.nativeVideo = !0)
        }
    }

    function removeSectionVideos(sectionId) {
        for (var key2 in videos) if (videos.hasOwnProperty(key2)) {
            var video = videos[key2];
            video.sectionId === sectionId && (video.player && video.player.destroy(), delete videos[key2])
        }
    }

    return {init: init7, hosts, loadVideos, removeSectionVideos}
}(), WAU.Slideout = function () {
    var wrapper = void 0;
    document.addEventListener("keyup", function (event2) {
        event2.key === "Escape" && (event2.preventDefault(), closeActiveSlideout())
    }), document.addEventListener("click", function (event2) {
        event2.target === document.querySelector(".js-slideout-overlay") && closeActiveSlideout()
    });

    function closeActiveSlideout() {
        const activeSlideoutName = document.querySelector(".slideout--active").getAttribute("data-wau-slideout"),
            opener = document.querySelector('.js-slideout-open[data-wau-slideout-target="' + activeSlideoutName + '"]'),
            direction = opener.getAttribute("data-slideout-direction");
        close(direction, opener)
    }

    function isOpen() {
        return wrapper = document.querySelector(".js-slideout-toggle-wrapper"), wrapper.classList.contains("slideout-left--open") || wrapper.classList.contains("slideout-right--open")
    }

    function open(direction, targetSlideoutEl, opener) {
        wrapper.classList.add("slideout-" + direction + "--open"), wrapper.classList.remove("slideout-" + direction + "--closed"), targetSlideoutEl.classList.add("slideout--active"), opener.setAttribute("aria-expanded", "true");
        let scrollPosition = Math.abs(0 - document.querySelector(".site-wrap").getBoundingClientRect().top);
        targetSlideoutEl.querySelectorAll("*").forEach((item, i) => {
            item.setAttribute("tabIndex", "0")
        }), wrapper.style.overflow = "hidden", wrapper.style.position = "fixed", wrapper.style.top = `-${scrollPosition}px`, wrapper.style.width = "100%"
    }

    function close(direction, openerEl) {
        const activeOpenSlideouts = document.querySelectorAll(".slideout--active"),
            openers = document.querySelectorAll(".js-slideout-open"),
            closers = document.querySelectorAll(".js-slideout-close");
        wrapper.classList.remove("slideout-" + direction + "--open"), wrapper.classList.add("slideout-" + direction + "--closed"), activeOpenSlideouts.forEach(function (activeSlideoutDrawer) {
            activeSlideoutDrawer.classList.remove("slideout--active"), activeSlideoutDrawer.querySelectorAll("*").forEach((item, i) => {
                item.setAttribute("tabIndex", "-1")
            })
        }), openers.forEach(function (opener) {
            opener.setAttribute("aria-expanded", "false")
        }), closers.forEach(function (closer) {
            closer.setAttribute("aria-expanded", "false")
        }), openerEl.focus();
        let scrollPosition = Math.abs(0 - document.querySelector(".site-wrap").getBoundingClientRect().top);
        wrapper.style.removeProperty("overflow"), wrapper.style.removeProperty("position"), wrapper.style.removeProperty("top"), wrapper.style.removeProperty("width"), window.scrollTo(0, scrollPosition)
    }

    function closeByName(name) {
        const direction = document.querySelector('[data-wau-slideout-target="' + name + '"]').getAttribute("data-slideout-direction"),
            opener = document.querySelector('.js-slideout-open[data-wau-slideout-target="' + name + '"]');
        close(direction, opener)
    }

    function openByName(name) {
        const opener = document.querySelector('[data-wau-slideout-target="' + name + '"]'),
            direction = opener.getAttribute("data-slideout-direction"),
            targetSlideoutEl = document.querySelector('[data-wau-slideout="' + name + '"]');
        open(direction, targetSlideoutEl, opener)
    }

    function createCloser(name, direction) {
        const closeDiv = document.createElement("div"), button = document.createElement("button"),
            icon = document.createElement("div");
        return closeDiv.classList.add("slideout__trigger--close"), closeDiv.classList.add("slideout__trigger-" + name + "__wrapper"), closeDiv.classList.add("slideout__trigger-general-slideout"), button.classList.add("slideout__trigger-" + name), button.classList.add("js-slideout-close"), button.setAttribute("data-slideout-direction", direction), button.setAttribute("aria-controls", "slideout-" + name), button.setAttribute("aria-label", "Close slideout"), icon.classList.add("icn-close"), button.appendChild(icon), closeDiv.appendChild(button), closeDiv
    }

    function createSlideoutEl(direction, name, wrapperEl) {
        const aside = document.createElement("aside"), innerDiv = document.createElement("div"),
            innerContentDiv = document.createElement("div"),
            opener = document.querySelector('[data-wau-slideout-target="' + name + '"]'),
            content = document.querySelector('[data-wau-slideout-content="' + name + '"]'),
            generatedId = "slideout-" + name;
        if (wrapperEl = wrapperEl || wrapper, aside.classList.add("slideout"), aside.classList.add("slideout__drawer-" + direction), aside.setAttribute("data-wau-slideout", name), aside.setAttribute("id", generatedId), innerDiv.classList.add("slideout__inner-wrapper"), innerDiv.classList.add("slideout__general-slide__wrapper"), innerContentDiv.innerHTML = content.innerHTML, innerContentDiv.classList.add("slideout__inner-content-container"), content.innerHTML = "", content.dataset.wauSlideoutButton && content.dataset.wauSlideoutButton == "true") {
            let closeDiv = createCloser(name, direction);
            innerDiv.prepend(closeDiv)
        }
        return aside.appendChild(innerDiv), innerDiv.appendChild(innerContentDiv), opener.setAttribute("aria-controls", generatedId), wrapperEl.appendChild(aside), aside
    }

    function reloadSlideoutContents(name) {
        const content = document.querySelector('[data-wau-slideout-content="' + name + '"]'),
            innerWrapper = document.querySelector('aside[data-wau-slideout="' + name + '"]').querySelector(".slideout__inner-content-container");
        innerWrapper.innerHTML = content.innerHTML
    }

    function init7(name) {
        if (typeof name > "u") {
            console.log("The Slideout must have an associated name.");
            return
        }
        wrapper = document.querySelector(".js-slideout-toggle-wrapper");
        const slideoutOpeners = document.querySelectorAll('.js-slideout-open[data-wau-slideout-target="' + name + '"]');
        let slideoutTargetEl;
        slideoutOpeners.forEach((slideoutOpener, i) => {
            const slideoutDirection = slideoutOpener.getAttribute("data-slideout-direction");
            slideoutOpener && (slideoutTargetEl = document.querySelector(`aside[data-wau-slideout=${name}]`)), slideoutTargetEl || (slideoutTargetEl = createSlideoutEl(slideoutDirection, name, wrapper)), Events.trigger("slideout:active:" + name), slideoutTargetEl.querySelectorAll("*").forEach((item, i2) => {
                item.setAttribute("tabIndex", "-1")
            }), slideoutOpener.addEventListener("click", function () {
                open(slideoutDirection, slideoutTargetEl, slideoutOpener)
            })
        }), document.querySelectorAll(".js-slideout-close").forEach((slideoutCloser, i) => {
            const slideoutCloseDirection = slideoutCloser.getAttribute("data-slideout-direction");
            slideoutCloser.addEventListener("click", function () {
                close(slideoutCloseDirection, slideoutCloser)
            })
        })
    }

    const privateFunctions = {openByName, closeByName, createSlideoutEl, reloadSlideoutContents};
    let returnObj = {};
    return returnObj.init = init7, Object.keys(privateFunctions).forEach(function (pf) {
        returnObj["_" + pf] = privateFunctions[pf]
    }), returnObj
}(), WAU.Modal = function () {
    var wrapper = void 0;
    document.addEventListener("keyup", function (event2) {
        event2.key === "Escape" && (event2.preventDefault(), closeActiveModal())
    }), document.addEventListener("click", function (event2) {
        event2.target === document.querySelector(".js-modal-overlay") && closeActiveModal()
    });

    function closeActiveModal() {
        const activeModal = document.querySelector(".modal--active"),
            activeModalName = activeModal.getAttribute("data-wau-modal"),
            closer = activeModal.querySelector(".js-modal-close");
        close(closer)
    }

    function isOpen() {
        return wrapper = document.querySelector(".js-modal-toggle-wrapper"), wrapper.classList.contains("modal--open")
    }

    function open(targetModalEl, opener) {
        let scrollPosition = Math.abs(0 - document.querySelector(".site-wrap").getBoundingClientRect().top);
        if (wrapper.style.width = "100%", targetModalEl.style.top = `calc(${scrollPosition}px + 10vh)`, wrapper.classList.add("modal--open"), wrapper.classList.remove("modal--closed"), targetModalEl.classList.add("modal--active"), targetModalEl.getAttribute("data-wau-modal")) {
            var elClass = targetModalEl.getAttribute("data-wau-modal"), elClass = "modal-" + elClass + "--open";
            wrapper.classList.add(elClass)
        }
        opener.setAttribute("aria-expanded", "true")
    }

    function close(openerEl) {
        const activeOpenModals = document.querySelectorAll(".modal--active"),
            openers = document.querySelectorAll(".js-modal-open"),
            closers = document.querySelectorAll(".js-modal-close");
        openerEl.getAttribute("aria-controls") == "modal-quickview" && (document.querySelector(".js-quickview-content").innerHTML = ""), wrapper.classList.remove("modal--open"), wrapper.classList.add("modal--closed"), activeOpenModals.forEach(function (activeModalDrawer) {
            if (activeModalDrawer.getAttribute("data-wau-modal")) {
                var elClass = activeModalDrawer.getAttribute("data-wau-modal"), elClass = "modal-" + elClass + "--open";
                wrapper.classList.remove(elClass)
            }
            activeModalDrawer.classList.remove("modal--active")
        }), openers.forEach(function (opener) {
            opener.setAttribute("aria-expanded", "false")
        }), closers.forEach(function (closer) {
            closer.setAttribute("aria-expanded", "false")
        }), wrapper.style.removeProperty("overflow"), wrapper.style.removeProperty("position"), wrapper.style.removeProperty("padding-right"), wrapper.style.removeProperty("top"), wrapper.style.removeProperty("width"), document.body.classList.remove("overflow-hidden")
    }

    function closeByName(name) {
        const closer = document.querySelector('[data-wau-modal-target="' + name + '"]'),
            opener = document.querySelector('.js-modal-open[data-wau-modal-target="' + name + '"]');
        close(opener)
    }

    function openByName(name) {
        const opener = document.querySelector('[data-wau-modal-target="' + name + '"]'),
            targetModalEl = document.querySelector('[data-wau-modal="' + name + '"]');
        open(targetModalEl, opener)
    }

    function createCloser(name) {
        const closeDiv = document.createElement("div"), button = document.createElement("button"),
            icon = document.createElement("div");
        return closeDiv.classList.add("slideout__trigger--close"), closeDiv.classList.add("slideout__trigger-" + name + "__wrapper"), closeDiv.classList.add("slideout__trigger-general-modal__wrapper"), button.classList.add("slideout__trigger-" + name), button.classList.add("slideout__trigger-general-modal"), button.classList.add("js-modal-close"), button.setAttribute("aria-controls", "modal-" + name), button.setAttribute("aria-label", "Close modal"), icon.classList.add("icn-close"), button.appendChild(icon), closeDiv.appendChild(button), closeDiv
    }

    function createModalEl(name, wrapperEl) {
        const div = document.createElement("div"), innerDiv = document.createElement("div"),
            innerContentDiv = document.createElement("div"),
            opener = document.querySelector('[data-wau-modal-target="' + name + '"]'),
            content = document.querySelector('[data-wau-modal-content="' + name + '"]'), generatedId = "modal-" + name;
        wrapperEl = wrapperEl || wrapper, div.classList.add("modal"), div.classList.add("modal__container"), div.setAttribute("data-wau-modal", name), div.setAttribute("id", generatedId), innerDiv.classList.add("modal__inner-wrapper"), innerDiv.classList.add("modal__general-modal__wrapper"), content.hasAttribute("data-wau-modal-remove-original") ? innerContentDiv.appendChild(content) : innerContentDiv.innerHTML = content.innerHTML, innerContentDiv.classList.add("modal__inner-content-container");
        let closeDiv = createCloser(name);
        return innerDiv.prepend(closeDiv), div.appendChild(innerDiv), innerDiv.appendChild(innerContentDiv), opener.setAttribute("aria-controls", generatedId), wrapperEl.appendChild(div), div
    }

    function init7(name) {
        if (typeof name > "u") {
            console.log("The Modal must have an associated name.");
            return
        }
        wrapper = document.querySelector(".js-modal-toggle-wrapper");
        const modalOpeners = document.querySelectorAll('.js-modal-open[data-wau-modal-target="' + name + '"]');
        let modalTargetEl;
        modalOpeners && (modalTargetEl = document.querySelector(`div[data-wau-modal=${name}]`)), modalTargetEl || (modalTargetEl = createModalEl(name, wrapper)), modalOpeners.forEach((modalOpener, i) => {
            modalOpener.addEventListener("click", function () {
                open(modalTargetEl, modalOpener)
            })
        }), document.querySelectorAll(".js-modal-close").forEach(function (modalCloser) {
            modalCloser.addEventListener("click", function () {
                close(modalCloser)
            })
        })
    }

    const privateFunctions = {openByName, closeByName, createModalEl};
    let returnObj = {};
    return returnObj.init = init7, Object.keys(privateFunctions).forEach(function (pf) {
        returnObj["_" + pf] = privateFunctions[pf]
    }), returnObj
}(), WAU.Accordion = function () {
    const classes = {show: "is-active", open: "js-accordion-is-open", mobileNavAccordion: "js-accordion-mobile-nav"},
        selectors2 = {
            accordion: ".js-accordion",
            accordionItem: ".c-accordion__item",
            accordionLink: ".js-accordion-link",
            accordionHeader: ".js-accordion-header",
            accordionPanel: ".c-accordion__panel"
        }, publicAPIs = {}, stripClassPeriod = function (className) {
            if (className) return className.split(".")[1]
        };
    return publicAPIs.getConfigClass = function (className) {
        if (className) return classes[className] && classes[className] != "" ? classes[className] : !1
    }, publicAPIs.hide = function (target) {
        target.setAttribute("aria-expanded", "false");
        const panel = document.querySelector(`#${target.getAttribute("aria-controls")}`);
        panel.setAttribute("hidden", ""), panel.classList.remove(classes.show), setTimeout(function () {
            panel.style.display = "none"
        }, 350)
    }, publicAPIs.show = function (target, allowMultiple) {
        const panel = document.querySelector(`#${target.getAttribute("aria-controls")}`),
            parentElement = target.closest(panel.getAttribute("data-parent")),
            allowMultipleFlag = !!(allowMultiple || parentElement.hasAttribute("data-accordion-allow-multiple")),
            isMobileNav = parentElement.classList.contains(classes.mobileNavAccordion);
        if (!allowMultipleFlag && panel.hasAttribute("data-parent")) {
            let childSelector = "";
            if (isMobileNav ? childSelector = ':scope > li > [aria-expanded="true"]' : childSelector = ':scope > [aria-expanded="true"]', !childSelector) return;
            const activePanels = target.closest(panel.getAttribute("data-parent")).querySelectorAll(childSelector);
            if (!activePanels) return;
            activePanels.forEach(function (element) {
                publicAPIs.hide(element)
            })
        }
        target.setAttribute("aria-expanded", "true"), panel.removeAttribute("hidden"), panel.style.display = "block", setTimeout(function () {
            panel.classList.add(classes.show)
        }, 10)
    }, publicAPIs.toggle = function (target, allowMultiple) {
        if (target.getAttribute("aria-expanded") == "true") {
            publicAPIs.hide(target);
            return
        } else publicAPIs.show(target, allowMultiple)
    }, publicAPIs.init = function () {
        document.querySelectorAll(`[data-toggle="accordion"]:not(.${classes.open})`).forEach(function (element, index) {
            publicAPIs.hide(element)
        }), document.addEventListener("keydown", function (event2) {
            let target = event2.target;
            const key2 = event2.code, pageScrollOptions = !1 ? {preventScroll: !0} : {preventScroll: !1},
                isDropDownArrow = target.classList.contains("dropdown-arrow");
            if ((target.classList.contains(stripClassPeriod(selectors2.accordionHeader)) || target.classList.contains(stripClassPeriod(selectors2.accordionLink)) || isDropDownArrow) && (key2 == "ArrowUp" || key2 == "ArrowDown")) {
                const isMobile = !!target.closest(selectors2.accordion).classList.contains(classes.mobileNavAccordion),
                    accordionSelector = isMobile ? `:scope > li > ${selectors2.accordionLink}` : `:scope > ${selectors2.accordionHeader}`,
                    accordions = target.closest(selectors2.accordion).querySelectorAll(accordionSelector);
                if (isMobile && isDropDownArrow) {
                    target.previousElementSibling.focus(pageScrollOptions);
                    return
                }
                let indexPlace;
                accordions.forEach(function (element, index) {
                    element == target && (indexPlace = index)
                });
                const direction = key2 == "PageDown" || key2 == "ArrowDown" ? 1 : -1, length = accordions.length,
                    newIndex = (indexPlace + length + direction) % length;
                accordions[newIndex].focus(pageScrollOptions)
            }
        }), document.addEventListener("click", function (event2) {
            const target = event2.target.matches('[data-toggle="accordion"]') ? event2.target : event2.target.closest('[data-toggle="accordion"]');
            if (!target) return !1;
            publicAPIs.toggle(target), event2.preventDefault()
        })
    }, publicAPIs
}(), WAU.ProductGridVideo = {
    init: function () {
        document.querySelectorAll(".js-bg-video-wrapper").forEach(function (element) {
            WAU.ProductGridVideo.initVideo(element)
        })
    }, initVideo: function (element) {
        var selectorId = element.dataset.productId, videoUrl = element.dataset.videoUrl,
            selector = ".js-bg-video-" + selectorId + ":not(.is-active)", el = document.querySelector(selector);
        if (!el) return !1;
        var options = {mp4: videoUrl}, instance = new vidbg(selector, options);
        el.classList.add("is-active"), document.addEventListener("shopify:section:unload", function (event2) {
            WAU.ProductGridVideo.destroyVideo(instance)
        }), document.addEventListener("shopify:section:select", function (event2) {
            WAU.ProductGridVideo.reinitVideo(selector, options)
        }), WAU.ProductGridVideo.addIntersectionObserver(instance)
    }, addIntersectionObserver: function (instance) {
        if (!instance) return console.error("No instance provided to the function."), !1;
        if ("IntersectionObserver" in window) {
            let callback2 = function (entries, observer) {
                entries.forEach(entry => {
                    entry.isIntersecting ? instance.isVideoPlaying() || instance.playVideo() : instance.isVideoPlaying() && instance.pauseVideo()
                })
            }, observeElementHandler2 = function (event2) {
                new IntersectionObserver(callback2).observe(target), target.removeEventListener("playing", observeElementHandler2)
            };
            var callback = callback2, observeElementHandler = observeElementHandler2;
            const target = instance.videoEl;
            if (!target) return console.error("Error. not a valid target to observe."), !1;
            target.addEventListener("playing", observeElementHandler2)
        } else console.log("Intersection observer API not supported in this browser.")
    }, destroyVideo: function (element) {
        element.destroy()
    }, reinitVideo: function (selector, options) {
        var instance = new vidbg(selector, options);
        return instance
    }
}, window.theme = window.theme || {}, theme.a11yHelpers = function () {
    let alreadySetUpKeyEvents = !1;

    function setUpAriaExpansion() {
        document.querySelectorAll(".js-aria-expand").forEach(function (ariaExpandEl) {
            ariaExpandEl.addEventListener("mouseover", function (event2) {
                ariaExpandEl.setAttribute("aria-expanded", "true")
            }), ariaExpandEl.addEventListener("mouseout", function (event2) {
                ariaExpandEl.setAttribute("aria-expanded", "false")
            })
        })
    }

    function focusOnElement(parent) {
        var focussableElements = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
        const elementToFocusOn = parent.querySelector(focussableElements);
        elementToFocusOn && elementToFocusOn.focus()
    }

    function findFocusableElement(parent, element, direction) {
        const focusableElements = parent.querySelectorAll('a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'),
            numOfFocusableElements = focusableElements.length;
        var elementIndex = 0;
        for (let i = 0; i < focusableElements.length; i += 1) focusableElements[i] === element && (elementIndex = i);
        if (direction === "next") return elementIndex === numOfFocusableElements - 1 ? focusableElements[0] : focusableElements[elementIndex + 1];
        if (direction === "prev") return elementIndex === 0 ? focusableElements[numOfFocusableElements - 1] : focusableElements[elementIndex - 1]
    }

    function findNextFocusableElement(parent, element) {
        return findFocusableElement(parent, element, "next")
    }

    function findPreviousFocusableElement(parent, element) {
        return findFocusableElement(parent, element, "prev")
    }

    function setUpAccessibleNavigationMenus() {
        function closeDropdownMenus() {
            document.querySelectorAll(".navigation__menuitem--active").forEach(function (activeMenuItem) {
                activeMenuItem.classList.remove("navigation__menuitem--active"), activeMenuItem.setAttribute("aria-expanded", "false")
            })
        }

        function closeNestedDropdownMenus() {
            document.querySelectorAll(".js-menuitem-with-nested-dropdown").forEach(function (nestedDropdown) {
                nestedDropdown.classList.remove("dropdown__menuitem--active"), nestedDropdown.setAttribute("aria-expanded", "false")
            })
        }

        function closeNestedMegaMenuDropdownMenus() {
            document.querySelectorAll(".js-megamenu-listitem-with-nested-dropdown").forEach(function (nestedDropdown) {
                nestedDropdown.classList.remove("megamenu__listitem--active"), nestedDropdown.setAttribute("aria-expanded", "false")
            })
        }

        function addEdgeToDropdown(dropdown) {
            setTimeout(function () {
                theme.DOMHelpers.isElementPastEdge(dropdown) ? dropdown.classList.add("dropdown--edge") : dropdown.classList.remove("dropdown--edge")
            }, 0)
        }

        alreadySetUpKeyEvents || document.addEventListener("keyup", function (event2) {
            if (event2.key === "Escape") {
                const openNestedDropdownMenus = document.querySelectorAll(".dropdown__menuitem--active"),
                    openDropdownMenus = document.querySelectorAll(".navigation__menuitem--active"),
                    openMegaMenuNestedDropdownMenus = document.querySelectorAll(".megamenu__listitem--active");
                if (event2.preventDefault(), openNestedDropdownMenus.length >= 1) {
                    closeNestedDropdownMenus();
                    return
                }
                if (openMegaMenuNestedDropdownMenus.length >= 1) {
                    closeNestedMegaMenuDropdownMenus();
                    return
                }
                if (openDropdownMenus.length >= 1) {
                    closeDropdownMenus();
                    return
                }
            }
        }), alreadySetUpKeyEvents || document.addEventListener("keydown", function (event2) {
            if (event2.key === "Enter") {
                if ((document.activeElement.classList.contains("js-open-dropdown-on-key") || document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown") || document.activeElement.parentNode.classList.contains("js-megamenu-listitem-with-nested-dropdown")) && (event2.stopPropagation(), event2.preventDefault()), document.activeElement.parentNode.classList.contains("navigation__menuitem--active")) {
                    closeDropdownMenus();
                    return
                }
                if (document.activeElement.parentNode.classList.contains("dropdown__menuitem--active")) {
                    closeNestedDropdownMenus();
                    return
                }
                if (document.activeElement.parentNode.classList.contains("megamenu__listitem--active")) {
                    closeNestedMegaMenuDropdownMenus();
                    return
                }
                if (document.activeElement.classList.contains("js-open-dropdown-on-key")) {
                    closeDropdownMenus(), document.activeElement.parentNode.classList.add("navigation__menuitem--active");
                    return
                }
                if (document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown")) {
                    closeNestedDropdownMenus(), document.activeElement.parentNode.classList.add("dropdown__menuitem--active"), addEdgeToDropdown(document.activeElement.parentNode);
                    return
                }
                if (document.activeElement.parentNode.classList.contains("js-megamenu-listitem-with-nested-dropdown")) {
                    document.activeElement.parentNode.classList.add("megamenu__listitem--active"), addEdgeToDropdown(document.activeElement.parentNode);
                    return
                }
            }
        }), alreadySetUpKeyEvents = !0
    }

    return {setUpAriaExpansion, setUpAccessibleNavigationMenus, focusOnElement}
}(), theme.DOMHelpers = function () {
    function isElementPastEdge(element) {
        const bounding = element.getBoundingClientRect(), l = bounding.left, w = bounding.width,
            docH = document.documentElement.clientHeight, docW = document.documentElement.clientWidth;
        return l + w >= docW
    }

    function wrapTable(options) {
        options.tables.forEach(function (table) {
            var wrapper = document.createElement("div");
            wrapper.classList.add(options.tableWrapperClass), table.parentNode.insertBefore(wrapper, table), wrapper.appendChild(table)
        })
    }

    function wrapIframe(options) {
        options.iframes.forEach(function (iframe) {
            var wrapper = document.createElement("div");
            wrapper.classList.add(options.iframeWrapperClass), iframe.parentNode.insertBefore(wrapper, iframe), wrapper.appendChild(iframe), iframe.src = iframe.src
        })
    }

    function isOutOfBounds(elem) {
        if (!elem) return console.log("Error. Must provide element to check out of bounds"), !1;
        var bounding = elem.getBoundingClientRect(), out = {};
        return out.left = bounding.left < 0, out.leftAmount = bounding.left, out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth), out.rightAmount = bounding.right - (window.innerWidth || document.documentElement.clientWidth), out
    }

    function adjustElementXPosition(element, padding) {
        const bounding = element.getBoundingClientRect(), l = bounding.left, w = bounding.width,
            docH = document.documentElement.clientHeight, docW = document.documentElement.clientWidth,
            adjustAmount = l + w - docW;
        return adjustAmount > 0 ? (element.style.transform = `translateX(-${adjustAmount + padding}px)`, !0) : !1
    }

    return {isOutOfBounds, isElementPastEdge, wrapIframe, wrapTable, adjustElementXPosition}
}(), theme.Helpers = function () {
    var touchDevice = !1;

    function setTouch() {
        touchDevice = !0
    }

    function isTouch() {
        return touchDevice
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments, later = function () {
                timeout = null, immediate || func.apply(context, args)
            }, callNow = immediate && !timeout;
            clearTimeout(timeout), timeout = setTimeout(later, wait), callNow && func.apply(context, args)
        }
    }

    function animateCSS(element, animation, prefix = "animate__") {
        return new Promise(function (resolve, reject) {
            const animationName = `${prefix}${animation}`, node = element;
            node.classList.add(`${prefix}animated`, animationName);

            function handleAnimationEnd() {
                node.classList.remove(`${prefix}animated`, animationName), resolve("Animation ended")
            }

            node.addEventListener("animationend", handleAnimationEnd, {once: !0})
        })
    }

    function Toggle(id) {
        var element = document.getElementById(id);
        element.classList.contains("animate-hide") ? (element.classList.remove("animate-hide", "fadeOut"), element.classList.add("animate-show", "fadeIn"), element.style.visibility = "visible") : (element.classList.remove("animate-show", "fadeIn"), element.classList.add("animate-hide", "fadeOut"), element.style.visibility = "hidden")
    }

    function toggleClass(id, className) {
        var element = document.getElementById(id);
        if (!element) return !1;
        element.classList.contains(className) ? element.classList.remove(className) : element.classList.add(className)
    }

    function Accordion(container, tlink, submenu) {
        let accorContent = container.querySelector(submenu);
        if (!container.querySelector(tlink)) return !1;
        container.querySelector(tlink).addEventListener("click", function (event2) {
            event2.preventDefault(), this.classList.contains("closed") ? (this.classList.remove("closed"), this.parentElement.classList.remove("closed"), this.setAttribute("aria-expanded", "true")) : (this.classList.add("closed"), this.parentElement.classList.add("closed"), this.setAttribute("aria-expanded", "false")), accorContent.classList.contains("closed") ? (accorContent.classList.remove("closed"), accorContent.style.display = "block") : (accorContent.classList.add("closed"), accorContent.style.display = "none")
        })
    }

    function fadeOut(el) {
        el.style.opacity = 1, function fade() {
            (el.style.opacity -= .1) < 0 ? el.style.display = "none" : requestAnimationFrame(fade)
        }()
    }

    function fadeIn(el, display) {
        el.style.opacity = 0, el.style.display = display || "block", function fade() {
            var val = parseFloat(el.style.opacity);
            (val += .1) > 1 || (el.style.opacity = val, requestAnimationFrame(fade))
        }()
    }

    function getScrollbarWidth() {
        const outer = document.createElement("div");
        outer.style.visibility = "hidden", outer.style.overflow = "scroll", outer.style.msOverflowStyle = "scrollbar", document.body.appendChild(outer);
        const inner = document.createElement("div");
        outer.appendChild(inner);
        const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
        return outer.parentNode.removeChild(outer), scrollbarWidth
    }

    function formatMoney(cents, format) {
        const moneyFormat = "${{amount}}";
        typeof cents == "string" && (cents = cents.replace(".", ""));
        let value = "";
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
            if (isNaN(number) || number == null) return 0;
            number = (number / 100).toFixed(precision);
            const parts = number.split("."),
                dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`),
                centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case"amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case"amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case"amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case"amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break
        }
        return formatString.replace(placeholderRegex, value)
    }

    function setCookie(name, value, hours) {
        var expires = "";
        if (hours) {
            var date = new Date;
            date.setTime(date.getTime() + hours * 60 * 60 * 1e3), expires = "; expires=" + date.toUTCString()
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/"
    }

    function getCookie(name) {
        for (var nameEQ = name + "=", ca = document.cookie.split(";"), i = 0; i < ca.length; i++) {
            for (var c = ca[i]; c.charAt(0) == " ";) c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
        }
        return null
    }

    return {
        setTouch,
        isTouch,
        debounce,
        animateCSS,
        Toggle,
        toggleClass,
        Accordion,
        fadeOut,
        fadeIn,
        getScrollbarWidth,
        formatMoney,
        setCookie,
        getCookie
    }
}(), theme.LibraryLoader = function () {
    var types = {link: "link", script: "script"}, status = {requested: "requested", loaded: "loaded"},
        cloudCdn = "https://cdn.shopify.com/shopifycloud/", libraries = {
            youtubeSdk: {tagId: "youtube-sdk", src: "https://www.youtube.com/iframe_api", type: types.script},
            plyrShopifyStyles: {
                tagId: "plyr-shopify-styles",
                src: cloudCdn + "shopify-plyr/v1.0/shopify-plyr.css",
                type: types.link
            },
            modelViewerUiStyles: {
                tagId: "shopify-model-viewer-ui-styles",
                src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                type: types.link
            }
        };

    function load(libraryName, callback) {
        var library = libraries[libraryName];
        if (library && library.status !== status.requested) {
            if (callback = callback || function () {
            }, library.status === status.loaded) {
                callback();
                return
            }
            library.status = status.requested;
            var tag;
            switch (library.type) {
                case types.script:
                    tag = createScriptTag(library, callback);
                    break;
                case types.link:
                    tag = createLinkTag(library, callback);
                    break
            }
            tag.id = library.tagId, library.element = tag;
            var firstScriptTag = document.getElementsByTagName(library.type)[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
        }
    }

    function createScriptTag(library, callback) {
        var tag = document.createElement("script");
        return tag.src = library.src, tag.addEventListener("load", function () {
            library.status = status.loaded, callback()
        }), tag
    }

    function createLinkTag(library, callback) {
        var tag = document.createElement("link");
        return tag.href = library.src, tag.rel = "stylesheet", tag.type = "text/css", tag.addEventListener("load", function () {
            library.status = status.loaded, callback()
        }), tag
    }

    return {load}
}(), theme.Sections = function () {
    this.constructors = {}, this.instances = [], document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)), document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)), document.addEventListener("shopify:section:select", this._onSelect.bind(this)), document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)), document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)), document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this))
}, theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var id = container.getAttribute("data-section-id"), type = container.getAttribute("data-section-type");
        if (constructor = constructor || this.constructors[type], !(typeof constructor > "u")) {
            var instance = Object.assign(new constructor(container), {id, type, container});
            this.instances.push(instance)
        }
    }, _onSectionLoad: function (evt) {
        var container = document.querySelector('[data-section-id="' + evt.detail.sectionId + '"]');
        container && this._createInstance(container), AOS && AOS.refreshHard()
    }, _onSectionUnload: function (evt) {
        this.instances = this.instances.filter(function (instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;
            return isEventInstance && typeof instance.onUnload == "function" && instance.onUnload(evt), !isEventInstance
        })
    }, _onSelect: function (evt) {
        var instance = this.instances.find(function (instance2) {
            return instance2.id === evt.detail.sectionId
        });
        typeof instance < "u" && typeof instance.onSelect == "function" && instance.onSelect(evt)
    }, _onDeselect: function (evt) {
        var instance = this.instances.find(function (instance2) {
            return instance2.id === evt.detail.sectionId
        });
        typeof instance < "u" && typeof instance.onDeselect == "function" && instance.onDeselect(evt)
    }, _onBlockSelect: function (evt) {
        var instance = this.instances.find(function (instance2) {
            return instance2.id === evt.detail.sectionId
        });
        typeof instance < "u" && typeof instance.onBlockSelect == "function" && instance.onBlockSelect(evt), AOS && AOS.refreshHard()
    }, _onBlockDeselect: function (evt) {
        var instance = this.instances.find(function (instance2) {
            return instance2.id === evt.detail.sectionId
        });
        typeof instance < "u" && typeof instance.onBlockDeselect == "function" && instance.onBlockDeselect(evt)
    }, register: function (type, constructor) {
        this.constructors[type] = constructor, document.querySelectorAll('[data-section-type="' + type + '"]').forEach(function (container) {
            this._createInstance(container, constructor)
        }.bind(this))
    }
}), theme.Disclosure = function () {
    var selectors2 = {
        disclosureForm: "[data-disclosure-form]",
        disclosureList: "[data-disclosure-list]",
        disclosureToggle: "[data-disclosure-toggle]",
        disclosureInput: "[data-disclosure-input]",
        disclosureOptions: "[data-disclosure-option]"
    }, classes = {listVisible: "disclosure-list--visible"};

    function Disclosure(disclosure) {
        this.container = disclosure, this._cacheSelectors(), this._setupListeners()
    }

    return Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
        _cacheSelectors: function () {
            this.cache = {
                disclosureForm: this.container.closest(selectors2.disclosureForm),
                disclosureList: this.container.querySelector(selectors2.disclosureList),
                disclosureToggle: this.container.querySelector(selectors2.disclosureToggle),
                disclosureInput: this.container.querySelector(selectors2.disclosureInput),
                disclosureOptions: this.container.querySelectorAll(selectors2.disclosureOptions)
            }
        }, _setupListeners: function () {
            this.eventHandlers = this._setupEventHandlers(), this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList), this.cache.disclosureOptions.forEach(function (disclosureOption) {
                disclosureOption.addEventListener("click", this.eventHandlers.connectOptions)
            }, this), this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp), this.cache.disclosureList.addEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut), this.cache.disclosureToggle.addEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut), document.body.addEventListener("click", this.eventHandlers.onBodyClick)
        }, _setupEventHandlers: function () {
            return {
                connectOptions: this._connectOptions.bind(this),
                toggleList: this._toggleList.bind(this),
                onBodyClick: this._onBodyClick.bind(this),
                onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
            }
        }, _connectOptions: function (event2) {
            event2.preventDefault(), this._submitForm(event2.currentTarget.dataset.value)
        }, _onDisclosureToggleFocusOut: function (event2) {
            var disclosureLostFocus = this.container.contains(event2.relatedTarget) === !1;
            disclosureLostFocus && this._hideList()
        }, _onDisclosureListFocusOut: function (event2) {
            var childInFocus = event2.currentTarget.contains(event2.relatedTarget),
                isVisible = this.cache.disclosureList.classList.contains(classes.listVisible);
            isVisible && !childInFocus && this._hideList()
        }, _onDisclosureKeyUp: function (event2) {
            event2.which === 27 && (this._hideList(), this.cache.disclosureToggle.focus())
        }, _onBodyClick: function (event2) {
            var isOption = this.container.contains(event2.target),
                isVisible = this.cache.disclosureList.classList.contains(classes.listVisible);
            isVisible && !isOption && this._hideList()
        }, _submitForm: function (value) {
            this.cache.disclosureInput.value = value, this.cache.disclosureForm.submit()
        }, _hideList: function () {
            this.cache.disclosureList.classList.remove(classes.listVisible), this.cache.disclosureToggle.setAttribute("aria-expanded", !1)
        }, _toggleList: function () {
            var ariaExpanded = this.cache.disclosureToggle.getAttribute("aria-expanded") === "true";
            this.cache.disclosureList.classList.toggle(classes.listVisible), this.cache.disclosureToggle.setAttribute("aria-expanded", !ariaExpanded)
        }, destroy: function () {
            this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList), this.cache.disclosureOptions.forEach(function (disclosureOption) {
                disclosureOption.removeEventListener("click", this.eventHandlers.connectOptions)
            }, this), this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp), this.cache.disclosureList.removeEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut), this.cache.disclosureToggle.removeEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut), document.body.removeEventListener("click", this.eventHandlers.onBodyClick)
        }
    }), Disclosure
}();
var mobile = window.matchMedia("(max-width: 740px)"),
    tablet = window.matchMedia("(max-width: 979px) and (min-width: 741px)"),
    desktop = window.matchMedia("(min-width: 980px)");
document.addEventListener("DOMContentLoaded", function () {
    WAU.Accordion.init(), AOS.init({
        easing: "ease-out-quad",
        once: !1,
        mirror: !1,
        offset: 50
    }), document.addEventListener("shopify:block:select", function (e) {
        AOS.refreshHard()
    }), function () {
        document.querySelector('[data-wau-modal-content="contact-form"]') && WAU.Modal.init("contact-form"), document.querySelector('[data-wau-modal-content="create-customer"]') && WAU.Modal.init("create-customer"), document.querySelector('[data-wau-modal-content="recover-password"]') && WAU.Modal.init("recover-password"), document.querySelector('[data-wau-modal-content="new-address"]') && WAU.Modal.init("new-address");
        var modals = document.querySelectorAll("[data-wau-modal-content]");
        if (!modals) return !1;
        modals.forEach((item, i) => {
            var contentType = item.dataset.wauModalContent;
            contentType.includes("edit-address") && WAU.Modal.init(item.dataset.wauModalContent)
        })
    }(), function () {
        if (window.IntersectionObserver) {
            let callback2 = function (entries, observer2) {
                entries.forEach(entry => {
                    entry.isIntersecting ? scrollToTopBtn.classList.add("showBtn") : scrollToTopBtn.classList.remove("showBtn")
                })
            }, scrollToTop2 = function () {
                rootElement.scrollTo({top: 0, behavior: "smooth"})
            };
            var callback = callback2, scrollToTop = scrollToTop2, target = document.querySelector("footer"),
                scrollToTopBtn = document.querySelector(".scrollup"), rootElement = document.documentElement;
            if (!scrollToTopBtn) return !1;
            scrollToTopBtn.addEventListener("click", scrollToTop2), new IntersectionObserver(callback2).observe(target)
        }
    }(), function () {
        theme.DOMHelpers.wrapIframe({
            iframes: document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
            iframeWrapperClass: "videoWrapper"
        }), theme.DOMHelpers.wrapTable({
            tables: document.querySelectorAll(".rte table"),
            tableWrapperClass: "rte__table-wrapper"
        })
    }(), function () {
        var touchingCarousel = !1, touchStartCoords;
        document.body.addEventListener("touchstart", function (e) {
            if (e.target.closest(".flickity-slider")) touchingCarousel = !0; else {
                touchingCarousel = !1;
                return
            }
            touchStartCoords = {x: e.touches[0].pageX, y: e.touches[0].pageY}
        }), document.body.addEventListener("touchmove", function (e) {
            if (touchingCarousel && e.cancelable) {
                var moveVector = {
                    x: e.touches[0].pageX - touchStartCoords.x,
                    y: e.touches[0].pageY - touchStartCoords.y
                };
                Math.abs(moveVector.x) > 7 && e.preventDefault()
            }
        }, {passive: !1})
    }();

    function Toggle(show, hide) {
        var show = document.getElementById(show);
        show.classList.remove("hide"), show.classList.add("show"), show.style.display = "block";
        var hide = document.getElementById(hide);
        hide.classList.remove("show"), hide.classList.add("hide"), hide.style.display = "none"
    }

    window.addEventListener("touchstart", function onFirstTouch() {
        Events.trigger("device:touchstart"), window.removeEventListener("touchstart", onFirstTouch, !1)
    }), function () {
        if (theme.DOMHelpers.isElementPastEdge === void 0 || theme.DOMHelpers.adjustElementXPosition === void 0) {
            console.log("Error. Missing helper functions");
            return
        }
        document.addEventListener("click", event2 => {
            let target = event2.target;
            if (!target.classList.contains("disclosure__toggle")) return;
            let disclosureList = target.closest(".disclosure").querySelector(".disclosure-list");
            if (theme.DOMHelpers.isElementPastEdge(disclosureList)) {
                theme.DOMHelpers.adjustElementXPosition(disclosureList, 10);
                return
            }
        })
    }(), function () {
        class PredictiveSearch extends HTMLElement {
            constructor() {
                super(), this.featureDetections(), this.routesPredictiveSearchURL = this.dataset.routes, this.inputSelector = this.dataset.inputSelector, this.resultsSelector = this.dataset.resultsSelector, this.input = this.querySelector(this.inputSelector) ? this.querySelector(this.inputSelector) : this.querySelector('input[type="search"]'), this.predictiveSearchResults = this.querySelector(this.resultsSelector) ? this.querySelector(this.resultsSelector) : this.querySelector("#predictive-search"), this.input.addEventListener("input", theme.Helpers.debounce(event2 => {
                    this.onChange(event2)
                }, 300).bind(this))
            }

            featureDetections() {
                if (!this.isFunction(theme.Helpers.debounce)) return console.log("Error. Missing debouce theme helper method for predictive search."), !1;
                if (!window.fetch) return console.log("Error. Web browser does not support fetch required for predictive search"), !1
            }

            getTypeOf(value) {
                return Object.prototype.toString.call(value)
            }

            isFunction(value) {
                return this.getTypeOf(value) === "[object Function]"
            }

            onChange() {
                const searchTerm = this.input.value.trim();
                if (!searchTerm.length) {
                    this.close();
                    return
                }
                this.getSearchResults(searchTerm)
            }

            getSearchResults(searchTerm) {
                fetch(`${this.routesPredictiveSearchURL}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`).then(response => {
                    if (!response.ok) {
                        var error = new Error(response.status);
                        throw this.close(), error
                    }
                    return response.text()
                }).then(text => {
                    const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
                    this.predictiveSearchResults.innerHTML = resultsMarkup, this.open()
                }).catch(error => {
                    throw this.close(), error
                })
            }

            open() {
                WAU.ProductGridVideo.init(), typeof theme.Helpers.fadeIn == "function" ? theme.Helpers.fadeIn(this.predictiveSearchResults) : this.predictiveSearchResults.style.display = "block"
            }

            close() {
                typeof theme.Helpers.fadeOut == "function" ? theme.Helpers.fadeOut(this.predictiveSearchResults) : this.predictiveSearchResults.style.display = "none"
            }
        }

        customElements.define("predictive-search", PredictiveSearch)
    }()
}), Shopify.theme.cart = function (exports2) {
    "use strict";

    function getDefaultRequestConfig() {
        return JSON.parse(JSON.stringify({
            credentials: "same-origin",
            headers: {"X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json;"}
        }))
    }

    function fetchJSON(url, config) {
        return fetch(url, config).then(function (response) {
            if (!response.ok) throw response;
            return response.json()
        })
    }

    function cart() {
        return fetchJSON("/cart.js", getDefaultRequestConfig())
    }

    function cartAdd(id2, quantity3, properties2) {
        var config = getDefaultRequestConfig();
        return config.method = "POST", config.body = JSON.stringify({
            id: id2,
            quantity: quantity3,
            properties: properties2
        }), fetchJSON("/cart/add.js", config)
    }

    function cartAddFromForm(formData) {
        var config = getDefaultRequestConfig();
        return delete config.headers["Content-Type"], config.method = "POST", config.body = formData, fetchJSON("/cart/add.js", config)
    }

    function cartChange(line, options2) {
        var config = getDefaultRequestConfig();
        return options2 = options2 || {}, config.method = "POST", config.body = JSON.stringify({
            line,
            quantity: options2.quantity,
            properties: options2.properties
        }), fetchJSON("/cart/change.js", config)
    }

    function cartClear() {
        var config = getDefaultRequestConfig();
        return config.method = "POST", fetchJSON("/cart/clear.js", config)
    }

    function cartUpdate(body) {
        var config = getDefaultRequestConfig();
        return config.method = "POST", config.body = JSON.stringify(body), fetchJSON("/cart/update.js", config)
    }

    function cartShippingRates() {
        return fetchJSON("/cart/shipping_rates.json", getDefaultRequestConfig())
    }

    function key2(key3) {
        if (typeof key3 != "string" || key3.split(":").length !== 2) throw new TypeError("Theme Cart: Provided key value is not a string with the format xxx:xxx")
    }

    function quantity2(quantity3) {
        if (typeof quantity3 != "number" || isNaN(quantity3)) throw new TypeError("Theme Cart: An object which specifies a quantity or properties value is required")
    }

    function id(id2) {
        if (typeof id2 != "number" || isNaN(id2)) throw new TypeError("Theme Cart: Variant ID must be a number")
    }

    function properties(properties2) {
        if (typeof properties2 != "object") throw new TypeError("Theme Cart: Properties must be an object")
    }

    function form(form2) {
        if (!(form2 instanceof HTMLFormElement)) throw new TypeError("Theme Cart: Form must be an instance of HTMLFormElement")
    }

    function options(options2) {
        if (typeof options2 != "object") throw new TypeError("Theme Cart: Options must be an object");
        if (typeof options2.quantity > "u" && typeof options2.properties > "u") throw new Error("Theme Cart: You muse define a value for quantity or properties");
        typeof options2.quantity < "u" && quantity2(options2.quantity), typeof options2.properties < "u" && properties(options2.properties)
    }

    function getState() {
        return cart().then(function (cart2) {
            Events.trigger("cart:ready", cart2)
        })
    }

    function getCart() {
        return cart().then(function (cart2) {
            return cart2
        })
    }

    function getItemIndex(key$$1) {
        return key2(key$$1), cart().then(function (state) {
            var index = -1;
            return state.items.forEach(function (item, i) {
                index = item.key === key$$1 ? i + 1 : index
            }), index === -1 ? Promise.reject(new Error("Theme Cart: Unable to match line item with provided key")) : index
        })
    }

    function getItem(key$$1) {
        return key2(key$$1), cart().then(function (state) {
            var lineItem = null;
            return state.items.forEach(function (item) {
                lineItem = item.key === key$$1 ? item : lineItem
            }), lineItem === null ? Promise.reject(new Error("Theme Cart: Unable to match line item with provided key")) : lineItem
        })
    }

    function addItem(id$$1, options$$1) {
        return options$$1 = options$$1 || {}, id(id$$1), cartAdd(id$$1, options$$1.quantity, options$$1.properties)
    }

    function addItemFromForm(form$$1) {
        form(form$$1);
        var formData = new FormData(form$$1);
        return id(parseInt(formData.get("id"), 10)), cartAddFromForm(formData)
    }

    function updateItem(key$$1, options$$1) {
        return key2(key$$1), options(options$$1), getItemIndex(key$$1).then(function (line) {
            return cartChange(line, options$$1)
        })
    }

    function removeItem(key$$1) {
        return key2(key$$1), getItemIndex(key$$1).then(function (line) {
            return cartChange(line, {quantity: 0})
        })
    }

    function clearItems() {
        return cartClear().then(function () {
            Events.trigger("cart:clear")
        })
    }

    function getAttributes() {
        return cart().then(function (state) {
            return state.attributes
        })
    }

    function updateAttributes(attributes) {
        return cartUpdate({attributes})
    }

    function clearAttributes() {
        return getAttributes().then(function (attributes) {
            for (var key$$1 in attributes) attributes[key$$1] = "";
            return updateAttributes(attributes)
        })
    }

    function getNote() {
        return cart().then(function (state) {
            return state.note
        })
    }

    function updateNote(note) {
        return cartUpdate({note})
    }

    function clearNote() {
        return cartUpdate({note: ""})
    }

    function getShippingRates() {
        return cartShippingRates()
    }

    return exports2.getState = getState, exports2.getCart = getCart, exports2.getItemIndex = getItemIndex, exports2.getItem = getItem, exports2.addItem = addItem, exports2.addItemFromForm = addItemFromForm, exports2.getDefaultRequestConfig = getDefaultRequestConfig, exports2.updateItem = updateItem, exports2.removeItem = removeItem, exports2.clearItems = clearItems, exports2.getAttributes = getAttributes, exports2.updateAttributes = updateAttributes, exports2.clearAttributes = clearAttributes, exports2.getNote = getNote, exports2.updateNote = updateNote, exports2.clearNote = clearNote, exports2.getShippingRates = getShippingRates, exports2
}({}), Shopify.theme.ajaxCart = {
    init: function () {
        let config = document.getElementById("cart-config");
        if (!config) return !1;
        config = JSON.parse(config.innerHTML || "{}");
        var selectors2 = {
            cartTrigger: ".js-mini-cart-trigger",
            cartPageLoader: ".ajax-cart__page-wrapper .js-mini-cart-loader",
            addToCart: ".js-ajax-submit"
        };
        this.initializeAjaxCart(config), config.cart_action == "no_js_cart" ? document.querySelector(".js-ajax-cart-content") && document.querySelector(".js-ajax-cart-content").remove() : document.querySelector(".js-ajax-cart-content-nojs") && document.querySelector(".js-ajax-cart-content-nojs").remove(), config.cart_action == "drawer" ? WAU.Slideout.init("ajax-cart") : config.cart_action == "modal_cart" && WAU.Modal.init("ajax-cart"), document.querySelectorAll(selectors2.addToCart).forEach((element, i) => {
            element.addEventListener("click", function (e) {
                e.preventDefault();
                var isQuickAdd = element.hasAttribute("data-quick-add"), addToCartForm = this.closest("form");
                return Shopify.theme.ajaxCart.addToCart(addToCartForm, element.parentNode, config, !1, isQuickAdd), !1
            })
        }), document.querySelector("body").classList.contains("template-cart") && Shopify.theme.cart.getCart().then(Cart => {
            Shopify.theme.ajaxCart.updateView(config, Cart), setTimeout(function () {
                theme.Helpers.fadeOut(document.querySelector(selectors2.cartPageLoader)), document.querySelectorAll("#dynamic-checkout-cart").length == 2 && document.querySelectorAll("#dynamic-checkout-cart")[1].remove()
            }, 800)
        }), document.querySelectorAll(selectors2.cartTrigger).forEach((item, i) => {
            item.addEventListener("click", function (e) {
                return e.preventDefault(), Shopify.theme.cart.getCart().then(Cart => {
                    Shopify.theme.ajaxCart.updateView(config, Cart), config.cart_action == "drawer" ? Shopify.theme.ajaxCart.showDrawer(config) : config.cart_action == "modal_cart" ? Shopify.theme.ajaxCart.showModal(config) : window.location.href = config.cart_url
                }), !1
            })
        })
    }, cartEvents: function (config) {
        var selectors2 = {
            cartDrawerRemove: ".js-cart-remove",
            cartDrawerQty: "[data-item-qty]",
            cartDrawerQtyDecrease: "[data-ajax-qty-decrease]",
            cartDrawerQtyIncrease: "[data-ajax-qty-increase]",
            cartNote: ".js-cart-note"
        }, cartDrawerQtyElems = document.querySelectorAll(selectors2.cartDrawerQty);
        if (cartDrawerQtyElems.length === 0) return !1;
        cartDrawerQtyElems.forEach((element, i) => {
            element.addEventListener("change", function (e) {
                e.preventDefault();
                var quantity2 = parseInt(this.value), itemKey = this.dataset.itemKey, itemMax = this.dataset.limit,
                    lineElement = element.closest(".ajax-cart__cart-item");
                return element.value = quantity2, setTimeout(function () {
                    quantity2 === 0 ? Shopify.theme.ajaxCart.removeFromCart(itemKey, config) : (Shopify.theme.ajaxCart.checkLimit(itemMax, quantity2, lineElement, config), Shopify.theme.cart.updateItem(itemKey, {quantity: quantity2}).then(state => {
                        Shopify.theme.ajaxCart.updateView(config, state)
                    }))
                }, 250), !1
            })
        }), document.querySelectorAll(selectors2.cartDrawerRemove).forEach((element, i) => {
            element.addEventListener("click", function (e) {
                e.preventDefault();
                var itemKey = this.dataset.itemKey;
                return Shopify.theme.ajaxCart.removeFromCart(itemKey, config), !1
            })
        }), document.querySelectorAll(selectors2.cartDrawerQtyDecrease).forEach((element, i) => {
            element.addEventListener("click", function (e) {
                if (e.preventDefault(), this.nextElementSibling.value === "1") {
                    var itemKey = this.dataset.itemKey;
                    Shopify.theme.ajaxCart.removeFromCart(itemKey, config)
                } else {
                    var itemId = this.dataset.ajaxQtyDecrease;
                    Shopify.theme.ajaxCart.adjustQty(-1, itemId, config)
                }
                return !1
            })
        }), document.querySelectorAll(selectors2.cartDrawerQtyIncrease).forEach((element, i) => {
            element.addEventListener("click", function (e) {
                e.preventDefault();
                var itemId = this.dataset.ajaxQtyIncrease;
                return Shopify.theme.ajaxCart.adjustQty(1, itemId, config), !1
            })
        }), document.querySelectorAll(selectors2.cartNote).forEach((element, i) => {
            element.addEventListener("blur", event2 => {
                let note = element.value;
                Shopify.theme.cart.updateNote(note).then(state => {
                    Shopify.theme.ajaxCart.updateView(config, state)
                })
            })
        }), config.show_calculator && setTimeout(function () {
            Shopify.theme.shippingCalculator.init()
        }, 1e3), Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize()
    }, showDrawer: function (config) {
        if (config.cart_action != "drawer") return !1;
        WAU.Slideout._openByName("ajax-cart"), setTimeout(function () {
            theme.Helpers.fadeOut(document.querySelector(".ajax-cart__drawer-wrapper .js-mini-cart-loader"))
        }, 800)
    }, hideDrawer: function (config) {
        if (config.cart_action != "drawer") return !1;
        WAU.Slideout._closeByName("ajax-cart"), setTimeout(function () {
            theme.Helpers.fadeIn(document.querySelector(".ajax-cart__drawer-wrapper .js-mini-cart-loader"))
        }, 800)
    }, showModal: function (config) {
        if (config.cart_action != "modal_cart") return !1;
        WAU.Modal._openByName("ajax-cart"), setTimeout(function () {
            theme.Helpers.fadeOut(document.querySelector(".ajax-cart__modal-wrapper .js-mini-cart-loader"))
        }, 800)
    }, hideModal: function (config) {
        if (config.cart_action != "modal_cart") return !1;
        WAU.Modal._closeByName("ajax-cart"), setTimeout(function () {
            theme.Helpers.fadeIn(document.querySelector(".ajax-cart__modal-wrapper .js-mini-cart-loader"))
        }, 800)
    }, removeFromCart: function (itemKey, config, callback) {
        Shopify.theme.cart.removeItem(itemKey).then(state => {
            Shopify.theme.ajaxCart.updateView(config, state)
        })
    }, adjustQty: function (value, itemId, config) {
        var selectors2 = {lineItem: ".item_" + itemId, updatesItem: ".updates_" + itemId};
        document.querySelectorAll(selectors2.lineItem).forEach((element, i) => {
            if (elementInput = element.querySelector(selectors2.updatesItem), key = elementInput.dataset.itemKey, max = elementInput.dataset.limit, quantity = parseInt(elementInput.value) + parseInt(value), Shopify.theme.ajaxCart.checkLimit(max, quantity, element, config) || quantity === 0) return !1;
            elementInput.value = quantity, setTimeout(function () {
                Shopify.theme.cart.updateItem(key, {quantity}).then(state => {
                    Shopify.theme.ajaxCart.updateView(config, state)
                })
            }, 250)
        })
    }, checkLimit: function (max2, quantity2, element, config) {
        if (max2 != "" && quantity2 > max2) {
            let cartNote = document.createElement("div");
            cartNote.classList.add("mini-cart__cart-note"), cartNote.innerHTML = "<p><b>" + config.cart_error + "</b>&nbsp;&nbsp;" + config.update_qty_error + "</p>";
            let adjacentElement = element.querySelector(".js-item-quantity"),
                parentElement = adjacentElement.parentNode;
            return parentElement.appendChild(cartNote, adjacentElement), setTimeout(function () {
                theme.Helpers.fadeOut(cartNote), parentElement.removeChild(cartNote)
            }, 2e3), !0
        }
    }, addToCart: function (addToCartForm, formContext, config, isQuickview, isQuickAdd) {
        var selectors2 = {addToCart: ".js-ajax-submit", cartAddedMsg: ".js-added-msg"};
        let context;
        if (isQuickview ? context = document.querySelector(".js-quickview-content") : context = formContext, [...addToCartForm.elements].filter(element => element.name == "properties[__shopify_send_gift_card_to_recipient]" && element.checked).length !== 0) {
            const recipientConfig = Shopify.theme.cart.getDefaultRequestConfig(),
                formData = new FormData(addToCartForm);
            delete recipientConfig.headers["Content-Type"], recipientConfig.method = "POST", recipientConfig.body = formData, fetch("/cart/add.js", recipientConfig).then(function (response) {
                return response.json()
            }).then(function (data) {
                if (data.status == 422) {
                    const errors = data.description, messages = data.message;
                    Events.trigger("recipientform:errors", messages, errors, config, addToCartForm)
                }
            }).catch(function (error) {
                console.error(error)
            })
        }
        theme.ProductProperties.checkLineItemProperties(addToCartForm) !== !1 && (context.querySelector(selectors2.addToCart).value = config.adding_to_cart, context.querySelector(selectors2.addToCart).classList.add("disabled"), context.querySelector(selectors2.addToCart).getAttribute("disabled", "disabled"), Shopify.theme.cart.addItemFromForm(addToCartForm).then(item => {
            context.querySelector(selectors2.addToCart).value = config.added_to_cart, context.querySelector(selectors2.addToCart).classList.remove("disabled"), context.querySelector(selectors2.addToCart).removeAttribute("disabled", "disabled"), setTimeout(function () {
                context.querySelector(selectors2.addToCart).value = config.add_to_cart
            }, 3e3), Shopify.theme.cart.getCart().then(Cart => {
                isQuickview && config.cart_added_event != "product_page" ? Shopify.theme.quickview.hideModal() : isQuickview && config.cart_added_event == "product_page" && (theme.Helpers.fadeIn(context.querySelector(selectors2.cartAddedMsg)), setTimeout(function () {
                    theme.Helpers.fadeOut(context.querySelector(selectors2.cartAddedMsg))
                }, 3e3)), config.cart_action == "drawer" && config.cart_added_event == "go_to_active_cart" ? Shopify.theme.ajaxCart.showDrawer(config) : config.cart_action == "modal_cart" && config.cart_added_event == "go_to_active_cart" ? Shopify.theme.ajaxCart.showModal(config) : config.cart_action == "page_only" && config.cart_added_event == "go_to_active_cart" ? window.location.href = config.cart_url : config.cart_added_event == "product_page" ? isQuickAdd || (theme.Helpers.fadeIn(context.querySelector(selectors2.cartAddedMsg)), setTimeout(function () {
                    theme.Helpers.fadeOut(context.querySelector(selectors2.cartAddedMsg))
                }, 3e3)) : window.location.href = config.cart_url, Shopify.theme.ajaxCart.updateView(config, Cart)
            })
        }).catch(error => {
            error.status == 422 ? (theme.Helpers.fadeIn(context.querySelector(".js-error-msg")), context.querySelector(selectors2.addToCart).value = config.add_to_cart, context.querySelector(selectors2.addToCart).classList.remove("disabled"), context.querySelector(selectors2.addToCart).removeAttribute("disabled", "disabled"), setTimeout(function () {
                theme.Helpers.fadeOut(context.querySelector(".js-error-msg"))
            }, 3e3)) : console.log(error)
        }))
    }, getAjaxCart: function (response) {
        const el = document.createElement("div");
        el.innerHTML = response;
        const responseOptions = JSON.parse(el.querySelector("[data-options]").innerHTML),
            htmls = el.querySelectorAll("[data-html]");
        let html = {};
        if (htmls.length === 1 && htmls[0].getAttribute("data-html") === "") html = htmls[0].innerHTML; else for (let i = 0; i < htmls.length; i++) html[htmls[i].getAttribute("data-html")] = htmls[i].innerHTML;
        let options = responseOptions;
        return html
    }, initializeAjaxCart: function (config) {
        let data, url;
        url = config.cart_url + "/?view=ajax", fetch(url, data).then(res => res.text()).then(response => {
            let html = Shopify.theme.ajaxCart.getAjaxCart(response);
            document.querySelectorAll(".js-ajax-cart-content").forEach((item, i) => {
                item.innerHTML = html.content
            })
        }).then(response => {
            config.show_calculator && setTimeout(function () {
                Shopify.theme.shippingCalculator.init()
            }, 1e3)
        }).catch(error => {
            console.log(error)
        })
    }, updateView: function (config, Cart) {
        let data, url;
        url = config.cart_url + "/?view=ajax";

        function showHideExpressCheckoutButtons() {
            let footerWrapperEl = document.querySelector(".ajax-cart__footer-wrapper");
            footerWrapperEl && (Cart.item_count < 1 ? footerWrapperEl.style.display = "none" : footerWrapperEl.style.display = "block")
        }

        showHideExpressCheckoutButtons(), fetch(url, data).then(res => res.text()).then(response => {
            let html = Shopify.theme.ajaxCart.getAjaxCart(response);
            var selectors2 = {
                cartContent: ".js-ajax-cart-content",
                cartEmpty: ".js-cart-empty",
                cartForm: ".js-cart-form",
                cartAccordion: ".js-cart-accordion",
                cartCount: ".js-cart-count"
            };
            Cart.item_count === 0 ? (document.querySelectorAll(selectors2.cartForm).forEach((item, i) => {
                item.classList.add("hide")
            }), document.querySelectorAll(selectors2.cartEmpty).forEach((item, i) => {
                item.classList.remove("hide")
            }), document.querySelectorAll(selectors2.cartCount).forEach((item, i) => {
                item.innerHTML = "0"
            })) : (document.querySelectorAll(selectors2.cartEmpty).forEach((item, i) => {
                item.classList.add("hide")
            }), document.querySelectorAll(selectors2.cartCount).forEach((item, i) => {
                item.innerHTML = Cart.item_count
            }), document.querySelectorAll(selectors2.cartContent).forEach((item, i) => {
                item.innerHTML = html.content
            }), document.querySelectorAll(selectors2.cartAccordion).forEach((item, i) => {
                theme.Helpers.Accordion(item, ".tlink.has_sub_menu a", ".accordion-content.sub"), theme.Helpers.Accordion(item, ".tlink2.has_sub_menu a", ".accordion-content2.sub")
            }), Shopify.theme.ajaxCart.cartEvents(config)), setTimeout(function () {
                document.querySelector("body").classList.add("cart-loaded"), document.querySelectorAll("#dynamic-checkout-cart").length == 2 && document.querySelectorAll("#dynamic-checkout-cart")[1].remove()
            }, 500)
        }).catch(error => {
            console.log(error)
        })
    }
}, Shopify.theme.shippingCalculator = {
    init: function () {
        var config = document.getElementById("cart-config");
        if (!config) return !1;
        var config = JSON.parse(config.innerHTML || "{}"), selectors2 = {
            container: ".js-shipping-calc-wrapper",
            submitButton: ".js-shipping-calc-submit",
            addressZip: ".js-shipping-calc-address-zip",
            addressCountry: ".js-shipping-calc-address-country",
            addressProvince: ".js-shipping-calc-address-province",
            addressProvinceLabel: ".js-shipping-calc-address-province-label",
            response: ".js-shipping-calc-response"
        };
        document.querySelectorAll(selectors2.container).forEach((element, i) => {
            element.classList.add("shipping-calculator-" + i)
        });
        let container = document.querySelector(".shipping-calculator-0");
        if (!document.querySelector("body").classList.contains("template-cart")) return !1;
        new Shopify.CountryProvinceSelector("address_country", "address_province", {hideElement: "address_province_container"});
        var countriesSelect = container.querySelector(selectors2.addressCountry),
            addressProvinceLabelEl = container.querySelector(selectors2.addressProvinceLabel);
        typeof Countries < "u" && (Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl), countriesSelect.change(function () {
            Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl)
        })), container.querySelector(selectors2.submitButton).addEventListener("click", function (e) {
            e.preventDefault(), Shopify.theme.shippingCalculator.disableButtons(config, container), container.querySelector(selectors2.response).style.display = "none";
            let shippingAddress = {};
            shippingAddress.zip = container.querySelector(selectors2.addressZip).value || "", shippingAddress.country = container.querySelector(selectors2.addressCountry).value || "", shippingAddress.province = container.querySelector(selectors2.addressProvince).value || "", Shopify.theme.shippingCalculator.getRates(config, shippingAddress, container)
        })
    }, enableButtons: function (config, container) {
        var selectors2 = {submitButton: ".js-shipping-calc-submit"};
        container.querySelector(selectors2.submitButton).removeAttribute("disabled"), container.querySelector(selectors2.submitButton).classList.remove("disabled"), container.querySelector(selectors2.submitButton).value = config.calculator_submit
    }, disableButtons: function (config, container) {
        var selectors2 = {submitButton: ".js-shipping-calc-submit"};
        container.querySelector(selectors2.submitButton).setAttribute("disabled", "disabled"), container.querySelector(selectors2.submitButton).classList.add("disabled"), container.querySelector(selectors2.submitButton).value = config.calculator_calculating
    }, getRates: function (config, shipping_address, container) {
        let url = "/cart/shipping_rates.json?shipping_address%5Bzip%5D=" + shipping_address.zip + "&shipping_address%5Bcountry%5D=" + shipping_address.country + "&shipping_address%5Bprovince%5D=" + shipping_address.province;
        fetch(url, {
            method: "GET",
            headers: {Accept: "application/json", "Content-Type": "application/json"}
        }).then(res => res.json()).then(response => {
            if (!response.shipping_rates) Shopify.theme.shippingCalculator.onError(response, config, container); else {
                let rates = response.shipping_rates;
                Shopify.theme.shippingCalculator.onRatesUpdate(rates, shipping_address, config, container)
            }
        }).catch(error => {
            Shopify.theme.shippingCalculator.onError(error, config, container)
        })
    }, onError: function (error, config, container) {
        Shopify.theme.shippingCalculator.enableButtons(config, container);
        let feedback = config.calculator_error + " " + Object.keys(error)[0] + " " + Object.values(error)[0];
        Shopify.theme.shippingCalculator.render({
            rates: [],
            errorFeedback: feedback,
            success: !1
        }, container, config), container.querySelector(".js-shipping-calc-rates").style.display = "none", container.querySelector(".js-shipping-calc-response").style.display = "block"
    }, onRatesUpdate: function (rates, shipping_address, config, container) {
        Shopify.theme.shippingCalculator.enableButtons(config, container);
        var readable_address = "";
        if (shipping_address.zip && (readable_address += shipping_address.zip + ", "), shipping_address.province && (readable_address += shipping_address.province + ", "), readable_address += shipping_address.country, !rates) return !1;
        rates.forEach((rate, i) => {
            rate.price = Shopify.theme.shippingCalculator.formatRate(rate.price, config)
        }), Shopify.theme.shippingCalculator.render({rates, address: readable_address, success: !0}, container, config)
    }, formatRate: function (ratePrice, config) {
        let cents = function (value) {
            return value = (value + "").replace(/[^\d.-]/g, ""), value && value.includes(".") && (value = value.substring(0, value.indexOf(".") + 3)), value ? Math.round(parseFloat(value) * 100) : 0
        }(ratePrice);
        return theme.Helpers.formatMoney(cents, config.money_format)
    }, render: function (response, container, config) {
        let rateFeedback = document.querySelector(".js-shipping-calc-rates-feedback"),
            rateList = document.querySelector(".js-shipping-calc-rates");
        rateFeedback.innerHTML = "", response.rates.length > 1 ? rateFeedback.innerHTML = config.shipping_multi_rate_one + response.rates.length + config.shipping_multi_rate_two + response.address + config.shipping_multi_rate_three + response.rates[0].price : response.rates.length === 1 ? rateFeedback.innerHTML = config.shipping_single_rate + response.address : rateFeedback.innerHTML = config.shipping_no_destination, rateList.innerHTML = "", response.rates.forEach((rate, i) => {
            const rateLI = document.createElement("li");
            rateLI.classList.add("shipping-calc__rate"), rateLI.innerHTML = rate.name + " at " + rate.price, rateList.appendChild(rateLI)
        }), container.querySelector(".js-shipping-calc-rates").style.display = "block", document.querySelector(".js-shipping-calc-response").style.display = "block"
    }
}, Shopify.theme.quickview = {
    init: function () {
        var selectors2 = {quickviewButton: ".js-quickview-trigger"};
        this.handleEvents()
    }, handleEvents: () => {
        var selectors2 = {quickviewButton: ".js-quickview-trigger"};
        document.addEventListener("click", event2 => {
            let element = event2.target.matches(selectors2.quickviewButton) ? event2.target : event2.target.closest(selectors2.quickviewButton);
            if (!element || !element.matches(selectors2.quickviewButton)) return !1;
            event2.preventDefault(), WAU.Modal.init("quickview");
            let productURL = element.dataset.productUrl,
                cleanProductURL = Shopify.theme.quickview.cleanUrl(productURL, "variant");
            Shopify.theme.quickview.getTemplate(cleanProductURL)
        })
    }, formatTemplate: function (response) {
        const el = document.createElement("div");
        el.innerHTML = response;
        const htmls = el.querySelectorAll("[data-html]");
        let html = {};
        if (htmls.length === 1 && htmls[0].getAttribute("data-html") === "") html = htmls[0].innerHTML; else for (let i = 0; i < htmls.length; i++) html[htmls[i].getAttribute("data-html")] = htmls[i].innerHTML;
        return html
    }, showModal: function () {
        WAU.Modal._openByName("quickview")
    }, hideModal: function () {
        document.querySelector(".js-quickview-content").innerHTML = "", WAU.Modal._closeByName("quickview")
    }, cleanUrl: function (url, key2) {
        return url.split("?")[0] + "?view=quick"
    }, getTemplate: function (productUrl) {
        let data, url;
        url = productUrl, fetch(url, data).then(res => res.text()).then(response => {
            let html = Shopify.theme.quickview.formatTemplate(response);
            document.querySelector(".js-quickview-content").innerHTML = html.content
        }).then(response => {
            let context = document.querySelector(".js-quickview-wrapper");
            theme.Product(context)
        }).then(response => {
            document.querySelector(".js-quickview-wrapper").dataset.paymentButton == "true" && Shopify.PaymentButton && Shopify.PaymentButton.init()
        }).then(response => {
            document.querySelector(".js-quickview-wrapper").querySelector(".js-ajax-submit").addEventListener("click", function (e) {
                e.preventDefault();
                var addToCartForm = this.closest("form");
                let cartConfig = document.getElementById("cart-config");
                return cartConfig && (cartConfig = JSON.parse(cartConfig.innerHTML || "{}"), Shopify.theme.ajaxCart.addToCart(addToCartForm, null, cartConfig, !0, !1)), !1
            })
        }).then(response => {
            Shopify.theme.quickview.showModal()
        }).catch(error => {
            console.log(error)
        })
    }
}, Shopify.theme.quickview.init(), Shopify.theme.ajaxCart.init(), document.addEventListener("shopify:section:load", function (event2) {
    Shopify.theme.ajaxCart.init()
});
const ViewedProducts = function () {
    return function (params) {
        const publicAPIs = {};
        var config = {
            howManyToShow: 3,
            howManyToStoreInMemory: 30,
            wrapperId: "recently-viewed-products",
            onComplete: null
        }, productHandleQueue = [], wrapper = null, shown = 0, cookie = {
            configuration: {
                expires: 90,
                path: "/",
                domain: window.location.hostname,
                sameSite: "none",
                secure: !0
            }, name: "shopify_recently_viewed", write: function (recentlyViewed) {
                Cookies.set(this.name, recentlyViewed.join(" "), this.configuration)
            }, read: function () {
                var recentlyViewed = [], cookieValue = Cookies.get(this.name);
                return cookieValue !== void 0 && cookieValue !== "" && (recentlyViewed = cookieValue.split(" ")), recentlyViewed
            }, destroy: function () {
                Cookies.remove(this.name, null, this.configuration)
            }, remove: function (productHandle) {
                var recentlyViewed = this.read(), position = recentlyViewed.indexOf(productHandle);
                position !== -1 && (recentlyViewed.splice(position, 1), this.write(recentlyViewed))
            }
        }, finalize = function () {
            if (shown > 0) {
                if (wrapper.classList.contains("recently-viewed-products--hidden") && wrapper.classList.remove("recently-viewed-products--hidden"), config.onComplete) try {
                    config.onComplete()
                } catch {
                }
            } else return console.log("No recently viewed products to show"), !1
        }, formatTemplate = product => {
            if (!product) return console.log("Error. Must provide a valid product in order to format it"), !1;
            var parser = new DOMParser, doc = parser.parseFromString(product, "text/html"),
                template2 = doc.querySelector('[data-html="listing"]');
            if (!template2) return console.log("Error. Could not find template elment."), !1;
            let productWrap = document.createElement("div");
            return productWrap.classList.add("product", "product-index", "recently-viewed-products__product", "js-product-listing"), productWrap.appendChild(template2.content), productWrap
        }, moveAlong = function () {
            if (productHandleQueue.length && shown < config.howManyToShow) {
                let furl = `${window.Shopify.routes.root}products/${productHandleQueue[0]}?view=listing`;
                fetch(furl).then(response => response.text()).then(response => {
                    let product = formatTemplate(response);
                    wrapper.appendChild(product), productHandleQueue.shift(), shown++, moveAlong()
                }).catch(error => {
                    console.log(error.message), cookie.remove(productHandleQueue[0]), productHandleQueue.shift(), moveAlong()
                })
            } else finalize()
        };
        return publicAPIs.showRecentlyViewed = function (params2) {
            var params2 = params2 || {};
            config = Object.assign(config, params2), shown = 0, productHandleQueue = [], wrapper = null, template = null, productHandleQueue = cookie.read(), wrapper = document.getElementById(config.wrapperId), config.howManyToShow && wrapper && moveAlong()
        }, publicAPIs.getConfig = function () {
            return config
        }, publicAPIs.clearList = function () {
            cookie.destroy()
        }, publicAPIs.getCount = function () {
            return cookie.read().length
        }, publicAPIs.showRecentlyViewed(params), publicAPIs
    }
}();
Shopify.RecordViewedProducts = function () {
    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 30,
        wrapperId: "recently-viewed-products",
        onComplete: null
    }, productHandleQueue = [], wrapper = null, shown = 0, cookie = {
        configuration: {
            expires: 90,
            path: "/",
            domain: window.location.hostname,
            sameSite: "none",
            secure: !0
        }, name: "shopify_recently_viewed", write: function (recentlyViewed) {
            Cookies.set(this.name, recentlyViewed.join(" "), this.configuration)
        }, read: function () {
            var recentlyViewed = [], cookieValue = Cookies.get(this.name);
            return cookieValue !== void 0 && cookieValue !== "" && (recentlyViewed = cookieValue.split(" ")), recentlyViewed
        }, destroy: function () {
            Cookies.remove(this.name, null, this.configuration)
        }, remove: function (productHandle) {
            var recentlyViewed = this.read(), position = recentlyViewed.indexOf(productHandle);
            position !== -1 && (recentlyViewed.splice(position, 1), this.write(recentlyViewed))
        }
    };
    return {
        getConfig: function () {
            return config
        }, clearList: function () {
            cookie.destroy()
        }, getCount: function () {
            return cookie.read().length
        }, recordRecentlyViewed: function (params) {
            var params = params || {};
            config = Object.assign(config, params);
            var recentlyViewed = cookie.read();
            if (window.location.pathname.indexOf("/products/") !== -1) {
                var urlPathname = new URL(window.location).pathname,
                    urlArray = decodeURIComponent(urlPathname).split("/"),
                    productHandle = urlArray[urlArray.indexOf("products") + 1];
                if (!productHandle) return console.log("Error, no product handle found."), !1;
                var position = recentlyViewed.indexOf(productHandle);
                position === -1 ? (recentlyViewed.unshift(productHandle), recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory)) : (recentlyViewed.splice(position, 1), recentlyViewed.unshift(productHandle)), cookie.write(recentlyViewed)
            }
        }
    }
}(), theme.ProductForm = function (context, sectionId, events, Product) {
    var prodForm = context.querySelector(`#product-form-${sectionId}`),
        config = JSON.parse(prodForm.dataset.productForm || "{}"), selector, varSelectors, options, variant;
    if (function () {
        var element = context.querySelector(".js-back-in-stock"),
            form = context.querySelector(".js-back-in-stock-form");
        if (!element) return !1;
        events.on("variantchange", function (variant2) {
            variant2.available ? element.style.display = "none" : (element.style.display = "block", document.getElementById("hidden_variant").value = "SKU: " + variant2.sku, document.getElementById("hidden_title").value = "Variant: " + variant2.title)
        }), element.addEventListener("click", function (event2) {
            event2.preventDefault(), theme.Helpers.fadeIn(form)
        }), document.addEventListener("click", function (event2) {
            event2.target === element || element.contains(event2.target) || event2.target === form || form.contains(event2.target) || theme.Helpers.fadeOut(form)
        })
    }(), context.querySelectorAll(".formVariantId").forEach((item, i) => {
        item.setAttribute("name", "id")
    }), function () {
        var elements = context.querySelectorAll(".product-qty, .formQty");
        elements.forEach((element, i) => {
            events.on("quantitycontrol:click", change), events.on("variantchange", reset), element.addEventListener("change", event2 => {
                elements.forEach(element2 => {
                    element2.value = parseInt(event2.target.value)
                })
            });

            function change(value) {
                var quantity3 = parseInt(element.value) + value;
                if (quantity3 < 1) return !1;
                element.value = quantity3
            }

            function reset() {
                element.value = 1
            }
        })
    }(), function () {
        Control(".quantity-control-up", 1), Control(".quantity-control-down", -1);

        function Control(selector2, value) {
            var element = context.querySelector(selector2);
            if (!element) return !1;
            element.addEventListener("click", function (event2) {
                event2.preventDefault(), events.trigger("quantitycontrol:click", value)
            })
        }
    }(), function () {
        const acceptedFormats = {icon: "icon", percentage: "percentage", amount: "amount"},
            selectors2 = {salePriceBadge: ".price__badge.price__badge--sale"}, settings2 = {debugging: !1},
            saleIconEl = context.querySelector(selectors2.salePriceBadge), dataFormat = context.dataset.saleFormat,
            savingsString = config.savings;
        if (typeof money != "function" && settings2.debugging) return console.log("sale_icon:: Error. Money helper function is not available."), !1;
        if (dataFormat == acceptedFormats.icon && settings2.debugging) return console.log("sale_icon:: Error. Format does not match an accepted format."), !1;
        if (!config && settings2.debugging) return console.log("sale_icon:: Error. Do not have access to the config object for translations."), !1;
        if (!saleIconEl && settings2.debugging) return console.log("sale_icon:: Error. No Sale icon element to work with."), !1;

        function salePercentage(variant2) {
            const difference = variant2.compare_at_price - variant2.price;
            return Math.floor(difference / variant2.compare_at_price * 100) + "%"
        }

        function saleAmount(variant2) {
            const difference = variant2.compare_at_price - variant2.price;
            return money(difference)
        }

        function showDiscount(variant2, format, string, regex = /{{ savings }}/i) {
            if (!variant2) return console.log("Error. No variant passed into function."), !1;
            if (!format) return console.log("Error. No format was passed into function."), !1;
            if (!string) return console.log("Error. No string passed into function."), !1;
            switch (format) {
                case acceptedFormats.percentage:
                    return string.replace(regex, salePercentage(variant2));
                case acceptedFormats.amount:
                    return string.replace(regex, saleAmount(variant2))
            }
        }

        function updateSaleIcon(variant2) {
            dataFormat != "icon" && variant2.compare_at_price > variant2.price && (saleIconEl.innerHTML = showDiscount(variant2, dataFormat, savingsString))
        }

        events.on("variantchange", updateSaleIcon)
    }(), function () {
        const classes = {
                variantStockLevels: "js-variant-stock-levels",
                variantStockLevelsMessage: "js-variant-stock-levels__message",
                hide: "visually-hidden"
            }, selectors2 = {
                variantStockLevels: "." + classes.variantStockLevels,
                variantStockLevelsMessage: "." + classes.variantStockLevelsMessage,
                variantStockLevelsTheshold: "data-variant-stock-level-threshold"
            }, DEFAULT_LIMIT = 11, variantStockLevelEl = context.querySelector(selectors2.variantStockLevels),
            variantStockLevelMessageEl = context.querySelector(selectors2.variantStockLevelsMessage);
        if (!variantStockLevelEl) return !1;
        const stockLevelThreshold = variantStockLevelEl.getAttribute(selectors2.variantStockLevelsTheshold) !== void 0 ? parseInt(variantStockLevelEl.dataset.stockLevelThreshold, 10) : DEFAULT_LIMIT,
            checkFadeSupport = () => typeof theme.Helpers.fadeIn == "function" && typeof theme.Helpers.fadeOut == "function",
            showElement = element => {
                element && (element.classList.remove(classes.hide), checkFadeSupport && theme.Helpers.fadeIn(element))
            }, hideElement = element => {
                element && checkFadeSupport && theme.Helpers.fadeOut(element)
            },
            getMessage = (config2, quantity2, regex = /{{ count }}/) => quantity2 == 1 ? config2.only_left.one.includes(regex.source) ? config2.only_left.one.replace(regex, quantity2) : config2.only_left.one : config2.only_left.one.includes(regex.source) ? config2.only_left.other.replace(regex, quantity2) : config2.only_left.other;
        events.on("variantchange", variant2 => {
            variant2.inventory_management && variant2.inventory_quantity < stockLevelThreshold && variant2.inventory_quantity > 0 ? (variantStockLevelMessageEl.innerHTML = getMessage(config, variant2.inventory_quantity), showElement(variantStockLevelEl)) : hideElement(variantStockLevelEl)
        }), events.on("variantunavailable", variant2 => {
            hideElement(variantStockLevelEl)
        })
    }(), function (context2) {
        if (!context2.querySelector("[data-store-availability-container]")) return !1;
        var id = context2.querySelector("[data-store-availability-container]").dataset.variantId,
            title = context2.querySelector("[data-store-availability-container]").dataset.productTitle;
        updateContent(id, title, context2), events.on("storeavailability:variant", function (id2, title2, context3) {
            updateContent(id2, title2, context3)
        });

        function updateContent(id2, title2, context3) {
            const container = context3.querySelector("[data-store-availability-container]"),
                rootUrl = container.dataset.rootUrl, productId = container.dataset.productId,
                variantSectionUrl = (rootUrl === "/" ? "" : rootUrl) + "/variants/" + id2 + "/?section_id=pickup-availability";
            container.innerHTML = "", fetch(variantSectionUrl).then(function (response) {
                return response.text()
            }).then(function (storeAvailabilityHTML) {
                if (storeAvailabilityHTML.trim() === "") return;
                if (container.innerHTML = storeAvailabilityHTML, container.innerHTML = container.firstElementChild.innerHTML, container.style.opacity = 1, container.style.visibility = "visible", container.querySelector(".store-availability-container").classList.remove("fadeOut"), container.querySelector(".store-availability-container").style.display = "block", events.on("storeavailability:unavailable", function () {
                    container.querySelector(".store-availability-container").classList.add("fadeOut"), container.querySelector(".store-availability-container").style.display = "none"
                }), container.querySelector('[data-pick-up-available="false"]')) return container.style.display = "none", !1;
                container.style.display = "block";
                const source = document.getElementById(`StoreAvailabilityModal--${productId}`),
                    slideoutContainer = document.querySelector(".js-slideout-toggle-wrapper"),
                    slideoutAside = document.getElementById(`slideout-store-availability--${productId}`);
                slideoutAside ? (slideoutAside.innerHTML = "", slideoutAside.appendChild(source)) : WAU.Slideout._createSlideoutEl("right", `store-availability--${productId}`, slideoutContainer).appendChild(source), WAU.Slideout.init(`store-availability--${productId}`)
            }).catch(function (err) {
                console.log(err.message)
            })
        }
    }(context), Product.variants.length == 1) return context.querySelector("[data-store-availability-container]") && events.trigger("storeavailability:variant", Product.variants[0].id, Product.title, context), !1;
    if (config.featured_product) var prodSelector = "fp-product-select-" + context.dataset.sectionId; else if (config.quickview) var prodSelector = "qv-product-select-" + Product.id; else var prodSelector = "product-select-" + Product.id;
    if (Product.has_only_default_variant) return !1;
    varSelectors = context.querySelectorAll(".js-variant-selector"), varSelectors.forEach((item, i) => {
        item.addEventListener("change", function (event2) {
            event2.preventDefault(), config.swatches == "swatches" ? options = Array.from(varSelectors).map(swatch => Array.from(swatch.querySelectorAll("input")).find(radio => radio.checked).value) : options = Array.from(context.querySelectorAll("select.js-variant-selector"), select => select.value), variant = Product.variants.find(variant2 => !variant2.options.map((option, index) => options[index] === option).includes(!1)), variantEvents(context, variant, config)
        })
    }), function () {
        // config.swatches == "swatches" ? options = Array.from(varSelectors).map(swatch => Array.from(swatch.querySelectorAll("input")).find(radio => radio.checked).value) : options = Array.from(context.querySelectorAll("select.js-variant-selector"), select => select.value), variant = Product.variants.find(variant2 => !variant2.options.map((option, index) => options[index] === option).includes(!1)), variantEvents(context, variant, config)
        config.swatches == "swatches" ? options = Array.from(varSelectors).map(swatch => {
            const checkedRadio = Array.from(swatch.querySelectorAll("input")).find(radio => radio.checked);
            return checkedRadio ? checkedRadio.value : null;
        }) : options = Array.from(context.querySelectorAll("select.js-variant-selector"), select => select.value), variant = Product.variants.find(variant2 => !variant2.options.map((option, index) => options[index] === option).includes(!1)), variantEvents(context, variant, config)
    }(), function () {
        var elements = context.querySelectorAll("[type=radio]"), states = {
            sold_out: function (element) {
                element.parentElement.classList.add("soldout")
            }, available: function (element) {
                element.parentElement.classList.remove("soldout")
            }
        };
        events.on("variantunavailable", set_unavailable), elements.forEach(Swatch);
        var swatchLabel = context.querySelectorAll(".swatches__form--label");
        swatchLabel.forEach(selectInput);

        function set_unavailable() {
            var selected = {}, selected_elements = document.querySelectorAll("[type=radio]:checked");
            selected_elements.forEach(function (element) {
                var option = "option" + element.getAttribute("data-position"), value = element.value;
                selected[option] = value
            }), elements.forEach(function (element) {
                var available = !1, current_option = "option" + element.getAttribute("data-position"),
                    current_value = element.value,
                    other_options = ["option1", "option2", "option3"].filter(function (option) {
                        return selected[option] && option != current_option
                    });
                Product.variants.forEach(function (variant2) {
                    if (variant2.available && variant2[current_option] == current_value && variant2[other_options[0]] == selected[other_options[0]] && variant2[other_options[1]] == selected[other_options[1]]) {
                        available = !0;
                        return
                    }
                }), available ? states.available(element) : states.sold_out(element)
            })
        }

        function Swatch(element) {
            var option_position = element.getAttribute("data-position"), current_option = "option" + option_position,
                other_options = ["option1", "option2", "option3"].filter(function (option) {
                    return option != current_option
                });
            element.addEventListener("change", function (event2) {
                var selectedLabel = context.querySelector("#selected-option-" + option_position);
                selectedLabel.innerHTML = element.value, events.trigger("swatch:change:" + option_position, element.value)
            }), events.on("variantchange:option" + option_position + ":" + element.value, select), events.on("variantchange", set_availability);

            function select() {
                element.checked = !0
            }

            function set_availability(current_variant) {
                var available = !1;
                Product.variants.forEach(function (variant2) {
                    variant2.available && variant2[current_option] == element.value && variant2[other_options[0]] == current_variant[other_options[0]] && variant2[other_options[1]] == current_variant[other_options[1]] && (available = !0)
                }), available ? states.available(element) : states.sold_out(element)
            }
        }

        function selectInput(element) {
            element.addEventListener("keyup", function (event2) {
                event2.keyCode === 13 && (event2.preventDefault(), event2.target.parentNode.querySelector(".swatches__form--input").click())
            })
        }
    }(), function () {
        var element = context.querySelector(".price__regular .price-item--regular");
        if (!element) return !1;
        events.on("variantchange", function (variant2) {
            var price2 = money(variant2.price);
            element.innerHTML = price2, events.on("variantunavailable", function (variant3) {
                price2 = config.unavailable, element.innerHTML = price2
            })
        })
    }(), function () {
        var element = context.querySelector("[data-price]");
        element && events.on("variantchange", function (variant2) {
            variant2.available && variant2.compare_at_price > variant2.price ? (element.classList.add("price--on-sale"), element.classList.remove("price--sold-out")) : !variant2.available && variant2.compare_at_price > variant2.price ? (element.classList.add("price--sold-out"), element.classList.add("price--on-sale")) : variant2.available ? (element.classList.remove("price--on-sale"), element.classList.remove("price--sold-out")) : (element.classList.add("price--sold-out"), element.classList.remove("price--on-sale")), variant2.unit_price_measurement ? element.classList.add("price--unit-available") : element.classList.remove("price--unit-available")
        })
    }(), function () {
        var element = context.querySelector("[data-unit-price]"), wrapper = context.querySelector(".price__unit");
        if (!element) return !1;
        events.on("variantchange", function (variant2) {
            var unitPrice = "";
            variant2.unit_price ? (unitPrice = theme.Helpers.formatMoney(variant2.unit_price, config.money_format), +" " + config.unit_price_separator + "" + getBaseUnit(variant2), wrapper.style.display = "flex") : wrapper.style.display = "none", element.innerHTML = unitPrice
        })
    }(), function () {
        var saleEl = context.querySelector(".price__sale .price-item--sale"),
            regEl = context.querySelector(".price__sale .price-item--regular");
        if (!saleEl) return !1;
        events.on("variantchange", function (variant2) {
            var salePrice = "", regPrice = "";
            variant2.compare_at_price > variant2.price && (regPrice = money(variant2.compare_at_price), salePrice = money(variant2.price)), saleEl.innerHTML = salePrice, regEl.innerHTML = regPrice
        })
    }(), function () {
        var element = context.querySelector(".js-product-sku");
        if (!element) return !1;
        events.on("variantchange", function (variant2) {
            var variant_sku = variant2.sku;
            element.innerHTML = variant_sku, variant_sku === "" ? context.querySelector(".js-product-sku-container").classList.add("hide") : context.querySelector(".js-product-sku-container").classList.remove("hide")
        })
    }(), function () {
        var element = context.querySelector(".js-ajax-submit");
        if (!element) return !1;
        events.on("variantchange", function (variant2) {
            var text = config.button, disabled = !1;
            variant2.available || (text = config.sold_out, disabled = !0), element.value = text, element.disabled = disabled
        }), events.on("variantunavailable", function () {
            element.value = config.unavailable, element.disabled = !0
        })
    }(), function () {
        const element = context.querySelector("#product-form-installment");
        if (!element) return !1;
        const input = element.querySelector('input[name="id"]'), selectId = element.querySelector('select[name="id"]');
        events.on("variantchange", function (variant2) {
            selectId.value = parseInt(variant2.id), input.value = variant2.id, selectId.dispatchEvent(new Event("change", {bubbles: !0})), input.dispatchEvent(new Event("change", {bubbles: !0}))
        })
    }(), function () {
        var element = context.querySelector(".shopify-payment-button");
        if (!element) return !1;
        events.on("variantchange", function (variant2) {
            variant2.available ? element.style.display = "block" : element.style.display = "none"
        })
    }(), function () {
        var element = context.querySelector('[name="selling_plan"]');
        if (!element) return !1;
        var submitForm = context.querySelector(".js-prod-form-submit"), input = document.createElement("input");
        input.name = "selling_plan", input.type = "hidden", input.className = "js-selling-plan", submitForm.appendChild(input), element.addEventListener("change", function (event2) {
            input.value = event2.target.value
        })
    }();

    function money(cents) {
        return theme.Helpers.formatMoney(cents, config.money_format)
    }

    function getBaseUnit(variant2) {
        return variant2.unit_price_measurement.reference_value === 1 ? variant2.unit_price_measurement.reference_unit : variant2.unit_price_measurement.reference_value + variant2.unit_price_measurement.reference_unit
    }

    function variantEvents(context2, variant2, config2) {
        if (!variant2) {
            events.trigger("variantunavailable", config2), events.trigger("storeavailability:unavailable");
            return
        }
        if (Product.variants.length == 1) {
            if (!variant2.available) {
                var element = context2.querySelector(".product-price");
                element.innerHTML = config2.sold_out
            }
            return
        }
        events.trigger("variantchange", variant2, config2), events.trigger("variantchange:option1:" + variant2.option1), events.trigger("variantchange:option2:" + variant2.option2), events.trigger("variantchange:option3:" + variant2.option3), context2.querySelector("[data-store-availability-container]") && events.trigger("storeavailability:variant", variant2.id, Product.title, context2), variant2.featured_media && Events.trigger("variantchange:image", variant2.featured_media.id, context2), config2.enable_history && !window.Shopify.designMode && historyState(variant2, context2), updateVariantInput(variant2, context2)
    }

    function historyState(variant2, context2) {
        variant2 && window.history.replaceState({}, "", `${context2.dataset.url}?variant=${variant2.id}`)
    }

    function updateVariantInput(variant2, context2) {
        context2.querySelectorAll(".formVariantId").forEach((item, i) => {
            item.setAttribute("name", "id"), item.value = variant2.id, item.dispatchEvent(new Event("change", {bubbles: !0}))
        })
    }
}, theme.ProductScrollGallery = function () {
    function init7(context, sectionId, events, Product) {
        let config = JSON.parse(context.querySelector(".js-product-gallery").dataset.galleryConfig || "{}"),
            main = context.querySelector(".js-carousel-main");
        if (!main || (Events.on("mediaquery:mobile", function () {
            theme.ProductScrollGallery.enableCarousel(main, config, context)
        }), Events.on("mediaquery:tablet", function () {
            theme.ProductScrollGallery.enableCarousel(main, config, context)
        }), config.clickToEnlarge && theme.ProductScrollGallery.enlargePhoto(context), theme.ProductScrollGallery.scrollForm(context), Events.on("variantchange:image", function (id, context2) {
            if (context2.dataset.sectionId === "quickview" || id === null) return !1;
            let main2 = context2.querySelector(".js-carousel-main"),
                el = main2.querySelector("[data-image-id='" + id + "']"), index = el.dataset.slideIndex;
            desktop.matches && theme.ProductScrollGallery.scrollToImage(index, context2, el)
        }), mobile.matches)) return !1;
        context.querySelectorAll(".product-media-container").forEach((item, i) => {
            item.addEventListener("YTVideoStart", function () {
                theme.ProductScrollGallery.switchMedia(item.dataset.mediaNumber, context)
            }), document.body.addEventListener("click", function (event2) {
                item.contains(event2.target) && theme.ProductScrollGallery.switchMedia(item.dataset.mediaNumber, context)
            })
        })
    }

    function enableCarousel(main, config, context) {
        let initialEl = main.querySelector("[data-image-id='" + context.dataset.initialVariant + "']"), initialIndex;
        if (initialEl ? initialIndex = initialEl.dataset.slideIndex : initialIndex = 0, config.navStyle == "dots") var dots = !0,
            arrows = !1; else var dots = !1, arrows = !0;
        var flkty = new Flickity(main, {
            fade: !0,
            wrapAround: !0,
            cellAlign: "left",
            draggable: !0,
            contain: !0,
            pageDots: dots ? !1 : arrows,
            prevNextButtons: arrows,
            autoPlay: !1,
            selectedAttraction: .01,
            dragThreshold: 5,
            accessibility: !1,
            adaptiveHeight: !1,
            imagesLoaded: !0,
            initialIndex,
            on: {
                ready: function () {
                    let id = this.selectedElement.dataset.imageId;
                    context.querySelector(".js-product-gallery").style.visibility = "visible"
                }, change: function () {
                    theme.ProductScrollGallery.removeFocus(context), theme.ProductScrollGallery.addFocus(this.selectedElement, context), theme.ProductScrollGallery.switchMedia(this.selectedElement.dataset.imageId, context), this.selectedElement.classList.contains("model-slide") && this.isDraggable && (this.options.draggable = !this.options.draggable, this.updateDraggable())
                }
            }
        });
        theme.ProductScrollGallery.galleryEvents(flkty, main, config, context)
    }

    function disableCarousel(flkty) {
        flkty.destroy()
    }

    function galleryEvents(flkty, main, config, context) {
        Events.on("variantchange:image", function (id, context2) {
            if (context2.dataset.sectionId === "quickview" || id === null) return !1;
            let main2 = context2.querySelector(".js-carousel-main"),
                el = main2.querySelector("[data-image-id='" + id + "']"), index = el.dataset.slideIndex;
            theme.ProductScrollGallery.switchMedia(id, context2), desktop.matches ? theme.ProductScrollGallery.scrollToImage(index, context2, el) : flkty.select(index)
        }), Events.on("mediaquery:desktop", function () {
            theme.ProductScrollGallery.disableCarousel(flkty), theme.ProductScrollGallery.scrollForm(context)
        }), Events.on("editor:section:select", function () {
            desktop.matches ? (theme.ProductScrollGallery.disableCarousel(flkty), theme.ProductScrollGallery.scrollForm(context)) : theme.ProductScrollGallery.enableCarousel(main, config, context)
        })
    }

    function removeFocus(context) {
        let main;
        context ? main = context : main = context.querySelector(".js-carousel-main"), context.querySelectorAll(".js-carousel-main *").forEach((item, i) => {
            item.setAttribute("tabIndex", "-1"), item.blur()
        }), context.querySelectorAll(".flickity-button *").forEach((item, i) => {
            item.setAttribute("tabIndex", "-1"), item.classList.add("js-hide-focus")
        }), main.classList.contains(".flickity-enabled") && (main.setAttribute("tabIndex", "-1"), main.classList.add("js-hide-focus"))
    }

    function addFocus(current, context) {
        current.classList.contains("image-slide") ? current.querySelector("img").setAttribute("tabIndex", "0") : current.classList.contains("video-slide") ? current.querySelectorAll(".plyr__controls *").forEach((item, i) => {
            item.setAttribute("tabIndex", "0")
        }) : current.classList.contains("external_video-slide") ? current.querySelector("iframe").setAttribute("tabIndex", "0") : current.classList.contains("model-slide") && current.querySelectorAll(".shopify-model-viewer-ui__controls-area *").forEach((item, i) => {
            item.setAttribute("tabIndex", "0")
        })
    }

    function scrollForm(context) {
        var HHeight = document.querySelector("header").offsetHeight, OffSet2 = Number(HHeight) + 20;
        stickybits(".is_sticky", {stickyBitStickyOffset: OffSet2});
        var stickyEl = document.querySelectorAll(".is_sticky");
        if (!stickyEl) return !1
    }

    function scrollToImage(index, context, currentItem) {
        if (context.querySelectorAll(".js-product-image-item").forEach((item, i) => {
            item.classList.remove("selected")
        }), !currentItem) return !1;
        if (currentItem.classList.add("selected"), document.querySelector("body").classList.contains("template-index")) currentItem.scrollIntoView(); else {
            let headerHeight = document.querySelector("header").offsetHeight;
            document.documentElement.scrollTo({
                top: currentItem.offsetTop - headerHeight + 250,
                left: 0,
                behavior: "smooth"
            })
        }
    }

    function enlargePhoto(context) {
        let buttons = context.querySelectorAll("a.zoom_btn");
        if (!buttons) return !1;
        buttons.forEach((button, i) => {
            button.addEventListener("click", function (event2) {
                event2.preventDefault();
                var btn = event2.target;
                openPhotoSwipe(i)
            })
        });
        var openPhotoSwipe = function (index) {
            var pswpElement = document.querySelectorAll(".pswp")[0];
            let images = context.querySelectorAll(".js-image-slide");
            if (images.length < 2) var arrows = !1; else var arrows = !0;
            let items = [];
            images.forEach((image, i) => {
                let imageTag = image.querySelector(".product__image"), item = {
                    src: imageTag.getAttribute("data-zoom-src"),
                    w: imageTag.getAttribute("data-width"),
                    h: imageTag.getAttribute("data-height")
                };
                items.push(item)
            });
            var options = {
                index,
                arrowEl: arrows,
                captionEl: !1,
                closeOnScroll: !1,
                counterEl: !1,
                history: !1,
                fullscreenEl: !1,
                preloaderEl: !1,
                shareEl: !1,
                tapToClose: !1,
                getThumbBoundsFn: function (index2) {
                    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                        thumbnail = context.querySelector(".product__image"), rect = thumbnail.getBoundingClientRect();
                    return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}
                }
            }, gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.init(), gallery.listen("afterChange", function () {
                var flkty = Flickity.data(".js-carousel-main");
                if (!flkty) return !1;
                var newIndex = gallery.getCurrentIndex();
                flkty.select(newIndex)
            })
        }
    }

    function switchMedia(mediaId, context) {
        let main = context.querySelector(".js-carousel-main"),
            currentMedia = main.querySelector("[data-product-single-media-wrapper]:not(.inactive)"),
            newMedia = main.querySelector("[data-product-single-media-wrapper][data-thumbnail-id='product-template-" + mediaId + "']"),
            otherMedia = main.querySelectorAll("[data-product-single-media-wrapper]:not([data-thumbnail-id='product-template-" + mediaId + "'])");
        currentMedia && currentMedia.dispatchEvent(new CustomEvent("mediaHidden", {
            bubbles: !0,
            cancelable: !0
        })), newMedia && (newMedia.classList.add("active-slide"), newMedia.classList.remove("inactive"), newMedia.dispatchEvent(new CustomEvent("mediaVisible", {
            bubbles: !0,
            cancelable: !0
        }))), otherMedia && otherMedia.forEach(function (el) {
            el.classList.add("inactive"), el.classList.remove("active-slide")
        }.bind(this))
    }

    return {
        init: init7,
        enableCarousel,
        disableCarousel,
        galleryEvents,
        addFocus,
        removeFocus,
        scrollForm,
        scrollToImage,
        enlargePhoto,
        switchMedia
    }
}(), theme.ProductGallery = function () {
    function init7(context, sectionId, events, Product) {
        let config = JSON.parse(context.querySelector(".js-product-gallery").dataset.galleryConfig || "{}"),
            main = context.querySelector(".js-carousel-main"),
            carouselNav = context.querySelector(".js-thumb-carousel-nav");
        if (!main) return !1;
        this.mainSlider(main, carouselNav, config, context), theme.ProductGallery.stickyImages(context), carouselNav && config.thumbPosition == "bottom" && config.thumbSlider == !0 && this.thumbSlider(carouselNav, main, context), config.clickToEnlarge && theme.ProductGallery.enlargePhoto(context)
    }

    function mainSlider(main, carouselNav, config, context) {
    if (!config.mainSlider) return !1;
    let initialEl = main.querySelector("[data-image-id='" + context.dataset.initialVariant + "']"), initialIndex;
    if (initialEl ? initialIndex = initialEl.dataset.slideIndex : initialIndex = 0, config.navStyle == "dots") var dots = !0,
        arrows = !1; else var dots = !1, arrows = !0;

    // Progress bar replaces dots
    var progressBar = document.createElement("div");
    progressBar.className = "product-gallery-progress";
    var progressFill = document.createElement("div");
    progressFill.className = "product-gallery-progress__fill";
    progressBar.appendChild(progressFill);
    main.parentNode.insertBefore(progressBar, main.nextSibling);

    function updateProgressBar(flktyInstance) {
        var total = flktyInstance.slides.length;
        var current = flktyInstance.selectedIndex;
        var percent = total > 1 ? ((current + 1) / total) * 100 : 100;
        progressFill.style.width = percent + "%";
    }

    var flkty = new Flickity(main, {
        fade: !0,
        wrapAround: !0,
        cellAlign: "left",
        draggable: !0,
        contain: !0,
        pageDots: !1,
        prevNextButtons: !0,
        autoPlay: !1,
        accessibility: !1,
        selectedAttraction: .01,
        dragThreshold: 5,
        adaptiveHeight: !0,
        imagesLoaded: !0,
        initialIndex,
        on: {
            ready: function () {
                let id = this.selectedElement.dataset.imageId;
                context.querySelector(".js-product-gallery").style.visibility = "visible";
                updateProgressBar(this);
            }, change: function () {
                theme.ProductGallery.removeFocus(context), theme.ProductGallery.addFocus(this.selectedElement, context), theme.ProductGallery.setActiveThumbnail(this.selectedElement.dataset.imageId, this.selectedElement, context), theme.ProductGallery.switchMedia(this.selectedElement.dataset.imageId, context), this.selectedElement.classList.contains("model-slide") && this.isDraggable && (this.options.draggable = !this.options.draggable, this.updateDraggable());
                updateProgressBar(this);
            }
        }
    });
    theme.ProductGallery.galleryEvents(flkty, context), carouselNav && theme.ProductGallery.thumbnails(flkty, carouselNav, config, context)
}

    function thumbSlider(wrapper, main, context) {
        var flktyThumbs = new Flickity(wrapper, {
            asNavFor: main,
            wrapAround: !1,
            groupCells: !0,
            cellAlign: "left",
            draggable: !1,
            contain: !0,
            imagesLoaded: !0,
            pageDots: !1,
            autoPlay: !1,
            selectedAttraction: .01,
            dragThreshold: 5,
            accessibility: !1
        })
    }

    function thumbnails(flkty, carouselNav, config, context) {
        if (!carouselNav) return !1;
        let thumbs = carouselNav.querySelectorAll(".js-thumb-item");
        if (!thumbs) return !1;
        thumbs.forEach((thumb, i) => {
            thumb.addEventListener("click", function (event2) {
                event2.preventDefault();
                let index = this.dataset.slideIndex, el = carouselNav.querySelectorAll(".js-thumb-item")[index],
                    mediaId = this.dataset.imageId;
                theme.ProductGallery.setActiveThumbnail(mediaId, el, context), theme.ProductGallery.switchMedia(mediaId, context), theme.ProductGallery.setThumbPos(this, carouselNav), flkty.select(index)
            }), thumb.addEventListener("keypress", function (event2) {
                if (event2.preventDefault(), event2.which == 13) {
                    let index = this.dataset.slideIndex, el = carouselNav.querySelectorAll(".js-thumb-item")[index],
                        mediaId = this.dataset.imageId;
                    theme.ProductGallery.setActiveThumbnail(mediaId, el, context), theme.ProductGallery.switchMedia(mediaId, context), theme.ProductGallery.setThumbPos(this, carouselNav), flkty.select(index)
                }
            })
        })
    }

    function setThumbPos(selected, carouselNav) {
        carouselNav.scrollTo({top: selected.offsetTop - 20, left: 0, behavior: "smooth"})
    }

    function galleryEvents(flkty, context) {
        Events.on("variantchange:image", function (id, context2) {
            if (id === null) return !1;
            var main, el, index, curFlkty;
            main = context2.querySelector(".js-carousel-main"), el = main.querySelector("[data-image-id='" + id + "']"), index = el.dataset.slideIndex, theme.ProductGallery.setActiveThumbnail(id, el, context2), theme.ProductGallery.switchMedia(id, context2), curFlkty = Flickity.data(main), curFlkty && curFlkty.select(index)
        }), Events.on("mediaquery:desktop", function () {
            theme.ProductGallery.stickyImages(context)
        }), Events.on("editor:section:select", function () {
            desktop.matches && theme.ProductGallery.stickyImages(context)
        })
    }

    function removeFocus(context) {
        let main;
        context ? main = context : main = context.querySelector(".js-carousel-main"), context.querySelectorAll(".js-carousel-main *").forEach((item, i) => {
            item.setAttribute("tabIndex", "-1"), item.blur()
        }), context.querySelectorAll(".flickity-button *").forEach((item, i) => {
            item.setAttribute("tabIndex", "-1"), item.classList.add("js-hide-focus")
        }), main.classList.contains(".flickity-enabled") && (main.setAttribute("tabIndex", "-1"), main.classList.add("js-hide-focus"))
    }

    function addFocus(current, context) {
        current.classList.contains("image-slide") ? current.querySelector("img").setAttribute("tabIndex", "0") : current.classList.contains("video-slide") ? current.querySelectorAll(".plyr__controls *").forEach((item, i) => {
            item.setAttribute("tabIndex", "0")
        }) : current.classList.contains("external_video-slide") ? current.querySelector("iframe").setAttribute("tabIndex", "0") : current.classList.contains("model-slide") && current.querySelectorAll(".shopify-model-viewer-ui__controls-area *").forEach((item, i) => {
            item.setAttribute("tabIndex", "0")
        })
    }

    function enlargePhoto(context) {
        let buttons = context.querySelectorAll("a.zoom_btn");
        if (!buttons) return !1;
        buttons.forEach((button, i) => {
            button.addEventListener("click", function (event2) {
                event2.preventDefault();
                var btn = event2.target, index = btn.getAttribute("data-ps-slide-index"), index = parseInt(index, 10);
                openPhotoSwipe(index)
            })
        });
        var openPhotoSwipe = function (index) {
            var pswpElement = document.querySelectorAll(".pswp")[0];
            let images = context.querySelectorAll("#slider .slides.carousel-main .image-slide");
            if (images.length < 2) var arrows = !1; else var arrows = !0;
            let items = [];
            images.forEach((image, i) => {
                let imageTag = image.querySelector(".product__image"), item = {
                    src: imageTag.getAttribute("data-zoom-src"),
                    w: imageTag.getAttribute("data-width"),
                    h: imageTag.getAttribute("data-height")
                };
                items.push(item)
            });
            var options = {
                index,
                arrowEl: arrows,
                captionEl: !1,
                closeOnScroll: !1,
                counterEl: !1,
                history: !1,
                fullscreenEl: !1,
                preloaderEl: !1,
                shareEl: !1,
                tapToClose: !1,
                getThumbBoundsFn: function (index2) {
                    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                        thumbnail = context.querySelector(".product__image"), rect = thumbnail.getBoundingClientRect();
                    return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}
                }
            }, gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.init(), gallery.listen("afterChange", function () {
                var flkty = Flickity.data(".slides.carousel-main"), newIndex = gallery.getCurrentIndex();
                let sliderImage = context.querySelector(`[data-ps-slide-index="${newIndex}"]`),
                    newNewIndex = parseInt(sliderImage.dataset.index, 10);
                flkty.select(newNewIndex)
            })
        }
    }

    function switchMedia(mediaId, context) {
        let main = context.querySelector(".js-carousel-main"),
            currentMedia = main.querySelector("[data-product-single-media-wrapper]:not(.inactive)"),
            newMedia = main.querySelector("[data-product-single-media-wrapper][data-thumbnail-id='product-template-" + mediaId + "']"),
            otherMedia = main.querySelectorAll("[data-product-single-media-wrapper]:not([data-thumbnail-id='product-template-" + mediaId + "'])");
        currentMedia.dispatchEvent(new CustomEvent("mediaHidden", {
            bubbles: !0,
            cancelable: !0
        })), newMedia.classList.add("active-slide"), newMedia.classList.remove("inactive"), newMedia.dispatchEvent(new CustomEvent("mediaVisible", {
            bubbles: !0,
            cancelable: !0
        })), otherMedia.forEach(function (el) {
            el.classList.add("inactive"), el.classList.remove("active-slide")
        }.bind(this))
    }

    function setActiveThumbnail(mediaId, el, context) {
        let main = context.querySelector(".js-carousel-main"),
            carouselNav = context.querySelector(".js-thumb-carousel-nav");
        typeof mediaId > "u" && (mediaId = main.querySelector("[data-product-single-media-wrapper]:not(.hide)").dataset.mediaId), carouselNav && carouselNav.querySelectorAll(".js-thumb-item").forEach((item, i) => {
            item.classList.remove("is-nav-selected"), item.classList.remove("active-slide"), item.removeAttribute("aria-current")
        });
        let thumbActive = context.querySelector(".js-thumb-item[data-image-id='" + mediaId + "']");
        thumbActive && (thumbActive.classList.add("is-nav-selected"), thumbActive.classList.add("active-slide"), thumbActive.setAttribute("aria-current", !0))
    }

    function stickyImages(context) {
        var HHeight = document.querySelector("header").offsetHeight, OffSet2 = Number(HHeight) + 20;
        stickybits(".is_sticky", {stickyBitStickyOffset: OffSet2});
        var stickyEl = document.querySelectorAll(".is_sticky");
        if (!stickyEl) return !1
    }

    return {
        init: init7,
        mainSlider,
        thumbSlider,
        thumbnails,
        setThumbPos,
        galleryEvents,
        stickyImages,
        removeFocus,
        addFocus,
        enlargePhoto,
        switchMedia,
        setActiveThumbnail
    }
}(), theme.ProductVideo = function (context, sectionId) {
    var videos = {}, hosts = {html5: "html5", youtube: "youtube"},
        selectors2 = {productMediaWrapper: "[data-product-single-media-wrapper]"},
        attributes = {enableVideoLooping: "enable-video-looping", videoId: "video-id"};

    function init7(videoContainer, sectionId2) {
        if (videoContainer) {
            var videoElement = videoContainer.querySelector("iframe, video");
            if (videoElement) {
                var mediaId = videoContainer.getAttribute("data-media-id");
                videos[mediaId] = {
                    mediaId,
                    sectionId: sectionId2,
                    host: hostFromVideoElement(videoElement),
                    container: videoContainer,
                    element: videoElement,
                    ready: function () {
                        createPlayer(this)
                    }
                };
                var video = videos[mediaId];
                switch (video.host) {
                    case hosts.html5:
                        window.Shopify.loadFeatures([{
                            name: "video-ui",
                            version: "1.0",
                            onLoad: setupPlyrVideos
                        }]), theme.LibraryLoader.load("plyrShopifyStyles");
                        break;
                    case hosts.youtube:
                        theme.LibraryLoader.load("youtubeSdk", setupYouTubeVideos);
                        break
                }
            }
        }
    }

    function setupPlyrVideos(errors) {
        if (errors) {
            fallbackToNativeVideo();
            return
        }
        loadVideos(hosts.html5)
    }

    function setupYouTubeVideos() {
        window.YT.Player && loadVideos(hosts.youtube)
    }

    function createPlayer(video) {
        if (!video.player) {
            var productMediaWrapper = video.container.closest(selectors2.productMediaWrapper),
                enableLooping = productMediaWrapper.getAttribute("data-" + attributes.enableVideoLooping) === "true";
            switch (video.host) {
                case hosts.html5:
                    video.player = new Shopify.Plyr(video.element, {
                        loop: {active: enableLooping},
                        muted: !0,
                        hideControlsOnPause: !0,
                        tooltips: {controls: !1, seek: !0}
                    }), video.player.on("ready", event2 => {
                        video.container.querySelector(".plyr--full-ui").setAttribute("tabindex", "-1"), video.container.querySelectorAll(".plyr--full-ui *").forEach((item, i) => {
                            item.setAttribute("tabindex", "-1")
                        })
                    }), video.player.on("play", event2 => {
                        video.container.querySelectorAll(".plyr__controls *").forEach((item, i) => {
                            item.setAttribute("tabIndex", "0")
                        })
                    });
                    break;
                case hosts.youtube:
                    var videoId = productMediaWrapper.getAttribute("data-" + attributes.videoId);
                    video.player = new YT.Player(video.element, {
                        videoId, events: {
                            onStateChange: function (event2) {
                                event2.data === 0 && enableLooping && event2.target.seekTo(0), event2.data === 1 && productMediaWrapper.dispatchEvent(new CustomEvent("YTVideoStart", {
                                    bubbles: !0,
                                    cancelable: !0
                                }))
                            }, onReady: function (event2) {
                                video.player.mute()
                            }
                        }
                    });
                    break
            }
            var pauseVideo = function () {
                video.player && (video.host === hosts.html5 && video.player.pause(), video.host === hosts.youtube && video.player.pauseVideo && video.player.pauseVideo())
            };
            productMediaWrapper.addEventListener("mediaHidden", pauseVideo), productMediaWrapper.addEventListener("xrLaunch", pauseVideo), productMediaWrapper.addEventListener("mediaHidden xrLaunch", function () {
                video.player && (video.host === hosts.html5 && video.player.pause(), video.host === hosts.youtube && video.player.pauseVideo && video.player.pauseVideo())
            }), productMediaWrapper.addEventListener("mediaVisible", function () {
                theme.Helpers.isTouch() || video.player && (video.host === hosts.html5 && desktop.matches && video.player.play(), video.host === hosts.youtube && video.player.playVideo && desktop.matches && video.player.playVideo())
            })
        }
    }

    function hostFromVideoElement(video) {
        return video.tagName === "VIDEO" ? hosts.html5 : video.tagName === "IFRAME" && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(video.src) ? hosts.youtube : null
    }

    function loadVideos(host) {
        for (var key2 in videos) if (videos.hasOwnProperty(key2)) {
            var video = videos[key2];
            video.host === host && video.ready()
        }
    }

    function fallbackToNativeVideo() {
        for (var key2 in videos) if (videos.hasOwnProperty(key2)) {
            var video = videos[key2];
            if (video.nativeVideo) continue;
            video.host === hosts.html5 && (video.element.setAttribute("controls", "controls"), video.nativeVideo = !0)
        }
    }

    function removeSectionVideos(sectionId2) {
        for (var key2 in videos) if (videos.hasOwnProperty(key2)) {
            var video = videos[key2];
            video.sectionId === sectionId2 && (video.player && video.player.destroy(), delete videos[key2])
        }
    }

    return {init: init7, hosts, loadVideos, removeSectionVideos}
}(), theme.ProductModel = function () {
    var modelJsonSections = {}, models = {}, xrButtons = {},
        selectors2 = {mediaGroup: "[data-product-single-media-group]", xrButton: "[data-shopify-xr]"};

    function init7(modelViewerContainers, sectionId) {
        modelJsonSections[sectionId] = {loaded: !1}, modelViewerContainers.forEach(function (modelViewerContainer, index) {
            var mediaId = modelViewerContainer.getAttribute("data-media-id"),
                modelViewerElement = modelViewerContainer.querySelector("model-viewer"),
                modelId = modelViewerElement.getAttribute("data-model-id");
            if (index === 0) {
                var mediaGroup = modelViewerContainer.closest(selectors2.mediaGroup),
                    xrButton = mediaGroup.querySelector(selectors2.xrButton);
                xrButtons[sectionId] = {element: xrButton, defaultId: modelId}
            }
            models[mediaId] = {modelId, sectionId, container: modelViewerContainer, element: modelViewerElement}
        }), window.Shopify.loadFeatures([{
            name: "shopify-xr",
            version: "1.0",
            onLoad: setupShopifyXr
        }, {
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: setupModelViewerUi
        }]), theme.LibraryLoader.load("modelViewerUiStyles")
    }

    function setupShopifyXr(errors) {
        if (!errors) {
            if (!window.ShopifyXR) {
                document.addEventListener("shopify_xr_initialized", function () {
                    setupShopifyXr()
                });
                return
            }
            for (var sectionId in modelJsonSections) if (modelJsonSections.hasOwnProperty(sectionId)) {
                var modelSection = modelJsonSections[sectionId];
                if (modelSection.loaded) continue;
                var modelJson = document.querySelector("#ModelJson-" + sectionId);
                window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML)), modelSection.loaded = !0
            }
            window.ShopifyXR.setupXRElements()
        }
    }

    function setupModelViewerUi(errors) {
        if (!errors) {
            for (var key2 in models) if (models.hasOwnProperty(key2)) {
                var model = models[key2];
                model.modelViewerUi || (model.modelViewerUi = new Shopify.ModelViewerUI(model.element)), setupModelViewerListeners(model)
            }
        }
    }

    function setupModelViewerListeners(model) {
        var xrButton = xrButtons[model.sectionId];
        model.container.addEventListener("mediaVisible", function () {
            xrButton.element.setAttribute("data-shopify-model3d-id", model.modelId), !mobile.matches && model.modelViewerUi.play()
        }), model.container.addEventListener("mediaHidden", function () {
            xrButton.element.setAttribute("data-shopify-model3d-id", xrButton.defaultId), model.modelViewerUi.pause()
        }), model.container.addEventListener("xrLaunch", function () {
            model.modelViewerUi.pause()
        })
    }

    function removeSectionModels(sectionId) {
        for (var key2 in models) if (models.hasOwnProperty(key2)) {
            var model = models[key2];
            model.sectionId === sectionId && (models[key2].modelViewerUi.destroy(), delete models[key2])
        }
        delete modelJsonSections[sectionId]
    }

    return {init: init7, removeSectionModels}
}(), theme.ProductSPIBanner = function () {
    const defaults = {spiTagName: "SHOPIFY-PAYMENT-TERMS", spiBannerSelector: ".product-form-installment"};
    let spiBannerActivated = !1;
    const removeMargins = function (element) {
        if (!element) return console.log("Error. Must provide an element to remove margins from."), !1;
        element.style.marginTop = 0, element.style.marginBottom = 0
    }, checkForTag = function (tag, element) {
        if (!tag) return console.log("Error. Must provide a tag to test against."), !1;
        if (!element) return console.log("Error. Must provide an element to loop through."), !1;
        if (element.children.length > 0) {
            for (let i = 0; i < element.children.length; i++) if (element.children[i].tagName === tag) return !0
        }
        return !1
    };
    return {
        init: function (context, options) {
            var settings2 = Object.assign({}, defaults, options);
            let spiBanner = context.querySelector(settings2.spiBannerSelector);
            checkForTag(settings2.spiTagName, spiBanner) && (spiBannerActivated = !0), spiBannerActivated || removeMargins(spiBanner)
        }
    }
}(), theme.complementaryProducts = function (context, events) {
    (function () {
        var element = context.querySelector(".js-complementary-products");

        function initFlickity() {
            let carousel = element.querySelector(".js-carousel");
            if (!carousel) return !1;
            let flickityData = carousel.getAttribute("data-flickity");
            if (!flickityData) return console.warn("Error. No Flickity data."), !1;
            let flickityOptions = JSON.parse(flickityData);
            new Flickity(carousel, flickityOptions)
        }

        if (!element) return !1;
        var loadComplementaryProducts = function () {
            var baseUrl = element.dataset.baseUrl;
            if (element !== null) {
                var productId = element.dataset.productId, sectionId = element.dataset.sectionId,
                    limit = element.dataset.limit, intent = element.dataset.intent,
                    complementarySectionUrl = baseUrl + "?section_id=" + sectionId + "&product_id=" + productId + "&limit=" + limit + "&intent=" + intent;
                fetch(complementarySectionUrl).then(response => response.text()).then(text => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector(".js-complementary-products");
                    recommendations && recommendations.innerHTML.trim().length && (element.innerHTML = recommendations.innerHTML), Shopify.theme.ajaxCart.init(), Shopify.theme.quickview.init(), limit > 1 && initFlickity()
                })
            }
        };
        loadComplementaryProducts()
    })()
}, theme.ProductProperties = function (exports2) {
    "use strict";
    const classes = {filled: "is__filled", error: "required-error"},
        selectors2 = {customizationInput: "[data-product-property]", error: ".required-error"};

    function _updateValue(value, i) {
        return `properties[${`${value.split("properties[")[1].split("]")[0]}${i}`}]`
    }

    function _fixDuplicateNameValues(addToCartForm) {
        const elements = [...addToCartForm.elements].filter(element => element.hasAttribute("data-product-property"));
        if (!elements) {
            console.error("Error. No elements.");
            return
        }
        const arr = [];
        let j = 0, current;
        elements.forEach(element => {
            arr.push(element.getAttribute("name"))
        }), elements.forEach((element, i) => {
            let name = element.getAttribute("name");
            current != name ? current = name : elements[i].setAttribute("name", _updateValue(name, j++))
        })
    }

    function _scrollToFirstError(form) {
        if (typeof window.scrollTo != "function") return;
        const firstErrorInput = form ? form.querySelector(selectors2.error) : document.querySelector(selectors2.error);
        if (firstErrorInput) {
            const coords = firstErrorInput.getBoundingClientRect();
            window.scrollTo({top: coords.y, left: coords.x, behavior: "smooth"})
        }
    }

    function init7(context, events) {
        var elements = context.querySelectorAll(selectors2.customizationInput);
        elements.forEach((element, i) => {
            element.addEventListener("blur", event2 => {
                event2.target.value != "" ? event2.target.classList.add(classes.filled) : event2.target.classList.remove(classes.filled)
            })
        })
    }

    function checkLineItemProperties(addToCartForm) {
        if (addToCartForm.elements.length > 0) {
            _fixDuplicateNameValues(addToCartForm);
            const requiredFields = [...addToCartForm.elements].filter(element => element.hasAttribute("data-product-property") && element.required);
            if (requiredFields.length > 0) {
                let required = !1;
                if (requiredFields.forEach(requiredField => {
                    requiredField.classList.remove(classes.error), requiredField.value === "" && (required = !0, requiredField.classList.add(classes.error))
                }), _scrollToFirstError(addToCartForm), required) return !1
            }
        }
    }

    return exports2.init = init7, exports2.checkLineItemProperties = checkLineItemProperties, exports2
}({}), theme.Product = function () {
    function Product(context) {
        var events = new EventEmitter3;
        events.trigger = events.emit;
        var productJson = context.querySelector(".product-json");
        if (!productJson) return !1;
        var Product2 = productJson.innerHTML, Product2 = JSON.parse(Product2 || "{}"),
            sectionId = context.dataset.sectionId;
        document.body.className.includes("template-product") && Shopify.RecordViewedProducts.recordRecentlyViewed();
        let productModals = context.querySelectorAll("[data-wau-modal-content]");
        productModals.length > 0 && productModals.forEach(modal => {
            WAU.Modal.init(modal.dataset.wauModalContent)
        }), context.querySelector(".product-form-installment") && theme.ProductSPIBanner.init(context), context.querySelector("[data-complementary-products]") && theme.complementaryProducts(context, sectionId, events, Product2), context.querySelector("[data-static-gallery]") && theme.ProductGallery.init(context, sectionId, events, Product2), context.querySelector("[data-scroll-gallery]") && theme.ProductScrollGallery.init(context, sectionId, events, Product2), context.querySelector("[data-product-form]") && theme.ProductForm(context, sectionId, events, Product2), context.querySelectorAll("[data-product-property]").length && theme.ProductProperties.init(context, events), context.querySelectorAll("[data-product-media-type-video]").forEach(function (context2, sectionId2) {
            theme.ProductVideo.init(context2, sectionId2)
        }), context.querySelector("[data-recipient-form]") && theme.GiftCardRecipient(context, sectionId, events, Product2);
        let modelViewerElements = context.querySelectorAll("[data-product-media-type-model]");
        modelViewerElements.length > 0 && theme.ProductModel.init(modelViewerElements, sectionId);
        var self2 = this;
        document.addEventListener("shopify_xr_launch", function () {
            var currentMedia = document.querySelector("[data-product-single-media-wrapper]:not(.inactive)", self2);
            currentMedia.dispatchEvent(new CustomEvent("xrLaunch", {bubbles: !0, cancelable: !0}))
        })
    }

    return document.addEventListener("shopify:section:load", function (event2) {
        if (event2.target.querySelector('[data-section-type="product__section"]')) return Product
    }), Product
}(), theme.GiftCardRecipient = function (context, sectionId, events, Product) {
    const container = context.querySelector(".recipient-form");
    if (!container) return !1;
    const recipientCheckbox = container.querySelector(`#Recipient-Checkbox-${sectionId}`);
    recipientCheckbox.disabled = !1;
    const emailInput = container.querySelector(`#Recipient-email-${sectionId}`),
        nameInput = container.querySelector(`#Recipient-name-${sectionId}`),
        messageInput = container.querySelector(`#Recipient-message-${sectionId}`),
        hiddenField = container.querySelector(`#Recipient-Control-${sectionId}`);
    hiddenField.disabled = !0;
    const form = container.closest(".js-prod-form-submit"), formSubmitButton = form.querySelector(".js-ajax-submit"),
        defaultErrorMessage = context.querySelector(".js-error-msg").innerHTML;
    form.addEventListener("change", handleChange);

    function handleChange(event2) {
        recipientCheckbox.checked ? emailInput.required = !0 : clearForm()
    }

    function clearForm() {
        clearErrorMessage(), emailInput.value = "", nameInput.value = "", messageInput.value = "", emailInput.required = !1
    }

    function clearErrorMessage() {
        container.querySelectorAll(".recipient-fields .form__message").forEach(field => {
            field.classList.add("hidden");
            const textField = field.querySelector(".error-message");
            textField && (textField.innerText = "")
        })
    }

    function displayErrorMessage(title, body, formContext) {
        if (form.isSameNode(formContext) && (clearErrorMessage(), typeof body == "object")) return Object.entries(body).forEach(([key2, value]) => {
            const errorMessageId = `RecipientForm-${key2}-error-${sectionId}`,
                fieldSelector = `#Recipient-${key2}-${sectionId}`,
                message = `${container.querySelector(`${fieldSelector}`)?.getAttribute("placeholder") || key2} ${value}`,
                errorMessageElement = container.querySelector(`#${errorMessageId}`),
                errorTextElement = errorMessageElement?.querySelector(".error-message");
            errorTextElement && (errorTextElement.innerText = `${message}.`, errorMessageElement.classList.remove("hidden"))
        })
    }

    function updateErrorMessage(title, config, formContext) {
        if (!form.isSameNode(formContext)) return;
        const errorMessage = context.querySelector(".js-error-msg");
        if (!errorMessage) {
            console.warn("No error message found.");
            return
        }
        errorMessage.innerHTML = `<b>${config.form_error}</b> ${title}`, setTimeout(() => {
            errorMessage.innerHTML = defaultErrorMessage
        }, 4e3)
    }

    Events.on("recipientform:errors", function (title, body, config, addToCartForm) {
        displayErrorMessage(title, body, addToCartForm), updateErrorMessage(title, config, addToCartForm)
    })
}, theme.ProductRecommendations = function () {
    function ProductRecommendations() {
        var loadProductRecommendationsIntoSection = function () {
            var container = document.querySelector(".js-product-rec-wrapper");
            if (!container) return !1;
            var baseUrl = container.dataset.baseUrl;
            if (container !== null) {
                var productId = container.dataset.productId, sectionId = container.dataset.sectionId,
                    intent = container.dataset.intent,
                    recommendationsSectionUrl = baseUrl + "?section_id=" + sectionId + "&product_id=" + productId + "&intent=" + intent;
                fetch(recommendationsSectionUrl).then(function (response) {
                    return response.text()
                }).then(function (productHtml) {
                    productHtml.trim() !== "" && (container.innerHTML = productHtml, container.innerHTML = container.firstElementChild.innerHTML, WAU.ProductGridVideo.init())
                })
            }
        };
        document.addEventListener("shopify:section:select", function (event2) {
            event2.detail.sectionId.includes("product-recommendations") && loadProductRecommendationsIntoSection()
        }), loadProductRecommendationsIntoSection()
    }

    return ProductRecommendations
}(), theme.RecentlyViewed = function () {
    function RecentlyViewed(container) {
        if (!container) return console.log("Error. Recently viewed section must be provided a container in order to work."), !1;
        const limit = container.dataset.limit ? container.dataset.limit : 6, grid = container.dataset.grid,
            carouselEnabled = (container.dataset.carousel ? container.dataset.carousel : !1) === "true",
            wrapperId = container.dataset.wrapperId, revealOuterWrapper = (wrapperId2 = "recently-viewed") => {
                if (!wrapperId2) return console.log("Error. must provide a wrapperId as an argument."), !1;
                let wrapper = document.getElementById(wrapperId2);
                if (!wrapper) return console.log("Error. No wrapper element was found."), !1;
                typeof theme.Helpers.fadeIn === void 0 ? wrapper.style.display = "block" : typeof theme.Helpers.fadeIn == "function" && theme.Helpers.fadeIn(wrapper)
            }, initCarousel = wrapperId2 => {
                if (!wrapperId2) return console.log("Error. Must provide a wrapper element to initialze the carousel on."), !1;
                const carousel2 = document.getElementById(wrapperId2);
                if (!carousel2) return console.log("Error. No carousel element for recently viewed products found!"), !1;
                const flktyData = carousel2.dataset.flickityConfig, flktyOptions = JSON.parse(flktyData);
                Shopify.RecordViewedProducts.getCount() > grid && (flktyOptions.wrapAround = !0, flktyOptions.prevNextButtons = !0, flktyOptions.draggable = !0), new Flickity(carousel2, flktyOptions)
            }, afterComplete = (carousel2, container2, wrapperId2) => {
                revealOuterWrapper(container2.id), carousel2 === !0 && initCarousel(wrapperId2, this.container), Shopify.theme.quickview.init(), WAU.ProductGridVideo.init()
            }, viewedProduct = new ViewedProducts({
                howManyToShow: limit,
                wrapperId,
                onComplete: afterComplete.bind(this, carouselEnabled, container, wrapperId)
            })
    }

    return RecentlyViewed
}();
var selectors = {disclosureLocale: "[data-disclosure-locale]", disclosureCurrency: "[data-disclosure-currency]"};
theme.AnnouncementBarCarousel = function () {
    "use strict";

    function Carousel(container, settings2 = {}) {
        if (!container) return console.error("Error. No container for announcement bar carousel"), !1;
        const announcementSlider = container.querySelector(".js-announcement-carousel");
        if (announcementSlider) {
            const carouselConfig = announcementSlider.getAttribute("data-flickity-config"), finalCarouselOptions = {
                ...JSON.parse(carouselConfig), ...{
                    on: {
                        ready: function () {
                            this.element.classList.remove("is-hidden"), this.resize()
                        }
                    }
                }
            };
            let flkty = new Flickity(announcementSlider, finalCarouselOptions)
        }
    }

    return Carousel
}(), theme.AnnouncementBar = function () {
    function AnnouncementBar(container) {
        new theme.AnnouncementBarCarousel(container);
        const searchTrigger = document.querySelector(".js-search-trigger"),
            searchReveal = document.querySelector(".js-search-reveal"),
            currencySelector = document.querySelector(".shopify-currency-form select");
        this.container = container, this.cache = {}, this.cacheSelectors(), this.cache.localeDisclosure && (this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure)), this.cache.currencyDisclosure && (this.currencyDisclosure = new theme.Disclosure(this.cache.currencyDisclosure));
        const countrySelector = document.querySelectorAll(".disclosure__toggle");
        if (!countrySelector) return !1;

        function addActiveClass() {
            this.closest(".announcement__bar-section").classList.add("active")
        }

        function removeActiveClass() {
            const container2 = this.closest(".announcement__bar-section");
            setTimeout(function () {
                container2.classList.remove("active")
            }.bind(this), 500)
        }

        for (let i = 0; i < countrySelector.length; i++) {
            const child = countrySelector[i];
            child.addEventListener("click", addActiveClass), child.addEventListener("focus", addActiveClass), child.addEventListener("blur", removeActiveClass)
        }

        function AnnouncementCarousel() {
            const announcements = document.querySelectorAll(".js-announcement-carousel");
            if (!announcements) return !1;
            announcements.forEach(Carousel => {
                const flktyData = Carousel.getAttribute("data-flickity"), flktyOptions = JSON.parse(flktyData);
                new Flickity(Carousel, flktyOptions)
            })
        }

        document.addEventListener("shopify:section:unload", function (event2) {
            const Carousel = event2.target.closest(".js-announcement-carousel");
            if (!Carousel) return !1;
            Flickity.data(Carousel).destroy()
        }), document.addEventListener("shopify:block:select", function (event2) {
            const Carousel = event2.target.closest(".js-announcement-carousel");
            if (!Carousel) return !1;
            const flkty = Flickity.data(Carousel), Slide = event2.target.getAttribute("data-slider-index");
            flkty.select(Slide), flkty.pausePlayer()
        }), document.addEventListener("shopify:section:select", function (event2) {
            AnnouncementCarousel()
        }), document.addEventListener("shopify:section:deselect", function (event2) {
            const Carousel = event2.target.closest(".js-announcement-carousel");
            if (!Carousel) return !1;
            Flickity.data(Carousel).destroy()
        }), document.addEventListener("shopify:section:load", AnnouncementCarousel), WAU.Slideout.init("search-sidebar")
    }

    return AnnouncementBar.prototype = _.assignIn({}, AnnouncementBar.prototype, {
        cacheSelectors: function () {
            this.cache = {
                localeDisclosure: this.container.querySelector(selectors.disclosureLocale),
                currencyDisclosure: this.container.querySelector(selectors.disclosureCurrency)
            }
        }, onUnload: function () {
            this.cache.localeDisclosure && this.localeDisclosure.destroy(), this.cache.currencyDisclosure && this.currencyDisclosure.destroy()
        }
    }), AnnouncementBar
}(), theme.HeaderHoursOfOperation = function (container) {
    "use strict";
    const widget = container.querySelector(".js-hours-of-operations");
    if (!widget || !(widget.getAttribute("data-enable-highlighting") === "true")) return !1;
    let day = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"][new Date().getDay()];
    [...widget.querySelectorAll(".key")].filter(element => element.getAttribute("data-day") === day)[0].parentElement.classList.add("today")
}, theme.Header = function () {
    function Header(container) {
        container.querySelector(".js-hours-of-operations") && theme.HeaderHoursOfOperation(container);
        const el = document.querySelector(".wau--header");
        if (!el) return !1;
        new IntersectionObserver(([e]) => e.target.classList.toggle("is-stuck", e.intersectionRatio < 1), {threshold: [1]}).observe(el);

        function updateHeaderHeight() {
            const headerElement = document.querySelectorAll(".wau--header")[0];
            if (!headerElement) return !1;
            const negativeHeaderHeight = -1 * headerElement.offsetHeight;
            document.documentElement.style.setProperty("--header-height", negativeHeaderHeight + "px")
        }

        updateHeaderHeight(), document.addEventListener("load resize orientationchange", function () {
            window.innerWidth > 980 && updateHeaderHeight()
        }), document.addEventListener("shopify:section:load", function (event2) {
            window.innerWidth > 980 && updateHeaderHeight()
        }), document.addEventListener("shopify:section:unload", function (e) {
            window.innerWidth > 980 && updateHeaderHeight()
        });
        const menuItemsWithNestedDropdowns = document.querySelectorAll(".js-menuitem-with-nested-dropdown"),
            doubleTapToGoItems = document.querySelectorAll(".js-doubletap-to-go");
        theme.a11yHelpers.setUpAriaExpansion(), theme.a11yHelpers.setUpAccessibleNavigationMenus(), menuItemsWithNestedDropdowns.forEach(function (menuItem) {
            menuItem.addEventListener("mouseenter", function (event2) {
                const nestedDropdown = menuItem.querySelector(".js-dropdown-nested");
                nestedDropdown && theme.DOMHelpers.isElementPastEdge(nestedDropdown) && nestedDropdown.classList.add("dropdown--edge")
            })
        });

        function closeMenu(activeClass) {
            document.querySelectorAll(`[data-active-class="${activeClass}"]`).forEach(function (activeMenu) {
                activeMenu.classList.remove(activeClass)
            })
        }

        doubleTapToGoItems.forEach(function (doubleTapItem) {
            let preventClick = !1, prevEventTarget;
            const activeClass = doubleTapItem.getAttribute("data-active-class");
            Events.on("device:touchstart", function () {
                preventClick = !0
            }), doubleTapItem.addEventListener("click", function (event2) {
                preventClick && event2.preventDefault()
            }), doubleTapItem.addEventListener("touchstart", function (event2) {
                event2.target.setAttribute("aria-expanded", "false"), closeMenu(activeClass), prevEventTarget === event2.target ? preventClick = !1 : (event2.target.classList.toggle(activeClass), event2.target.setAttribute("aria-expanded", "true")), prevEventTarget = event2.target
            })
        }), WAU.Slideout.init("search-sidebar")
    }

    return Header.prototype = _.assignIn({}, Header.prototype, {
        onSelect: function () {
            WAU.Slideout.init("mobile-navigation")
        }
    }), Header
}(), theme.CarouselSection = function () {
    function CarouselSection(container) {
        const Carousels = document.querySelectorAll(".js-carousel");
        if (!Carousels) return !1;
        Carousels.forEach(Carousel => {
            const flktyData = Carousel.getAttribute("data-flickity"), flktyOptions = JSON.parse(flktyData);
            new Flickity(Carousel, flktyOptions)
        }), document.addEventListener("shopify:section:unload", function (event2) {
            const Carousel = event2.target.closest(".js-carousel");
            if (!Carousel) return !1;
            Flickity.data(Carousel).destroy()
        }), document.addEventListener("shopify:section:load", function (event2) {
            const Carousel = event2.target.closest(".js-carousel");
            if (!Carousel) return !1;
            const flktyData = Carousel.getAttribute("data-flickity"), flktyOptions = JSON.parse(flktyData);
            new Flickity(".js-carousel", flktyOptions)
        })
    }

    return CarouselSection
}(), theme.Slideshow = function () {
    function Slideshow(container) {
        const sectionId = container.dataset.sectionId;
        var slideshows = document.querySelectorAll(".js-slideshow");
        slideshows.forEach(Slideshow2 => {
            const iframes = Slideshow2.querySelector(".js-embed-player"),
                lazyImages = Slideshow2.querySelector(".js-slideshow-slide"), lazyCounter = 0,
                videoAudio = Slideshow2.dataset.videoAudio, sliderControls = Slideshow2.dataset.sliderControls,
                flktyData = Slideshow2.getAttribute("data-flickity"), flktyOptions = JSON.parse(flktyData);
            let flkty = new Flickity(Slideshow2, flktyOptions);
            const updateCells = function () {
                flkty.cells.forEach(function (cell, i) {
                    if (cell.element == flkty.selectedElement) {
                        const videoType = cell.element.dataset.slideType, videoAudio2 = cell.element.dataset.videoAudio;
                        (videoType == "youtube" || videoType == "video") && WAU.Video.init(cell.element, sectionId, flkty, videoAudio2);
                        return
                    }
                })
            };
            updateCells(), flkty.on("change", e => {
                updateCells()
            })
        })
    }

    return Slideshow
}(), theme.Slideshow.prototype = _.assignIn({}, theme.Slideshow.prototype, {
    onLoad: function (event2) {
        const flktyData = event2.target.closest(".js-slideshow").getAttribute("data-flickity"),
            flktyOptions = JSON.parse(flktyData);
        new Flickity(".slideshow", flktyOptions)
    }, onBlockSelect: function (event2) {
        const Slideshow = event2.target.closest(".js-slideshow"), flkty = Flickity.data(Slideshow),
            Slide = event2.target.getAttribute("data-slider-index");
        flkty.select(Slide), flkty.pausePlayer()
    }, onBlockDeselect: function () {
        const Slideshow = event.target.closest(".js-slideshow");
        Flickity.data(Slideshow).unpausePlayer()
    }
}), theme.Maps = function () {
    var google_api_loaded = !1;
    let allMaps = [];
    var events = new EventEmitter3;
    events.trigger = events.emit, window.gm_authFailure = function () {
        google_api_loaded = !1, Shopify.designMode ? events.trigger("gmauthfailure:themeeditor") : events.trigger("gmauthfailure")
    };
    const getScript = url => new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = url, script.async = !0, script.onerror = reject, script.onload = script.onreadystatechange = function () {
            const loadState = this.readyState;
            loadState && loadState !== "loaded" && loadState !== "complete" || (script.onload = script.onreadystatechange = null, resolve())
        }, document.head.appendChild(script)
    });

    function Map(container) {
        var config = container.querySelector("[data-map-config]").innerHTML, config = JSON.parse(config);
        if (!config.api_key) return !1;
        (function () {
            var element = container;
            events.on("gmauthfailure:themeeditor", error), events.on("map:error", error);

            function error() {
                element.classList.add("map-section-load-error")
            }
        })(), function () {
            var element = container.querySelector("[data-bg-image]");
            events.on("gmauthfailure", show);

            function show() {
                element.classList.add("show-image")
            }
        }(), function () {
            var element = container.querySelector("[data-map-overlay]");
            events.on("gmauthfailure:themeeditor", error), events.on("map:error", error);

            function error(message) {
                message = message || config.auth_error, element.innerHTML = '<div class="map-section-error errors text-center">' + message + "</div>"
            }
        }();

        function map() {
            var element = container.querySelector("[data-map]");
            events.on("ready", geolocate);

            function geolocate() {
                var geocoder = new google.maps.Geocoder;
                geocoder.geocode({address: config.address}, function (results, status) {
                    status == google.maps.GeocoderStatus.OK ? render2(results) : error(status)
                })
            }

            function render2(results) {
                element.innerHTML = "";
                var map2 = new google.maps.Map(element, {
                    zoom: config.zoom,
                    center: results[0].geometry.location,
                    draggable: !1,
                    clickableIcons: !1,
                    scrollwheel: !1,
                    disableDoubleClickZoom: !0,
                    styles: config.styles,
                    disableDefaultUI: !0
                }), center = map2.getCenter();
                new google.maps.Marker({
                    map: map2,
                    position: center
                }), google.maps.event.addDomListener(window, "resize", function () {
                    theme.Helpers.debounce(function () {
                        google.maps.event.trigger(map2, "resize"), map2.setCenter(center)
                    }, 250)
                }), document.addEventListener("shopify:section:unload", function () {
                    google.maps.event.clearListeners(map2, "resize")
                })
            }

            function error(status) {
                var message = config.address_error;
                switch (status) {
                    case"ZERO_RESULTS":
                        message = config.address_no_results;
                        break;
                    case"OVER_QUERY_LIMIT":
                        message = config.address_query_limit;
                        break;
                    case"REQUEST_DENIED":
                        message = config.auth_error;
                        break
                }
                Shopify.designMode && events.trigger("map:error", message)
            }
        }

        map(container), google_api_loaded === !0 ? events.trigger("ready") : google_api_loaded !== "loading" && (google_api_loaded = "loading", typeof window.google > "u" && getScript("https://maps.googleapis.com/maps/api/js?key=" + config.api_key + "&callback=initMap").then(() => {
            google_api_loaded = !0, events.trigger("ready")
        }).catch(() => {
            events.trigger("map:error", "Could not load map with API key. Check billing with Google."), console.error("Could not load script with api given")
        }))
    }

    return Map.prototype = _.assignIn({}, Map.prototype, {}), Map
}(), theme.ScrollingAnnouncements = function () {
    function ScrollingAnnouncements(container) {
        if (!container) return console.log("Error. Container element required for scrolling slideshow."), !1;
        var announcementSlider = container.querySelector(".scrolling__announcements--carousel");
        if (!announcementSlider) return console.log("Error. Could not find announcement slider element with Flickity data."), !1;
        var flktyData = announcementSlider.getAttribute("data-flickity-config"),
            sectionBlocksSize = parseInt(announcementSlider.getAttribute("data-section-blocks-size")),
            ifEnoughBlocks = sectionBlocksSize > 1, flktyOptions = JSON.parse(flktyData);
        window.matchMedia("screen and (max-width: 980px)").matches && (flktyOptions.wrapAround = !0, flktyOptions.draggable = ifEnoughBlocks), new Flickity(announcementSlider, flktyOptions)
    }

    return ScrollingAnnouncements
}(), theme.ScrollingAnnouncements.prototype = _.assignIn({}, theme.ScrollingAnnouncements.prototype, {
    onBlockSelect: event2 => {
        var announcementSlider = event2.target.closest(".scrolling__announcements--carousel"),
            flkty = Flickity.data(announcementSlider), Slide = event2.target.getAttribute("data-slider-index");
        flkty.select(Slide), flkty.pausePlayer()
    }, onBlockDeselect: event2 => {
        var announcementSlider = event2.target.closest(".scrolling__announcements--carousel"),
            flkty = Flickity.data(announcementSlider);
        flkty.unpausePlayer()
    }
}), theme.mobileNav = function () {
    function mobileNav(container) {
        var sectionId = container.dataset.sectionId;
        WAU.Slideout.init("mobile-navigation")
    }

    return mobileNav.prototype = _.assignIn({}, mobileNav.prototype, {
        onSelect: function () {
            WAU.Slideout._openByName("mobile-navigation")
        }, onDeselect: function () {
            WAU.Slideout._closeByName("mobile-navigation")
        }, onBlockSelect: function () {
            WAU.Slideout._openByName("mobile-navigation")
        }
    }), mobileNav
}(), theme.Collection = function () {
    (function () {
        document.addEventListener("DOMContentLoaded", function () {
            document.querySelectorAll(".js-parent-menu").forEach(function (parentMenu) {
                const toggleLink = parentMenu.querySelector(".js-collection-sidemenu-toggle"),
                    nestedUl = parentMenu.querySelector("ul.nested");
                parentMenu.classList.contains("open") || (nestedUl.style.display = "none", parentMenu.classList.add("closed")), toggleLink.addEventListener("click", function (event2) {
                    event2.preventDefault(), parentMenu.classList.toggle("open"), nestedUl.style.display = parentMenu.classList.contains("open") ? "block" : "none", parentMenu.classList.toggle("closed"), toggleLink.setAttribute("aria-expanded", parentMenu.classList.contains("open"))
                })
            })
        })
    })();

    function Collection(container) {
        (container.querySelector("[data-collection-filters]") || container.querySelector("[data-collection-sidebar-filters]")) && (theme.CollectionFilters.init(container, container.dataset.sectionId), initToggleSidebar("collection")), container.querySelector("[data-collection-infinite-scroll]") && theme.CollectionFilters.infiniteScroll()
    }

    return Collection.prototype = _.assignIn({}, Collection.prototype, {}), Collection
}(), theme.CollectionFilters = {
    init: function (container, sectionId) {
        (container.querySelector("[data-collection-filters-hz]") || container.querySelector("[data-collection-sort-by]")) && (theme.CollectionFilters.horizontalFilters(container), theme.CollectionFilters.currentFilters()), container.querySelector("[data-collection-sidebar-filters]") && (WAU.Slideout.init("collection-sidebar"), theme.CollectionFilters.sidebarFilters(), theme.CollectionFilters.stickySidebar()), container.querySelector("[data-collection-filters-price-range]") && (theme.CollectionFilters.priceRange(), theme.CollectionFilters.priceSlider()), this.filterData = []
    }, horizontalFilters: function (container) {
        document.querySelectorAll(".js-hz-filter").forEach((item, i) => {
            const inputField = item.querySelector(".js-hz-filter-input"),
                dropdown = item.querySelector(".js-hz-filter-list"), dropdownArray = [...item.querySelectorAll("li")];
            let valueArray = [];
            dropdownArray.forEach(item2 => {
                let searchLabel = item2.querySelector(".js-hz-filter-label");
                if (!searchLabel) return !1;
                valueArray.push(searchLabel.textContent)
            });
            const closeDropdown = () => {
                dropdown.classList.remove("open")
            };
            inputField.addEventListener("input", () => {
                dropdown.classList.add("open");
                let inputValue = inputField.value.toLowerCase(), valueSubstring;
                if (inputValue.length > 0) for (let j = 0; j < valueArray.length; j++) inputValue.substring(0, inputValue.length) !== valueArray[j].substring(0, inputValue.length).toLowerCase() ? dropdownArray[j].classList.add("closed") : dropdownArray[j].classList.remove("closed"); else for (let i2 = 0; i2 < dropdownArray.length; i2++) dropdownArray[i2].classList.remove("closed")
            }), dropdownArray.forEach(item2 => {
                item2.addEventListener("click", evt => {
                    item2.querySelector('input[type="checkbox"]').checked ? (item2.classList.remove("current"), item2.querySelector('input[type="checkbox"]').checked = !1) : (item2.classList.add("current"), item2.querySelector('input[type="checkbox"]').checked = !0), item2.getAttribute("data-placeholder") && (inputField.placeholder = item2.dataset.placeholder);
                    const formData = new FormData(inputField.closest("form")),
                        searchParams = new URLSearchParams(formData).toString();
                    theme.CollectionFilters.renderPage(searchParams), dropdownArray.forEach(dropdown2 => {
                        dropdown2.classList.add("closed")
                    })
                })
            }), inputField.addEventListener("focus", () => {
                inputField.placeholder = inputField.dataset.genericPlaceholder, inputField.classList.add("active"), dropdown.classList.add("open"), dropdownArray.forEach(dropdown2 => {
                    dropdown2.classList.remove("closed")
                })
            }), inputField.addEventListener("blur", () => {
                inputField.placeholder = inputField.dataset.placeholder, inputField.classList.remove("active"), setTimeout(() => {
                    dropdown.classList.remove("open")
                }, 500)
            }), document.addEventListener("click", evt => {
                const isDropdown = dropdown.contains(evt.target), isInput = inputField.contains(evt.target);
                !isDropdown && !isInput && dropdown.classList.remove("open")
            })
        }), container.contains(container.querySelector(".js-show-filters")) && new theme.HorizontalFiltersToggle("collection-toolbar", {
            selectors: {
                button: ".js-show-filters",
                wrapper: "collection__filter-wrapper"
            }
        })
    }, priceRange: function () {
        const filters = document.querySelectorAll(".js-filter-range-input");
        filters.length > 0 && filters.forEach((item, i) => {
            item.addEventListener("change", function (event2) {
                setTimeout(function () {
                    const formData = new FormData(item.closest("form")),
                        searchParams = new URLSearchParams(formData).toString();
                    theme.CollectionFilters.renderPage(searchParams)
                }, 1e3)
            })
        }), document.querySelectorAll(".js-hz-filter-price-trigger").forEach((item, i) => {
            document.addEventListener("click", function (event2) {
                const dropdown = item.nextElementSibling,
                    isTrigger = event2.target.classList.contains("js-hz-filter-price-trigger"),
                    isDropdown = dropdown.contains(event2.target);
                if (isTrigger && event2.preventDefault(), !isDropdown && !isTrigger && (item.classList.remove("active"), dropdown.style.display = "none"), !isTrigger) return !1;
                dropdown.style.display == "inline-block" ? (item.classList.remove("active"), dropdown.style.display = "none") : (item.classList.add("active"), dropdown.style.display = "inline-block")
            });
            let mouseDown = !1;
            item.addEventListener("mousedown", () => {
                mouseDown = !0
            }), item.addEventListener("mouseup", () => {
                mouseDown = !1
            }), item.addEventListener("focus", event2 => {
                if (!mouseDown) {
                    const dropdown = event2.target.nextElementSibling;
                    item.classList.add("active"), dropdown.style.display = "inline-block"
                }
            }), document.addEventListener("keyup", event2 => {
                if (event2.keyCode == 9) {
                    const dropdown = document.querySelector(".js-hz-filter-price-dropdown");
                    document.querySelector(".js-hz-filter-price").contains(event2.target) || (item.classList.remove("active"), dropdown.style.display = "none")
                }
            })
        })
    }, priceSlider: function () {
        var parents = document.querySelectorAll(".js-price-range");
        if (!parents) return !1;
        parents.forEach((parent, i) => {
            var rangeS = parent.querySelectorAll("input[type=range]"),
                numberS = parent.querySelectorAll("input[type=number]");
            rangeS.forEach(function (el) {
                el.oninput = function () {
                    var slide1 = parseFloat(rangeS[0].value), slide2 = parseFloat(rangeS[1].value),
                        slide1Dec = (Math.round(slide1 * 100) / 100).toFixed(2),
                        slide2Dec = (Math.round(slide2 * 100) / 100).toFixed(2);
                    parseFloat(slide1Dec) > parseFloat(slide2Dec) && ([slide1Dec, slide2Dec] = [slide2Dec, slide1Dec]), numberS[0].value = slide1Dec, numberS[1].value = slide2Dec
                }
            }), rangeS[0].onchange = function () {
                numberS[0].dispatchEvent(new Event("change", {bubbles: !0}))
            }, rangeS[1].onchange = function () {
                numberS[1].dispatchEvent(new Event("change", {bubbles: !0}))
            }, numberS.forEach(function (el) {
                el.oninput = function () {
                    var number1 = parseFloat(numberS[0].value), number2 = parseFloat(numberS[1].value),
                        number1Dec = (Math.round(number1 * 100) / 100).toFixed(2),
                        number2Dec = (Math.round(number2 * 100) / 100).toFixed(2);
                    if (number1Dec > number2Dec) {
                        var tmp = number1Dec;
                        numberS[0].value = number2Dec, numberS[1].value = tmp
                    }
                    rangeS[0].value = number1Dec, rangeS[1].value = number2Dec
                }
            })
        })
    }, currentFilters: function () {
        document.querySelectorAll(".js-current-filter").forEach((item, i) => {
            item.addEventListener("click", event2 => {
                event2.preventDefault(), theme.CollectionFilters.onActiveFilterClick(event2)
            })
        })
    }, sidebarFilters: function () {
        document.querySelectorAll(".js-collection-side-filter").forEach((item, i) => {
            item.addEventListener("click", event2 => {
                event2.preventDefault(), item.querySelector('input[type="checkbox"]').checked ? (item.classList.remove("current"), item.querySelector('input[type="checkbox"]').checked = !1) : (item.classList.add("current"), item.querySelector('input[type="checkbox"]').checked = !0);
                const formData = new FormData(item.closest("form")),
                    searchParams = new URLSearchParams(formData).toString();
                theme.CollectionFilters.renderPage(searchParams)
            })
        })
    }, stickySidebar: function () {
        window.innerWidth > 980 && stickySidebar3(), document.addEventListener("load resize orientationchange", function () {
            window.innerWidth > 980 && stickySidebar3()
        }), document.addEventListener("shopify:section:load", function (event2) {
            window.innerWidth > 980 && stickySidebar3()
        });

        function stickySidebar3() {
            var stickyEl = document.querySelectorAll(".is_sticky");
            if (!stickyEl) return !1;
            const header = document.querySelector("header"), HHeight = header.clientHeight;
            OffSet = Number(HHeight) + 10, stickybits(".is_sticky", {stickyBitStickyOffset: OffSet})
        }
    }, infiniteScroll: function () {
        if (!document.querySelector(".paginate_next")) return;
        let elem = document.querySelector("[data-collection-infinite-scroll]");
        if (!elem) return !1;
        let infScroll = new InfiniteScroll(elem, {
            path: ".paginate_next",
            append: ".is_infinite .product-index",
            hideNav: "#pagination",
            history: !1
        })
    }, renderFilters: function () {
        if ((document.querySelector("[data-collection-filters-hz]") || document.querySelector("[data-collection-sort-by]")) && (theme.CollectionFilters.horizontalFilters(), theme.CollectionFilters.currentFilters()), document.querySelector("[data-collection-sidebar-filters]") && (WAU.Slideout._reloadSlideoutContents("collection-sidebar"), WAU.Slideout.init("collection-sidebar"), theme.CollectionFilters.sidebarFilters(), theme.CollectionFilters.stickySidebar()), document.querySelector("[data-collection-filters-price-range]") && (theme.CollectionFilters.priceRange(), theme.CollectionFilters.priceSlider()), document.querySelector("[data-collection-infinite-scroll]") && theme.CollectionFilters.infiniteScroll(), document.querySelector("[data-collection-sort-by]") && document.querySelector("[data-collection-sort-by]").querySelector(".current")) {
            const placeholder = document.querySelector("[data-collection-sort-by]").querySelector(".current").dataset.placeholder;
            document.querySelector("[data-collection-sort-by]").querySelector(".js-hz-filter-input").placeholder = placeholder
        }
        Shopify.theme.quickview.init(), WAU.ProductGridVideo.init(), initToggleSidebar("collection")
    }, renderSectionFromFetch: function (url, section) {
        fetch(url).then(response => response.text()).then(responseText => {
            const html = responseText;
            this.filterData = [...this.filterData, {
                html,
                url
            }], theme.CollectionFilters.renderProductGrid(html), theme.CollectionFilters.renderFilters()
        })
    }, renderSectionFromCache: function (filterDataUrl, section) {
        const html = this.filterData.find(filterDataUrl).html;
        theme.CollectionFilters.renderProductGrid(html), theme.CollectionFilters.renderFilters()
    }, renderPage: function (searchParams, updateURLHash3 = !0) {
        theme.CollectionFilters.getSections().forEach(section => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`,
                filterDataUrl = element => element.url === url;
            this.filterData.some(filterDataUrl) ? theme.CollectionFilters.renderSectionFromCache(filterDataUrl, section) : theme.CollectionFilters.renderSectionFromFetch(url, section)
        }), updateURLHash3 && theme.CollectionFilters.updateURLHash(searchParams)
    }, renderProductGrid: function (html) {
        const innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("CollectionProductGrid").innerHTML;
        document.getElementById("CollectionProductGrid").innerHTML = innerHTML
    }, onActiveFilterClick: function (event2) {
        event2.preventDefault(), theme.CollectionFilters.renderPage(new URL(event2.currentTarget.href).searchParams.toString())
    }, updateURLHash: function (searchParams) {
        history.pushState({searchParams}, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`)
    }, getSections: function () {
        return [{
            id: "main-collection-product-grid",
            section: document.getElementById("main-collection-product-grid").dataset.id
        }]
    }
};

function initToggleSidebar(name) {
    if (!name) return console.error("Error. There is no name."), !1;

    function checkSupport() {
        return theme.Helpers.getCookie === void 0 || theme.Helpers.setCookie === void 0 ? (console.error("Missing theme helper function."), !1) : !0
    }

    if (!checkSupport()) return console.error("Error. Missing helper functions."), !1;
    var button = document.querySelector(".js-show--hide"), sidebar = document.querySelector(".js-desktop-sidebar"),
        content = document.querySelector(".js-collection-content");
    if (!button) return !1;
    button.addEventListener("click", function (event2) {
        event2.preventDefault(), sidebar.style.display === "none" ? (sidebar.style.display = "", content.classList.remove("extended"), button.classList.remove("sidebar--hidden"), theme.Helpers.setCookie(`${name}-toggleState`, "show", 1 / 24)) : (sidebar.style.display = "none", content.classList.add("extended"), button.classList.add("sidebar--hidden"), theme.Helpers.setCookie(`${name}-toggleState`, "hide", 1 / 24))
    });
    var toggleState = theme.Helpers.getCookie(`${name}-toggleState`);
    toggleState === "hide" && (sidebar.style.display = "none", content.classList.add("extended"))
}

theme.HorizontalFiltersToggle = function () {
    "use strict";
    const defaults = {selectors: {button: ".js-show-filters", wrapper: "collection__filter-wrapper"}};

    function HorizontalFiltersToggle(name, options) {
        this.name = name, this.options = options, this.settings = Object.assign({}, defaults, this.options), this.button = document.querySelector(this.settings.selectors.button), this.wrapper = document.querySelector(`#${this.settings.selectors.wrapper}`), this.init = this.init.bind(this), this.destroy = this.destroy.bind(this), this._handleClick = this._handleClick.bind(this), this._checkSupport(), this.init()
    }

    return HorizontalFiltersToggle.prototype = Object.assign({}, HorizontalFiltersToggle.prototype, {
        _checkSupport: function () {
            return typeof theme.Helpers.setCookie != "function" ? (console.error("Error. Theme helper setCookie does not exist."), !1) : typeof theme.Helpers.getCookie != "function" ? (console.error("Error. Theme helper getCookie does not exist."), !1) : !0
        }, _handleClick: function (event2) {
            event2.preventDefault(), this.wrapper.classList.contains("open") ? (this.wrapper.classList.remove("open"), theme.Helpers.setCookie(`${this.name}-toggleState`, "hide", 1 / 24)) : (this.wrapper.classList.add("open"), theme.Helpers.setCookie(`${this.name}-toggleState`, "show", 1 / 24))
        }, init: function () {
            this.button.addEventListener("click", this._handleClick);
            const toggleState = theme.Helpers.getCookie(`${this.name}-toggleState`);
            toggleState !== null && this.wrapper.classList.toggle("open", toggleState !== "hide")
        }, destroy: function () {
            this.button.removeEventListener("click", this._handleClick)
        }
    }), HorizontalFiltersToggle
}(), theme.Search = function () {
    function Search(container) {
        container.querySelector("[data-search-filters]") && (theme.SearchFilters.init(container, container.dataset.sectionId), initToggleSidebar("search"))
    }

    return Search.prototype = _.assignIn({}, Search.prototype, {}), Search
}(), theme.SearchFilters = {
    init: function (container, sectionId) {
        theme.SearchFilters.horizontalFilters(container), theme.SearchFilters.currentFilters(), container.querySelector("[data-search-filters-price-range]") && (theme.SearchFilters.priceRange(), theme.SearchFilters.priceSlider()), container.querySelector("[data-collection-sidebar-filters]") && (WAU.Slideout.init("collection-sidebar"), theme.SearchFilters.sidebarFilters(), theme.SearchFilters.stickySidebar()), container.querySelector("[data-collection-infinite-scroll]") && theme.SearchFilters.infiniteScroll(), this.filterData = []
    }, horizontalFilters: function (container) {
        document.querySelectorAll(".js-hz-filter").forEach((item, i) => {
            const inputField = item.querySelector(".js-hz-filter-input"),
                dropdown = item.querySelector(".js-hz-filter-list"), dropdownArray = [...item.querySelectorAll("li")];
            let valueArray = [];
            dropdownArray.forEach(item2 => {
                let searchLabel = item2.querySelector(".js-hz-filter-label");
                if (!searchLabel) return !1;
                valueArray.push(searchLabel.textContent)
            });
            const closeDropdown = () => {
                dropdown.classList.remove("open")
            };
            inputField.addEventListener("input", () => {
                dropdown.classList.add("open");
                let inputValue = inputField.value.toLowerCase(), valueSubstring;
                if (inputValue.length > 0) for (let j = 0; j < valueArray.length; j++) inputValue.substring(0, inputValue.length) !== valueArray[j].substring(0, inputValue.length).toLowerCase() ? dropdownArray[j].classList.add("closed") : dropdownArray[j].classList.remove("closed"); else for (let i2 = 0; i2 < dropdownArray.length; i2++) dropdownArray[i2].classList.remove("closed")
            }), dropdownArray.forEach(item2 => {
                item2.addEventListener("click", evt => {
                    item2.querySelector('input[type="checkbox"]').checked ? (item2.classList.remove("current"), item2.querySelector('input[type="checkbox"]').checked = !1) : (item2.classList.add("current"), item2.querySelector('input[type="checkbox"]').checked = !0), item2.getAttribute("data-placeholder") && (inputField.placeholder = item2.dataset.placeholder);
                    const formData = new FormData(inputField.closest("form")),
                        searchParams = new URLSearchParams(formData).toString(),
                        query = `q=${new URL(window.location).searchParams.get("q")}`;
                    theme.SearchFilters.renderPage(query + "&" + searchParams), dropdownArray.forEach(dropdown2 => {
                        dropdown2.classList.add("closed")
                    })
                })
            }), inputField.addEventListener("focus", () => {
                inputField.placeholder = inputField.dataset.genericPlaceholder, inputField.classList.add("active"), dropdown.classList.add("open"), dropdownArray.forEach(dropdown2 => {
                    dropdown2.classList.remove("closed")
                })
            }), inputField.addEventListener("blur", () => {
                inputField.placeholder = inputField.dataset.placeholder, inputField.classList.remove("active"), setTimeout(() => {
                    dropdown.classList.remove("open")
                }, 500)
            }), document.addEventListener("click", evt => {
                const isDropdown = dropdown.contains(evt.target), isInput = inputField.contains(evt.target);
                !isDropdown && !isInput && dropdown.classList.remove("open")
            })
        }), container.contains(container.querySelector(".js-show-filters")) && new theme.HorizontalFiltersToggle("collection-toolbar", {
            selectors: {
                button: ".js-show-filters",
                wrapper: "collection__filter-wrapper"
            }
        })
    }, infiniteScroll: function () {
        if (console.log("infiniteScroll"), !document.querySelector(".paginate_next")) return;
        let elem = document.querySelector("[data-collection-infinite-scroll]");
        if (!elem) return;
        let infScroll = new InfiniteScroll(elem, {
            path: ".paginate_next",
            append: ".is_infinite .product-index",
            hideNav: "#pagination",
            history: !1
        })
    }, handleClick: function (event2) {
        const target = event2.target;
        if (!target.matches(".js-collection-side-filter")) return;
        const checkbox = target.querySelector('input[type="checkbox"]');
        if (!checkbox) return;
        event2.preventDefault(), checkbox.checked ? (target.classList.remove("current"), checkbox.checked = !1) : (target.classList.add("current"), checkbox.checked = !0);
        const formData = new FormData(target.closest("form")), searchParams = new URLSearchParams(formData).toString(),
            query = `q=${new URL(window.location).searchParams.get("q")}`;
        theme.SearchFilters.renderPage(query + "&" + searchParams)
    }, sidebarFilters: function () {
        document.addEventListener("click", theme.SearchFilters.handleClick)
    }, stickySidebar: function () {
        window.innerWidth > 980 && stickySidebar3(), document.addEventListener("load resize orientationchange", function () {
            window.innerWidth > 980 && stickySidebar3()
        }), document.addEventListener("shopify:section:load", function (event2) {
            window.innerWidth > 980 && stickySidebar3()
        });

        function stickySidebar3() {
            var stickyEl = document.querySelectorAll(".is_sticky");
            if (!stickyEl) return !1;
            const header = document.querySelector("header"), HHeight = header.clientHeight;
            OffSet = Number(HHeight) + 10, stickybits(".is_sticky", {stickyBitStickyOffset: OffSet})
        }
    }, priceRange: function () {
        const filters = document.querySelectorAll(".js-filter-range-input");
        filters.length > 0 && filters.forEach((item, i) => {
            item.addEventListener("change", function (event2) {
                setTimeout(function () {
                    const formData = new FormData(item.closest("form")),
                        searchParams = new URLSearchParams(formData).toString(),
                        query = `q=${new URL(window.location).searchParams.get("q")}`;
                    theme.SearchFilters.renderPage(query + "&" + searchParams)
                }, 1e3)
            })
        }), document.querySelectorAll(".js-hz-filter-price-trigger").forEach((item, i) => {
            document.addEventListener("click", function (event2) {
                const dropdown = item.nextElementSibling,
                    isTrigger = event2.target.classList.contains("js-hz-filter-price-trigger"),
                    isDropdown = dropdown.contains(event2.target);
                if (isTrigger && event2.preventDefault(), !isDropdown && !isTrigger && (item.classList.remove("active"), dropdown.style.display = "none"), !isTrigger) return !1;
                dropdown.style.display == "inline-block" ? (item.classList.remove("active"), dropdown.style.display = "none") : (item.classList.add("active"), dropdown.style.display = "inline-block")
            });
            let mouseDown = !1;
            item.addEventListener("mousedown", () => {
                mouseDown = !0
            }), item.addEventListener("mouseup", () => {
                mouseDown = !1
            }), item.addEventListener("focus", event2 => {
                if (!mouseDown) {
                    const dropdown = event2.target.nextElementSibling;
                    item.classList.add("active"), dropdown.style.display = "inline-block"
                }
            }), document.addEventListener("keyup", event2 => {
                if (event2.keyCode == 9) {
                    const dropdown = document.querySelector(".js-hz-filter-price-dropdown");
                    document.querySelector(".js-hz-filter-price").contains(event2.target) || (item.classList.remove("active"), dropdown.style.display = "none")
                }
            })
        })
    }, priceSlider: function () {
        var parents = document.querySelectorAll(".js-price-range");
        if (!parents) return !1;
        parents.forEach((parent, i) => {
            var rangeS = parent.querySelectorAll("input[type=range]"),
                numberS = parent.querySelectorAll("input[type=number]");
            rangeS.forEach(function (el) {
                el.oninput = function () {
                    var slide1 = parseFloat(rangeS[0].value), slide2 = parseFloat(rangeS[1].value),
                        slide1Dec = (Math.round(slide1 * 100) / 100).toFixed(2),
                        slide2Dec = (Math.round(slide2 * 100) / 100).toFixed(2);
                    parseFloat(slide1Dec) > parseFloat(slide2Dec) && ([slide1Dec, slide2Dec] = [slide2Dec, slide1Dec]), numberS[0].value = slide1Dec, numberS[1].value = slide2Dec
                }
            }), rangeS[0].onchange = function () {
                numberS[0].dispatchEvent(new Event("change", {bubbles: !0}))
            }, rangeS[1].onchange = function () {
                numberS[1].dispatchEvent(new Event("change", {bubbles: !0}))
            }, numberS.forEach(function (el) {
                el.oninput = function () {
                    var number1 = parseFloat(numberS[0].value), number2 = parseFloat(numberS[1].value),
                        number1Dec = (Math.round(number1 * 100) / 100).toFixed(2),
                        number2Dec = (Math.round(number2 * 100) / 100).toFixed(2);
                    if (number1Dec > number2Dec) {
                        var tmp = number1Dec;
                        numberS[0].value = number2Dec, numberS[1].value = tmp
                    }
                    rangeS[0].value = number1Dec, rangeS[1].value = number2Dec
                }
            })
        })
    }, currentFilters: function () {
        document.querySelectorAll(".js-current-filter").forEach((item, i) => {
            item.addEventListener("click", event2 => {
                event2.preventDefault(), theme.SearchFilters.onActiveFilterClick(event2)
            })
        })
    }, renderFilters: function () {
        if (theme.SearchFilters.horizontalFilters(), theme.SearchFilters.currentFilters(), document.querySelector("[data-collection-sidebar-filters]") && (WAU.Slideout._reloadSlideoutContents("collection-sidebar"), WAU.Slideout.init("collection-sidebar"), theme.SearchFilters.sidebarFilters(), theme.SearchFilters.stickySidebar()), document.querySelector("[data-search-filters-price-range]") && (theme.SearchFilters.priceRange(), theme.SearchFilters.priceSlider()), document.querySelector("[data-collection-sort-by]") && document.querySelector("[data-collection-sort-by]").querySelector(".current")) {
            const placeholder = document.querySelector("[data-collection-sort-by]").querySelector(".current").dataset.placeholder;
            document.querySelector("[data-collection-sort-by]").querySelector(".js-hz-filter-input").placeholder = placeholder
        }
        Shopify.theme.quickview.init(), WAU.ProductGridVideo.init(), initToggleSidebar("search")
    }, renderSectionFromFetch: function (url, section) {
        fetch(url).then(response => response.text()).then(responseText => {
            const html = responseText;
            this.filterData = [...this.filterData, {
                html,
                url
            }], theme.SearchFilters.renderSearchGrid(html), theme.SearchFilters.renderFilters()
        })
    }, renderSectionFromCache: function (filterDataUrl, section) {
        const html = this.filterData.find(filterDataUrl).html;
        theme.SearchFilters.renderSearchGrid(html), theme.SearchFilters.renderFilters()
    }, renderPage: function (searchParams, updateURLHash3 = !0) {
        theme.SearchFilters.getSections().forEach(section => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`,
                filterDataUrl = element => element.url === url;
            this.filterData.some(filterDataUrl) ? theme.SearchFilters.renderSectionFromCache(filterDataUrl, section) : theme.SearchFilters.renderSectionFromFetch(url, section)
        }), updateURLHash3 && theme.SearchFilters.updateURLHash(searchParams)
    }, renderSearchGrid: function (html) {
        const innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("searchResultsWrapper").innerHTML;
        document.getElementById("searchResultsWrapper").innerHTML = innerHTML
    }, onActiveFilterClick: function (event2) {
        event2.preventDefault();
        const searchParams = new URL(event2.currentTarget.href).searchParams.toString(),
            searchString = new URL(window.location).searchParams.get("q"),
            clearButtonShowProducts = event2.target.classList.contains("clear-tags") && event2.target.hasAttribute("data-products-only");
        var finalSearchParams = searchParams || (clearButtonShowProducts ? "q=" + searchString + "&type=product" : "q=" + searchString);
        theme.SearchFilters.renderPage(finalSearchParams)
    }, updateURLHash: function (searchParams) {
        history.pushState({searchParams}, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`)
    }, getSections: function () {
        return [{id: "main-search-results", section: document.getElementById("main-search-results").dataset.id}]
    }
}, theme.Parallax = function () {
    function Parallax(container) {
        var sectionId = container.dataset.sectionId, Scale = container.dataset.scale,
            image = container.querySelectorAll("img"), initParallaxSection = function (ParallaxSection) {
                new simpleParallax(image, {
                    scale: Scale,
                    delay: .3,
                    customWrapper: "parallax-image",
                    transition: "cubic-bezier(0,0,0,1)"
                })
            };
        initParallaxSection(image), document.addEventListener("shopify:section:load", function (event2) {
            event2.detail.sectionId == sectionId && initParallaxSection(image)
        })
    }

    return Parallax
}(), theme.Parallax.prototype = _.assignIn({}, theme.Parallax.prototype, {});
var selectors = {disclosureLocale: "[data-disclosure-locale]", disclosureCurrency: "[data-disclosure-currency]"};
theme.Footer = function () {
    function Footer(container) {
        this.container = container, this.cache = {}, this.cacheSelectors(), this.cache.localeDisclosure && (this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure)), this.cache.currencyDisclosure && (this.currencyDisclosure = new theme.Disclosure(this.cache.currencyDisclosure))
    }

    return Footer.prototype = _.assignIn({}, Footer.prototype, {
        cacheSelectors: function () {
            this.cache = {
                localeDisclosure: this.container.querySelector(selectors.disclosureLocale),
                currencyDisclosure: this.container.querySelector(selectors.disclosureCurrency)
            }
        }, onUnload: function () {
            this.cache.localeDisclosure && this.localeDisclosure.destroy(), this.cache.currencyDisclosure && this.currencyDisclosure.destroy()
        }
    }), Footer
}(), theme.Password = function () {
    function Password(container) {
        window.addEventListener("DOMContentLoaded", event2 => {
            if (document.querySelector(".errors")) WAU.Slideout._openByName("password"); else return !1
        }), WAU.Slideout.init("password"), window.addEventListener("shopify:section:select", event2 => {
            WAU.Slideout.init("password")
        })
    }

    return Password.prototype = _.assignIn({}, Password.prototype, {}), Password
}();
const VideoTT = {
    init(container) {
        var tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }, playerBuild() {
        document.querySelectorAll('[data-section-type="background-video"]').forEach(function (container, i) {
            var player, selector = "js-alternative-yt-" + container.dataset.sectionId,
                ytcontainer = container.querySelector("#js-alternative-yt-" + container.dataset.sectionId),
                caption = container.querySelector(".background-video__caption");
            if (caption) var showButtonsOnly = caption.classList.contains("tablet-hide");
            let autoPlay = 1;
            const minWidth = 500;
            if (!ytcontainer) return !1;
            window.matchMedia("(max-width: (minWidth)px)") && (autoPlay = 0), player = new YT.Player(selector, {
                videoId: ytcontainer.dataset.id,
                playerVars: {autoplay: autoPlay, controls: 0, loop: 1, playlist: ytcontainer.dataset.id},
                events: {onReady: VideoTT.onPlayerReady}
            });
            let playBtn = container.querySelector(".js-play-video");
            playBtn && playBtn.addEventListener("click", function (event2) {
                player.playVideo(), showButtonsOnly ? caption.style.display = "none" : playBtn.style.display = "none"
            })
        })
    }, onPlayerReady(event2) {
        event2.target.mute(), window.matchMedia("(max-width: (minWidth)px)") && event2.target.playVideo()
    }
};
theme.BackgroundVideo = function () {
    function BackgroundVideo(container) {
        var config = JSON.parse(container.dataset.videoConfig || "{}"), selectorId = config.sectionId,
            selector = ".js-bg-video-" + selectorId;
        if (!config.mp4) container.querySelector(".js-has-yt") && VideoTT.init(container); else {
            var options = {mp4: config.mp4, poster: config.poster}, instance = new vidbg(selector, options),
                vid = selector + " video", vid = document.querySelector(vid);
            vid.muted = !0
        }
    }

    return BackgroundVideo
}(), theme.BackgroundVideo.prototype = _.assignIn({}, theme.BackgroundVideo.prototype, {
    onSectionLoad: event2 => {
        if (event2.target.querySelector('[data-section-type="background-video"]')) {
            var container = event2.target.querySelector('[data-section-type="background-video"]');
            theme.BackgroundVideo(container), container.querySelector(".js-has-yt") && VideoTT.init(container)
        }
    }, onSelect: event2 => {
        if (event2.target.querySelector('[data-section-type="background-video"]')) {
            var container = event2.target.querySelector('[data-section-type="background-video"]');
            container.querySelector(".js-has-yt") && VideoTT.playerBuild()
        }
    }
}), theme.CustomerAccount = function () {
    function CustomerAccount() {
    }

    function Toggle(show) {
        var allDivs = document.querySelectorAll(".content-item");
        allDivs.forEach((item, i) => {
            item.style.display = "none"
        });
        var show = document.getElementById(show);
        show.style.display = "block"
    }

    var list = document.querySelectorAll(".sidebar-nav li a[data-toggle-link]");
    return list.forEach((item, i) => {
        item.addEventListener("click", function (event2) {
            event2.preventDefault(), document.querySelector(".sidebar-nav .selected").classList.remove("selected"), Toggle(item.dataset.toggleLink), this.classList.add("selected")
        }, !1)
    }), CustomerAccount.prototype = _.assignIn({}, CustomerAccount.prototype, {}), CustomerAccount
}(), theme.ShopTheLook = function () {
    function ShopTheLook(container) {
        const dataAOS = container.dataset.aos, PADDING = 10;
        document.addEventListener("aos:in", ({detail}) => {
            detail === container && setTimeout(() => {
                detail.classList.remove("aos-init"), detail.classList.remove("aos-animate"), detail.removeAttribute("data-aos")
            }, 2e3)
        }), document.addEventListener("aos:out", ({detail}) => {
            detail === container && (detail.classList.add("aos-init"), detail.setAttribute("data-aos", dataAOS))
        });
        const handleProductPopup = event2 => {
            let target = event2.target;
            if (!target || target.nodeName === "#document" || !target.matches(".hotspot")) return !1;
            let product = target.querySelector(".product-hotspot"), isOut = theme.DOMHelpers.isOutOfBounds(product);
            isOut.left && (product.style.transform = `translateX(${Math.round(Math.abs(isOut.leftAmount)) + PADDING}px)`), isOut.right && (product.style.transform = `translateX(${(Math.round(isOut.rightAmount) + PADDING * 2) * -1}px)`)
        };
        let hotspots = container.querySelectorAll(".hotspot");
        hotspots.length > 0 && hotspots.forEach(hotspot => {
            hotspot.addEventListener("click", handleProductPopup), hotspot.addEventListener("mouseenter", handleProductPopup)
        })
    }

    return ShopTheLook.prototype = _.assignIn({}, ShopTheLook.prototype, {}), ShopTheLook
}(), theme.MailingPopup = function () {
    const Popup = function () {
        const defaults = {
            selectors: {
                popupContainer: ".newsletter__popup-container",
                popupOverlay: ".newsletter__popup-overlay",
                popupCloseButton: ".js-mailing-popup-close"
            },
            classes: {visible: "is-visible"},
            overlay: !0,
            defaultFrequency: 5,
            defaultPopupDelay: 5e3,
            cookieSetName: "popupShown",
            debug: !1,
            escape: !0,
            fadeAnimation: !1,
            enableLastFocus: !0,
            openCallback: function () {
            },
            closeCallback: function () {
            }
        };
        let lastFocus, popupTestMode, popupFrequency;
        const publicAPIs = {}, handleOverlayEvent = event2 => {
                event2.target === document.querySelector(`${settings.selectors.popupOverlay}.${settings.classes.visible}`) && publicAPIs.close()
            }, handleEscapeKeyboardEvent = event2 => {
                event2.key === "Escape" && (event2.preventDefault(), publicAPIs.close())
            },
            checkFadeSupport = () => typeof theme.Helpers.fadeIn == "function" && typeof theme.Helpers.fadeOut == "function",
            useFadeAnimation = () => settings.fadeAnimation && checkFadeSupport(), handleCloseButtonEvent = event2 => {
                publicAPIs.close(event2)
            }, themeEditorCheck = () => Shopify.designMode;
        return publicAPIs.open = () => {
            settings.overlay && document.querySelector(settings.selectors.popupOverlay) && document.querySelector(settings.selectors.popupOverlay).classList.add(settings.classes.visible), document.querySelector(settings.selectors.popupContainer) && (useFadeAnimation() ? theme.Helpers.fadeIn(document.querySelector(settings.selectors.popupContainer)) : document.querySelector(settings.selectors.popupContainer).style.display = "block"), themeEditorCheck() !== !0 && Cookies.set(settings.cookieSetName, "yes", {expires: popupFrequency}), typeof theme.a11yHelpers.focusOnElement == "function" && theme.a11yHelpers.focusOnElement(document.querySelector(settings.selectors.popupContainer)), settings.openCallback && typeof settings.openCallback == "function" && settings.openCallback()
        }, publicAPIs.close = event2 => {
            document.querySelector(settings.selectors.popupContainer) && (useFadeAnimation() ? theme.Helpers.fadeOut(document.querySelector(settings.selectors.popupContainer)) : document.querySelector(settings.selectors.popupContainer).style.display = "none"), settings.overlay && document.querySelector(settings.selectors.popupOverlay) && document.querySelector(settings.selectors.popupOverlay).classList.remove(settings.classes.visible), event2 && event2.preventDefault(), settings.enableLastFocus && lastFocus && lastFocus.focus(), settings.closeCallback && typeof settings.closeCallback == "function" && settings.closeCallback()
        }, publicAPIs.init = options => {
            settings = Object.assign({}, defaults, options), popupFrequency = document.querySelector(settings.selectors.popupContainer).getAttribute("data-popup-frequency") ? Number(document.querySelector(settings.selectors.popupContainer).getAttribute("data-popup-frequency")) : settings.defaultFrequency;
            const popupDelayAttribute = document.querySelector(settings.selectors.popupContainer).getAttribute("data-popup-delay");
            let popupDelay = Number(popupDelayAttribute) * 1e3;
            const popupCloseEl = document.querySelector(settings.selectors.popupCloseButton);
            popupCloseEl || settings.debug && console.log("err. no popup close button");
            const popupEnabled = document.querySelector(settings.selectors.popupContainer).getAttribute("data-popup-enabled") == "true";
            popupCloseEl.addEventListener("click", handleCloseButtonEvent), settings.escape && document.addEventListener("keyup", handleEscapeKeyboardEvent), settings.overlay && document.addEventListener("click", handleOverlayEvent), !(themeEditorCheck() || !popupEnabled) && setTimeout(function () {
                themeEditorCheck() == !0 ? (settings.enableLastFocus && (lastFocus = document.activeElement), publicAPIs.open()) : Cookies.get(settings.cookieSetName) || (settings.enableLastFocus && (lastFocus = document.activeElement), publicAPIs.open())
            }, popupDelay)
        }, publicAPIs
    }();

    function MailingPopup(container) {
        Popup.init({
            selectors: {
                popupContainer: ".js-popup",
                popupOverlay: ".js-popup-overlay",
                popupCloseButton: ".js-mailing-popup-close"
            }, fadeAnimation: !0, enableLastFocus: !1, openCallback: function () {
                console.log("Hurray!")
            }, closeCallback: function () {
                console.log("Foo!")
            }
        })
    }

    return MailingPopup.prototype = _.assignIn({}, MailingPopup.prototype, {
        onSelect: function () {
            Popup.open()
        }, onDeselect: function () {
            Popup.close()
        }
    }), MailingPopup
}(), theme.Countdown = function () {
    function getCountDown(container) {
        setTimeout(function () {
            container.querySelectorAll(".countdown__time--wrapper").forEach((item, i) => {
                item.style.opacity = 1
            })
        }, 100);
        var timestamp = container.getAttribute("data-launch-date"), timestamp = parseInt(timestamp);
        if (!timestamp) return !1;
        var count = setInterval(function () {
            var nowTime = new Date, endTime = new Date(timestamp * 1e3), t = endTime.getTime() - nowTime.getTime(),
                days = Math.floor(t / 1e3 / 60 / 60 / 24), hours = Math.floor(t / 1e3 / 60 / 60 % 24),
                mins = Math.floor(t / 1e3 / 60 % 60), secs = Math.floor(t / 1e3 % 60);
            days < 10 && (days = "0" + days), hours < 10 && (hours = "0" + hours), mins < 10 && (mins = "0" + mins), secs < 10 && (secs = "0" + secs), days >= 0 && (container.querySelector("[data-launch-days]").innerHTML = days), hours >= 0 && (container.querySelector("[data-launch-hours]").innerHTML = hours), mins >= 0 && (container.querySelector("[data-launch-mins]").innerHTML = mins), secs > 0 && (container.querySelector("[data-launch-secs]").innerHTML = secs), t < 0 && (clearInterval(count), reloadSection(container))
        }, 1e3)
    }

    function reloadSection(container) {
        const id = container.dataset.sectionId, url = `${container.dataset.baseUrl}?section_id=${id}`;
        fetch(url).then(function (response) {
            return response.text()
        }).then(function (html) {
            if (html.trim() !== "") {
                var parser = new DOMParser, doc = parser.parseFromString(html, "text/html"),
                    countdownWrapper = doc.querySelector("#countdownWrapper");
                if (countdownWrapper) {
                    var containerCountdownWrapper = container.querySelector("#countdownWrapper");
                    containerCountdownWrapper && (containerCountdownWrapper.innerHTML = countdownWrapper.innerHTML)
                }
            }
        })
    }

    return document.querySelectorAll('[data-section-type="countdown"]').forEach(function (container, i) {
        getCountDown(container)
    }), document.addEventListener("shopify:section:select", function (event2) {
        if (!event2.target.querySelector('[data-section-type="countdown"]')) return !1;
        var container = event2.target.querySelector('[data-section-type="countdown"]');
        getCountDown(container)
    }), getCountDown
}(), document.addEventListener("DOMContentLoaded", function () {
    var sections = new theme.Sections;
    sections.register("announcement-bar-section", theme.AnnouncementBar), sections.register("header-section", theme.Header), sections.register("footer-section", theme.Footer), sections.register("slideshow-section", theme.Slideshow), sections.register("carousel-section", theme.CarouselSection), sections.register("product__section", theme.Product), sections.register("product-recommendations", theme.ProductRecommendations), sections.register("recently-viewed", theme.RecentlyViewed), sections.register("mobile-navigation", theme.mobileNav), sections.register("collection-section", theme.Collection), sections.register("map", theme.Maps), sections.register("scrolling-announcements", theme.ScrollingAnnouncements), sections.register("search-section", theme.Search), sections.register("related-products-section", theme.RelatedProducts), sections.register("iwto-section", theme.Parallax), sections.register("shop-the-look", theme.ShopTheLook), sections.register("password-page", theme.Password), sections.register("mailing-popup", theme.MailingPopup), sections.register("customer-account", theme.CustomerAccount), sections.register("background-video", theme.BackgroundVideo), sections.register("countdown", theme.Countdown)
}), document.addEventListener("DOMContentLoaded", function () {
    mobile.matches && Events.trigger("mediaquery:mobile"), tablet.matches && Events.trigger("mediaquery:tablet"), desktop.matches && Events.trigger("mediaquery:desktop"), window.addEventListener("resize", function () {
        mobile.matches && Events.trigger("mediaquery:mobile"), tablet.matches && Events.trigger("mediaquery:tablet"), desktop.matches && Events.trigger("mediaquery:desktop")
    }), document.addEventListener("shopify:section:select", function (event2) {
        Events.trigger("editor:section:select", event2)
    }), document.addEventListener("shopify:section:deselect", function (event2) {
        Events.trigger("editor:section:deselect", event2)
    }), document.addEventListener("shopify:section:load", function (event2) {
        Events.trigger("editor:section:load", event2)
    }), document.addEventListener("shopify:section:unload", function (event2) {
        Events.trigger("editor:section:unload", event2)
    }), document.addEventListener("shopify:block:select", function (event2) {
        Events.trigger("editor:block:select", event2)
    }), document.addEventListener("shopify:block:deselect", function (event2) {
        Events.trigger("editor:block:deselect", event2)
    }), document.querySelectorAll(".js-bg-video-wrapper") && WAU.ProductGridVideo.init()
}), log = function () {
    var args = Array.prototype.slice.call(arguments);
    return args.unshift(console), Function.prototype.bind.apply(console.log, args)
}, log("Icon Version 10.1.1 by Underground", {bar: 1})();

class UpsellProduct extends HTMLElement {
    constructor() {
        super(), this.dataProductUrl = this.getAttribute("data-product-url"), this.loadProduct(this.dataProductUrl)
    }

    loadProduct(productURL) {
        fetch(productURL).then(response => response.text()).then(response => {
            this.appendChild(this.formatTemplate(response));
            let context = this.querySelector(".js-upsell-wrapper");
            theme.Product(context)
        }).then(response => {
            this.querySelector(".js-upsell-wrapper").querySelector(".js-ajax-submit").addEventListener("click", function (e) {
                e.preventDefault();
                var addToCartForm = this.closest("form");
                let cartConfig = document.getElementById("cart-config");
                return cartConfig && (cartConfig = JSON.parse(cartConfig.innerHTML || "{}"), Shopify.theme.ajaxCart.addToCart(addToCartForm, addToCartForm, cartConfig, !1)), !1
            })
        }).catch(error => {
            console.log(error.message)
        })
    }

    formatTemplate(response) {
        var parser = new DOMParser, doc = parser.parseFromString(response, "text/html"),
            template2 = doc.querySelector('[data-html="content"]');
        return template2.content
    }
}

customElements.get("upsell-product") || customElements.define("upsell-product", UpsellProduct);
//# sourceMappingURL=/s/files/1/0047/9638/3330/t/32/assets/theme.js.map?v=1726140131
